import { relativeTimeThreshold } from "moment";
import { createI18n } from "vue-next-i18n";

export default createI18n({
    legacy: false,
    locale: "en",
    globalInjection: true,
    silentTranslationWarn: true,
    missingWarn: false, fallbackWarn: false,
    messages: {
        en: {
          at: 'At',
          confirmDialogLoginHeader: 'In order to perform this operation you need to authenticate',
          create: 'Create',
          'Master Data': 'Master Data',
          Security: 'Security',
          ' ': '',
          id: 'Id',
          yes: 'Yes',
          no: 'No',
          exit: 'Exit',
          welcomeMessage: 'Welcome to Smart SIM',
          testlink1: 'Test site is available ',
          testlinkHere: 'HERE',
          homeMessage: 'To access the features use the side menu or the search bar',
          resetPassword: 'Password Reset',
          updatePassword: 'Update Password',
          noRecordsFound: 'No records found',
          imported: 'Imported',
          readyToSend: 'Ready to send',
          date: 'Date',
          createdOn: 'Created On',
          changePassword: {
            title: 'Change password',
            message: 'Password is expired. You have to update your password',
            oldPassword: 'Old password',
            newPassword: 'New password',
            confirmNewPassword: 'Confirm new password',
            oldPasswordRequired: 'Old password is required',
            newPasswordRequired: 'New password is required',
            confirmNewPasswordNotEquals: 'New password doesn\'t match with confirm',
            forgotPassword:'Forgot your password?',
            forgotPasswordMessage: '*Fill in the two fields to receive an email on your inbox that will allow you to change your password',
            returnLogin: 'Return to Login',
            resetPasswordSuccessMessage: 'Password successfully reset! Check your inbox',
            newPasswordRules: 'New Password rules',
            minLength: 'At least 10 characters',
            upperCaseLetter: 'At least one upper case letter',
            lowerCaseLetter: 'At least one lower case letter',
            numberPresence: 'At least one digit',
            specialCharacter: 'At least one special character',
            confirmEqual: 'Confirm password must be equal',
            RulesNotMatched: 'Rules not matched'
          },
          messages: {
            generic_error_message: 'An error occurred. If error persists, please contact support',
            delete_message_question: 'Are you sure to delete item?',
            delete_message_success: 'Item successfully deleted',
            upload_message_success: 'Item uploaded successfully',
            update_message_success: 'Item successfully updated',
            create_message_success: 'Item successfully created',
            import_message_success: 'Imported successfully',
            operation_message_success: 'Operation performed successfully',

            reset_password_question: 'Choose a new password',

            assignNewDocumentNumber: 'Document already has a number. Generate a new one?',
            clone_current_lot: 'Do you want to clone this lot?',
            clone_deal: 'Do you want to clone this Deal?',
            calculate_true_up: 'Do you wanto to calculate True Up?',
            calculate_priced_quantities_balance: 'Do you want to calculate Priced Quantity Balance?',
            passwordResetSuccessMessage: 'Password successfully recovered!',
            delete_current_movement_instruction: 'You are about to cancel the instruction. If you want to restore a previous version, use the "restore version" function. Do you want to continue with the cancellation?',
            delete_current_lot: 'Do you want to delete this lot?',
            exclude_message_question: 'Do you want to exclude this record?',
            include_message_question: 'Do you want to include this record?',
            confirm_import: 'Do you want to confirm import?',
            verify_all_tabs_validation: 'Verify all tabs validation',
            confirm_pending_processing_production_before_import: 'Cannot upload other files, for this version have already been uploaded the entire month. Please confirm this version or cancel an imported period, before you can continue',
            confirm_reload_page_to_switch_theme_color: 'This change will reload the page and any unsaved information will be lost. Are you sure you want to continue?',
            importSuccess: 'Import successfully done',
            exportSuccess: 'Export successfully done',
            exportMessage: 'Do you want to export data?',
            documentDownloadCorruptedMessage: 'The document you want to download is corrupted.',
            operationTypeRequired: 'You have to select an operation type',
            movementInstructionCreateFromTheoreticalLot: 'Do you want to create a movement instruction from this theoretical lot?',
            movementInstructionLinkTheoreticalLot: 'Do you want to link selected theoretical lot to movement instruction?',
            movementInstructionUnlinkTheoreticalLot: 'Do you want to unlink theoretical lot?',
            importQuestion: 'Do you want to import data?',
            generic_confirm_message: 'Are you sure?',
            documentDownloadCorruptedMessage: 'The document you want to download is corrupted.',
            importDateRequired: 'Date is required',
            layoutNotSelected: 'You have to select a layout',
            layoutNameRequired: 'A name is required for a new layout',
            item_exists_replace_message: 'This item exists yes. Do you want to replace it?',
            movementInstructionNotAssociatedMessage: 'This voyage is not linked to a theoretical lot. Do you want to link it?',
            request_not_valid: 'Request not valid.',
            db_no_data_saved: 'DB save error. No data saved.',
            itemNotFound: 'Item not found',
            itemsListNotValid: 'Items list not valid',
            import_interface: 'Do you want to import DensityEstimation and FeedstockTanks?',
            oldValue: 'Old Value: ',
            exceptionSpec: 'Exception Value',
            promiscousTankCalculator: 'The selected tank is currently managed as promiscuous. Do you wish to proceed with development in promiscuous mode?'
          },
          btn: {
            notes: 'Notes',
            history: 'History',
            save: 'Save',
            back: 'Back',
            add: 'Add',
            cancel: 'Cancel',
            filter: 'Filter',
            reset_filters: 'Reset filters',
            logout: 'Logout',
            login: 'Login',
            changePassword: 'Change password',
            updatePassword: 'Update password',
            clone: 'Clone',
            search: 'Search',
            edit: 'Edit',
            addChild: 'Add Child',
            addRoot: 'Add Root',
            delete: 'Delete',
            newTree: 'New Tree',
            viewDetails: 'View Details',
            viewFile: 'View File',
            refresh: 'Refresh',
            copy: 'Copy',
            showVessel: 'Show Vessel',
            restore: 'Restore',
            print: 'Print',
            remove: 'Remove',
            reset: 'Reset',
            send: 'Send',
            insert: 'Insert',
            publish: 'Publish',
            timesheet: 'TimeSheet',
            export: 'Export',
            excel: 'Excel',
            saveAsFavourite: 'Save as Favourite',
            removeFromFavourites: 'Remove from favourites',
            create: 'Create',
            recreate: 'Delete and recreate',
            importEveryone: 'Import Everyone',
            load: 'Load',
            preview: 'Preview',
            import: 'Import',
            select: 'Select',
            assignLocalNumber: 'Assign local number',
            nextversion: 'Next Version',
            unlock: 'Unlock',
            develop: 'Develop',
            confirm: 'Confirm',
            change: 'Change',
            calculate: 'Calculate',
            convert: 'Convert',
            validateAll: 'Validate All',
            resend: 'Re-Send',
            view: 'View Report',
            editAssets: 'Edit assets',
            reimport: 'Re-Import',
            close: 'Close',
            reOpen: 'Reopen',
            assign: 'Assign',
            download: 'Download',
            copyToTomorrow: 'Copy in another plan',
            selectDocuments: 'Select Documents',
            cancelDocuments: 'Delete Documents',
            stockExport: 'Stock Export',
            attachments: 'Attachments',
            link: 'Link',
            comment: 'Comment',
            upload: 'Upload',
            theoreticalLots: 'Theoretical Lots',
            addNode: 'Add Node',
            warnings : 'Warnings',
            theoreticalLots: 'Theoretical Lots',
            unlinkTheoreticalLot: 'Unlink Theoretical Lot',
            align: 'Align',
            configure: 'Configure',
            layout: 'New Layout',
            apply: 'Apply',
            applyAll: 'Apply All',
            expand: 'Expand',
            collapse: 'Collapse',
            unlink: 'Unlink',
            readPi: 'Read PI',
            admin: 'Admin',
            stock: 'Stocks',
            importFromFile: 'Import From File',
            importWeeklyFromFile: 'Import Weekly From File'
          },
          system: {
            page_title: 'System'
          },
          generic: {
            page_title: 'General'
          },
          fiscalData: {
            page_title: 'Fiscal Data'
          },
          products: {
            page_title: 'Products'
          },
          movementOperation: {
            page_title: 'Operations'
          },
          users: {
            page_title: 'Users',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            username: 'Username',
            password: 'Password',
            realm: 'Realm',
            isEnabled: 'Enabled',
            isChangePasswordRequired: 'Change password required',
            newPassword: 'New password',
            isAPIKeyUser: 'API Key User',
            isLoginByActiveDirectory: 'Login By Active Directory',
            isDisabledByAdmin: 'Disabled By Admin'
          },
          roles: {
            page_title: 'Roles',
            name: 'Name',
            description: 'Description',
            isEnabled: 'Enabled'
          },
          menu_configuration: {
            page_title: 'Menu Configuration',
            permissions: 'Permissions'
          },
          notifications: {
            page_title: 'Notifications',
            sender: 'Sender',
            receivers: 'Receivers',
            subject: 'Subject',
            message: 'Message',
            send: 'Send notification',
            date: 'Date',
            notificationDate: 'Notification Date',
            applicationUrlReference: "Application Url Reference"
          },
          thread: {
            page_title: 'Thread',
            threadName: 'Thread name',
            validFrom: 'Valid from',
            validTo: 'Valid to',
            users: 'Users',
            validityPeriod: 'Validity period',
            partecipants: 'Partecipants',
            sentBy: 'Sent by',
            at: 'at',
            noThreadSelected: 'Choose a thread',
            btn: {
              newThread: "New thread",
              reply: 'Reply',
              edit: 'Edit thread'
            }
          },
          search: {
            strict: 'Strict Mode'
          },
          attributes: {
            page_title:  'Attributes',
            role: 'Role',
            attribute: 'Attribute',
            type: 'Type',
            value: 'Value'
          },
          importCvt: {
            page_title: 'Import CVT',
            startDate: 'Start Date',
            endDate: 'End Date',
            tank: 'Tank',
            productCode: 'Product Code',
            movedWeight: 'Mov Qty (kg)',
            movedVolume: 'Mov Qty (lt)',
            isDenaturatedProduct: 'Denaturated Product',
            denaturantWeight: 'Denaturant Weight',
            exciseValue: 'Excise',
            suspendedExciseValue: 'Suspended Excise',
            imported: 'Imported',
            status: 'Status',
            date: 'Date'
          },
          cvtDeviation: {
            btn:{
              excelDownload: 'Download Excel',
              editSelected: 'Edit Selected',
              sendToInfoil: 'Send To Infoil',
              calculate: 'Calculate',
              importFromPI: 'Import From PI'
            },
            page_title: 'CVT Deviation',
            deviationCalculator: 'Deviation Calculator',
            date: 'Date',
            dateFrom: 'Date From',
            dateTo: 'Date To',
            sent: 'Sent',
            fiscalCommunicationCode: 'Communication Code',
            isabTankCode: 'Tank',
            simProductCode: 'Product',
            simProductDescription: 'Product Desc',
            initialStockWeight: 'Start Stock (Kg)',
            initialStockVolume: 'Start Stock (Lt)',
            realStockWeight: 'Real Stock (Kg)',
            realStockVolume: 'Real Stock (Lt)',
            extractProductWeight: 'Kg Difference',
            extractProductVolume: 'Lt Difference',
            lossValue: 'Loss',
            excessValue: 'Excess',
            difference: 'Difference',
            totalDifference: 'Total Difference',
            totalExcess: 'Total Excess',
            totalLoss: 'Total Loss',
            temperature: 'Temperature',
            productLevel: 'Product Level',
            envTemperature: 'Env Temperature',
            gasTemperature: 'Gas Temperature',
            gasPressure: 'Gas Pressure (Bar)',
            molecularWeight: 'Molecular Weight',
            notAllFiscalZeroingOnTanks: 'Tanks {tanks} have not yet been zeroed. It will be proposed again to calculate the deviation when all the connected tanks have a zeroing',
            manageMultipleTanks: 'Do you want to manage tanks {tanks} and calculate deviation of GPL summary?'
          },
          cvtReport: {
            page_title: 'CVT Tanks Report',
            tanks: 'Tanks',
            operationDate: 'Date',
            fiscalNotificationCode: 'Azz Fiscal Notification Code',
            operationDate: 'Azz Operation Date',
            tankCode: "Tank",
            initialStock: 'Inizial Stock',
            finalStock: 'Fiscal Stock',
            realStock: 'Real Final Stock',
            extractProduct:'Fiscal Moved',
            realExtractProduct: 'Real Moved',
            stockDifference: 'Fiscal - Real Diff.',
            deviationPerc: '% Deviation',
            noTanksForFilters: 'No tank for Date / Plant selected'
          },
          user_roles: {
            page_title: 'User Roles',
            user: 'Reference User',
            role: 'Role'
          },
          analysisSampleReceiver: {
            page_title: 'Analysis Sample Receivers',
            fk: 'Analysis Sample Receiver',
            description: 'Description',
            englishDescription: 'English description',
            isDeleted: 'Deleted'
          },
          clearanceMovementType: {
            page_title: 'Clearance Movement Types',
            fk: 'Clearance Movement Type'
          },
          vessel: {
            search: 'Vessel search',
            page_title: 'Vessels',
            fk: 'Vessel',
            imoNumber: 'Imo Number',
            name: 'Name',
            deadWeightTonnage: 'Dead Weight Tonnage',
            lengthOverall: 'Length Overall',
            draught: 'Draught',
            grossTonnage: 'Gross Tonnage',
            netTonnage: 'Net Tonnage',
            isBunkerBarge: 'Is Bunker Barge',
            countryAndTerritoryFlagCode: 'Country And Territory Flag Code',
            yearOfBuilt: 'Year Of Built'
          },
          company: {
            page_title: 'Companies',
            fk: 'Company',
            transportDepartmentCode: 'Transport Department Code',
            infoilCode:'Infoil Code',
            cvtCode:'CVT Code',
            isChargeByLandRetailer: 'Cargo by Land Retailer',
            compulsoryStockCode: 'Compulsory Stock Code',
            isCompulsoryStockEnabled: 'Compulsory Stock Enabled',
            isStocchinoPlanEnabled: 'Stocchino Plan Enabled'
          },
          companyAddress: {
            page_title: 'Company Addresses',
            completeAddress: 'Complete Address',
            city: 'City',
            country: 'Country',
            zipCode: 'Zip Code',
            district: 'District',
            isMainAddress: 'Main Address'
          },
          accountType: {
            page_title: 'Account Type',
            fk: 'Account Type'
          },
          recordFileState: {
            page_title: 'Record File State',
          },
          importFromFileState: {
            page_title: 'Import From File State',
          },
          companySection: {
            page_title: 'Company Section',
          },
          balanceConfidentialLevel: {
            page_title: 'Confidential Level',
          },
          balancePhase: {
            page_title: 'Balance Phase',
          },
          balanceSheetAccountType: {
            page_title: 'Profile Type',
          },
          balanceSheetType: {
            page_title: 'Balance Sheet Type',
          },
          originStorage: {
            page_title: 'Product Stock Origin',
          },
          customsChangeValue: {
            page_title: 'Customs Change Value',
          },
          VAT: {
            page_title: 'VAT',
          },
          portualTax: {
            page_title: 'Portual Tax',
          },
          vesselProtocolPaymentType: {
            page_title: 'Vessel Protocol Payment Type',
          },
          authorizationType: {
            page_title: 'authorizationtype',
            fk: 'Authorization Type'
          },
          dealNoteColumnCombo: {
            page_title: 'Deal Note Column',
            family: 'Family',
            columnType: 'Column Type',
            description: 'Desciption',
            referenceDate: 'Reference Date',
            isDeleted: 'Is Deleted'
          },
          commercialOperationType: {
            page_title: 'Commercial Operation Types',
            fk: 'Commercial Operation Type',
            name: 'Name',
            code: 'Code',
            isPhysicalOperation: 'Physical'
          },
          countryAndTerritory: {
            countryAndTerritory: 'Country And Territory',
            page_title: 'Countries and Territories',
            isoCode: 'Iso Code',
            shortName: 'Short Name',
            transportDepartmentCode: 'Transport Department Code',
            transportDepartmentDescription: 'Transport Department Description',
            originDestination: 'Origin / Destination',
            placeOfLoadingDischarge: 'Place of Loading / Discharge'
          },
          currency: {
            page_title: 'Currencies'
          },
          documentType: {
            page_title: 'Document Types',
            fk: 'Document type'
          },
          documentReceiver: {
            page_title: 'Document Receivers',
            fk: 'Receiver'
          },
          fiscalPosition: {
            page_title: 'Fiscal Positions',
            fk: 'Fiscal Position'
          },
          fiscalUse: {
            page_title: 'Fiscal Uses',
            fk: 'Fiscal Use'
          },
          incoterm: {
            page_title: 'Incoterms',
            fk: 'Incoterm'
          },
          inspectionCost: {
            page_title: 'Inspection Costs',
            fk : 'Inspection Cost'
          },
          inspector: {
            page_title: 'Inspectors',
            fk: 'Inspector',
            email: 'Email',
            isVoyageReportEmailEnabled: 'Voyage Report Email'
          },
          language: {
            page_title: 'Languages'
          },
          macroMovementType: {
            page_title: 'Macro Movement Types',
            fk: 'Macro Movement'
          },
          samplingPoint: {
            page_title: 'Sampling Points',
            fk: 'Sampling Point'
          },
          shippingAgency: {
            page_title: 'Shipping Agencies',
            fk: 'Shipping Agency'
          },
          transportType: {
            page_title: 'Transport Types',
            fk: 'Transport Type'
          },
          counterFieldType: {
            fk: 'Counter Field Types',
            page_title: 'Counter Field Types'
          },
          counter: {
            page_title: 'Counters'
          },
          registryPlant: {
            page_title: 'Plants',
            fk: 'Plant',
            registryPortCode: 'Port Code',
            infoilPortCode: 'Infoil Port Code',
            customAgencyOfficeReference: 'Agency Office Reference',
            transportDepartmentCode: 'Transport Department Code',
            infoSipCode: 'Info SIP Code'
          },
          originStorage: {
            page_title: 'Product Stock Origin',
            fk: 'Origin',
          },
          contractType: {
            page_title: 'Contract Types',
            fk: 'Contract Type'
          },
          fiscalDestination: {
            fk: 'Fiscal Destination',
            page_title: 'Fiscal Destinations'
          },
          infoilFamilyProduct: {
            page_title: 'Infoil Family Products',
            fk: 'Infoil Family Product',
            isIncludedIntoHter9Flag: 'Is Included Into Hter9',
            isGasFlag: 'Is Gas',
            uoMFlag: 'UoM',
            denaturationLabel: 'Denaturation Label'
          },
          infoilOperationType: {
            page_title: 'Infoil Operation Types'
          },
          energyProduct: {
            page_title: 'Energy Products',
            fk: 'Product',
            nC: 'NC',
            infoilRegisterCode: 'Infoil Register Code',
            unitOfMeasureEad: 'UoM EaD Exception',
            packagingType: 'Packaging Type Code'
          },
          energyProductDetail: {
            page_title: 'Energy Product Details',
            fk: 'Energy Product Detail',
            cPA: 'CPA',
            tARIC: 'TARIC',
            cADD: 'CADD',
            isTaxed: 'Is Taxed',
            fiscalSectionCode: 'Fiscal Section Code',
            regionalAccountCode: 'Regional Account Code'
          },
          laytimeUoM: {
            page_title: 'Laytime UoM',
            fk: 'Laytime UoM'
          },
          portAndLocation: {
            page_title: 'Ports And Locations',
            fk: 'Port',
            movementInstrFK: 'Location'
          },
          product: {
            product: 'Product',
            fk: 'Product',
            page_title: 'Products',
            imoCode: 'IMO Code',
            imoDescription: 'IMO Description',
            dealNoteCode: 'Crude Code',
            dealNoteSheetFamily: 'Deal Note Sheet Family',
            familyDescription: 'Family Description'
          },
          productCompanyOwner: {
            page_title: 'Product Company Owner',
            productPool: 'Product Pool',
            productType: 'Product Type',
            productNature: 'Product Nature',
            smartsim_product: 'Smart Sim Product',
            import: 'Product Owner Import'
          },
          processingProductionProduct: {
            page_title: 'Processing Production Product',
            smartsim_product: 'Smart Sim Product',
            productLabel: 'Product',
          },
          productAggregation: {
            page_title: 'Product Aggregations'
          },
          typeMovementInstructionLot: {
            page_title: 'Instruction Lot Movement Types'
          },
          unitOfMeasure: {
            page_title: 'Units Of Measure',
            fk: 'UoM'
          },
          unitOfMeasureUsageScopeConfig: {
            page_title: 'UoM Usage Scopes',
            printOrder: 'Print order'
          },
          movementInstruction: {
            page_title: 'Movement Instructions',
            laycanData: 'Laycan Data',
            laytimeData: 'Laytime Data',
            revertConfirmMessage: 'By confirming, you will need to re-enter the vessel. Do you want to continue?'
          },
          taxWarehouse: {
            page_title: 'Tax Warehouses',
            fk: 'Tax Warehouse',
            consignee: 'Tax Warehouse',
            placeOfDelivery: 'Place of Delivery',
            consigneeExciseCode: 'Primary Excise Code',
            consigneeName: 'Name',
            consigneeAddress: 'Address',
            consigneeStreetNumber: 'Street Number',
            consigneeZipCode: 'Zip Code',
            consigneeCity: 'City',
            consigneeEoriCode: 'Eori Code',
            consigneeVatNumber: 'Vat Number',
            consigneeActivationDate: 'Activation Date',
            consigneeLanguageCode: 'Language Code',
            consigneeCountryTerritoryCode: 'Country Territory Code',
            consigneeStartDate: 'Start Date',
            consigneeEndDate: 'End Date',
            competentAuthorityDispatchOfficeReferenceNumber: 'Competent Authority Dispatch Office Reference Number',
            placeOfDeliveryExciseCode: 'Destination Excise Code',
            placeOfDeliveryName: 'Name',
            placeOfDeliveryAddress: 'Address',
            placeOfDeliveryStreetNumber: 'Street Number',
            placeOfDeliveryZipCode: 'Zip Code',
            placeOfDeliveryCity: 'City',
            placeOfDeliveryLanguageCode: 'Language Code',
            placeOfDeliveryActivationDate: 'Activation Date',
            placeOfDeliveryStartDate: 'Start Date',
            placeOfDeliveryEndDate: 'End Date'
          },
          customsSituation: {
            page_title: 'Customs Situations',
            fk: 'Customs Situation',
          },
          typeOperationEnergyProductDetailAndProductLink: {
            page_title: 'Products NC'
          },
          operationType: {
            page_title: 'Operation Types',
            fk: 'Operation Type',
            isNotifyToCustomAgency: 'Notify To Custom Agency',
            tankOperationFlag: 'Tank Operation',
            punctualFlag: 'Punctual Flag',
            accountingOperationFlag: 'Accounting Operation',
            chargeDischargeFlag: 'Charge Discharge',
            tankGridFlag: 'Tank Grid',
            movementDirectionFlag: 'Movement Direction',
            operationPlanFlag: 'Operation Plan',
            isInsideOfRefineryWarehouse: 'Inside Of Refinery Warehouse',
            denaturationProcessingFlag: 'Denaturation Processing',
            isNotIncludedIntoOperationPlan: 'Not Included Into Operation Plan',
            sourceOrRecipientFlag: 'Source Or Recipient',
            isSetStorage: 'Set Storage',
            checkCargoByLandSendToInfoilIsEnabled: 'Check Infoil Send Is Enabled for CVT',
            measurementReportType: 'Measurement Report Type',
            infoilCode: 'Infoil Code',
            infoilDescription: 'Infoil Description'
          },
          instructionMovement: {
            page_title: 'Movement Instructions'
          },
          movementInstructions: {
            page_title: 'Movement Instructions',
            new: 'New Movement Instruction',
            voyageNumber: 'Voyage Number',
            laycanFrom: 'Laycan from',
            laycanTo: 'Laycan to',
            lots: 'Lots',
            etaDate: 'Eta',
            btn: {
              vesselProtocol: 'Open Vessel Protocol',
              restorePrevVersion: 'Restore prev. version',
              prevVersion: 'Prev. Versions',
              addLot: 'Add Lot',
              cloneLot: 'Clone Lot',
              duplicateLot: 'Duplicate Lot',
              copyLot: 'Copy from Lot',
              load: 'Load',
              cloneNote: 'Import Note',
              deleteInstruction: 'Delete Instruction',
              deleteLot: 'Delete Lot',
              saveVesselNominationNewParcelLink: 'Apply New Link'
            },
            messages: {
              bolHeaderNotSelected: 'You have to select a Bill Of Lading',
              documentNotSelected: 'You have to select a Document',
              lotClonedSuccess: 'Lot cloned successfully',
              minMaxQuantityValidation: 'Minimum quantity can\'t be greater than maximum',
              laycanDateValidation: 'Laycan from must be before laycan to'
            },
            laycanData: 'Laycan Data',
            laytimeData: 'Laytime Data',
            loadingLaytime: 'Loading Laytime',
            loadingFreetime: 'Loading Freetime',
            dischargeLaytime: 'Discharge Laytime',
            dischargeFreetime: 'Discharge Freetime',
            totalLaytime: 'Total Laytime',
            totalFreetime: 'Total Freetime',
            demurrageRate: 'Demurrage Rate',
            demurrage: 'Demurrage',
            isCrudeOilWashing: 'Crude Oil Washing',
            crudeOilWashingHours: 'Crude Oil Washing Hours',
            lotHeader: 'Lot Header',
            isOutCDep: 'Out / Dep. Acc.',
            origin: 'Loading Place / Location',
            destination: 'Discharge Place / Location',
            destinationPort: 'Destination Port',
            originNation: 'Origin',
            destinationNation: 'Destination',
            product: 'Product',
            contractDate: 'Contract Date',
            contractNumber: 'Contract Number',
            shipper: 'Shipper',
            deliveryDocumentHolder: 'Delivery Document Holder',
            billOfLadingHolder: 'Bill Of Lading Holder',
            notifyCompleteAddress: 'Notify Complete Address',
            placeOfLoadingCode: 'Country',
            placeofDischargeCode: 'Country',
            quantity: 'Quantity',
            minimumQuantity: 'Min Quantity',
            maximumQuantity: 'Max Quantity',
            productTradeDescription: 'Product Trade Description',
            typeMovementInstructionLotCode: 'Type',
            analysisDocumentLanguageCode: 'Analysis Document Language',
            documentLanguageCode: 'Document Language',
            newBoL: 'New Bill Of Lading',
            newBoLItem: 'New Bill Of Lading Item',
            newAnalysisSample: 'New Analysis sample',
            numberofSamples: 'Number of samples',
            newMeasureUnit: 'New measure unit',
            minimumValue: 'Minimum value',
            maximumValue: 'Maximum value',
            characteristicValue: 'Characteristic value',
            samplingMethod: 'Sampling method',
            noteCodes: 'Note codes',
            headerInfo: 'Header',
            lotMainInfo: 'Main',
            billOfLading: 'Bill of Lading',
            documents: 'Documents',
            documentReceivers: 'Receivers',
            productSpecifications: 'Product Specifications',
            measureUnits: 'Measure Units',
            analysisSamples: 'Analysis Samples',
            fiscalInfo: 'Fiscal info',
            isCounterSignedByInspector: 'Counter signed by inspector',
            isCounterSignedByThirdparty: 'Counter signed by thirdparty',
            isIssuedByThirdparty: 'Issued by thirdparty',
            eta: 'ETA',
            etaNumber: 'Eta Number',
            notifyDate: 'Notify Date',
            notifyMeans: 'Notify Means',
            numberOfOriginals: 'Number of Originals',
            numberOfCopies: 'Number of Copies',
            addDocumentNumberRequired: 'Document Number is required',
            log: 'Log',
            externalVoyageNumber: 'External Voyage Number',
            isFip: 'FIP',
            isOnlyOneLotPermitted: 'Only a lot permitted',
            isPartialEndNotificationWithOnlyInputParams: 'Partial Measure permitted', 
            versionNote: 'Version Note',
            copyLotSuccessMessage: 'Data successfully copied',
            selectLot: 'Select a lot',
            selectVersion: 'Select a version',
            revertSuccessMessage: 'Version successfully reverted',
            cloneMessageBtn: 'Do you want clone this element?',
            insertCode: 'Insert code',
            eventDescription: 'Event description',
            completionDate: 'Completion date',
            completed: 'Completed',
            pipeTransferTypeFlag: 'Pipe Type',
            pipeTypeC: 'Period',
            pipeTypeP: 'Batch',
            notes: 'Notes',
            BillOfLadingReportFormat: 'BOL format',
            isRefinery: 'Refinery',
            shipToShip: 'Ship to Ship',
            charterPartyDated: 'Charter Party Dated'
          },
          movementInstructionLots: {
            title: 'Lots',
            lotCode: 'Lot Ref.',
            productCode: 'Product',
            quantity: 'Total Qty',
            quantityUoMCode: 'Unit of Measure',
            typeMovementInstructionLotCode: 'BL Type',
            billofLadingHolder: 'Holder',
            note: 'Note',
            documentLanguageCode: 'Doc Language',
            analysisDocumentLanguageCode: 'Analysis Lang',
            isOutCDep: 'Out / Dep. Acc.'
          },
          movementInstructionCompaniesByOperation: {
            page_title: 'Companies By Operation'
          },
          productSpecificationHeader: {
            page_title: 'Product Specifications'
          },
          productSpecificationDetail: {
            page_title: 'Product Specifications Detail'
          },
          productSpecificationNote: {
            page_title: 'Product Specifications Note'
          },
          movementInstructionOutcDepRules: {
            page_title: 'OUTC/DEP Configuration'
          },
          movementInstructionSavedAsFavourite: {
            page_title: 'Favourites'
          },
          movementInstructionChecklist: {
            page_title: 'Checklist'
          },
          productAnalysisTestMethod: {
            page_title: 'Product Analysis - Test Methods'
          },
          logs: {
            page_title: 'Logs',
            level: 'Level',
            utcTimeStamp: "Utc Time Stamp",
            messageTemplate: "Message Template",
            renderedMessage:"Rendered Message",
            properties:"Properties",
            exception:"Exception",
            key: 'Key',
            value: 'Value',
            collection: 'Collection'
          },
          tankManagement: {
            page_title: 'Tank Management',
            load: 'Load',
            downloadTemplate: 'Download Template',
            uploadTemplate: 'Upload Template',
            downloadTemplateButtonEmpty: 'Empty (new tank)',
            downloadTemplateButtonFilled: 'Calibration Update',
            deleteSelected: 'Delete',
            downloadCalibrationTable: 'Download Calibration Table',
            isActive: 'Active',
            type: 'Type',
            code: 'Code',
            plant: 'Plant',
            details: 'Details',
            description: 'Description',
            startDate: 'Start Date',
            endDate: 'End Date',
            maxLevel: 'Max Level',
            minLevel: 'Min Level',
            inextricableVolume: 'Inextricable Volume',
            maxVolume: 'Max Volume',
            highFeetMinValue: 'High Feet Min Value',
            level: 'Level',
            calibrationFactor: 'Calibration Factor',
            volume: 'Volume',
            deleteHeader: 'Elimination',
            deleteMessage: 'Are you sure you want to proceed?',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            uploadHeader: 'Upload Template',
            uploadButton: 'Upload',
            toastLoadErrorMessage: 'Load failed: You have to select a tank',
            toastUploadSuccesMessage: 'The template has been successfully uploaded',
            toastDeleteSuccesMessage: 'The template has been successfully deleted',
            insulated: 'Insulated'
          },
          calculatorInsertData:{
            title: 'Data',
            date_hour: 'Misure Datetime',
            container: 'Tank',
            product: 'Product',
            outOfService: 'Out of service',
            inService: 'In service',
            loadDate: 'Load from  PI',
            normal: 'Normal',
            exhaust: 'Discharge',
            wrongFeetMessage: 'Feet position of tank {tankCode} is {feetPosition}. Are you sure you want to continue?'
          },
          calculatorTankDevelopment:{
            level: 'Level (mm)',
            title: 'Input Data',
            tempCalib:'Calib Temp (C Deg)',
            tempAmb: 'Env Temp (C Deg)',
            tempLiq: 'Liq Temp (C Deg)',
            density:'Density 15 (Kg/Lt)',
            levWater: 'Water Liv (mm)',
            footPosition: 'Feet position',
            footPositionD: 'Low',
            footPositionH: 'High',
            empy: 'Empty',
            full: 'Full',
            movementType: 'Movement typr',
            extraction: 'Extraction',
            introduction: 'Introduction',
            tempGas: 'Gas Temp (C Deg)',
            calculate: 'Calculate',
            tankDevelopment: 'Tank Development',
            tempMant: 'Shell Temp. (C Deg)',
            deltaTemp: 'Delta Temp (C Deg)',
            volLordo: 'Gross Vol (Lt)',
            volAcqua:'Water Vol (Lt)',
            coeffDilatTerm:'Term Exp Coeff',
            volLordoH2o:'Gross - Water Vol',
            volTetto:'Roof Vol (Lt)',
            volNetto:'Net Vol (Lt)',
            coeffFX54:'FX54',
            vol15:'Vol 15 (Lt)',
            coeffFX56:'FX56',
            pesoGiacenza:'Stock Weight (Kg)',
            livelloApieno:'Full level (mm)',
            volEstraib:'Extractable Volume (Lt)',
            pesoEstraib:'Weight (Kg)',
            volVapore:'Steam Vol (Lt)',
            pesoVapore:'Steam Weight (Kg)',
            export: 'Export',
            start: "Initial",
            end: 'Final',
            result: 'Results',
            gasPressure: 'Gas Pressure (Bar)',
            gasPressureKGCM2: 'Gas Pressure (kg/cm2)',
            gasTemperature: 'Gas Temperature',
            molecularWeight: 'Molecular Weight',
            PIInterface: 'PI Interface',
            LimsInterface: 'Lims Interface',
            btnLimsLoad: 'Load',
            volumeExpansionFactor: 'Vol expansion factor',
            weightCorrectionFactorBiofeed: 'Weight Corr factor',
            roofWeight: 'Roof Weight',
            vacuumWeight: 'Vac Weight  (Kg)'
          },
          calculatorDischargeDevelopment:{
            title:'Discharge Development',
            export: 'Export',

            table1: 'Initial Measurement Data',
            livelloApieno:'Full level (mm)',
            levWater: 'Water Liv (mm)',
            tempCalib:'Calib Temp (°C)',
            tempAmb: 'Env Temp (°C)',
            tempLiq: 'Liq Temp (°C)',
            
            sampleTitle: 'Sample Data',
            density:'Density 15 (Kg/Lt)',
            contAcqua: 'Water Cont (%Vol)',
            sediments: 'Sediments (%Vol)',
            contAcquaSediments: 'Water + Sediments Cont (%Vol)',
            buttonLims: 'LIMS Data',
            exhaust: 'Discharge',
            travaso: 'Transfer',
            calculate: 'Calculate',

            prevOperationTitle: 'Initial Assessment Data',
            vol15:'Vol 15 (Lt)',
            pesoGiacenza:'Stock Weight (Kg)',

            initialMeasureRecalculatedTitle: 'Initial Assessment Data Recalculated',
            coeffFX54:'FX54',
            volNetto:'Net Vol (Lt)',

            weightedAverageDensityTitle: 'Average Weight Density',
            volLordoTetto: 'Gross - Roof Vol (Lt)',
            densityMed:'Average Density (Kg/Lt)',
            coeffFX56:'FX56',
            volTetto:'Roof Vol (Lt)',

            finalLiquidMeasureTitle: 'Final Assessment Gross Data',
            tempMant: 'Shell Temp (°C)',
            deltaTemp: 'Delta Temp (°C)',
            volLordo: 'Gross Vol (Lt)',
            volAcqua:'Water Vol (Lt)',
            coeffDilatTerm:'Term Exp Coeff',
            volLordoAcqua: 'Gross - Water Vol (Lt)',
            volIntr: 'Intr Vol (Lt)',
            
            netFinalMeasureTitle: 'Final Assessment Net Data',
            SW:'S & W (%Vol)',
            coeffsSW: 'S & W Corr Coeff (%Vol)',
            SWLt:'S & W (Lt)',
            Qta: 'Intr Qty (Lt)',
            volEstraib:'Extractable Volume (Lt)',
            pesoEstraib:'Extractable Weight (Kg)',

            limsData: 'LIMS Data'
          },
          limsInterface: {
            type: 'Type',
            dischargeType: 'Discharge',
            customsType: 'Customs',
            sampleNumber: 'Sample Number',
            tank: 'Tank',
            densita15: 'Density 15',
            pesoMolecolare: 'Moleculare Weight',
            puntoPrelievo: 'Sampling Point',
            contenutoAcqua: 'Water Content',
            prodotto: 'Product',
            sedimentiPerEstrazione: 'Sediments',
            dataPrelievo: 'Sampling Date',
            contenutoAcquaSedimenti: 'Water and Sediments',
            viaggio: 'Allocation',
            gradoApi: 'Api grade',
            nave: 'Ship',
            contenutoZolfo: 'Solfur',
            analysisCode: 'Code',
            analysisDescription: 'Description',
            analysisMethod: 'Method',
            measureUnit: 'Unit of Measure',
            analysisValue: 'Value',
            sito: 'Site',
            categoria: 'Category',
            codiceProdotto: 'Product Code'
          },
          productAnalysis: {
            page_title: 'Product Analysis'
          },
          movement_instruction_roles: {
            page_title: 'Movement Instruction Roles'
          },
          movement_instruction_user_roles: {
            page_title: 'Movement Instruction User Roles'
          },
          movement_instruction_user_role_operation_types: {
            page_title: 'Movement Instruction Operation User Roles'
          },
          tankManagementTypes: {
            page_title: 'Tank Types',
            fk: 'Tank Type'
          },
          equipmentType: {
            page_title: 'Equipment Types',
            fk: 'Equipment Type'
          },
          equipment: {
            page_title: 'Equipments',
            fk: 'Equipment'
          },
          equipmentTypeProperty: {
            page_title: 'Equipment Type Properties',
            fk: 'Equipment Type Property'
          },
          equipmentProperty: {
            page_title: 'Equipment Properties'
          },
          cargoByLandEquipment: {
            page_title: 'Cargo By Land Equipment'
          },
          tankConfiguration: {
            page_title: 'Tank Configurations',
            tankCode: 'Tank Code',
            isCalculationEnabled: 'Calculation Enabled',
            densityCorrectionFactor: 'Density Correction Factor',
            isThermalExpansionEnabled: 'Thermal Expansion Enabled',
            isPromiscousCalculationEnabled: 'Promiscous Calculation Enabled'
          },
          tmProductConfiguration: {
            page_title: 'Product Configurations',
            f54Routine: 'F54 Routine',
            enabledTankTypes: 'Enabled Tank Types',
            fixedDensity: 'Fixed Density',
            volumeExpansionFactor: 'Volume Expansion Factor',
            isEthylene: 'Ethylene',
            gasType: 'Gas Type'
          },
          cargoByLandEquipment: {
            page_title: 'Cargo By Land Equipment',
            registryEquipment: 'Attrezzature',
            disableSendToInfoil: 'Invio Ad Infoil Disabilitato',
            isLPG: 'LPG',
            validityStartDate: 'Inizio Validità',
            validityEndDate: 'Fine Validità',
          },
          materialBalance: {
            page_title: 'Material Balance'
          },
          materialBalanceTemplateLot: {
            page_title: 'Recurring Lot Templates'
          },
          productStock: {
            page_title: 'Product Stock',
            stockDate: 'Stock Date',
            copyFromDate: 'Copy From Date',
            balanceSheetDate: 'Balance Sheet Date',
            origins: 'Origins',

            btn: {
              copyFrom: 'Copy From',
              importFrom: 'Import From',
            }
          },
          processingProduction: {
            page_title: 'Processing/Production Management',
            periodDate: 'Period Date',
            version: 'Version No',
            period: 'Period',
            importStatus: 'Importable',
            revision: 'Revision',
            importDate: 'Import Date',
            recordFileState: 'State',
            externalProduct: 'External Product',
            errorMessage: 'Message',
            choosePeriod: 'No Period',
            dateFrom: 'Date From',
            dateTo: 'Date To',
            totalQuantity: 'Total Quantity',
            dailyAverageQuantity: 'Daily Qty (MT)',
            totalQuantitySud: 'Total Quantity Sud',
            dailyAverageQuantitySud: 'Daily Qty Sud (MT)',
            totalQuantityNord: 'Total Quantity Nord',
            dailyAverageQuantityNord: 'Daily Qty Nord (MT)',
            lastDayQuantity: 'Last Qty (MT)',
            confirmed: 'Confirmed',
            imported: 'Imported',
            fileReferenceCode: 'File Ref. Code',
            registryPlant: 'Plant',

            btn: {
              importFrom: 'Import From',
              exclude: 'Exclude',
              include: 'Include'
            },
            revisionDescriptionValidation: 'Revisione Description Can\'\t be OBR0 when the Status is PLAN'
          },
          monthlyMaterialBalance: {
            page_title: 'Monthly Material Balance',
            lastElaborated: 'Last Elaborated',
            period: 'Period',
            profile: 'Profile',
            type: 'Type',
            phase: 'Phase',
            level: 'Level',
            elaboratedOn: 'Elaborated On',
            initialStockQty: 'Initial Stock (MT)',
            processingProductionQty: 'Processing/Production (MT)',
            inputBySeaQty: 'Input By Sea (MT)',
            inputByPipeQty: 'Input By Pipe (MT)',
            inputByLandQty: 'Input By Land (MT)',
            inputByStockTransferQty: 'Input By TS (MT)',
            outputBySeaQty: 'Output By Sea (MT)',
            outputByPipeQty: 'Output By Pipe (MT)',
            outputByLandQty: 'Output By Land (MT)',
            outputByStockTransferQty: 'Output By TS (MT)',
            internalConsumptionQty: 'Internal Consumption (MT)',
            finalStockQty: 'Final Stock (MT)',
            elaboratedFrom: 'Elaborated From',
            elaboratedTo: 'Elaborated To',
            periodFrom: 'Period From',
            periodTo: 'Period To',
            search: 'Search',
            isLastElaborated: 'Last Elaborated',
            runRefineryBalance: 'Run Refinery Balance',
            runCompanyBalance: 'Run Company Balance',
            refineryId: 'Refinery Id',
            runProgressiveBalance: 'Progressive Balance',
            publish: 'Publish',

            btn: {
              progressive: 'Progressive',
              calculateCompanies: 'Calculate Companies',
            }
          },
          lotsManagement: {
            page_title: 'Lots Management',
            idMovementInstructionLot: 'Movement Instruction Lot Id',
            balanceSheetDate: 'Balance Sheet Date',
            voyageNumber: 'Voyage No',
            lotCode: 'Lot Code',
            externalVoyageNumber: 'External Voyage No',
            registryPlant: 'Plant',
            registryProduct: 'Product',
            registryTransportType: 'Transport',
            registryCommercialOperationType: 'Trade Operation',
            chargeDischargeFlag: 'Item Type',
            isInternalConsumption: 'Internal Consumption',
            expectedQuantity: 'Expected Quantity',
            laycanStartDate: 'Laycan From',
            laycanEndDate: 'Laycan To',
            etaDate: 'ETA',
            portOrLocationOfLoading: 'Loading Port/Location',
            portOrLocationOfDischarge: 'Discharge Port/Location',
            vesselName: 'Vessel',
            registryInspector: 'Inspector',
            company: 'Company',
            counterparty: 'Counterparty',
            registryContractType: 'Contract Type',
            contractStartDate: 'Contract From',
            contractEndDate: 'Contract To',
            contractNumberReference: 'Contract No.',
            registryAccountType: 'Account Type',
            incotermCode: 'Incoterm',
            loadingStartDate: 'Loading From',
            loadingEndDate: 'Loading To',
            dischargingStartDate: 'Discharge From',
            dischargingEndDate: 'Discharge To',
            finalDate: 'Final Date',
            finalQuantity: 'Actual Quantity',
            actualQuantity: 'Quantità Effettiva',
            billOfLadingDate: 'B/L Date',
            billOfLadingQuantity: 'B/L Quantity',
            counterpartyLaycanStartDate: 'Counterparty Laycan From',
            counterpartyLaycanEndDate: 'Counterparty Laycan To',
            mooringPlatform: 'Mooring Platform',
            mooringDate: 'ETB',
            unmooringDate: 'ETS',
            note: 'Notes',
            isClosed: 'Closed',
            isDeleted: 'Canceled',
            isCreateSelfInvoice: 'Create Self Invoice',
            protocolNumberofIntentLetter: 'Protocol Number Of Intent Letter',
            importLotFromRS3: 'Import Lot From RS3',
            dateFrom: 'Date From',
            dateTo: 'Date To',
            origins: 'Origins',

            btn: {
              addLot: 'Add Lot',
              cloneLot: 'Clone Lot',
              importFrom: 'Import From',
            },
          },
          productAggregation: {
            page_title: 'Product Aggregation',
            properties: 'Properties',
            aggregations: 'Aggregations',
            parents: 'Parents',
            property: 'Property',
            value: 'Value',
            name: 'Name',
            level: 'Level',
            addPropertyToAggregation: 'Add Property To Aggregation',
            aggregation: 'Aggregation',
          },
          tankOperations: {
            page_title: 'Tank Operations',
            tabOperations: 'Operations',
            tank: 'Tank',
            tankContent: 'Content',
            mainInfo: 'General',
            btn: {
              addOperation: 'Add',
              updateOperation: 'Update',
              export: 'Export',
              showTankInfo: 'Tank Info'
            },
            operationStatus: 'Status',
            fiscalCommunicationCode: 'Comumnic',
            operationDate: 'Measure Date',
            operationType: 'Operat',
            product: 'Product',
            combinedNomenclature: 'Comb Nom',
            operationCircuit: 'Circ',
            isSender: 'Sender',
            measureType: 'Meas Type',
            movedWeight: 'Mov Qty (kg)',
            fiscalMovedWeight: 'Fiscal Mov Qty (kg)',
            stockWeight: 'Stock (kg)',
            totalAccountingStockWeight: 'Tot. Stock Weight (kg)',
            fiscalStockWeight: 'Fiscal Stock (kg)',
            totalFiscalStockWeight: 'Tot. Stock Fisc. (kg)',
            movedVolume: 'Mov Qty (lt)',
            fiscalMovedVolume: 'Fiscal Mov Qty (lt)',
            stockVolume15: 'Stock (lt)',
            totalAccountingStockVolume: 'Tot. Volume Cont. (lt)',
            fiscalStockVolume: 'Fiscal Stock (lt)',
            totalFiscalStockVolume: 'Tot. Stock Fisc. (lt)',
            averageDensity15Deg: 'Average Density 15°C',
            productLevel: 'Prod Lev',
            waterLevel: 'Water Lev',
            temperature: 'Temp',
            environmentTemperature: 'Env Temp',
            density15: 'Dens 15',
            gasPressure: 'Press (Bar)',
            molecularWeight: 'Mol Weight',
            shrinkage: 'Shrinkage',
            shrinkageGas: 'Gas Shrinkage',
            gasTemperature: 'Gas Temp',
            sulfurPercentage: '% Sulfur',
            denaturantQuantity: 'Denat Qty',
            stockVolume: 'Net Vol',
            waterVolume: 'Water Vol',
            //Volume netto
            grossVolume: 'Gross Vol',
            fX54: 'FX54',
            fX56: 'FX56',
            shellTemperature: 'Shell Temp',
            deltaTemperatura: 'Delta Temp',
            thermalExpansionFactor: 'Thermal Exp Factor',
            steamVolume: 'Steam Vol',
            steamWeight: 'Steam Weight',
            roofWeight: 'Roof Weight',
            roofVolume: 'Roof Vol',
            removableVolume: 'Rem Vol',
            removableWeight: 'Rem Weight',
            feetPosition: 'Feet Pos',
            productOwner: 'Product Owner',
            plantCode: 'Plant',
            voyageNumber: 'Voyage',
            managementType: 'Manag Type',
            introducedGrossVolume: 'Intr Gross Vol (lt)',
            introducedGrossWeight: 'Intr Gross Weight (kg)',
            sampleBarrelDensity15: 'Sample Barrel Dens (kg/lt)',
            weightedAverageDensity: 'Weighted Avg Density  (kg/lt)',
            waterAndSedimentsVolumePercentage: 'Water + Sed (%vol)',
            waterAndSedimentsCorrectionFactor: 'Water + Sed Corr Factor',
            waterAndSedimentsIntroducedVolume: 'Water + Sed Intr Vol (lt)',
            volumeExpansionFactor: 'Vol Exp Factor',
            biofeedWeightCorrectiornFactor: 'Weight Exp Factor (Biofeed)',
            emptyStockWeight: 'VAC Stock (kg)',
            automaticProductLevel: 'Prod Level PI (mm)',
            automaticTemperature: 'PI Temp(°C)',
            automaticStockWeight: 'PI Stock (kg)',
            automaticMovedWeight: 'PI Mov Qty (kg)',
            automaticStockVolume: 'PI Volume 15 (lt)',
            automaticMovedVolume: 'PI Mov Vol (lt)',
            deltaMovedQuantity: 'Delta Mov (kg)',
            deltaMovedPercentage: '% Delta Mov',
            otherTank: 'Other tank',
            measureTypeLevel: 'Level',
            measureTypeQty: 'Quantity',
            fiscalDocumentNumber: 'Fiscal Doc N',
            fiscalDocumentType: 'Fiscal Doc Type',
            general: 'General Info',
            levelData: 'Data',
            environmentTemperatureSensor: 'Sensor',
            shellVolume: 'Shell Volume',
            exportInCalculator: 'Export in calculator',
            calculationMode: 'Calculation Mode',
            importInOperation: 'Import in Operation',

            movedQuantitiesNegativeMessageForSwitchSenderReceiver : 'Moved quantities will be negative. Do you want to switch Sender / Receiver?',
            movedQuantitiesNegativeMessageForWarning: 'Moved quantities will be negative. Please check values inserted',
            
            isLayerStockAvailableMessage : 'The handled quantities will be greater than the remaining amount of the layer. Do you want to proceed with the total unloading of the layer (a quantity measurement containing the total amount of the layer will be recorded)?',
            weightCorrectionFactorBiofeed: 'WCF (Biofeed)',
            totalWeightInVac: 'Stock NSW VAC (Kg)',

            azzPDWarning: 'You can\'t import this operation type from calculator',
            checkOperationTankAlert: 'Warning! Normally this sequence of operations is not allowed. Do you want to continue anyway?',
            sequence: 'Sequence: ',
            accountingStockWeight: 'Accounting Stock Weight(Kg)',
            accountingStockWeightPercentage: '% Accounting Stock',
            accountingStockVolume: 'Accounting Stock Volume (lt)',
            accountingStockVolumePercentage: '% Accounting Volume',
            fiscalStockWeightPercentage: '% Fiscal Stock Weight',
            fiscalStockVolumePercentage: '% Fiscal Stock Volume',
            productCode: 'Product Code',
            productDescription: 'Product',
            introductionDate: 'Introduction Date',
            contentProductFamilies: 'Content Product Families',
            productDetails: 'Products Detail',
            tankContent: 'Tank Content',
            highFeetMinValue: 'High Feet Min Value',
            lowFeetMinValue: 'Low Feet Min Value',
            highFeetMaxValue: 'High Feet Max Value',
            lowFeetMaxValue: 'Low Feet Max Value',
            calibrationTemperature: 'Calibration Temperature',
            sequence: 'Sequence: ',
            msg: {
              noMeasuresFound: 'No measure found',
              multipleMeasuresFound: 'Multiple measures found',
              measureTypeNotValid: 'Measure type is not valid',
              invalidOperationGasProduct: 'Invalid Operation: product is a gas',
              deviationCheckDisabled: 'Deviation Check disabled',
              manualMeasuresNotValid: 'Manual Measures not valid',
              noPiDataFound: 'No data found from PI',
              piError: 'Pi Error',
              uomNotValid: 'Uom is not valid'
            }
          },
          tankCalculator: {
            level: 'Level',
            movement: 'Movement',
            discharge: 'Discharge',
            tank: 'Tank',
            calculator: 'Calculator',
            operation: 'Operation'
          },
          conversionFactor: {
            page_title: 'Conversion Factors',
            code: 'Code',
            density: 'Density',
            factor: 'Factor'
          },
          automaticEMailAddress: {
            page_title: 'Automatic mail addresses',
            mode: 'Mode',
            address: 'Addresses'
          },
          automaticMailingList: {
            page_title: 'Mailing Lists',
            fk: 'Mailing List',
            emailType: 'Email Type'
          },
          communication: {
            page_title: 'Communications',
          },
          operativePlan: {
            page_title: 'Operative Plan',
            tracking_page_title: 'Scheduled Operation',
            scheduled: 'Scheduled',
            eta: 'Eta',
            dailyplanning: 'Daily Planning',
            mooringsDateTo: 'Moorings up to',

            sentToDailyPlan: 'Sent',
            voyageNumber: 'Voyage Number',
            vessel: 'Vessel',
            product: 'Product',
            company: 'Owner',
            operationType: 'Operation Type',
            inspector: 'Isp.',
            tankListString: 'Tanks',
            pipilineListString: 'Pipelines',
            aspiratorsListString: 'Aspirators',
            pumpsListString: 'Pumps',
            measurersListString: 'Measurers',
            mooringPlatform: 'Plat.',
            isVesselInRoadstead: 'Roadstead',
            etaDate: 'Eta Date',
            laycanStartDate: 'Laycan from',
            laycanEndDate: 'Laycan to',
            mooringDate: 'Mooring Date',
            unmooringDate: 'Unmooring Date',
            scheduledOperationDate: 'Scheduled Operation Date',
            plant: 'Plant',
            status: 'Status',
            movementInstructionCode: 'Movement Instr Code',
            notes: 'Notes',
            minimumQuantity: 'Min Qty',
            maximumQuantity: 'Max Qty',
            draught: 'Draught',
            deadWeightTonnage: 'DWT',
            grossTonnage: 'Gross Tons',
            loadingLaytime: 'Loading Laytime',
            dischargeLaytime: 'Discharge Laytime',
            shippingAgency: 'Agency',
            isHidden: 'Hidden',
            isMovementInstructionLotDeleted: 'Lot deleted',

            selectEquipments: 'Select Equipments',
            selectTanks: 'Select Tanks',
            selectPipelines: 'Select Pipelines',
            selectAspirators: 'Select Aspirators',
            selectPumps: 'Select Pumps',
            selectMeasurers: 'Select Measurers',
            selectPlatforms: 'Select Platforms',
            isPushInLine: 'Push in Line',
            isTankReceiver: 'Receiver',
            dailyPlanDate: 'Plan Date',
            quantity: 'Quantity',
            denaturingFlag: 'Denaturing flag',
            equipmentLayout: 'Equipment',
            addMovementInstruction: 'Create Movement Instructions',
            originTank: 'Origin Tank', 
            sendMessage: 'Do you want to send current plan?',
            sendMessageSuccess: 'Current plan successfully sent',

            movements: 'Movements',
            equipments: 'Equipments',
            utifProgramCode: 'Utif Code',
            fiscalNotificationCode: 'Fiscal Notification Code',
            fiscalNotificationDate: 'Fiscal Notification Date',
            fiscalNotificationStatus: 'fiscal Notification Status',
            idFiscalNotification: 'Id Fiscal Notification',
            fiscalNotificationInfoilCode: 'Fiscal Notification Infoil Code',
            fiscalNotificationInfoilDate: 'Fiscal Notification Infoil Date',
            propagateOnAllOperations: 'Copy changes on all operations',

            alertMooringDateBeforeLaycanStart: 'Mooring date is before laycan start date. Do you want to save?',
            errorMooringDateAfterUnmooringDate: 'Mooring date can\'t be after Unmooring date',
            alertDetailsUpdateRequired: 'All fields are required!',
            alertDetailsDisplacementUpdateRequired: 'Measure Date and at least one of Moved Volume / Quantity is required',
          
            tank: 'Tank',
            operationCode: 'Tp',
            operationDateTime: 'Date Time',
            operationClass: 'Cls',
            operation: 'Op.',
            tanks: 'Tanks',
            ptf: 'Ptf',
            t: 'T',
            minQuantity: 'Q.Min',
            maxQuantity: 'Q.Max',
            aspirators: 'Aspirations',
            pipeline: 'Pipeline',
            pumps: 'Pumps',
            mis: 'Mis.',
            mooring: 'Mooring',
            shortAspirator: 'Asp.',
            firstPump: 'Pump',
            code: 'Code',
            qty: 'Qty',
            atb: 'Aut',
            atk: 'ATK',
            platform: 'Plat.',
            emittedOn: 'Emitted on ',
            at: 'at ',
            cvt: 'CVT',
            displacementTransfer: 'Displ. Transfer',
            copyInTomorrowPlanMsg: 'Do you want to copy this operation to another plan?',
            noteScheduling: 'Note Scheduling'
          },
          recurringOperationTemplate : {
            page_title: 'Recurring Operation Templates'
          },
          operationTypeClass : {
            page_title: 'Operation Type Classes',
            fk: 'Class'
          },
          dailyPlanValidation: {
            page_title: 'Daily Plan Validation',
            operationFrom: 'Operations From',
            status: 'Status',
            schedulationBtn: 'Schedulations',
            scheduledOperations: 'Scheduled Operations',
            operationDate: 'Operation Date',
            qty: 'Quantity',
            isValidated: 'Validated',

            massSelectionRequired: 'You have to select at least an operation',
            planEmpty: 'This plan is empty!',
            publishPlanSuccess: 'Plan successfully published',
            publishPlanMessage: 'Do you want to publish current plan?',
            validateAllMessage: 'Do you want to validate all plan?'
          },
          dailyPlanManagement: {
            page_title: 'Daily Plan Management',
            cantCreateOperationReceiver: 'You can\'t create an operation on the reicever tank',
            warningOperationOnReceiver: 'You want to create an operation on the receiver tank. Do you want to continue?',
            warningOperationModified: 'There are changes to the telex/tracking. Send the modified communication before saving the measurements in the tank operations.',
            warningOperationModifiedTelex: 'There are changes to the telex. Send the modified communication before saving the measurements in the tank operations.',
            warningOperationModifiedScheduled: 'There are changes to the tracking. Send the modified communication before saving the measurements in the tank operations.',
            aggregations: 'Aggregations',
            operationsAggregated: 'Aggregated',
            operationsToAggregate: 'To aggregate',
            fixedBalanceSplit: 'Fixed / Balance Split',
            measurementReportBillOfLadingWeight: 'B/L Weight',
            measurementReportBillOfLadingVolume: 'B/L Volume',
            measurementReportNotes: 'Notes',
            cannotAddOperation: 'Communication Status doesn\'t allow to add a measure for the selected tank'
          },
          biodieselMixingReport: {
            page_title: 'Biodiesel Mixing Report',
            generalData: 'General Data', 
            dataTransferPureBiodiesel: 'Transfer of FAME Data', 
            biodieselDataOutOfCount: 'FAME Out Of Count Data', 
            mixtureTransferData: 'Biodiesel Transfer Data', 
            productionVerificationData: 'Production Verification Data', 
            azzPdData: 'Fiscal Closing Data', 
            finalMixtureData: 'Final Mixture Data',
            documentNumber: 'Document Number',
            startDateValidity: 'Report Date',
            company: 'Company',
            biodieselTank: 'FAME Tank',
            mixTank: 'Biodiesel Tank',
            sendTankTrvMix: 'Transfer Sender Biodiesel Tank',
            qtyTrvPureBiodieselKg: 'FAME in count Kg',
            volTrvPureBiodieselLt: 'FAME in count Lt',
            qtyBiodieselOutOfCountKg: 'FAME out of count Kg',
            volBiodieselOutOfCountLt: 'FAME out of count Lt',
            qtyIntrTrvMixKg: 'Intr Qty Kg',
            volIntrtrvMixLt: 'Intr Vol Lt',
            percWeightSenderTrvMix: '% FAME Kg',
            percVolSenderTrvMix: '% FAME Lt',
            qtyBiodieselIntrTrvMixKg: 'Intr Qty FAME Kg',
            volBiodieselIntrTrvMixLt: 'Intr Vol FAME Lt',
            stockWeightKg: 'Diesel Kg',
            stockVolumeLt: 'Diesel Lt',
            fiscalMovedWeightAzzPdKg: 'Diesel Kg',
            fiscalMovedVolumeAzzPdLt: 'Diesel Lt',
            qtyBiodieselPrevKg: 'Prev. FAME Kg',
            volBiodieselPrevLt: 'Prev. FAME Lt',
            percQtyBiodieselPrevKg: '% FAME Kg',
            percVolBiodieselPrevLt: '% FAME Lt',
            totalBiodieselWeightKg: 'Total FAME Kg',
            totalBiodieselVolumeLt: 'Total FAME Lt',
            percTotalBiodieselWeightKg: '% FAME Kg',
            percTotalBiodieselVolumeLt: '% FAME Lt',
          },
          jetty: {
            page_title: 'Jetty'
          },
          timesheet: {
            page_title: 'Timesheet',
            eventDescription: 'Event description',
            dateFrom: 'Date from',
            dateTo: 'Date to',
            note: 'Note',
            vessel: 'Vessel',
            voyage: 'Voyage',
            masterOfVessel: 'Master of vessel',
            operations: 'Operations',
            onlyOpenedVoyage: 'Only opened voyage',
            includePrivate: 'Include privates'
          },
          timesheetOperation: {
            page_title: 'Timesheet Operations',
            sequenceNumber: 'Sequence Number',
            reportSection: 'Section',
            chargeDischargeFlag: 'Charge/Discharge',
            isPrivate: 'Private',
            isMandatory: 'Required',
            isPunctualDate: 'Punctual Date'
          },
          timesheetOperationType: {
            fk: 'Operation Type',
            page_title: 'Operation Types'
          },
          vesselProtocol: {
            page_title: 'Vessel Protocol',
            tabs: {
              'Customs Info': 'Customs Info',
              'Loading': 'Loading',
              'Discharge': 'Discharge',
              'Previsional Commercial Info': 'Previsional Commercial Info',
              'Final Commercial Info': 'Final Commercial Info',
              'Payments': 'Payments',
              'Documents': 'Documents',
              'Report': 'Report'
            },
            closed: 'Closed',
            canceled: 'Canceled',
            protocolNumber: 'Protocol Number',
            voyageNumber: 'Voyage Number',
            externalVoyageNumber: 'External Voyage Number',
            plant: 'Plant',
            incoterms: 'Incoterms',
            operationType: 'Operation Type:',
            vessel: 'Vessel',
            productDescription: 'Product',
            fiscalCommunicationNumber: 'Fiscal Communication',
            originCountry: 'Origin - Country',
            destinationCountry: 'Provenance/Destination',
            combinedNomenclature: 'NC',
            customer: 'Customer',
            inspectionCompany: 'Inspection Company',
            cargoDestination: 'Cargo Destination',
            ceeDestinations: 'CEE Destinations',
            extraCeeDestinations: 'ExtraCEE Destinations',
            assets: 'Assets',
            tanks: 'Tanks',
            pipes: 'Pipes',
            pumps: 'Pumps',
            aspirations: 'Aspirations',
            platform: 'Platform',
            measurers: 'Measurers',
            importerExporter: 'Importer/Exporter',
            fiscalDestination: 'Fiscal Destination',
            lots: 'Lots',
            lotsAggregationManagement: 'Lots Aggregation Management',
            closingReason: 'Closing Reason',
            cancellationReason: 'Cancellation Reason',
            changeStatusReason: 'Change status Reason',
            billCode: 'Bill Code',
            billDate: 'Bill Date',
            declaredQuantity: 'Declared Quantity (Kg)',
            quantity: 'Quantity',
            registerType: 'Registration',
            registerDate: 'Registration Date',
            registerNumber: 'Registration number',
            field22: 'Field 22',
            field33: 'Field 33',
            field46: 'Field 46',
            field47: 'Field 47',
            a93Number: 'A93 Number',
            a93Date: 'A93 Date',
            
            a93DateFrom: 'A93 Date From',
            a93DateTo: 'A93 Date To',
            a98DateFrom: 'A98 Date From',
            a98DateTo: 'A98 Date To',
            numberA3: 'Number A3',
            a2Number: 'A2 Number',
            a2Date: 'A2 Date',
            mrn: 'MRN',
            customsClearanceProcedure: 'Customs Clearance Procedure',
            releaseCode: 'Release Code',
            status: 'Status',
            note: 'Note',
            country: 'Country',
            countryFlag: 'Country Flag',
            customsExchangeRate: 'Customs Exchange Rate',
            noticeECustomBill: 'Notice Custom Bill Declaration',
            finalECustomBill: 'Final Custom Bill Declaration',
            valueReviewBillDeclaration: 'Value Review Bill Declaration',
            incomingGoodsManifest: 'Incoming Goods Manifest',
            extraCEEGoodsDestinations: 'Extra CEE Goods Destination',
            CEEGoodsDestinations: 'CEE Goods Destination',
            mainInformation: 'Main Information',
            information: 'Information',
            confirmOperation: 'Confirm Operation',
            changeFiscalDestination: 'Change Fiscal Destination',
            changeImporterExporter: 'Change Importer/Exporter',
            otherPanels: 'Other Panels',
            addValueReview: 'Add Value Review',
            addIncomingGoodsManifest: 'Add Incoming Goods Manifest',
            addExtraCEEGoodsDestination: 'Add Goods Destination Extra CEE',
            addCEEGoodsDestination: 'Add Goods Destination CEE',
            shoreData: 'Shore Data',
            expectedQuantity: 'Expected Quantity',
            shoreWeightBoL: 'Shore Weight B/L',
            shoreVolumeBoL: 'Shore Volume B/L',
            density: 'Product Density',
            sulfurPercentage: 'Sulphur Percentage',
            shipShoreDataComparison: 'Ship/Shore Data Comparison',
            shipLessShoreWeight: 'Ship Less Shore (Weight)',
            shipWithVEFLessShoreWeight: 'Ship With VEF Less Shore (Weight)',
            shipWithVEFLessShoreVolume: 'Ship With VEF Less Shore (Volume)',
            shipData: 'Ship Data',
            measuredOnBoardWeight: 'Ship Weight',
            measuredOnBoardVolume: 'Ship Volume',
            vef: 'Vessel Experience Factor',
            measuredOnBoardWeightKgVEFApplied: 'Ship weight with VEF',
            measuredOnBoardVolumeLtVEFApplied: 'Ship Volume GSV with VEF',
            receiverShoreDifferences: 'Receiver Shore Differences',
            receiverLessShoreWeight: 'Receiver Less Shore (Weight)',
            receiverLessShoreVolume: 'Receiver Less Shore (Volume)',
            receiverData: 'Receiver Data',
            receiverMeasuredWeightKg: 'Receiver Weight',
            receiverMeasuredVolumeLt: 'Receiver Volume',
            receiverShipDifferences: 'Receiver Ship Differences',
            receiverLessShipWithVEFWeight: 'Receiver Less Ship With VEF (Weight)',
            receiverLessShipWithVEFVolume: 'Receiver Less Ship With VEF (Volume)',
            harbourTaxes: 'Harbour Taxes',
            notes: 'Notes',
            billOfLadingData: 'Bill Of Lading Data',
            billOfLadingGrossWeightKg: 'Gross Weight',
            billOfLadingVolumeLt15: 'Gross Volume',
            billOfLadingDensity: 'Density at 15 °C',
            billOfLadingFX56: 'Corrected Density (F56)',
            billOfLadingApiGrade: 'API Gravity at 60 °F',
            refineryAscertainmentData: 'Refinery Ascertainment Data',
            finalMeasureNetWeightOfH2OKg: 'Weight (net of H2O)',
            finalMeasureNetVolumeOfH2OLt: 'Vol. (net of H2O)',
            finalMeasureWaterAndSedimentsHogsHeadPercentage: 'H2O & Sediment (Automatic Sampler)',
            finalMeasureWaterVolume: 'H2O Volume',
            finalMeasureDensityHogsHead: 'Automatic Sampler Density',
            finalMeasureSulfurPercentage: 'Sulphur',
            finalMeasureGrossWeightWithH2O: 'Gross Weight (+ H2O)',
            finalMeasureGrossVolumeWithH2O: 'Gross Volume (+ H2O)',
            shipFigureOnDeparture: 'Ship Figure On Departure',
            loadingPortVolumeWithWaterAndOBQLt15: 'TSV (GSV + free H2O)',
            loadingPortVolumeWithWaterAndOBQVEFAppliedLt15: 'TSV with VEF (GSV + free H2O)',
            loadingPortWeightWithWaterAndOBQMetricTons: 'Weight with VEF (net of H2O & OBQ)',
            volumeTrasportationPerfomance: 'Volume Trasportation Performance',
            shipsOnDepartureWithVEFLessGrossVolumeBoL: 'Ship on Departure with VEF (TSV) - B/L Gross',
            shipsOnArrivalLessShipsOnDepartureWithVEFLt: 'Ship on Arrival - Ship on Departure (TSV Figure)',
            shipOnArrivalWithVEFLessGrossVolumeBoL: 'Ship on Arrival with VEF (TSV) - B/L Gross',
            shipFigureOnArrival: 'Ship Figure on Arrival',
            weightCustomsPerformance: 'Weight Customs Performance',
            shoreNetOfH2OLessGrossWeightBoL: 'Shore (net of H2O) - B/L Gross',
            shipDischargingData: 'Ship Discharging Data',
            obqCubicMeters: 'On Board Quantity',
            dischargeWaterVolumeCubicMeters: 'Free H2O Volume',
            dischargeVolumeWithoutH2OAndOBQLt15: 'Net (of H2O) Vol at 15 °C (GSV)',
            robCubicMeters: 'Remain On Board',
            dischargeGrossVolumeVEFAppliedCubicMeters: 'Gross (+ H2O + OBQ - ROB) ship Vol fisc with VEF',
            dischargeGrossWeightVEFAppliedKg: 'Gross (+ H2O + OBQ - ROB) ship weight disc',
            volumeCommercialPerformance: 'Volume Commercial Performance',
            dischargeGrossVolumeVEFAppliedLessGrossVolumeBoL: 'Ship Figure with VEF (+ H2O + OBQ - ROB) - B/L',
            dischargingLossLT: 'Shore ( + H2O, Sed) - Ship with VEF (+ H2O + OBQ - ROB)',
            totalLossLt: 'Shore ( + H2O, Sed) - B/L (Gross)',
            lotCode: 'Lot Code',
            protocolNumber: 'Protocol Number',
            commercialValues: 'Commercial Values',
            currency: 'Currency',
            invoiceNumber: 'Invoice N°',
            documentNumber: 'N°',
            documentDate: 'Document Date',
            documentQuantity: 'Document Quantity',
            documentUnitCost: 'Document Unit Cost',
            documentTotalAmount: 'Document Total Amount',
            documentAdjustedTotalAmount: 'Document Adjusted Total Amount',
            valueTaxes: 'Value Taxes',
            intentDeclarationNumber: 'Intent Declaration Number',
            intentDeclarationDate: 'Intent Declaration Date',
            intentDeclarationTotalAmount: 'Intent Declaration Total Amount',
            commercialValuesAndTributesOnReproportionedValues: 'Commercial Values and Tributes on Reproportioned Values',
            documentReproportionedTotalAmount: 'Document Total Amount',
            rentalTotalAmount: 'Rental Total Amount',
            rentalAdjustedTotalAmount: 'Rental Adjusted Total Amount',
            insuranceTotalAmount: 'Insurance Total Amount',
            insuranceAdjustedTotalAmount: 'Insurance Adjusted Total Amount',
            otherCostsTotalAmount: 'Other Costs Total Amount',
            otherCostsAdjustedTotalAmount: 'Other Costs Adjusted Total Amount',
            statisticalValueTotalAmount: 'Statistical Value Total Amount',
            customDutiesRate: 'Custom Duties Rate',
            customDutiesTotalAmount: 'Custom Duties Total Amount',
            experimentalStationRate: 'Experimental Station Rate',
            experimentalStationTotalAmount: 'Experimental Station Total Amount',
            portTaxTotalAmount: 'Port Tax Total Amount',
            taxableVatTotalAmount: 'Taxable Vat Total Amount',
            vatTotalAmount: 'Vat Total Amount',
            taxTotalAmount: 'Tax Total Amount',
            customDutiesRateToBeGuaranteed: 'Custom Duties Rate To Be Guaranteed',
            customDutiesRToBeGuaranteedTotalAmount: 'Custom Duties To Be Guaranteed Total Amount',
            customDutiesReliquidatedTotalAmount: 'Custom Duties Reliquidated Total Amount',
            rentalReproportionedTotalAmount: 'Rental Reproportioned Total Amount',
            experimentalStationReliquidatedTotalAmount: 'Experimental Station Reliquidated Total Amount',
            insuranceReproportionedTotalAmount: 'Insurance Reproportioned Total Amount',
            taxReliquidatedTotalAmount: 'Tax Reliquidated Total Amount',
            otherCostsReproportionedTotalAmount: 'Other Costs Reproportioned Total Amount',
            taxableVatReliquidatedTotalAmount: 'Taxable Vat Reliquidated Total Amount',
            statisticalValueReproportionedTotalAmount: 'Statistical Value Reproportioned Total Amount',
            paymentType: 'Payment Type',
            isRiliquidated: 'Reliquidated',
            referenceDate: 'Reference Date',
            dueDate: 'Due Date',
            paymentDescription: 'Payment Description',
            totalAmount: 'Total Amount',
            isValueReview: 'Value Review',
            isExecuted: 'Executed',
            isDueDateModifiable: 'Due to Modify',
            isNotifiedByEmail: 'Notified By Email',
            isPeriodicPayment: 'Periodic Payment',
            isSpecialPayment: 'Special Payment',
            a93Date: 'a93 Date',
            a93Number: 'a93 Number',
            a98Date: 'a98 Date',
            a98Number: 'a98 Number',
            valueReview: 'Value Review',
            calculateValueReview: 'Calculate Value Review',
            calculateTotalTaxes: 'Calculate Total Taxes',
            calculateStatisticValue: 'Calculate Statistic Value',
            calculateValues: 'Calculate Values',
            calculateReproportionedValues: 'Calculate Reproportioned Values',
            calculateReliquidatedTaxes: 'Calculate Reliquidated Taxes',
            documentAmount: 'Document Amount',
            toBeReproportioned: 'To Be Reproportioned',
            areYouSureToReproportion: 'Are you sure to reproportion',
            addDocument: 'Add Document',
            addPayment: 'Add Payment',
            receiver: 'Receiver',
            receiverRow1: 'Receiver Row 1',
            receiverRow2: 'Receiver Row 2',
            registryDate: 'Registry Date',
            registryType: 'Registry Type',
            company: 'Company',
            companyAddress: 'Company Address',
            companyPIva: 'Company - Vat Number',
            eoriNumber: 'Company - EORI Number',
            commitment: 'Company',
            commitmentAddress: 'Company Address',
            commitmentPIva: 'Company - Vat Number',
            excisePayd: 'Excise Paid',
            definitiveExcise: 'Definitive Excise',
            definitiveInterest: 'Definitive Interest',
            exciseDifference: 'excise Difference',
            ivaPayd: 'IVA Paid',
            definitiveIva: 'Definitive IVA',
            interest: 'Interest',
            interestPayd: 'Interest Paid',
            dateFrom: 'Date From',
            dateTo: 'Date To',
            excludedArea: 'Excluded Area',
            signer: 'Signer',
            field12: 'Field 12',
            field35: 'Field 35',
            field38: 'Field 38',
            field42: 'Field 42',
            field44: 'Field 44',
            field8: 'Field 8',
            field20: 'Field 20',
            field47A00: 'Field 47-A00',
            field47B00: 'Field 47-B00',
            field479AJ: 'Field 47-9AJ',
            field2: 'Field 2',
            comunicationDate: 'Communication Date',
            comunicationPlace: 'Communication Place',
            originalDestination: 'Original Destination',
            vesselName: 'Vessel',
            cnc: 'CNC code',
            otherDocument: 'Other Documents',
            destinationsCee: 'Destinations CEE',
            taxWarehouse: 'Fiscal Deposit',
            destination: 'Destination',
            registrationBillDate: 'Registration BoL Date',
            destinationsExtraCee: 'Destinations Extra CEE',
            reExportCountry: 'Re-export Country',
            valueType: 'Value Type',
            productName: 'Product',
            originCountryProduct: 'Product Origin Country',
            countryOfOrigin: 'Provenance',
            categories: 'Categories',
            documentType: 'Document Type',
            consignorTrader: 'Consignor Trader',
            consignorTraderAddress: 'Consignor Trader Address',
            originCountryType: 'Origin Country Type',
            consigneeTrader: 'Consignee Trader',
            consigneeTraderAddress: 'Consignee Trader Address',
            ascertainedQuantity: 'Ascertained Quantity',
            uom: 'Unit of misure',
            customsOffice: 'Customs Office',
            registryNumber: 'Registry Number',
            exporterName: 'Exporter Name',
            exporterAddress: 'Exporter Address',
            placeOfCertificate: 'Place Of Certificate',
            dateOfCertificate: 'Date Of Certificate',
            territory: 'Territory',
            exportCountry: 'Export Country',
            statisticValue: 'Statistic Value',
            ceeQuantity: 'CEE Quantity',
            invoice: 'Invoice',
            typeOfCertificate: 'Type Of Certificate',
            exporterIVA: 'Exporter IVA',
            formularies: 'Formularies',
            loadingSchedule: 'Loading Schedule',
            goods: 'Goods',
            totalPackages: 'Total Packages',
            flag: 'Flag',
            ctr: 'Ctr',
            transportIdentity: 'Transport Identity',
            transportMode: 'Transport Mode',
            loadingPlace: 'Loading Place',
            summaryDeclaration: 'Summary Declaration',
            specialMentions: 'Special Mentions',
            registrant: 'Registrant',
            dateBoL: 'Date B/L',
            port: 'Port',
            declarationDate: 'Declaration Date',
            declarationPlace: 'Declaration Place',
            description: 'Description',
            protocolDate: 'Protocol Date',
            field39: 'Field 39',
            field40: 'Field 40',
            field41: 'Field 41',
            field43: 'Field 43',
            date: 'Date',
            field45: 'Field 45',
            fieldXX: 'Field XX',
            evidenceDocumentation1: 'Evidence Documentation 1',
            evidenceDocumentation2: 'Evidence Documentation 2',
            evidenceDocumentation3: 'Evidence Documentation 3',
            evidenceDocumentation4: 'Evidence Documentation 4',
            evidenceDocumentation5: 'Evidence Documentation 5',
            evidenceDocumentation6: 'Evidence Documentation 6',
            certificateNumber: 'Certificate Number',
            certificateDate: 'Certificate Date',
            authorizationNumber: 'Authorization Number',
            authorizationDate: 'Authorization Date',
            documentPlace: 'Document Place',
            originCertificateCode: 'Origin Certificate Code',
            taxCodeOrVatNumber: 'Tax Code/Vat Number',
            documentIdentify: 'Document Identify',
            authorizationValidityFrom: 'Authorization Validity (From)',
            authorizationValidityTo: 'Authorization Validity (To)',
            maxExpectedDischarges: 'Max Expected Discharges',
            documentPlace: 'Document Place',
            requester: 'Requester',
            isOriginalBillTransmission: 'Transmission original bill',
            place: 'Place',
            subject: 'Subject (vessel, allocation)',
            allocation: 'Allocation',
            bdaNumber: 'BDA Number',
            bdaDate: 'BDA Date',
            originPlace: 'Origin Place',
            transportReason: 'Transport - Reason',
            transportType: 'Transport - Type',
            transportVector: 'Vector',
            goodsDescription: 'Goods Description',
            administration: 'Administration',
            plant: 'Plant',
            paymentDuedate: 'Payment Due Date',
            rate: 'Rate',
            totalTaxAmount: 'Total Tax Amount',
            isUe: 'UE',
            customsDescription: 'Customs',
            exportReportPortualTax: 'Export Portual Tax Report',
            type: 'Type',
            category: 'Category',
            document: 'Document',
            extension: 'Extension',
            typology: 'Typology',
            dragAndDropFile: 'Drag and drop file here to upload',
            customsBillEmail: 'Customs Bill - E-mail',
            customsBillEmailInformation: 'By attaching a Customs Bill type document, a notification e-mail will be sent. \nThe document in question will be attached to the email.',
            proceedToSend: 'Proceed to send?',
            documentsToAttach: 'Documents To Attach:',
            sendLater: 'Send Later',
            sendNow: 'Send Now',
            fileName: 'File Name',
            emailStatus: 'Email Status',
            sendEmail: 'Send Email',
            resendEmail: 'Resend Email',
            emailNotSent: 'Email Not Sent',
            emailSent: 'Email Sent',
            createdBy: 'Created By',
            isValid: 'Validated',
            confirm_report52: 'By saving this Report with the Value Review option selected, the protocol will be closed. Are you sure?',
            isValueRevisionConfirm: 'By saving this Report with the Value Review option selected, the protocol will be closed and a notification email will be sent. The report in question and a list of documents that can be selected below will be attached to the email.',
            attachmentDate: 'Document Date',
            paymentsEmail: 'Deferred Periodic Payment - E-mail',
            paymentsEmailInformation: 'You can send a notification email to S.O.T. di Augusta / Ufficio delle Dogane di Siracusa. It is possible to attach a list of documents to the email which you can select below.',
            paymentDescription: 'Payment Description',
            updateVesselProtocolButton: 'Update Protocol'         
          },
          vesselProtocolGeneralReports: {
            page_title: 'Report',
          },
          vesselProtocolSearch: {
            page_title: 'Vessel Protocol Search',
            dateFrom: 'Telex Date From',
            dateTo: 'To',
            advancedSearch: 'Advanced Search',
            protocolNumber: 'Protocol Number',
            protocolDate: 'Protocol Date',
            voyageNumber: 'Voyage Number',
            externalVoyageNumber: 'External Voyage Number',
            incoterms: 'Incoterms',
            fiscalCommunicationNumber: 'Fiscal Communication Number',
            originCountry: 'Origin Country',
            destinationCountry: 'Destination Country',
            combinedNomenclature: 'Combined Nomenclature',
            customer: 'Customer',
            inspectionCompany: 'Inspection Company',
            cargoDestination: 'Cargo Destination',
            CEEDestinations: 'CEE Destinations',
            extraCEEDestinations: 'Extra CEE Destinations',
            importerExporter: 'Importer Exporter',
            direction: 'Direction',
            tanks: 'Tanks',
            pipes: 'Pipes',
            pumps: 'Pumps',
            aspirations: 'Aspirations',
            measures: 'Measures',
            platform: 'Platform',
            status: 'Status',
            statusOpened: 'Registered',
            statusClosed: 'Closed',
            statusNoProtocol: 'Not Registered',
            mrn: 'MRN',
            finalECustomBillCode: 'Final Custom Bill Code',
            finalECustomBillDate: 'Final Custom Bill Date',
            registerType: 'Register Type',
            registerDate: 'Register Date',
            noticeECustomBillCode: 'Notice Custom Bill Code',
            noticeECustomBillDate: 'Notice Custom Bill Date',
            eRegistrationCode: 'Register Number',
            statisticValue: 'Field 46',
            field22: 'Field 22',
            field33: 'Field 33',
            totalTaxAmount: 'Field 47',
            a93Number: 'A93 Number',
            releaseCode: 'Release Code',
            periodicPaymentExpiration: 'A93 Date',
            a2Number: 'A2 Number',
            a2Date: 'A2 Date',
            customInformation: 'Custom Informations Section',
            customScheme: 'Custom Scheme',
            protocolDateFrom: 'Protocol Date From',
            protocolDateTo: 'To'
          },
          fiscalNotification: {
            page_title: 'Fiscal Notification Registry',
            detail_page_title: 'Fiscal Notification',
            infoilNumber: 'Infoil No.',
            infoilDate: 'Infoil Date',
            utifProgramCode: 'UTF Code',
            notificationSendDate: 'Notification DateTime',
            notificationCode: 'Notification Code',
            notificationNumber: 'No.',
            fiscalNotificationState: 'State',
            registryOperation: 'Operation',
            idRegistryOperation: 'Operation Type',
            endOperationDate: 'End Operation DateTime',
            idRegistryProduct: 'Product',
            productDescription: 'Product',
            fiscalCircuitCode: 'Fiscal Circuit',
            nc: 'Combined Nomenclature',
            quantity: 'Qty ~ (mt)',
            shippingNotificationUser: 'Shipper',
            voyageNumber: 'Voyage No.',
            vesselName: 'Vessel',
            portOrLocationOfFiscalDestinationDescription: 'Destination Port',
            placeOfDeliveryName: 'VAT Warehouse Description',
            portOrLocationOfLoading: 'Loading Country',
            placeOfFiscalDestinationDescription: 'Destination Country',
            customAgencyDescription: 'Destination Custom\'s Agency',
            idRegistryFiscalPosition: 'Fiscal Position',
            registryFiscalPositionCode: 'Fiscal Position',
            placeOfDeliveryExciseCode: 'Destination Excise Code',
            originCountry: 'Origin Country',
            exciseDuty: 'Duty Excise',
            exciseDue: 'Due Excise',
            documentReference: 'Document No.',
            note: 'Note',
            totalFiscalMovedWeight: 'Total Weight (Kg)',
            totalFiscalMovedVolume: 'Total Volume (Lt at 15°C)',
            plant: 'Plant',
            idRegistryPlant: 'Plant',
            equipmentCode: 'Code',
            equipmentDescription: 'Description',
            equipmentType: 'Type',
            sentBy: 'Sent By',
            isMovementInstructionModified: 'There are changes at Movement Instructions level.',
            isScheduledOperationModified: 'There are changes at Scheduled Operation level.',
            tankLayoutString: 'Tanks',
            sendSuccessMessage: 'Communication successfully saved. Infoil sending in progress',
            cc: 'Finalize',
            reinsertTankErrorMessage: 'You can\'t add a tank if exixts an operation not in CC status',
            endOperationDateCheckMessage: 'End Operation Date is not in the same day of Notification Date',
            addExciseButton: 'Add Excise Fiscal Register'
          },
          fiscalNotificationDetail: {
            isIncluded: 'Included',
            tank: 'Tank',
            operationDate: 'Measurement DateTime',
            fiscalNotificationState: 'Oper. State',
            fiscalNotificationCircuit: 'Fiscal Circuit',
            isReceiver: 'S/R',
            nc: 'Combined Nomenclature',
            fiscalMovedWeight: 'Moved Qty (Kg)',
            fiscalMovedVolume: 'Moved Vol (Lt)',
            fiscalStockWeight: 'Stock Weight (Kg)',
            fiscalStockVolume: 'Stock Volume (Lt)',
            waterLevel: 'Water Level (mm)',
            productLevel: 'Product Level (mm)',
            denaturantQuantity: 'Denaturant (Kg)',
            density15: 'Density at 15° (Kg/Lt)',
            gasPressure: 'Pressure (Bar)',
            temperature: 'Temperature (°C)',
            sulfurPercentage: '% Sulphur',
            receiver: 'R',
            sender: 'S',
          },
          fiscalNotificationList: {
            isClosed: 'Is Closed',
            plant: 'Plant',
            dateFrom: 'Date from',
          },
          clearanceDocument: {
            page_title: 'Clearance document'
          },
          issueOfDocuments: {
            page_title: 'Issue of documents',
            voyage: 'Voyage',
            documentVersion: 'Document version',
            typeDescription: 'Type',
            code: 'Code',
            product: 'Product',
            productCode: 'Product code',
            owner: 'Owner',
            receiver: 'Receiver',
            lot: 'Lot',
            telexNotes: 'Telex notes',
            shipperNotes: 'Shipper notes',
            quantity: 'Quantity',
            issueDate: 'Issue date',
            warningCreateNewVersion: 'No version found! Create new one?',
            dangerRecreateDocument: 'Are you sure you want to delete and recreate document?',
            documentsWithoutNumber: 'There are documents without number, assign them before print',
            documentsWithoutNumberClose: 'There are documents without number, assign them before close',
            confirmCloseVoyage: 'Are you sure to close the voyage?',
            lotsListToPrintFascicle: 'Select lots to print fascicle',
            noVersionsFound: 'No document version found',
            signer: 'Signer',
            tanks: 'Tanks',
            blackProductsTank: 'Black Product - Select Tanks to Calculate Density',
            isPushInLine: 'Push in Line',
            
            DAA: {
              page_title: 'DAA',
              submissionType: 'Submission type',
              deferredSubmissionFlag: 'Deferred submission flag',
              arc: '(1.d) Upstream ARC',
              guarantorTypeCode: '(11.a) Guarantor type code',
              dateOfValidationeEad: '(1.e) Date And Time Of Validation',
              eaadStateDescription: 'e-AD state',
              authorizationTypeDescription: 'Authorization type',
              journeyTime: '(1.b.1) Journey time',
              journeyType: '(1.b.2) Journey type',
              transportArrangement: '(1.c) Transport arrangement',
              documentNumber: '(1.f) Sequence number',
              dateOfUpdateValidation: '(1.g) Date and time of update validation',
              consignorTraderExciseNumber: '(2.a) Excise number',
              consignorTraderName: '(2.b) Name',
              consignorTraderStreetName: '(2.c) Street name',
              consignorTraderStreetNumber: '(2.d) Street number',
              consignorTraderPostcode: '(2.e) Post code',
              consignorTraderCity: '(2.f) City',
              consignorTraderLanguage: '(2.g) Language',
              placeOfDispatchTraderReferenceOfTaxWarehouse: '(3.a) Excise number',
              placeOfDispatchTraderName: '(3.b) Name',
              placeOfDispatchTraderStreetName: '(3.c) Street name',
              placeOfDispatchTraderStreetNumber: '(3.d) Street number',
              placeOfDispatchTraderPostcode: '(3.e) Post code',
              placeOfDispatchTraderCity: '(3.f) City',
              placeOfDispatchTraderLanguage: '(3.g) Language',
              dispatchImportOfficeReferenceNumber: '(4.a) Dispatch import office reference number',
              competentAuthorityDispatchOfficeReferenceNumber: '(10.a) Competent authority dispatch office reference number',
              consigneeTraderExciseNumber: '(5.a) Excise number',
              consigneeTraderName: '(5.b) Name',
              consigneeTraderStreetName: '(5.c) Street name',
              consigneeTraderStreetNumber: '(5.d) Street number',
              consigneeTraderPostcode: '(5.e) Post code',
              consigneeTraderCity: '(5.f) City',
              consigneeTraderLanguage: '(5.g) Language',
              consigneeTraderEoriNumber: 'EORI code',
              complementConsigneeTraderMemberStateCode: '(6.a) Complement consignee trader member state code',
              complementConsigneeTraderSerialNumberOfCertificateOfExemption: '(6.b) Complement consignee trader s/n of certificate of exemption',
              deliveryPlaceTraderExciseNumber: '(7.a) Excise number',
              deliveryPlaceTraderName: '(7.b) Name',
              deliveryPlaceTraderStreetName: '(7.c) Street name',
              deliveryPlaceTraderStreetNumber: '(7.d) Street number',
              deliveryPlaceTraderPostcode: '(7.e) Post code',
              deliveryPlaceTraderCity: '(7.f) City',
              deliveryPlaceTraderLanguage: '(7.g) Language',
              deliveryPlaceCustomsOfficeReferenceNumber: '(8.a) Delivery place customs office reference number',
              eaadLocalReferenceNumber: '(9.a) Local reference number',
              eaadInvoiceNumber: '(9.b) Invoice number',
              eaadInvoiceDate: '(9.c) Invoice date',
              eaadOriginTypeCode: '(9.d) Origin type code',
              eaadDateAndTimeOfDispatch: '(9.6e+f) Date e time of dispatch',
              transportModeCode: '(13.a) Transport mode code',
              transportArrangerTraderVatNumber: '(14.a) Excise number',
              transportArrangerTraderName: '(14.b) Name',
              transportArrangerTraderStreetName: '(14.c) Street name',
              transportArrangerTraderStreetNumber: '(14.d) Street number',
              transportArrangerTraderPostcode: '(14.e) Post code',
              transportArrangerTraderCity: '(14.f) City',
              transportArrangerTraderLanguage: '(14.g) Language',
              firstTransporterTraderVatNumber: '(15.a) Excise number',
              firstTransporterName: '(15.b) Name',
              firstTransporterStreetName: '(15.c) Street name',
              firstTransporterStreetNumber: '(15.d) Street number',
              firstTransporterPostcode: '(15.e) Post code',
              firstTransporterCity: '(15.f) City',
              firstTransporterLanguage: '(15.g) Language',
              transportUnitCode: '(16.1.a) Transport unit code',
              identityOfTransportUnits: '(16.1.b) Identity of transport units',
              transportComplementaryInformation: '(16.1.f) Complementary information',
              transportComplementaryInformationLanguage: '(16.1.g) Complementary information language',
              bodyRecordUniqueReference: '(17.1.a) Body record unique reference',
              cpaproductCategory: '(17.1.b) CPA product category',
              nc: '(17.1.c) NC code',
              quantity: '(17.1.d) Quantity (Lt at 15°)',
              grossWeight: '(17.1.e) Gross weight (Kg)',
              netWeight: '(17.1.f) Net weight (Kg)', 
              density: '(17.1.o) Density',
              taricCode: 'TARIC code',
              caddCode: 'CADD code',
              kindOfPackagesTypeCode: '(17.1.1.a) Kind of packages type code',
              numberOfPackages: '(17.1.1.b) Number of packages',
              header: 'Header',
              consignorTrader: 'Consignor Trader',
              placeOfDispatch: 'Place of Dispatch',
              complementConsigneeTrader: 'Complement Consignee Trader',
              consigneeTrader: 'Consignee Trader',
              deliveryPlace: 'Delivery Place',
              firstTransporterTrader: 'First Transporter Trader',
              dispatchDetails: 'Dispatch Details',
              packages: 'Packages',
              product: 'Product',
              transportArrangerTrader: 'Transport Arranger Trader',
              transportDetails: 'Transport Details',
              sendEAD: 'Send e-AD',
              getArc: 'Get ARC',
              issueDate: 'Issue Date'
            },

            XAB: {
              documentNumber: 'Document No',
              issueDate: 'Date',
              numberOfOriginals: 'Originals No.',
              numberOfCopies: 'Copies No.',
              departurePortAndLocationDescription: '2 Departure location',
              deliveryNoteHolder: '3 Delivered to',
              destinationDescription: '4 Destination',
              shippingNote: '5 Shipment Note',
              commercialReason: '6 Commercial Reason',
              transportTypeDescription: '7 Transport Type',
              carrierDescription: '8 Carrier',
              locationOfLoadingAndIncoterm: '9 Departure port / Incoterms',
              vesselName: '10 Vessel / Transport',
              contractNumber: '11 Contract No',
              voyageNumber: '12 Shipment',
              productCode: '13 Product code',
              productDescription: '14 Product description',
              weightMtAir: '16 Weight (KG)',
              weightInMtAirCoded: '16 Coded Weight (MT AIR)',
              volumeInM3At15CDeg: '16 Cubic Meter at 15° C',
              volumeInM3At15CDegCoded: '16 Coded Cubic Meter at 15° C',
              tareWeight: '18 Tare Weight',
              grossWeight: '19 Gross Weight',
              tit: '20 TIT',
              externalVoyageNumber: 'External Voyage Number',
              nc: '21 Combined nomenclature',
              densityAt15CDeg: '22 Density',
              tankList: '23 Tanks',
              signer: 'The Shipper',
            },
            'PLZ': {
              documentNumber: 'B/L No.',
              shipper: 'Shipper',
              voyageNumber: 'Shipment No.',
              externalVoyageNumber: 'External Voyage Number',
              numberOfOriginals: 'Originals No.',
              numberOfCopies: 'Copies No.',
              placeOfIssue: 'Place of issue',
              issueDate: 'Date of issue',
              documentHolder: 'Consignee',
              notifyAddress: 'Notify address',
              vesselName: 'Vessel',
              loadingPortDescription: 'Port of loading',
              dischargePortDescription: 'Port of discharge',
              productDescription: "Shipper's description of goods",
              weightInMtAir: 'Gross weight (MT)',
              volumeInM3At15CDeg: 'Cubic meters at 15°C',
              movementInstructionNote: 'Movement Instruction note',
              shippingNote: 'Shipment Note',
              customCertificateDescription: "Custom's certificate",
              customCertificateNumber: "Custom's certificate no.",
              customCertificateDate: "Custom's certificate date",
              freightAsPer: 'Freight payable as per',
              charterPartyDated: 'Charter Party dated',
              freightAdvance: 'Freight Advance',
              accountFreight: 'Received on account of freight',
              freigthAt: 'Freight payable at',
              signer: 'The Shipper',
              masterOfVessel: 'The Master',
              quantity: 'Quantity',
              minimumQuantity: 'Minimum quantity',
              maximumQuantity: 'Maximum quantity',

              items: {
                uoMCode: 'UoM',
                uoMDescription: 'UoM',
                movementInstructionLotUoMDescription: 'Unit of measure',
                quantity: 'Quantity',
              }
            },
            'CM': {
              voyageNumber: 'Shipment No.',
              issueDate: 'Date',
              vesselName: 'Vessel',
              vesselFlag: 'Flag',
              masterOfVessel: 'Master',
              loadingPortDescription: 'Sailed from',
              dischargePortDescription: 'Bound to',
              departureDate: 'Sailed date',
              shipper: 'Shippers',
              documentHolder: 'Receivers',
              movementInstructionNote: 'Movement instruction note',
              shippingNote: 'Shipment Note',
              packageAndMarks: 'Package & Marks',
              productDescription: "Description of goods",
              numberOfOriginals: 'Originals No.',
              numberOfCopies: 'Copies No.',
              signer: 'Signer',
              quantity: 'Quantity'
            },
            'CQTA': {
              voyageNumber: 'Shipment No.',
              numberOfOriginals: 'Originals No.',
              numberOfCopies: 'Copies No.',
              issueDate: 'Date',
              productDescription: "Product Description",
              loadingPortDescription: 'Loading Port',
              vesselName: 'Tank Vessel',
              dischargePortDescription: 'Destined to',
              documentHolder: 'Consigned to',
              densityAt15CDeg: 'Density at 15° C',
              weightInMtAir: 'Amounts to Metric Tons',
              firstProductDescription: '1st Product Description',
              firstProductWeightInMt: '1st Product MT',
              secondProductDescription: '2nd Product Description',
              secondProductWeightInMt: '2nd Product MT',
              volumeInM3At15CDeg: 'Cubic meters',
              volumeInLtAt15CDeg: 'Litres at 15° C',
              observedVolumeInLt: 'Natural Litres',
              volumeInLtAt20CDeg: 'Litres at 20° C',
              movementInstructionNote: 'Movement instruction note',
              shippingNote: 'Shipment Note',
              inspectorName: 'Indipedent Inspector',
              masterOfVessel: 'The Master',
              signer: 'The Shipper',
              departureDate: 'Departure date',

              items: {
                uoMCode: 'UoM',
                uoMDescription: 'UoM',
                movementInstructionLotUoMDescription: 'Unit of measure',
                conversionFactor: 'Conversion factor',
                quantity: 'Quantity',
              }
            },
            'NP': {
              documentNumber: 'Document No',
              issueDate: 'Date',
              numberOfOriginals: 'Originals No.',
              numberOfCopies: 'Copies No.',
              departurePortAndLocationDescription: '2 Departure location',
              deliveryNoteHolder: '3 Delivered to',
              destinationDescription: '4 Destination',
              movementInstructionNote: 'Movement instruction note',
              shippingNote: 'Shipment Note',
              commercialReason: '6 Commercial Reason',
              transportTypeDescription: '7 Transport Type',
              carrierDescription: '8 Carrier',
              locationOfLoadingAndIncoterm: '9 Departure port / Incoterms',
              vesselName: '10 Vessel / Transport',
              contractNumber: '11 Contract No',
              voyageNumber: '12 Shipment',
              productCode: '13 Product code',
              productDescription: '14 Product description',
              weightMtAir: '16 Weight (MT AIR)',
              weightInMtAirCoded: '16 Coded Weight (MT AIR)',
              volumeInM3At15CDeg: '16 Cubic Meter at 15° C',
              volumeInM3At15CDegCoded: '16 Coded Cubic Meter at 15° C',
              tit: '18 TIT',
              externalVoyageNumber: 'External Voyage Number',
              nC: '19 Combined nomenclature',
              densityAt15CDeg: '20 Density',
              tankList: '21 Tanks',
              signer: 'The Shipper',
            },
            'RCD': {
              voyageNumber: 'Shipment No.',
              issueDate: 'Date',
              numberOfOriginals: 'Originals No.',
              numberOfCopies: 'Copies No.',
              vesselName: 'Vessel',
              productDescription: "Cargo",
              shipper: 'Shipper',
              documentHolder: 'Consignee',
              movementInstructionNote: 'Movement instruction note',
              shippingNote: 'Shipment Note',
              masterOfVessel: 'The Master',
              signer: 'The Shipper',
              dischargePortDescription: 'Destination'
            },
            'RCC' : {
              voyageNumber: 'Shipment No.',
              issueDate: 'Date',
              numberOfOriginals: 'Originals No.',
              numberOfCopies: 'Copies No.',
              vesselName: 'Vessel',
              productDescription: "Cargo",
              dischargePortDescription: 'Destination',
              movementInstructionNote: 'Movement instruction note',
              shippingNote: 'Shipment Note',
              masterOfVessel: 'The Master',
              signer: 'The Shipper',

              items: {
                receiverDescription: 'Tank',
                idRegistrySamplingPoint: 'Sampling Point',
                samplingPointDescription: 'Sampling Point',
                idRegistryAnalysisSampleReceiver: 'Receiver',
                sampleReceiverDescription: 'Receiver',
                numberOfSamples: 'Samples No.',
                uoMCode: 'UoM',
                uoMDescription: 'UoM',
                quantity: 'Quantity',
              }
            },
            'BEM': {
              documentNumber: 'Document No',
              issueDate: 'Date',
              numberOfOriginals: 'Originals No.',
              numberOfCopies: 'Copies No.',
              companyDescription: 'Buyer',
              voyageNumber: 'Shipment No.',
              externalVoyageNumber: 'External Voyage No',
              vesselName: 'Vessel Name',
              tankList: 'Tanks',
              confirmation: 'Commercial reason',
              contractNumber: 'Contract No',
              productCode: 'Product code',
              productDescription: "Product Description",
              weightInMtAir: 'Weight (MT AIR)',
              volumeInM3At15CDeg: 'Cubic Meter at 15°C',
              densityAt15CDeg: 'Density at 15°C',
              movementInstructionNote: 'Movement instruction note',
              shippingNote: 'Shipment Note',
              signer: 'The Shipper',
            },
            'SHT': {
              issueDate: 'Date',
              numberOfOriginals: 'Originals No.',
              numberOfCopies: 'Copies No.',
              vesselName: 'Vessel Name',
              documentHolder: 'Consigned to',
              voyageNumber: 'Allocation',
              productCode: 'Product Code',
              productDescription: "Product Description",
              dischargePortDescription: 'Destination',
              movementInstructionNote: 'Movement instruction note',
              shippingNote: 'Shipment Note',
              masterOfVessel: 'The Master',
              signer: 'The Shipper',
            },

          },
          exciseRate: {
            page_title: 'Excises',
            fk: 'Rate Description',
            exciseRate: 'Rate',
            exciseDelta: 'Delta',
            isSpecialized: 'Is Specialized'
          },
          exciseRateSpecialization: {
            page_title: 'Excise Rate Specialization',
            exciseRate: 'Rate',
            exciseDelta: 'Delta'
          },
          fixedBalanceDistribution: {
            page_title: 'Fixed / Balance Split',
            lotsToShare: 'Lots to share',
            lotsMeasures: 'Balance lot measures',
            shareResults: 'Sharing results',

            level: 'Level (mm)',
            temperature : 'Temperature (°C)',
            density: 'Density @ 15°C (Kg/Lt)',
            waterLevel: 'Water Lev (mm)',
            movedQty: 'Mov Qty (Kg)',
            stockQty: 'Stock (Kg)',
            movelVolume: 'Mov Vol (Lt)',
            stockVolume: 'Volume (Lt)',

            saveSuccess: 'Split successfully done'
          },
          code: 'Code',
          infoilCode: 'Infoil Code',
          description: 'Description',
          isDeleted: 'Deleted',
          isEnabled: 'Enabled',
          startDate: 'Start Date',
          expireDate: 'Expire Date',
          endDate: 'End Date',
          position: 'Position',
          isRefinery: 'Is Refinery',
          isIgcc: 'Is Igcc',
          owner: 'Owner',
          currencyCode: 'Currency',
          isoCode: 'Iso Code',
          isoCodeNumber: 'Iso Code Number',
          name: 'Name',
          languageCode: 'Language',
          isIssued: 'Is Issued',
          isFiscal: 'Is Fiscal',
          aliasVesselNominationAI: 'Alias Vessel Nomination AI',
          englishDescription: 'English Description',
          isInternalUse: 'Is Internal Use',
          isForTheMaster: 'Is For The Master',
          isForTheConsignee: 'Is For The Consignee',
          documentDescription: 'Document Description',
          infoilCode: 'Infoil Code',
          shortDescription: 'Short Description',
          longDescription: 'Long Description',
          isMovementInstructionSelected: 'Is Movement Instruction Selected',
          prefix: 'Prefix',
          suffix: 'Suffix',
          format: 'Format',
          year: 'Year',
          month: 'Month',
          day: 'Day',
          progressive: 'Progressive',
          details: 'Details',
          header: 'Header',
          form: 'Form',
          abbreviation: 'Abbreviation',
          italianDocumentHeader: 'Italian Document Header',
          englishDocumentHeader: 'English Document Header',
          genericDescription: 'Generic Description',
          order: 'Order',
          note: 'Note',
          unitofMeasureCode: 'UoM',
          transportDepartmentCode: 'Transport Department Code',
          transportDepartmentDescription: 'Transport Department Description',
          isGas: 'Is Gas',
          isMain: 'Is Main',
          formatQuantity: 'Format quantity',
          conversionTableCode: 'Conversion table code',
          scope: 'Scope',
          general: 'General',
          isManual: 'Is Manual',
          isVisible: 'Is Visible',
          status: 'Status',
          counterparty: 'Counterparty',
          documentNumber: 'Document Number',
          documentDate: 'Document Date',
          grossQuantity: 'Gross Qty',
          netQuantity: 'Net Qty',
          DRAFT_STATUS: 'Draft',
          validFrom: 'Valid from',
          validTo: 'Valid to',
          testMethods: 'Test methods',
          uoMCode: 'Unit of measure',
          propertyCode: 'Property code',
          value:'Value',
          key: 'Key',
          minValue: 'Min value',
          maxValue: 'Max value',
          message: 'Message',
          operationDate: 'Operation Date',
          CREATED: 'Created',
          CANCELED: 'Canceled',
          CLOSED: 'Closed',
          ONGOING: 'On going',
          version: 'Version',
          alternativeDescription: 'Alternative Description',
          isTankOperationRegistryEnabled: 'Tank Operation Registry Enabled',
          isReal: 'Real',
          IsBufferTank: 'Buffer Tank',
          validityStartDate: 'Validity Start Date',
          validityEndDate: 'Validity End Date',
          intValue: 'Int Value',
          decimalValue: 'Decimal Value',
          textValue: 'Text Value',
          from: 'From',
          to: 'To',
          showHidden: 'Show Hidden',
          all: 'All',
          departmentNote: 'Department note',
          companyDescription: 'Company',
          counterparty: 'Counterparty',
          operationTypeDescription: 'Operation type',
          plant: 'Plant',
          productDescription: 'Product',
          lastInsertDate: 'Last insert date',
          quantity: 'Quantity',
          minimumQuantity: 'Minimum quantity',
          maximumQuantity: 'Maximum quantity',
          laycanStartDate: 'Laycan from',
          laycanEndDate: 'Laycan to',
          revision: 'Revision',
          group: 'Group',
          isFip: 'FIP',
          isOnlyOneLotPermitted: 'Only a lot permitted',
          isPartialEndNotificationWithOnlyInputParams: 'Partial Measure permitted',
          reports: 'Reports',
          total: 'Total',
          generalSettings: {
            page_title: 'General Settings',
            settingsKey: 'Key',
            settingValue: 'Value',
            settingType: 'Type'
          },
          stockManagement: {
            page_title: 'Stock Management'
          },
          StockManagementFixedTankCalibration:{
            page_title: 'Fixed Tank Calibration',
            tankCode: 'Tank Code',
            kLevel: 'K Level',
            defaultDensity: 'Default density'
          },
          StockManagementIgccTank:{
            page_title: 'IGCC Tank',
            tankCode: 'Tank Code',
            plantCode: 'Plant Code'
          },
          StockManagementLockedAsset:{
            page_title: 'Locked Asset',
            referenceDate: 'Reference Date',
            assetCode: 'Asset Code'
          },
          StockManagementLockedDaily:{
            page_title: 'Record Locked Details',
            referenceDate: 'Reference Date',
            tank: 'Tank',
            type: 'Type',
            productLevel: 'Product Level',
            waterLevel: 'Water Level',
            density: 'Density',
            temperature: 'Temperature',
            pressure: 'Pressure in bar',
            weightInKg: 'Weight In Kg',
            volumeInLt: 'Volume In Lt',
            totalVolumeInCubicMeters: 'Total Volume (M3)',
            liquidWeightInTons: 'Liq Weight (MT)',
            netGasWeightInTons: 'Net Gas Weight (MT)',
            gasVolumeInCubicMeters: 'Gas Volume (M3)',
            molecularWeight: 'Molecular Weight',
            gasTemperature: 'Gas Temperature',
            waterLevelCubicMeters: 'Water Level (M3)',
            environmentTemperature: 'Env Temp',
            note: 'Note',
          },
          StockManagementMovementType:{
            page_title: 'Movement Type',
            isCalculationEnabled: 'Is Calculation Enabled'
          },
          StockManagementPipe:{
            page_title: 'Daily Pipe Stock Management'
          },
          StockManagementPipeMonthly:{
            page_title: 'Monthly Pipe Stock Management'
          },
          StockManagementTankCorrectionFactor:{
            page_title: 'Tank Correction Factor',
            tankCode: 'Tank Code',
            correctionFactor: 'Correction Factor'
          },
          stockManagementMonthly: {
            page_title: 'Monthly'
          },
          stockManagementDaily: {
            page_title: 'Daily'
          },
          StockManagementDailyPipe: {
            page_title: 'Pipe Stock Management',
            referenceDate: 'Date',
            pipeCode: 'Pipe',
            capability: 'Capability',
            movementType: 'Movement Type',
            vesselName: 'Vessel',
            density: 'Density',
            temperature: 'Temperature',
            fX54: 'FX54',
            fX56: 'FX56',
            weightInKg: 'Weight (Kg)',

            reimportMessage: 'Do you want to re-import today data?',
            reimportSuccess: 'Data successfully imported'
          },
          StockManagementDailyDeadStock: {
            page_title: 'Dead Stock',
            referenceDate: 'Date',
            assetCode: 'Asset',
            capability: 'Capability',
            movementType: 'Movement Type',
            vesselName: 'Vessel',
            temperature: 'Temperature',
            density: 'Density',
            fX54: 'FX54',
            fX56: 'FX56',
            weight: 'Weight',
            environmentTemperature: 'Environment Temperature',
            gasTemperature: 'Gas Temperature',
            level: 'Level',
            minLevel: 'Min Level',
            molecularWeight: 'Molecular Weight',
            pressure: 'Pressure (Bar)',
            realLevel: 'Real Level',
            volume: 'Volume',
            waterLevel: 'Water Level',
            reimportMessage: 'Do you want to re-import today data?',
            reimportSuccess: 'Data successfully imported'
          },
          StockManagementMonthlyTank: {
            page_title: 'Monthly Tank Stock Management',
          },
          StockManagementDailyTank: {
            page_title: 'Daily Tank Stock Management',
            referenceDate: 'Date',
            manualTab: 'Manual',
            autoTab: 'Automatic',
            manualLockTab: 'Manual+Freezed',
            lockedProductLevel: 'Freezed Lvl',
            lockedForcedProductLevel: 'Forced Freezed Lvl',
            tankcode	: 'Tank',
            movementType: 'Mov type',
            productLevel: 'Lvl (mm)',
            waterLevel: 'H20 (mm)',
            yesterdayWaterLevel: 'Yesterday H20 (mm)',
            deltaWaterLevel: 'Delta H20 (mm)',
            density: 'Dens (Kg/Lt)',
            yesterdayDensity: 'Yesterday Dens (Kg/Lt)',
            deltaDensity: 'Delta Dens (Kg/Lt)',
            temperature: 'Temp (C deg)',
            pressure: 'Press (Bar)',
            weightInKg: 'Weight (Kg)',
            volumeInLt: 'Volume (Lt)',
            movementTypeSource: '',
            idProductSource: '',
            productSource: '',
            productLevelSource: '',
            waterLevelSource: '',
            densitySource: '',
            temperatureSource: '',
            pressureSource: '',
            weightInKgSource: '',
            volumeInLtSource: '',
            totalVolumeInCubicMeters: '',
            liquidWeightInTons: '',
            netGasWeightInTons: '',
            gasVolumeInCubicMeters: '',
            molecularWeight: 'Molecular Weight',
            gasTemperature: 'Gas Temp (C deg)',
            molecularWeightSource: '',
            gasTemperatureSource: '',
            waterLevelCubicMeters: 'H20 Vol (m3)',
            environmentTemperature: 'Env Temp (°C)',
            environmentSensor: '',
            environmentTemperatureSource: '',
            spVolumeTotal: '',
            spVolMax: '',
            spVolUnextractable: '',
            spVolAvailable: '',
            spVolExtractable: '',
            spWeightTotal: '',
            spWeightMax: '',
            spWeightUnextractable: '',
            spWeightAvailable: '',
            spWeightExtractable: '',
            waterLevelFromMTS: 'H2O MTS (mm)',
            deltaWaterLevelFromMTS: 'Delta H2O MTS (mm)',
            waterLevelFromMTSource: '',
            weightMTS: 'MTS Weight (Kg)',
            deltaWeightMTS: 'Delta Weight MTS (Kg)',
            deltaVolumeMTS: 'Delta Volume MTS (Lt)',
            volumeMTS: 'MTS Volume  (Lt)',
            waterVolumeCubicMetersMTS: 'MTS H20 Vol (m3)',
            deltaWaterVolumeCubicMetersMTS: 'Delta MTS H20 Vol (m3)',
            yesterdayWaterLevelCubicMeters: 'Yesterday Vol H20 (m3)',
            deltaWaterLevelCubicMeters: 'Delta Vol H20 (m3)',
            btn: {
              loadprovenance: 'Provenance',
              calculate: 'Calculate',
              tanksExcluded: 'Excluded Tanks',
              deltaStockReport: 'Delta Report',
              reimportExternalData: 'Import from External Systems',
              export: 'Export',
              createLockedAsset: 'Re-Import Locked Tanks',
              manualLockTank: 'Lock',
              manualUnlockTank: 'Unlock',
              deltaStockEmail: 'Send delta stock report e-mail'
            },
            calculateMessage: 'Do you want to calculate tank stock management?',
            reimportMessage: 'Do you want to reimport tank stock management? You will lost all updates',
            exportMessage: 'Do you wanto to export data?',
            createLockedAssetMessage: 'Do you want to re-import the locked tanks?',
            manualLockTankMessage: 'Do you want to lock the selected tank?',
            manualUnlockTankMessage: 'Do you want to unlock the selected tank?',
            deltaStockEmailMessage: 'Do you want to send the delta stock report e-mail for the daily stock of {XXX}?',

            sludgeWeight: 'Sludge Weight',
            sludgeVolume: 'Sludge Volume',
            propagateTankLock: 'Lock tank also in the following days'
          },
          DeltaStockReportConfiguration: {
            page_title: 'Delta Stock Report Configuration'
          },
          DeltaStockReportExcludedTanksConfig: {
            page_title: 'Tanks Excluded'
          },
          DeltaStockReportProductConfig: {
            page_title: 'Product',
            category: 'Category',
            subCategory: 'Sub-Category'
          },
          FiscalDocuments: {
            page_title: 'Fiscal Documents'
          },
          TanksMovementsListA18: {
            page_title: 'Tanks Movements List (A18)',
            tankCode: "TANK",
            tankFiscalCircuitCode: "CIRC.",
            operationDate: "OPERATION DATE",
            operationTypeCode: "MOV TYPE CODE",
            operationTypeShortDesc: "MOV TYPE",
            productCode: "PROD CODE",
            otherTankCode: "2° SERB",
            otherTankFiscalCircuitCode: "2° SERB CIRC",
            movedWeight: "MOVED QTY (KG)",
            movedVolume:  "MOVED QTY (LT)",
            company: "CUSTOMER",
            xyz: "XYZ",
            fiscalPositionShortDesc: "FISCAL POS",
            fiscalDestinationShortDesc: "DEST",
            fiscalUseDesc: "USE DEST",
            measurementReportNumber: 'REPORT N°'
          },
          StockSummary: {
            page_title: 'Stock Summary',
            productDescription: "Product",
            productCode: "Product",
            initialStockWeight: "Initial Stock KG",
            initialStockVolume: "Initial Stock LT",
            introducedWeight: "Introduced KG",
            introducedVolume: "Introduced LT",
            processedWeight: "Processed KG",
            processedVolume: "Processed LT",
            fiscalStockWeight: "Final Stock KG",
            fiscalStockVolume: "Final Stock LT"
          },
          Vetting: {
            page_title: 'Vetting'
          },
          VettingSafety: {
            page_title: 'Safety',
            status: ' ',
            plant: 'Plant',
            voyageNumber: 'Voyage No',
            vessel: 'Vessel',
            imoCode: 'IMO Code',
            chargeDischarge: ' ',
            product: 'Product',
            voyageType: 'Voyage Type',
            agency: 'Agency',
            laycan: 'Laycan',
            eta: 'ETA',
            etb: 'ETB',
            mooringDate: 'Mooring',
            inspectionDate: 'Inspection Date',
            evaluation: 'Evaluation',
            ticket: 'Ticket',
            doubleMooring: 'Double Mooring',
            vesselNamed: 'Vessel named',
            invoice: 'Invoice',
            amount: 'Amount',
            note: 'Notes',
            isPreArrivalOk: 'Pre Arrival OK',
            isTanksAcceptabilityOk: 'Acceptability Of Tanks OK',
            isPreArrivalKo: 'Pre Arrival KO',
            isTanksAcceptabilityKo: 'Acceptability Of Tanks KO'
          },
          isEthylene: 'Ethylene',
          isMethanol: 'Methanol',
          isBlackProduct: 'Black Product',
          isBiofeed: 'Biofeed',
          familyDescription: 'Family Product',
          taxRate: 'Tax Rate',
          destination: 'Destination',
          equipmentSenderTankDecantingOpSwitch: {
            page_title: 'Sender Decanting for Switch'
          },
          FINAL: 'Final',
          PARTIAL: 'Partial',
          reportType: 'Report Type',
          chooseReportTypeTitle: 'Choose format',
          macroProductCode: 'Macro Product',
          StockManagementManualEditLog: {
            page_title: 'Log',
            referenceDate: 'Reference Date',
            modificationDate: 'Date',
            modificationUser: 'User',
            modificationField: 'Field',
            oldValue: 'Old value',
            newValue: 'New value'
          },
          StockManagementMts: {
            page_title: 'MTS',
            referenceDate: 'Daily Stock Of',
            measureDate: 'Measure Date',
            tankCodeMts: 'Tank Code MTS',
            tankCode: 'Tank Code',
            waterLevelMts: 'Water Level MTS',
            waterLevel: 'Water Level',
            notes: 'Notes',
            productLevelMts: 'Product Level MTS',
            recordStatus: 'Record Status',
            btn: {
              insert: 'Insert',
              export: 'Export to manual daily stock',
              update: 'Update'
            },
            message: {
              confirmReimport: 'Warning! The operation will delete all the modifications applayed to the MTS data for the day. Proceed?',
              confirmExport: 'Do you want to export the MTS values to the Manual Daily Stock?',
              referenceDateRequired: 'Daily stock reference date not valid.'
            }
          },
          Hter9: {
            page_title: 'HTER9',
            productMacroCode: "Product",
            note: " ",
            destination: " ",
            movementType: "Mov Type",
            fiscalPosition: "Fisc Pos",
            movedWeight: "Moved Weight (Kg)",
            movedVolume: "Moved Volume (Lt)",
            taxableQuantity: "Taxable Qty Kg/Lt",
            exciseRate: "Rate",
            exciseDue: "Due",
            exciseDuty: "Duty",
            liquids: 'Liquid',
            gas: 'Gas',
            today: 'Today',
            total: 'Total',
            prev: 'Previous'
          },
          AdditiveReport: {
            page_title: 'Report Additives / Denaturing',
            tankCode: 'Tank',
            operationDate: 'Date',
            additive: 'Additives',
            denaturing: 'Denaturing',
            reportType: 'Type'
          },
          VesselProtocolAlerts: {
            page_title: 'Vessel Protocol Alerts',
            alertType: 'Type',
            alertCount: 'Count',
            exportExcel: 'Export Excel Alert',
            hiddenButton: 'Hidden Alert',
            hiddenMessage: 'Do you want to hidden the alert?'
          },
          VesselProtocolDocumentSearch: {
            page_title: 'Documents Search'
          },
          VesselProtocolTributeSearch: {
            page_title: 'Tributes Search',
            arc: 'Arc',
            portualTax: 'Portual taxes',
            dateFrom: 'Expiry date from:',
            dateTo: 'Expiry date to:'
          },
          JettyUllage: {
            page_title: 'Ullage Report',
            voyageNumber: 'Voyage Number',
            from: 'From',
            to: 'To',
            registryVessel: 'Vessel',
            berthNumber: 'Berth N°',
            ullageDate: 'Date',
            draftFore: 'Draft Fore',
            draftAfter: 'Draft After',
            draftTrim: 'Trim by Stern',
            list: 'List',
            products: 'Products',
            type: 'Type',
            insertDate: 'Insert Date',
            documentDescription: 'Description',
            documentDate: 'Sent date',

            gradeName: 'Grade Name',
            density15: 'Density @ 15°C',
            density20: 'Density @ 20°C',
            tov: 'T.O.V.',
            freeWater: 'Free Water',
            averageTemperature: 'Av. Temper.',
            gov: 'G.O.V.',
            gsv: 'G.S.V.',
            sedimentsAndWater: 'S&W',
            nsv: 'N.S.V.',
            obq: 'O.B.Q.',
            vef: 'V.E.F.',
            weightInAir: 'Weight in air',
            netWeight: 'Net Weight',

            tank: 'Tank n°',
            tankSubTitle: 'N° Cisterna',
            ullage: 'Ullage',
            freeWaterInnage: 'Free Water Innage',
            freeWaterVolume: 'Free Water Volume',
            temperature: 'Temp.',
            vcf: 'V.C.F.',

            tankVolume: 'Tank\'s Volume',
            level: 'Level',
            pressure: 'Pressure',
            liquidTemperature: 'Liquid T',
            liquidShrinkageFactor: 'Liquid Shr. Fac.',
            liquidDensity: 'Liquid Density',
            liquidVolume: 'Liquid Volume',
            liquidWeight: 'Liquid Weight',
            steamTemperature: 'Vapour T',
            steamShrinkageFactor: 'Vapour Shr. Fac.',
            molecularWeight: 'P.M.',
            steamVolume: 'Vapour Volume',
            steamWeight: 'Vapour Weight',
            steamDensity: 'Vapour Density',
            quantitiesOnBoard: 'Quantities On Board',
            quantitiesOnBoardBefore: 'Quantities On Board Before Operation',
            totalCorrectedLiquidVolume: 'Total Corrected Liquid Volume',
            totalCorrectedSteamVolume: 'Total Corrected Vapour Volume',
            totalLiquidWeight: 'Total Liquid Weight', 
            totalSteamWeight: 'Total Vapour Weight',
            totalWeight: 'Total Weight',
          },
          copyProfile: 'Clone Roles',
          copyProfileMessage: 'Are you sure to import roles from selected user?',
          cloneProductSpecification: 'Clone Specifications',
          cloneProductSpecificationMessage: 'Are you sure to clone selected specifications?',
          newValidityStartDate: 'New validity start date',
          type: 'Type',
          vesselProtocolProtocolReport: 'Protocol Report',
          ProtocolReport: {
            loading: 'Loading',
            discharge: 'Discharge',
            dataProtocollo: 'Protocol Date',
            protocolNumber: 'Protocol Number',
            allocation: 'Allocation',
            shipsName: 'Ship\'s name',
            cargoName: 'Cargo name',
            origineOfTheCargo: 'Origin of the Cargo',
            comingOfTheCargo: 'Coming of the Cargo',
            shipToShip: 'Ship to Ship',
            installation: 'Installation',
            berth: 'Berth',
            shorePipeline: 'Shore Pipeline',
            shoreTank: 'Shore Tank',
            customsDeclaration: 'Customs Declaration',
            documentsNumber: 'Documents Number',
            documentsDate: 'Documents Date',
            incoterms: 'Incoterms',
            totaleFatture: 'Invoice Value',
            valoreUnitario: 'Unit price per T/M',
            dataPolizza: 'Bill of lading date',
            qtaBillOfLading: 'Bill of lading qty(KG)',
            vol15BillOfLading_A: 'Bill of lading qty(Liters at 15) -A-',
            densitaDiPolizza: "Bill of lading density",
            densitaBarilotto: "Automatic Sample Density",
            obq: "OBQ",
            rob: "ROB",
            vef: 'VEF',
            volumeBordoPartenzaLordoAcquaObq: "Ship's Departure figure (Liters at 15°)",
            volumeBordoPartenzaLordoAcquaObqVEF: 'Ship\'s Departure figure V.E.F. applied (Liters at 15°)',
            volumeBordoArrivoLordoAcquaObq: 'Ship\'s arrival figure (Liters at 15°)',
            volumeBordoArrivoLordoAcquaObqVEF: 'Ship\'s arrival figure V.E.F. applied (Liters at 15°)',
            volumeLordoSbarcatoVEFApplicato: 'Ship\'s qty discharged including water and OBQ, less R.O.B. with V.E.F. applied (Liters at 15°)',
            accertamentoSerbatoioNettoH2O: 'Shore tanks qty including water and sediments (Liters at 15°)',
            bordoArrivo_Meno_BordoPartenzaInLitri: 'Ship\'s arrival figure LESS ship\'s departure figure (Liters at 15°)',
            bordoArrivoVEF_Meno_BordoPartenzaVEFInLitri: 'Ship\'s arrival figure LESS ship\'s departure figure V.E.F. applied (Liters at 15°)',
            volumeBordoArrivoLordo_Meno_BOLLitriA15: 'Ship\'s arrival figure V.E.F. applied LESS Bill of Lading (Liters at 15°)',
            volumeLordoSbarcatoVEF_Meno_BOLInLitri: 'Ship\'s qty discharged incl. H2O and OBQ less ROB VEF appl. LESS Bill of Lading',
            accSerbatoioLordoAcqua_Meno_VolLordoSbarcatoVEFInLitri: 'Shore tanks quantity Liters at 15° LESS Ship qty disch. Incl. H2O, OBQ less ROB VEF appl.',
            accSerbatoioLordoAcqua_Meno_VBillOfLadingQuantityLiters15: 'Shore tanks quantity incl. Water and sediments LESS Bill of Lading',
            bordoArrivo_Meno_BordoPartenzaPerc: 'Loss in transit (NO VEF)',
            bordoArrivoVEF_Meno_BordoPartenzaVEFPerc: 'Loss in transit (VEF applied)',
            volumeBordoArrivoLordo_Meno_BOLLitriA15Perc: 'Loss on arrival',
            volumeLordoSbarcatoVEF_Meno_BOLPerc: 'Loss transport',
            accSerbatoioLordoAcqua_Meno_VolLordoSbarcatoVEFPerc: 'Loss vs Ship',
            accSerbatoioLordoAcqua_Meno_VBillOfLadingQuantityPerc: 'Total Loss',

            cargoDestination: 'Cargo Destination',
            finalDestination: 'Final Destination',
            inf3AtrEur1Coo: 'Inf3-Atr-Eur1-Coo',
            averageDensity: 'Average Density',
            zolfoPerc: '% Zolfo',
            billOfLadingDate: 'Bill Of Lading Date',
            billOfLadingQttyLitri: 'Bill Of Lading Qty (Lt) -A1-',
            billOfLadingQttyKg: 'Bill Of Lading Qty (KG) -A-',
            pesoBordo: 'Ship s fig. as per ullage report(Kg)',
            pesoBordoVEF: 'Ship s fig. vef applied -B-',
            qtaAccertataDepRiceventeKg: 'Quantity received at discharging port (Kg.) - C -',
            qtaAccertataDepRiceventeLitri: 'Quantity received at discharging port (Lt.) - D -',
            pesoBordoVEF_Meno_QtaAccertataBillOfLadingKg: 'Ship s fig.(vef apll.) less B/L in KG-(B - A)',
            pesoBordoVEF_Meno_QtaAccertataBillOfLadingPerc: 'Ship s fig.(vef apll.) less B/L in %- (B - A)',
            qtaAccDepRicevente_Meno_QtaAccBillOfLadingKg: 'Qtty at disch. port less B/L in KG- (C - A)',
            qtaAccDepRicevente_Meno_QtaAccBillOfLadingKgPerc: 'Qtty at disch. port less B/L in %- (C - A)',
            qtaAccDepRicevente_Meno_QtaAccBillOfLadingLitri: 'Qtty at disch. port less B/L in LT- (D - A1)',
            qtaAccDepRicevente_Meno_QtaAccBillOfLadingLitriPerc: 'Qtty at disch. port less B/L in LT- (D - A1)',

            generalInfo: 'Main Info',
            asset: 'Equipment',
            customsInfo: 'Customs Info',
            refineryAscertainmentData: 'Refinery Ascertainment Data',
            boardAscertainmentData: 'Board Ascertainment Data',
            receiverAscertainmentData: 'Receiver Ascertainment Data',
            diffKg: 'Diff KG',
            diffLt: 'Diff LT',
            diffPerc: 'Diff %',

            commercialInfo: 'Commercial Info',
            billOfLadingData: 'Bill of Lading Data',
            ascertainmentData: 'Ascertainment Data',
            volumeDiff: 'Volume diff',
            percDiff: 'Perc diff',

          },
          compulsoryStock: {
            page_title: 'Compulsory Stocks Management - Monthly',
            importTab: 'Import',
            processTab: 'Process',
            exportTab: 'Export',
            referenceDate: 'Reference Date',
            registryProduct: 'Product',
            ownerCompany: "Owner Company",
            productFamily: "Stock Product Group",
            quantity: "Quantity",
            originType: "Origin",
            deposit: "Deposit",
            isImportable: "Importable",
            warning: "Warning",
            tankCode: 'Tank Code'
          },
          dailyCompulsoryStock: {
            page_title: 'Compulsory Stocks Management - Daily',
          },
          DischargeTrackingReport: {
            page_title: 'Discharge Tracking Report',
            referenceDate: 'Reference Date (Laycan To)',
            certificateOfOriginStatus: 'Certificate of Origin',
            suppliersDeclarationStatus: 'Supplier\'s Declaration',
            exportDeclarationStatus: 'Export Declaration',
            nonManipulationDeclarationStatus: 'Non Manipulation Declaration',
            voyageReportStatus: 'Voyage Report',
            receiptOfDocumentsAndSamplesStatus: 'Receipt of Documents and Samples',
            letterOfProtestSamplesStatus: 'Letter Of Protest (Samples)',
            letterOfProtestFromMasterStatus: 'Letter Of Protest from Master',
            isOriginSamplePresent: 'Origin Sample',
            isCompleted: 'Completed',
            document: 'Document',
            documentStatus: 'Status',
            genericGridDocumentStatus: 'Discharge Tracking Status',
            upload: 'Upload',
            status: {
              Missing: 'Missing',
              ToBeValidated: 'To be validated',
              NotValid: 'Not valid',
              Valid: 'Valid',
              Present: 'Present'
            },
            changeStatusMessage: 'Do you want to confirm document status change?',
            logDate: 'Log Date',
            logEntry: 'Event',
            loadingPort: 'Loading Port',
            dischargePort: 'Discharge Port',
            infoExportDeclaration: 'Required only if origin port is Russian',
            infoNonManipulation: 'Required only if ship to ship',
            infoLetterOfProtestSamples: 'Required only if the Origin Sample is missing',
            infoSuppliersDeclaration: 'Required if the product is not a Crude'
          },
          RawMaterialCheck: {
            page_title: 'Raw Material Check',
            originSample: 'Origin Sample',
            loadingPort: 'Loading Port',
            isRecordProcessed: 'Done?',
            rawMaterial: 'Raw Material',
            grade: 'Grade',
            voyageNumber: 'Allocation',
            vesselName: 'MT',
            analysisSampleNumber: 'Sample Number',
            sample: 'BARREL',
            originSampleHeader: 'ORIGIN SAMPLE',
            loadingPortHeader: 'LOADING PORT',
            uomDensity: 'd [kg/m3]',
            uomSulphur: 'zolfo [%p]',
            differenceSampleVsOriginSample: 'BARREL vs ORIGIN',
            differenceSampleVsLoadingPortSample: 'BARREL vs LOADING PORT',
            density: 'DENSITY',
            sulphur: 'SULPHUR (ASTM D4294)',
            x: 'X',
            r: 'R',
            plus2R: '+2R',
            minus2R: '-2R',
            result: 'Result',
            ok: 'Ok',
            associateNoteQuestion: 'Do you want to set this as note?',
            referenceDate: 'Reference Date',
            oldValue: 'Old value',
            newValue: 'New value',
            color: 'Color',
            analysisValuesImportSuccess: 'Analysis values successfully imported',
            analysisValuesImportNotFound: 'Analysis values not found',

            barrelDensity: 'Barrel Density',
            barrelApiGrade: 'Barrel Api Grade',
            barrelSulphurContent: 'Barrel Sulphur percentage',

            originSampleDensity: 'Origin Sample Density',
            originSampleApiGrade: 'Origin Sample Api Grade',
            originSampleSulphurContent: 'Origin Sample Sulphur percentage',
            importSample: 'Sample Import',
            validate: 'Validate',
            validateMessage: 'Set done status',
            done: 'Done',
            undone: 'Not done',
            copyFrom: 'Copy from',
            copyNotesQuestion: 'Do you want to copy Notes?',
            deleteNoteAssociation: 'Do you want to delete note association?'
          },
          isDischargeTrackingEnabled: 'Discharge Tracking',
          isEquipmentTrackingEnabled: 'Equipment Tracking',
          planning:{
            page_title: 'Planning'
          },
          vesselSummary: {
            page_title: 'Vessel Summary',
            cluster: 'Cluster',
            product: 'Product',
            note: 'Note',
            isabCode: 'Isab Code',
            terminal: 'Terminal',
            laycanString: 'Laycan',
            provisionalQuantityString: 'Provisional Quantity',
            pricing: 'Pricing',
            premium: 'Premium',
            weekNumber: 'Week',
            year: 'Year',
            norDate: 'NOR',
            mooringDate: 'Mooring Date',
            startDate: 'Start date',
            endDate: 'End date',
            lastVersions: 'Published Version',
            changeStatusBtn: 'Change Status',
            alignActualInfo: 'Allinea Info Actual',
            operationaLaycan: 'Operational Laycan'
          },
          dealNote:{
            page_title: 'Deal Note',
            laycanStartDate: "Laycan Start Date",
            laycanEndDate: 'Laycan End Date',
            plannedLaycanStartDate: "PlannedLaycanStartDate",
            plannedLaycanEndDate: 'PlannedLaycanEndDate',
            dealDate: 'Deal Date',
            family: 'Cluster',
            product: 'Product',
            plannedProduct: 'Planned Product',
            grade: 'Grade',
            isabCode: 'IsabCode',
            terminal: 'Terminal',
            plannedTerminal: 'Planned Terminal',
            status: 'Status',
            quantity: 'Quantity Kton',
            plannedQuantity: 'PlannedQuantity',
            quality: 'Quality',
            econs: 'Econs',
            priceWindow: 'Price Window',
            premium: 'Premium',
            dfl: 'DFL',
            margin: 'Marging',
            buyerSeller: 'Buyer/Seller',
            benchmark: 'BenchMark',
            comment: 'Comment',
            load: 'Load',
            minimumQuantity: 'Minimum Quantity Kton',
            maximumQuantity: 'Maximum Quantity Kton',
            uom: 'UoM',
            plannedMinimumQuantity: 'PlannedMinimumQuantity',
            plannedMaximumQuantity: 'PlannedMaximumQuantity',
            plannedUom: 'PlannedUoM',
            marker: 'Marker',
            export: 'Export',
            legend: 'Difference With Planned Field',
            description: 'Description',
            documentDate: 'Document Date',
            createdBy: 'Uploaded by',
            fileName: 'File Name',
            documents: 'Uploaded Documents',
            warning: 'No documents found for this Deal',
            fileExtension: 'File Type',
            premiumBase: 'Premium Base',
            qualityPremium: 'Quality Premium',
            code: 'Code',
            platts: 'Platts',
            startDate: 'Date From',
            updateStatusDoneMessage: 'The status of the deal is DONE. Do you want to proceed with the change?',
            uploadDocument: 'Upload Documents',
            downloadDocument: 'Download Documents',
            exportTooltip: 'Export Excel',
            registryVessel: 'Vessel',
            voyageNumber: 'Voyage Number',
            quantityKbbl: 'Quantity Kbbl',
            log: 'Deal Note Log',
            field: 'Modified Field',
            oldValue: 'Old Value',
            newValue: 'Actual Value',
            operationDate: 'Update Date',
            logWarning: 'Deal Note Created',
            openLog: 'Open Log',
            clone: 'Clone Deal',
            exitMessage: 'Do you really want to exit? Unsaved changes can be lost.',
            username: 'Username',
            provisionalDensity: 'Provisional Density',
            contractualCoefficient: 'Contractual Coefficient',
            labelPriceWindow: 'Price Window',
            labelDatePriceWindow: 'Reference Month',
            priceWindowMessage: 'Price Window Label/ReferenceMonth is required!',
            addPriceWindow: 'New Price Window',
            updateBlocked: 'The movement is part of a closed TrueUp',

            splitMessage1: 'Voyage to be cloned was closed with: ',
            splitMessage2: ' and ',
            splitMessage3: ' with Price Window: ',
            actualQuantity1: 'Qty 1',
            actualQuantity2: 'Qty 2',
            actualVolume1: 'Vol 1',
            actualVolume2: 'Vol 2',
          },
          stocchinoPlanManagement: {
            page_title: 'Stocchino Plan Management'
          },
          stocchinoPlanMasterData: {
            page_title: 'Master data'
          },
          operativeLevels: {
            page_title: 'Operative Levels',
            lastUpdateDate: 'Last Update Date',
            referenceLevel: 'Reference Level',
            minOperativeLevel: 'Min Operative Level',
            maxOperativeLevel: 'Max Operative Level',
            conversionFactor: 'Conversion Factor',
            downloadTemplateExcel: 'Download Excel Template',
            importExcel: 'Import from Excel',
            importSudSuccess: 'South data imported successfully',
            importNordSuccess: 'North data imported successfully'
          },
          StocchinoPlanAggregationType: {
            page_title: 'Aggregation Type',
            fk: 'Aggregation Type',
            nome: 'Name',
            descrizione: 'Description',
            validityStartDate: 'Validity Start Date',
            validityEndDate: 'Validity End Date',
            versione: 'Version',
            isAggregazioneProdotti: 'Product Aggregation?'
          },
          StocchinoPlanProductAggregation: {
            page_title: 'Product Aggregation',
            codice: 'Code',
            descrizione: 'Description',
            site: 'Site',
            ordineLivello: 'Level Order',
            isFamigliaProdottoDefault : 'Default Product Family',
            isSemiFinished: 'SemiFinished',
            isRawMaterial: 'Raw Material',
            newVersion: 'New Version',
            checked: 'Associated'
          },
          StocchinoPlanFamilyAggregation: {
            page_title: 'Family Aggregations',
            codice: 'Code',
            descrizione: 'Description',
            site: 'Site',
            ordineLivello: 'Level Order',
            isFamigliaProdottoDefault : 'Default Product Family',
            isSemiFinished: 'SemiFinished',
            isRawMaterial: 'Raw Material',
            calcolaMinMaxWS: 'Calculate Min Max WS',
            invertiSegnoDeltaTargetSummary: 'Reverse Sign Delta Target'
          },
          StocchinoPlanTankExceptions: {
            page_title: 'Tank Exceptions',
            idAttr: 'Tank',
            isImportEscluso: 'Import Excluded?',
            isVolumeFromPI: 'Volume from PI?',
            isDaRielaborare: 'To Reword?',
            startDate: 'Start Date',
            endDate: 'End Date'
          },
          StocchinoPlan: {
            page_title: 'Stocchino Plan',
            automatic_title: 'Stock',
            productFamilyStorage_title: 'Product Family Storage',
            inventory_title: 'Inventory',
            minMaxWs_title: 'Min/Max Working Stock',
            dataStocchino: 'Stocchino Date',
            tank: 'Tank',
            isFuoriServizio: 'Out of Service',
            site: 'Site',
            target: 'Target',
            ownerCompanyDescription: 'Owner company',
            ownerCompanyDescriptionNotSpecified: 'Not specified',
            density: 'Density',
            productLevel: 'Product Level',
            waterLevel: 'H2O Level',
            volH2O: 'MC H2O',
            isSemiFinished: 'Semifinished',
            volExtractable: 'MC Extractable',
            volEmpty: 'MC empty',
            weightExtractable: 'Ton. Extractable',
            weightEmpty: 'Ton. empty',
            volTotal: 'MC Total',
            weightTotal: 'Ton. Total',
            product: 'Product',
            family: 'Family',
            messageOutOfServiceChangedAuto: 'The tank status was set by the automatic job. Do you want to change the status of the tank?',
            stockFamilyDescription: 'Stock',
            recalculate: 'Recalculate',
            importAndRecalculate: 'Import and Recalculate',
            importAndRecalculateMessage: 'This functionality imports the data again from the COFI Daily Stocchino. Any changes you make will be lost. Do you want to continue?',
            saveHasWarnings: 'Saved successfully. Check the warnings',
            inventory: 'Inventory',
            holdUpQty: 'Qty Hold Up',
            inventoryHoldUpQty: 'Qty Inventory Hold Up',
            target: 'Target',
            maxVolumeOfTanksQty: 'Max Volume of Tanks Qty',
            availableVolume: 'Empty Volume',
            delta: 'Delta',
            inventorySouthQty: 'South Qty',
            inventoryNorthQty: 'North Qty',
            inventoryTotalQty: 'Total Qty',
            minWSQty: 'Qty Min. Ws',
            maxWSQty: 'Qty Max. Ws',
            isabTargetQty: 'ISAB Qty',
            availableVolumeOfTanksSouthQty: 'South Qty',
            availableVolumeOfTanksNorthQty: 'North Qty',
            availableVolumeOfTanksTotalQty: 'Total Qty',
            deltaInvMinWSQty: 'INV.-mWS',
            deltaMinWSInvQty: 'mWS -INV',
            deltaIsabTargetInvQty: 'INV - ISAB target',
            summaryViewBtn: 'Extended View',
            inventoryViewBtn: 'Compact View',
            inventoryExtractable: 'Extractable Inventory',
            inventoryUnextractable: 'Unextractable Inventory',
            inventoryExtractableSouthQty: 'South Qty',
            inventoryExtractableNorthQty: 'North Qty',
            inventoryExtractableTotalQty: 'Total Qty',
            floatingStorageQty: 'Floating Storage Qty',
            inventoryHoldUpLoadBtn: 'Load Hold-up',
            totalTankStorageQty: 'Tot. Storage Qty',
            oneThirdSemifinishedProductQty: '1/3 Semifinished Product Qty',
            unextractableQty: 'Unextractable Qty',
            safetyStockIN: 'Safety Stock',
            budgetProductDailyQtyIN: 'Daily Budget Product Qty',
            daysOfProductionIN: 'Days of Production',
            safetyTonsIN: 'Safety Tons',
            holdUpQtyIN: 'Hold Up',
            productionByBudgetDailyQtyIN: 'Daily Production Qty',
            budgetTpIN: 'Budget t/p',
            minWs: 'Min WS',
            maxWs: 'Max WS',
            lukoilTargetQty: 'LUKOIL Qty',
            deltaLukoilTargetLukoilInvQty: 'Lukoil Target - Inventory in Lukoil',
            deltaMaxWSInvQty: 'MWS - INV',
            inventoryLukoilTotalQty: 'Luoil Target Inventory Qty',
            changeTabMessage: 'There are some unsaved changes. When you change tab you will lose any unsaved changes. Do you want to continue?',
            tankCompositionNotAvailable: 'The composition for the selected tank is not available.',
            tankCompositionTitle: 'Tank Composition: '
          },
          StocchinoPlanAuditMasterData: {
            page_title: 'Master Data Audit'
          },
          StocchinoPlanAuditStocchino: {
            page_title: 'Stocchino Audit'
          },
          StocchinoPlanAuditOperativeLevels: {
            page_title: 'Operative Levels Audit'
          },
          StocchinoPlanAudit:{
            page_title: 'Audit',
            entity: 'Entity',
            idRecord: 'Id Record',
            username: 'User',
            dataOperazione: 'Operation Date',
            tipoOperazione: 'Operation Type'
          },
          StocchinoPlanFamilyAssociation: {
            page_title: 'Family Association'
          },
          parent: 'Parent',
          DailyProfiles: {
            page_title: 'Daily Profiles',
            family: 'Family',
            startDate: 'Start Date',
            endDate: 'End Date',
            referenceDate: 'Day',
            southMovedQuantity: 'S',
            southMovedNote: 'S Note',
            northMovedQuantity: 'N',
            northMovedNote: 'N Note',
            stkQuantity: 'STK',
            stkActualQuantity: 'STK Actual (BMG)',
            stkRealQuantity: 'STK Real (Stocchino)',
            plannedTPQuantity: 'T/P',
            actualTPQuantity: 'T/P Actual',
            minWSQuantity: 'mWS',
            maxWSQuantity: 'MWS',
            transferQuantityS: 'Transfer S',
            transferQuantityN: 'Transfer N',
            startingStk: 'Starting Stock',
            recalculateBtn: 'Calculate',
            importBMM: 'Import from BMM',
            importBMG: 'Import from BMG',
            importTpPlanned: 'Import LP Planned',
            importStkReal: 'Import Real Stk',
            importMinMaxWs: 'Import Min Max Ws',
            month: 'Month',
            createMonth: 'Create Month',
            TD: 't/d',
            TP: 't/p',
            deltaQuantity: 'Δ',
            minMaxWs: 'Min Max WS',
            initialStockQuantity: 'IN STK',
            tpQuantity: 'TP',
            inQuantity: 'INTRO',
            forecastQuantity: 'FORECAST',
            transferQuantity: 'TUBE',
            finalStockQuantity: 'FIN STK',
            finalBMMStockQuantity: 'IN STK BMM',
            refreshSummaryMessage: 'Do you want to restore data? Any changes will be overwritten.',
            familyTransferQuantity: 'Transfer Fam',
            truckQuantity: 'Truck',
            target: 'Target',
            inventory: 'Inventory',
            familyNameRequired: 'Family is required',
            exportMinMaxWS: 'Export in Daily Profiles',
            exportMinMaxWSSuccess: 'Operation successfully done',
            holdUpQuantity: 'Hold Up',
            extractableQuantity: 'Extractable',
            airLiquideQuantity: 'Air Liquide',
            versalisQuantity: 'Versalis',
            voyagesCount: 'VOYAGE COUNT',
            voyagesQuantity: 'VOYAGE QTY',
            plannedTpQuantity: 'TP',
            finalStkQuantity: 'FIN STK',
            alignStkMessage: 'Do you want to align Stk?',
            emptyQuantity: 'Ton Empty',
            notValidated: 'Not validated',
            massiveMoveVoyages: 'Massive Move',
            dateFrom: 'Date From',
            dateTo: 'Date To',
            days: 'Days (N°)',
            moveReferenceDate: 'Move Reference Date',
            moveLaycanDates: 'Move Laycan Dates'
          },
          weeklySettlement:{
            page_title: 'Weekly Settlement',
            periodStartDate: 'Period Start Date',
            periodEndDate: 'Period End Date',
            loadTransferStock: 'Load Transfer Stock',
            voyageNumber: 'Allocation',
            quantity: 'Quantity Mt',
            code: 'Product Code',
            productName: 'Product',
            isImportable: 'Importable',
            isCreated: 'Created',
            productQuantity: 'Product/Quantity',
            load: 'Load',
            errorString: 'Error Message',
            import: 'Import',
            operationType: 'Operation Type',
            exitMessage: 'Transfer Stock already imported! Go to the next page.',
            lotManagementCheck: 'Lot Management'
          },
          trueUp:{
            page_title: 'True Up',
            settings: 'Settings',
            priceFormula: 'Price Formula',
            description: 'Description',
            shortDescription: 'Short Description',
            registryCalculationType: 'Calculation Type',
            quantityUnitOfMeasureCode: 'UoM',
            currencyCode: 'Currency',
            formula: 'Formula',
            rangeTo: 'Range To',
            rangeFrom: 'Range From',
            markerBase: 'Marker Base',
            priceFormulaHeader: 'Price Formula',
            priceFormulaDetails: 'Price Formula Details',
            deletePriceFormulaDetails: 'Delete Detail'
          },
          FamilyPoolConfiguration:{
            page_title: 'Family Pool Configuration',
            monthStartDate: 'Month Date',
            poolName: 'Pool Name',
            familyGroup: 'Family Group',
            isCrude: 'Crude',
            isProduct: 'Product',
            isTrueUpEqualsToVessel: 'True Up Equals al Vessel',
            planningPriceFormula: 'Price Formula',
            referenceDensity: 'Reference Density',
            plannedDensity: 'Planned Density',
            isDeleted: 'Deleted'
          },
          Settle:{
            page_title: 'Settle',
            load: 'Load',
            startDate: 'Date',
            isFinal: 'Final',
            planningTrueUpFamilyPoolConfiguration: 'Family Pool Configuration',
            averageSettle: 'Average Settle',
            export: 'Export',
            exitMessage: 'Are you sure to Quit?'
          },
          SettleDetails:{
            page_title: 'Settle Daily Price',
            settleDate: 'Settle Date',
            settleValue: 'Settle Value',
            deletesettleDailyPrice: 'Delete Settle Daily Price'
          },
          provisionalInvoice:{
            page_title: 'Provisional Invoice',
            initialInventoryDate: 'Initial Inventory Date',
            endingInventoryDate: 'Ending Inventory Date',
            weeklyDescription: 'Weekly',
            planningTrueUpFamilyPoolConfiguration: 'Family Pool Configuration',
            familyGroup: 'Family Group',
            familyPool: 'Family Pool',
            cubicMeters: 'Cubic Meters',
            density: 'Density',
            conversionFactor: 'Conversion Factor',
            barrels: 'Barrels',
            metricTonnes: 'Metric Tons',
            settlementBase: 'Settlement Base',
            settlementDate: 'Settlement Date',
            settle: 'Settle',
            premiumOrDiscount: 'Premium or Discount',
            price: 'Price',
            escalatedPrice: 'Escalated Price',
            invoiceAmount: 'Invoice Amount',
            trafiguraTrade: 'Trafigura Trade',
            isValid: 'Is Valid',
            dateFromForImport: 'Import Date',
            isFinal: 'Is Final'
          },
          DensityEstimation: {
            page_title: 'Density Estimation',
            page_title: 'Density Estimation - Eudora',
            referenceDate: 'Reference Date',
            voyageNumber: 'Voyage Number',
            vesselName: 'Vessel',
            weeklyStartDate: 'Weekly Start Date',
            weeklyEndDate: 'Weekly End Date',
            laycanStartDate: 'Laycan From',
            laycanEndDate: 'Laycan To',
            deal: 'Deal',
            productCode: 'Product Code',
            productPool: 'Product Pool',
            productName: 'Product Name',
            quantityMt: 'Quantity Mt',
            previsionalQuantityMt: 'Previsional QuantityMt',
            finalQuantityMt: 'Final QuantityMt',
            isFinal: 'Is Final',
            density: 'Density',
            premium: 'Premium',
            isRevised: 'Is Revised'
          },
          ProductsWeightedAverageValue: {
            monthStartDate: 'Month',
            endingInventoryDate: 'Ending Inventory Date',
            isFinal: 'Is Final',
            planningTrueUpFamilyPoolConfiguration: 'Family Pool',
            totalQuantity: 'Total Quantity',
            weightedAverageDensity: 'Average Density',
            weightedAveragePremiumOrDiscount: 'Premium or Discount'
          },
          ProductsWtdDetail:{
            transactionTypeDescription: 'Transaction Type',
            dealId: 'Deal Id',
            vesselDescription: 'Vessel Description',
            quantity: 'Quantity',
            density: 'Density',
            premiumOrDiscount: 'Premium or Discount',           
          },
          InvoicePrices: {
            page_title: 'Invoice Prices',
            settlementDate: "Settlement Date",
            isFinal: 'Is Final',
            productFamily: "Product Family",
            settlementUnits: "Settlement Units",
            consumptionProduction: "Consumption Production",
            baseQuote: "Base Quote",
            settle: 'Settle',
            premiumDiscount: 'Premium/Discount',
            price: 'Price',
            density: 'Density',
            escalatedPrice: 'Escaleted Price',
            monthStartDate: 'Month Start Date',
            endingInventoryDate: 'Ending Inventory Date',
            isFinal: 'Is Final',
            familyPool: 'Family Pool'
          },
          FeedstocksWeightedAverage:{
            page_title: 'Feedstock Wtd Tank',
            monthStartDate: 'Month Start Date',
            endingInventoryDate: 'Ending Inventory Date',
            isFinal: 'Is Final',
            planningTrueUpFamilyPoolConfiguration: 'Family Pool',
            totalQuantity: 'Total Quantity',
            weightedAveragePremiumOrDiscount: 'Premium or Discount',
            grade: 'Grade',
            vessel: 'Vessel',
            laycanFrom: 'Laycan From',
            laycanTo: 'Laycan To',
            tradeId: 'Trade Id',
            dealId: 'Deal Id',
            volume: 'Volume',
            premiumOrDiscount: 'Premium Or Discount',
            settlementDate: 'Settlement Date',
            premiumConverted: 'Show Premium Excel',
            referenceDate: 'REference Date'
          },
          FeedstocksWtdDetail:{
            dealId: 'Deal Id',
            tradeId: 'Trade Id',
            vesselDescription: 'Vessel',
            volume: 'Volume',
            density: 'Density',
            laycanFrom: 'Laycan from',
            laycanTo: 'Laycan to',
            gradeDescription: 'Grade',
            premiumOrDiscount: 'Premium or Discount',
            totalVolume: 'Total Volume',
            premium: 'Prem/Disc'
          },
          PricedQuantitiesBalance:{
            page_title: 'Priced Quantities Balance',
            monthStartDate: 'Month Start Date',
            products: 'Products',
            feedstocks: 'FeedStocks',
            M3: 'M3',
            D15: 'D15',
            MT: 'MT',
            CF: 'CF',
            BBL: 'BBL',
            description: 'Description',
            isClosed: 'TrueUp Closed',
            isOpen: 'TrueUp Open',
            open_priced_quantities_balance: 'Do you want to open the TrueUp?',
            close_priced_quantities_balance: 'Do you want to close the TrueUp?'
          },
          FinalInvoice: {
            page_title: 'Final Invoice',
            unitOfMeasureCode: 'UoM',
            currency: 'Currency',
            deltaPrices: 'Delta Prices',
            quantities: 'Priced Quantities',
            totalFinalInvoices: 'True-Up',
            trueUpPrice: 'True Up Price',
            trueUpTollingValues: 'True Up Tolling Values',
            tollingPrice: 'Tolling Price',
            tollingInvoice: 'Tolling Invoice',
            deltaAmount: 'Delta',
            total: 'Total'
          },
          pitag: {
            page_title: 'Tag OSI PI Registry',
            equipmentCode: 'Equipment Code',
            tagCode: 'Tag Code',
            tagType: 'Tag Type',
            isMain: 'Main'
          },
          DailyProfileException: {
            page_title: 'Daily Profiles Exceptions',
            externalProductCode: 'Micro-Code',
            isTruck : 'Truck',
            isVersalis: 'Versalis',
            isAirLiquide: 'Air Liquide',
            stkManagement: 'Stk Management',
            addException: 'Add Exception'
          },
          crudeConversionFactor: {
            page_title: 'Crude Conversione Factor',
            registryProduct: 'Product',
            conversionFactor: 'Conversion Factor'
          },
          periodicMovementBySeaReport: {
            page_title: 'Periodic Movement By Sea Report',
            panelHeaderDischargeName: 'Discharges',
            panelHeaderChargeName: 'Charges',
            referenceMonthDate: 'Reference Month',
            idMovementInstructionLot: 'Lot Id',
            voyageNumber: 'Voyage Number',
            vesselName: 'Vessel',
            productCode: 'Product Code',
            productDescription: 'Product',
            incoterms: 'Incoterms',
            loadingDischargePort: 'Loading Port',
            finalDate: 'Final Date',
            finalQuantityMT: 'Final Quantity (MT)',
            finalQuantityM3: 'Final Quantity (M3)',
            finalQuantityBBL: 'Final Quantity (BBLS)',
            density15: 'Density at 15°C',
            mooringPlatform: 'Mooring Platform'
          },
          dealNotePriceWindow:{
            page_title: 'Price Window',
            description: 'Description',
            priceWindowType: 'Price Window Type',
            monthDate: 'Reference Month',
            dateFrom: 'Date From',
            datetTo: 'Date To',
            priceWindowDateType: 'Reference Date',
            dayToAdd: 'Days to Add',
            isReferenceDateIncluded: 'Include Reference Date'
          },
          VesselNomination: {
            page_title: 'Vessel Nomination',
            topicDescription: 'Mail Subject',
            vesselName: 'Vessel',
            loadingDateRangeFrom: 'Laycan From',
            loadingDateRangeTo: 'Laycan To',
            inspectors: 'Inspector',
            demurrageRate: 'Demuragge',
            agents: 'Agents',
            superIntendent: 'Super Intendent',
            incoterm: 'Incoterm',
            trafiguraTradeRef: 'Trafigura Trade Ref',
            linkTopicMessage: 'Do you want to link this mail thread to selected voyage?',
            parcel: {
              consignee: 'Consignee',
              notifyAddress: 'Notify Address',
              charterPartyDated: "CP Date",
              charterPartyDatedString: "CP Date String",
              portOfLoading: 'Loading Port',
              portOfDischarge: 'Discharge Port',
              freight: 'Freight',
              marked: 'Marked',
              product: 'Product',
              quantity: 'Quantity',
              eadConsignee: 'Ead Consignee',
              eadPlaceOfDelivery: 'Ead Place Of Delivery',
              masterForHisOwnUse: 'Master for his own use',
              masterForReceivers: 'Master for receivers'
            },
            modifiedFieldListNotEmpty: 'New emails have arrived.',
            lotsCountDifferent: 'The number of lots does not match those in the emails.',
            unlinkMessage: 'Are you sure to delete thread link?',
            threads: 'Threads',
            details: 'Details'
          },
          bookOut:{
            page_title: 'Book Out',
            monthReferenceDate: 'Month Date',
            load: 'Load BookOut',
            exportTooltip: 'Export BookOut',
            vessel: 'Vessel',
            tradeRef: 'Trade Ref',
            quantity: 'Quantity',
            uom: 'UOM',
            marker: 'Marker',
            period: 'Period',
            premium: 'Prem',
            price: 'Price (USD)',
            amount: 'Amount',
            invoice: 'Invoice #',
            sentReceiver: 'Sent / Receiver',
            isabPO: 'ISAB P.O.',
            billOfLadingDate: 'B/L Date',
            weeklyOrder: 'Weekly Order',
            quote: 'Quote',
            calculate_book_out: 'Do you want to calculate Book Out?',
            isFinal: 'Final/Previsional'
          },
          EudoraInterface:{
            page_title: 'Eudora Interface'
          },
          PremiumDiscountCalculationDetails:{
            page_title: 'Premium/Discount Details - Eudora',
            discount: 'Premium/Discount'
          },
          TankTracking: {
            page_title: 'Sells Tank Tracking',
            fiscalClearanceDate: 'Fiscal Clearance Date',
            viewed: 'Viewed',
            automaticRefresh: 'Automatic Refresh',
            vesselCommunicationPreventive: 'Vessel in Preventive State',
            referenceDate: "Reference Date",
            displacements: 'Displacements',
            stock: 'Stock',
            available: 'Available',
            notAvailable: 'Running Operation'
          },
          EquipmentTrackingAudit: {
            page_title: 'Log Sells Tank Tracking',
            idRecord: 'Record Id'
          },
          denaturantBulkCapacity: {
            page_title: 'Denaturant Bulk Capacity',
            capacity: 'Capacity'
          },
          denaturantBulkRegistry: {
            page_title: 'Denaturant Bulk Registry',
            referenceDate: 'Reference Date',
            registryProduct: 'Product',
            rechargeButton: 'Recharge Bulk',
            importButton: 'Import Truck Loading',
            operationDate: 'Operation Date',
            operationType: 'Operation',
            operationTypeRecharge: 'Recharge',
            operationTypeExtraction: 'Extraction',
            movedQuantity: 'Moved Quantity (Kg)',
            stockQuantity: 'Stock (Kg)',
            insertButton: 'Insert Extraction Operation',
            updateButton: 'Update',
            deleteButton: 'Delete',
            forceInsertInThePast: 'You are inserting an operation <b>in the past</b>. <br/>The stock quantity of all subsequent operations will be updated until the next recharge operation. <br/> Do you want to continue?',
            forceImport: 'Force Import',
            forceImportTooltip: 'By forcing the import, any extraction operations already inserted will be deleted.',
            selectPlantErrorMessage: 'Select the plant',
            selectProductErrorMessage: 'Select the product',
            rechargeInsertMessage: 'Do you want to charge Bulk?',
            thresholdSettings: {
              gridName: 'Bulk Emptying Threshold',
              DenaturantBulkRunningLowThreshold: 'Bulk Running Low Threshold (%)',
              DenaturantBulkEmptyThreshold: 'Bulk Empty Threshold (%)',
              valueNotValid: 'Threshold value not valid. Insert an integer value between 0 and 100.'
            }
          },
          TimeSpanConfiguration: {
            page_title: 'Time Span Configuration'
          },
          StockAdjustment:{
            page_title: 'DeadStock Adjustment',
            initialStockDate: 'Initial Stock Date',
            date: 'Final Stock Date',
            tankCode: 'Tank Code',
            productCode: 'Product Code',
            poolName: 'Family Pool',
            adjustmentType: 'Adjustment Type',
            dischargeOrCharge: 'Discharge/Charge',
            description: 'Description',
            cubicMeters: 'Cubic Meters',
            density: 'Density',
            conversionFactor: 'Conversion Factor',
            barrels: 'Barrels',
            metricTonnes: 'Metric Tons',
            monthStartDate: 'Month Start Date',
            required: 'is required!',
            field: 'The field',
            importDeadstock: 'Import Deadstock',
            sendToLotManagement: 'Insert PB Lot',
            voyageNumber: 'Voyage Number',
            referenceDate: 'Cofi Reference Date'
          },
          AdjustmentType:{
            page_title: 'Adjustment Type',
            description: 'Description',
            id: 'Id'
          },
          TmTankVolumetricData: {
            page_title: 'Volumetric Data',
            fk: 'Tank Code',
            grossShellCapacity: 'Gross Shell Capacity',
            maxOperatingCapacity: 'Max Operating Capacity',
            workingVolume: 'Working Volume',
            deadStockVolume: 'DeadStock Volume',
            downloadTemplate: 'Download Empty Template',
            importTemplate: 'Import From Excel'
          },
          ExciseFiscalRegister:{
            page_title: 'Excise Fiscal Register',
            notificationCode: 'Notification Code',
            notificationDate: 'Notification Date',
            notificationDateFrom: 'Notification Date From',
            plantDescription: 'Plant',
            operationTypeDescription: 'Operation Description',
            tankCode: 'Tank Code',
            idRegistryProduct: 'Product',
            productCode: 'Product Code',
            productDescription: 'Product Description',
            productFamily: 'Product Family',
            isGas: 'Gas',
            nc: 'NC',
            fiscalMovedWeight: 'Moved Weight',
            fiscalMovedVolume: 'Moved Volume',
            denaturantQuantity: 'Denaturant Quantity',
            denaturantVolume: 'Denaturant Volume',
            fiscalStockWeight: 'Stock Weight (Kg)',
            fiscalStockVolume: 'Stock Volume (Lt)',
            placeOfDeliveryName: 'Place Of Delivery',
            fiscalDestination: 'Fiscal Destination',
            fiscalPosition: 'Fiscal Position',
            fiscalUse: 'Fiscal Use',
            fiscalDocumentNumber: 'Fiscal Document Number',
            exciseDuty: 'Excise Duty',
            exciseDue: 'Excise Due',
            exciseDutySuspended: 'Excise Duty Suspended',
            taxableQuantity: 'Taxable Quantity',
            exciseRate: 'Excise Rate',
            portOrLocation: 'Port Or Location',
            infoilCvtOperationKey: 'InfoilCvtOperationKey',
            calculator: 'Calculator',
            localExciseDue: 'Local Excise Due',
            exciseDelta: 'Excise Delta',
            documentType: 'Document Type',
            documentTypeLanguage: 'Document Language',
            notificationDateTo: 'Notification Date To'
          },
          DeductionDefault:{
            page_title: 'Deduction Default',
            DeductionDescription: 'Description',
            timesheetOperationStartDate:'Start Date',
            timesheetOperationEndDate: 'End Date',
          },
          DemurrageCalculator:{
            page_title: 'Calculator',
            voyage: 'Voyages',
            onlyOpenedVoyage: 'Only voyages opened',
            vessel: 'Vessel',
            product: 'Product',
            loadport: 'Loadport',
            disport: 'Disport',
            nor: 'NOR',
            hosesDisconnection: 'Hoses Disconnection',
            documentOnBoard: 'Document on Board',
            contract: 'Contract',
            grossLayout: 'GROSS LAYOUT',
            laytimeCommenced: 'Laytime commenced',
            laytimeCompleted: 'Laytime completed',
            grossLaytime: 'Gross Laytime',
            demurrageRate: 'Demurrage Rate',
            proratedAllowedLaytime: 'Prorated Allowed Laytime',
            layday: 'Layday ISAB',
            deductions: 'DEDUCTIONS',
            reasons: 'Reasons',
            extendedReasonDescription: 'Extended Reason',
            from: 'From',
            to: 'To',
            share: 'Share',
            totalHoursMins: 'Total Hrs Mins',
            totalHours: 'Total Hrs',
            deliveryDocuments : 'DELIVERY OF DOCUMENTS',
            totalNetUsedTimeMins: 'Total net used Time (HRS MINS)',
            totalNetUsedTime: 'Total net used Time (HRS)',
            timeOnDemurrageMins: 'Time on Demurrage (HRS MINS)',
            timeOnDemurrage: 'Time on Demurrage (HRS)',
            totalHrs: 'Total (HRS)',
            total: 'Total',
            totalMins: 'Total (HRS MINS)',
            name: 'Name',
            deduction: 'Deduction',
            description: 'Description',
            sumAndDifference: 'Sum / Difference',
            origin: 'Origin',
            entryStart: 'Start entry',
            entryEnd: 'End entry',
            startDate: 'Start date',
            endDate: 'End date',
            value: 'Value (Hrs Mins)',
            titleDialogCalculator: 'Calculate Deduction',
            sign: 'Sign',
            sum: 'Sum',
            difference: 'Difference',
            timesheet: 'Timesheet',
            fixedValue: 'Fixed value',
            regenerateTitleDialog: 'Regenerate demurrage for the selected voyage - ',
            btn: {
              regenerate: "Regenerate",
              sendMail: "Send Mail",
              simpleDeduction: "Add simple deduction",
              composedDeduction: "Add composed deduction",
              reason: 'Add reason',
              internal: 'Download Internals',
              notInternal: 'Download Externals',

            },
            messages: {
              error_valid_date: 'Start date cannot be greater than end date',
              createCalculator: 'Do you want to create a new demurrage for the selected voyage?',
              error_valid_deduction: 'Please complete all fields',
              regenerateCalculator: 'Following regeneration, all data will be reloaded. Do you want to keep the manual deductions you have entered?',
              send_mail_message: 'Do you want to send the e-mail? You can enter notes that will be added to the e-mail:',
              noCalculatorCreated: 'Calculator has not been created yet',
              error_valid_hrs_minutes: 'Enter a valid time (e.g. 12:30)',
              error_valid_reason_hrs: 'You cannot enter a reason with total hours equal to 0',
            },
            note: 'Notes',
            totalDeduction: 'Total Deduction (HRS)',
            totalDeductionMins: 'Total Deduction (HRS MINS)',            
            totalNetLaytime: 'Total Net Laytime (HRS)',
            totalNetLaytimeMins: 'Total Net Laytime (HRS MINS)',
            from: 'From', 
            to: 'To',
            yearToExchange: 'Select the month',
            titleDialogExchange: 'Exchange currency',
            rate: 'Rate',
            titleDialogMail: 'Send Mail',
            demurrageReason: 'DEMURRAGE REASON',
            totalDemurrage: 'Total Demurrage',
            internalNote: 'Internal notes',
            demurrageDeltaHrsMins: 'Delta (HRS MINS)',
            demurrageDeltaHrs: 'Delta (HRS)',
            demurrageDeltaTotal: 'Delta',
            demurrageReasonHrsMins: 'Total Demurrage Reason (HRS MINS)',
            demurrageReasonHrs: 'Total Demurrage Reason (HRS)',
            demurrageReasonTotal: 'Total Demurrage Reason',
            reproportionateReasonsMessage: 'Do you want to reproportionate reasons values?',
            reproportionateBtn: 'Reproportionate'
          },
          DemurrageRegister:{
            demurrage_page_title: 'Demurrage',
            page_title: 'Register',
            month: 'Month',
            plant: 'ISAB North/South',
            dischargeLifting: 'Discharge/Lifting',
            discharge: 'D',
            lifting: 'L',
            vesselName: 'Vessel Name',
            allocation: 'Allocation',
            product: 'Product',
            demurrageRate: 'Demurrage Rate',
            timeOnDemurrage: 'Time on Demurrage (Hrs)',
            timeOnDemurrageNetOftimeExpired: 'Time on Demurrage (Hrs) net of time expired',
            totalUsd: 'Total',
            note: 'Note',
            extendedNote: 'Extended Note',
            netOfTimeEXpired: 'Total net of time expired',
            counterpartyRequest: 'Counterparty request',
            delta: 'Delta',
            agreedNotAgreed: 'Agreed/Not agreed',
            dateOrder: 'Date Order',
            dateInvoiceCounterparty: 'Counterparty invoice date of receipt',
            agreedValue: 'Agreed value',
            pendingValue: 'Not agreed. Pending value',
            poteintialClaim: 'Potential claim to be received',
            lastEstimedDateOfBLOrCOD: 'Last estimated date of B/L',
            availableTimeForClaimPresentation: 'Available time for claim presentation BL + 95',
            planningStrategy: 'Planning Strategy',
            btn: {
              detail: "Detail",
              preview: "Preview",
            },
            messages: {
              error_valid: 'Validation error, fill in data correctly',
              error_entry_month: 'Enter the month to display',
              error_entry_year: 'Enter the year to export',
            },
            titleDialogPreview : 'Preview deductions',
            titleDialogExcel: 'Export',
            yearToExport: 'Select year',
            valued: 'Valued',
            empty: 'Empty',
            all: 'All',
            originalValue: 'Original value: ',
          },
          SchedulingAttachments: {
            messages: {
              open_documents_messages: 'Do you want to open the folder?',
              close_documents_messages: 'Do you want to close the folder?',
              send_notification_messages: 'Do you want to send notification?',
              send_notification_success: 'Communication sent successfully',
            },
            closedDocuments: 'CLOSED FOLDER',
            openDocuments: 'Open Folder',
            closeDocuments: 'Close Folder',
            sendNotification: 'Send Notification',
            downloadDocuments: 'Download all documents'
          },
          TmTankType: {
            volumeCalculationRoutine: 'Volume Calculation Routine'
          },
          StockManagementInventory: {
            page_title: 'Inventory',
            referenceDate: 'Reference Date',
            liquid: 'Liquid',
            gas: 'Gas',
            measureDate: 'Measure Date',
            tankCode: "Tank",
            isOutOfService: "Out Of Service",
            isHidden: "Hidden",
            registryProduct: 'Product',
            productLevelManual: "Manual Measurement (mm)",
            productLevelAuto: "Authomatic Measurement (mm)",
            productLevelDailyStock: "Daily Stock Value (mm)",
            productLevelManualVsAutoDelta: "Differences (mm)",
            density: "Density (kg/l)",
            densityDailyStock: "Density Daily Stock (kg/l)",
            temperatureManual: "Manual Temperature (°C)",
            temperatureAuto: "Automatic Temperature (°C)",
            temperatureAutoGasGrid: "Temperature °C (liquid)",
            temperatureDailyStock: "Daily Stock Temperature (°C)",
            temperatureManualVsAutoDelta: "Differeces (°C)",
            waterLevel: "H2O (mm)",
            waterLevelDailyStock: "H2O Daily Stock (mm)",
            sludgeLevel: "Sludge",
            gasTemperature: "Temperature °C (gas)",
            gasTemperatureDailyStock: "Temperature °C Daily Stock (gas)",
            pressure: "Pressure (bar)",
            pressureDailyStock: "Pressure Daily Stock (bar)",
            molecularWeight: "Molecular Weight",
            molecularWeightDailyStock: "Molecular Weight",
            weightInKg: "Weight (kg)",
            weightInKgDailyStock: "Weight Daily Stock (kg)",
            volumeInLt: "Volume (lt)",
            volumeInLtDailyStock: "Volume Daily Stock (lt)",
            waterVolumeInLt: "Water Volume (lt)",
            waterVolumeInLtDailyStock: "Water Volume Daily Stock (lt)",
            theoreticalVolumeInLt: "Theoretical Volume (lt)",
            technicalVolumeInLt: "Technical Volume (lt)",
            lastChangedBy: "Person In Charge",
            audit: "KPMG",
            schedulingNotes: "Notes (SCHEDULING)",
            notes: "Notes",
            isValidated: "Validated",
            status: "Status",
            version: "version",
            elaborationStartedAt: "Elaboration Started At",
            elaborationEndedAt: "Elaboration Ended At",
            stage: "Stage",
            stageStartDate: "Started At",
            stageEndDate: "Ended At",
            errorMessage: "Error Message",
            elaborationUsername: "Username",
            dailyStockReferenceDate: "Daily Stock Reference Date",
            NoMoreDataToSpread: "No more data to spread left.",
            createdAt: "Created At",
            createdBy: "Created By",
            published: "Published",
            notPublished: "On Going",
            publishedAt: "Published At",
            publishedBy: "Published By",
            btn: {
              createNewInventory: 'Create new inventory',
              calculateInventoryStock: 'Calculate inventary',
              editRow: "Modifica",
              validateTank: "Validate Tank",
              validateTankTooltip: "Validate All Filtered Tanks",
              invalidateTank: "Invalidate Tank",
              invalidateTankTooltip: "Invalidate All Filtered Tanks",
              calculateStock: "Calculate Stock",
              calculateStockTooltip: "Calculate Stock for Filtered Tanks",
              startInventoryNewElaboration: "Start New Elaboration",
              continueInventoryElaboration: "Continue Elaboration",
              abortInventoryElaboration: "Abort Elaboration",
              inventoryElaboration: "Last Elaboration Status",
              updateItemsByOsiPi: "Update Measures by Osi PI",
              updateItemsByOsiPiTooltip: "Update Measures by Osi PI for Filtered Tanks",
              unlockItem: "Unlock",
              lockItem: "Lock",
              publishInventory: "Publish",
              publishInventoryCancel: "Cancel Publish",
              reportOverageLoss: 'Report Check',
            },
            Msg: {
              confirm: 'Do you want to proceed?',
              confirmNewInventoryCreation: 'Do you want to procede to create a new inventory from ',
              allDataWillBeDeleted: 'All existing data in this date will be overwritten.',
              invalidReferenceDate: 'Inventory date not valid.',
              CannotContinueDailyStockMissing: 'Cannot create inventory. Daily stock missing.',
              CannotCreateInventoryRefDate: 'Cannot create inventory. Inventory already exist on future date.',
              pendingInventoryElaborationExists: 'Cannot create inventory. Pending elaboration exist for the selected date.',
              CannotCreateInventoryGetTankListError: 'Cannot create inventory. Error while retrieng tank configuration data.',
              noSelectedInventoryItems: 'No tank selected.',
              elaborationNotFound: 'No elaboration found.',
              NoMoreDataToSpread: "Non ci sono più dati da propagare.",
              RecordLocked: "The record is locked.",
              CannotCreateInventoryPublished: 'Cannot create a new inventory. The actual one is published',
              CannotUpdateVersionPublished: 'Cannot update. The inventory is published',
              CannotUpdateItemValidated: 'Cannot update. The item is validated.',
              CannotStartElaborationNoInventoryFound: 'Cannot start a new elaboration. Inventory data missing.',
              CannotStartElaborationNoPublishedInventoryFound: 'Cannot start a new elaboration. The inventory is not yet published.',
              forceNewInventoryCreation: 'An inventory in the selected date already exists. Do you want to force the creation of a new version?',
              RecordLocked: "The tank is locked by ",
              RecordAlreadyLocked: "The tank is already locked.",
              RecordUnlocked: "The tank is unlocked. Block it before to procede.",
              RecordAlreadyUnlocked: "The tank is already unlocked.",
              RecordUnlockForce: "Do you want to force the unlock operation?",
              InvalidOperation: "Operation not valid."
            },
            inventoryElaborationStageStatus: {
              Start: 'Start',
              Init: 'Init',
              DailyStockProcessing: 'DailyStockProcessing',
              Completed: 'Completed',
              Aborted: 'Aborted'
            }
          },
          RegistryMaterialBalanceIgccEquipment: {
            page_title: 'IGCC Equipment'
          },
          DemurrageStatistics: {
            page_title: 'Demurrage Statistics',
            year: 'Year',
            previous_years: 'Previous Years',
            recap: 'Recap',
            referenceDate: 'Month',
            grossTotalDemurrage: "Gross Demurrage Calculation",
            netTotalDemurrage: "Net Demurrage Calculation",
            counterpartyOriginalRequest: "Counterparty's original request",
            counterpartyUpdatedRequest: "Counterparty's updated request",
            monthlyAverageDemurrageRate: "Monthly Avg Demurrage Rate (USD/day)",
            yearlyAverageDemurrageRate: "Yearly Avg Demurrage Rate (USD/day)",
            grossMonthlyAverageTimeOnDemurrage: "Gross Monthly Avg Time on Demurrage (hrs/vessel)",
            netMonthlyAverageTimeOnDemurrage: "Net Monthly Avg Time on Demurrage (hrs/vessel)",
            grossYearlyAverageTimeOnDemurrage: "Gross Yearly Avg Time on Demurrage (hrs/vessel)",
            netYearlyAverageTimeOnDemurrage: "Net Yearly Avg Time on Demurrage (hrs/vessel)",
            grossQuantity: 'Gross Quantity (tons)',
            grossMonthlyDemurrageRatioTotalTon: 'Gross Monthly Demurrage Ratio ($/ton)',
            grossYearlyDemurrageRatioTotalTon: 'Gross Yearly Demurrage Ratio ($/ton)',
            netQuantity: 'Net Quantity (tons)',
            netMonthlyDemurrageRatioTotalTon: 'Net Monthly Demurrage Ratio ($/ton)',
            netYearlyDemurrageRatioTotalTon: 'Net Yearly Demurrage Ratio ($/ton)',
            grossTimeOnDemurrage: 'Gross Time on Demurrage (hrs)',
            grossMonthlyDemurrageRatioHrsTon: 'Gross Monthly Demurrage Ratio (hrs/kton)',
            grossYearlyDemurrageRatioHrsTon: 'Gross Yearly Demurrage Ratio (hrs/kton)',
            netTimeOnDemurrage: 'Net Time on Demurrage (hrs)',
            netMonthlyDemurrageRatioHrsTon: 'Net Monthly Demurrage Ratio (hrs/kton)',
            netYearlyDemurrageRatioHrsTon: 'Net Yearly Demurrage Ratio (hrs/kton)',
            showReasons: 'Show Reasons',
            showPreviousYears: 'Show Previous Years',
            plant: 'Plant',
            chargeDischarge: 'Loading / Unloading',
            southTotalDemurrage: 'ISAB South',
            southTotalDemurragePercent: 'ISAB South %',
            northTotalDemurrage: 'ISAB North',
            northTotalDemurragePercent: 'ISAB North %',
            total: 'Total',
            chargeTotalDemurrage: 'Liftings',
            chargeTotalDemurragePercent: 'Liftings %',
            dischargeTotalDemurrage: 'Discharges',
            dischargeTotalDemurragePercent: 'Discharges %',
            bars: 'Bars',
            lines: 'Lines',
            graphs: 'Graphs',
            progressive: 'Progressive',
            pivot: 'Pivot',
            actVsBdg: 'Actual Vs Budget',
            mainReason: "ISAB's demurrage main reasons",
            totalDemurrage: 'SUM OF $ NET OF TIME EXPIRED',
            totalDemurragePercent: '% ($ NET OF TIME EXPIRED/TOTAL)',
            timeOnDemurrage: 'Sum of Time on Demurrage (Hrs)',
            timeOnDemurragePercent: '% (Time on Demurrage (Hrs)/TOTAL)',
            averageTimeOnDemurrage: 'Avg. of Time on Demurrage (Hrs)',
            averageDemurrageRate: 'Avg. of Demurrage Rate (USD/Day)',
            month: 'Month',
            dischargeLifting: 'Discharge/Lifting',
            note: 'Note',
            vesselName: 'Vessel Name',
            allocation: 'Allocation',
            planningStrategy: 'Planning Strategy',
            timeOnDemurrage: 'Time on Demurrage (Hrs)',
            product: 'Product',
            demurrageRate: 'Demurrage Rate (USD/DAY)',
            plantSouthNorth: 'ISAB North/South',
            netOfTimeEXpired: '$ Net of time expired',
            budget: 'Budget',
            estimatedVsBudget: 'Gross Demurrage vs Budget',
            titleActVsBudgetGraph: 'Act vs Budget',
            discharge: 'Discharge',
            lifting: 'Lifting',
            selectedMonths: 'Months'
          },
          monthNames: {
            0: 'January',
            1: 'February',
            2: 'March',
            3: 'April',
            4: 'May',
            5: 'June',
            6: 'July',
            7: 'August',
            8: 'September',
            9: 'October',
            10: 'November',
            11: 'December',
          },
          registryTankOperationRules: {
            page_title: 'Tank Operation Rules',
            previousOperationCode: 'Prev Operation Code',
            previousOperationDescription: 'Prev Operation Description',
            currentOperationCode: 'Current Operation Code',
            currentOperationDescription: 'Current Operation Description'
          },
          StockManagementInventoryDataStaging: {
              page_title: 'Data Staging',
              referenceDate: 'Reference Date',
              label: 'Inventory title',
              startLabel: 'Inventory dated ',
              liquid: 'Liquid',
              gas: 'Gas',
              reason: 'Motivation: ',
              product: 'Product',
              plantCode: 'Plant code',
              tankCode: 'Tank code',
              schedulingDate: 'Scheduling Date',
              measureDate: 'Measure Date',
              outOfService: 'Out of Service',
              onService: 'On Service',
              isFinal: 'Final',
              samplingMethod: 'Sampling method',
              productLevelManual: 'Product level manual',
              titleDialogCreateInventory: 'Create Inventory',
              titleDialogEditProductItem: 'Modify product',
              titleDialogPublishTankSelectionRevision: 'Select the plant code to publish',
              titleDialogEditMeasures: 'Modify Measures',
              titleDialogScheduleTank: 'Schedule tank',
              schedulationDate: 'Schedulation date:',
              selectInventory: 'Select Inventory',
              actualStageLabel: 'Actual inventory status:',
              TankSelection: 'Tank Selection',
              TankSelectionRevision: 'Tank Selection Revision',
              TankMeasurements: 'Tank Measurements',
              temperature: 'Temperature',
              isIncluded: 'Included',
              productLevelManual: "Manual Measurement (mm)",
              productLevelAuto: "Authomatic Measurement (mm)",
              productLevelManualVsAutoDelta: "Differences (mm)",
              density: "Density (kg/l)",
              densityDailyStock: "Density Daily Stock (kg/l)",
              temperatureManual: "Manual Temperature (°C)",
              temperatureAuto: "Automatic Temperature (°C)",
              temperatureAutoGasGrid: "Temperature °C (liquid)",
              temperatureManualVsAutoDelta: "Differeces (°C)",
              waterLevel: "H2O (mm)",
              sludgeLevel: "Sludge",
              gasTemperature: "Temperature °C (gas)",
              pressure: "Pressure (bar)",
              molecularWeight: "Molecular Weight",
              weightInKg: "Weight (kg)",
              volumeInLt: "Volume (lt)",
              waterVolumeInLt: "Water Volume (lt)",
              schedulingNotes: "Scheduling Notes",
              blendingNotes: 'Blending Notes',
              shippingNotes: 'Shipping Notes',
              bilmatNotes: 'Bilmat Notes',
              scheduling: "Scheduling",
              blending: 'Blending',
              shipping: 'Shipping',
              bilmat: 'Bilmat',
              notes: 'Notes',
              FILANTE:'Filante',
              PIUALTEZZE: ' Più altezze',
              NOCAMPIONE: 'No campione',
              environmentTemperature: 'Environment Temperature',
              measuresManual: 'Measures Manual',
              measuresAuto: 'Measures Auto',
              requiredMeasuredDate: 'Measures date required',
              requiredReferenceDate: 'Reference date required',
              requiredLabelInventory: 'Inventory title required',
              rescheduleRequests: 'Reschedule Requests',
              reason: 'Reason',
              reschedule_question:'Would you like to reschedule the tank for a new measurement?',
              requiredReason: 'Reason required',
              requestDate: 'Request Date',
              requestedBy: 'Requested by',
              responseBy: 'Response By',
              requestRejectedReason: 'Rejected reason',
              requestStatus: 'Status',
              NEW: 'New',
              APPROVED: 'Approved',
              REJECTED: 'Rejected',
              rejectReschedule: 'Reject reschedule request',
              valuedService: 'in Service',
              emptyService: 'Out of service',
              all: 'All',
              level:'Level (mm)',
              temperature: 'Temperature (°C)',
              volume: 'Volume (lt)',
              weight:'Weight (kg)',
              manual: 'Manual',
              automatic: 'Automatic',
              delta: 'Differeces',
              workPermit: 'Work Permit',
              analysisSampleNumber: 'Analysis Sample Number',
              insertDateDailyStock: 'Insert the date of the measurements to be imported from the daily stock',       
              densityFromDailyStock: 'Density (kg/l) from Daily Stock',
              waterLevelFromDailyStock: 'H20 (mm) from Daily Stock',
              weightFromCofi: 'Weight (kg) from Daily Stock',
              volumeFromCofi: 'Volume (lt) from Daily Stock',
              waterWeightFromCofi: 'Water Weight (kg) from Daily Stock',
              waterVolumeFromCofi: 'Water Volume (lt)from Daily Stock',
              fromInventory: ' (from Inventory)',
              manualAndFreeze: 'Manual + Frozen',
              mixed: 'Inventory',      
              cofidate: 'Daily Stock Date (Manual + Frozen)',
              btn: {
                selectTank: 'Select tanks',
                selectTankTooltip: 'Select tanks',
                editRow: "Modifica",
                publishInventory: "Publish",
                publishInventoryCancel: "Cancel Publish",
                schedule: 'Schedule',
                scheduleItem: 'Schedule',
                importPi: 'Import Pi',
                importLims: 'Import Lims',
                editMeasures: 'Edit measures',
                viewNotes: 'View note',
                reschedule:'Reschedule',
                approve: 'Approve',
                reject: 'Reject',
                create: 'Create Inventory',
                downloadExcel: 'Download excel',
                importLimsMassive: 'Massive Import Lims',
                planned: 'scheduled',
                toBePlanned: 'To be scheduled',
                importFromStockManagements: 'Import from Daily Stock',
              },
              messages: {
                create_message_question: 'Would you like to create a new inventory?',
                create_message_success: 'The inventory has been successfully created.',
                outOfService_message_question: 'Would you like to change the status of tank to "out of service"?',
                not_outOfService_message_question: 'Would you like to change the status of tank?',
                change_product_message_success: 'Would you like to change the product of tank?',
                include_message_question: 'Would you like to "include" the selected tank?',
                not_include_message_question: 'Would you like "not include" the selected tank?',
                publish_message_question: 'Would you like to publish the selected tanks?',
                publish_message_success: 'The publication was successful.',
                operation_message_success: 'The operation was succesful.',
                schedule_message_question: 'Would you like to schedule the selected tanks?',
                schedule_message_success: 'The schedulation was successful.',        
                importPi_message_question: 'Would you like to import the measures from Pi?',
                importLims_message_question : 'Would you like to import the measures from Lims?',
                confirm_measure_message_question: 'Would you like to confirm the measures in the date : ',
                confirm_approve_message_question: 'Would you like to approve the reschedule request',
                reject_request_question: 'Would you like to reject the reschedule request?',
                deactive_schedule_message_question:'Would you like to remove the tank publication?',
                importLimsMassive_message_question: 'Would you like import Lims for all tanks ?',
                importDailyStock_message_question:'Would you like import the measures from daily stock?',
                cant_schedule_message: 'You can\'t schedule tanks if there are unsaved changes'

              },
          },
          DischargeDropsReport:{
            page_title: 'Discharge Drops Report',
            referenceDate: 'Reference Date',
            tankCode: 'Tank',
            lockedDate: 'Locked Date',
            endOperationDate: 'Acc. Discharge Date',
            fiscalStockWeight: 'Stock Weight (Kg)',
            fiscalStockVolume: 'Stock Volume (Lt)',
            cofiLockedWeight: 'Locked Weight (Kg)',
            cofiLockedVolume: 'Locked Volume (Lt)',
            sludgeWeight: 'Sludge Weight (Kg)',
            sludgeVolume: 'Sludge Volume (Lt)',
            fiscalMovedWeight: 'Fiscal Moved Weight (Kg)',
            fiscalMovedVolume: 'Fiscal Moved Volume (Lt)',
            theoreticalWeight: 'Weight Theoretical (Kg)',
            theoreticalVolume: 'Theoretical Volume (Lt)',
            deltaWeight: 'Delta Weight (Kg)',
            deltaVolume: 'Delta Volume (Lt)'
          },
          VesselAcceptance: {
            page_title: 'Vessel Acceptance Interface',
            msg: {
              movementInstructionNotValid: 'Movement Instruction not valid.',
              movementInstructionLotListNotValid: 'Movement Instruction lot list not valid.',
              lotsProductListNotValid: 'The lot\'s product list is not valid.',
              operationTypeNotValid: 'Operation type not valid.',
              plantNotValid: 'Plant not valid.',
              noValidAcceptanceFound: 'No valid acceptance found.',
              movementInstructionNotCreted: 'It is possible to select the vessel only after the creation of the movement instruction and at least one lot.'
            },
            
          },
          versalisRegister: {
            page_title: 'Versalis Registers - Loading/Unloading',
            product_movements_page_title: 'Versalis Registers - Products',
            raw_materials_movements_page_title: 'Versalis Registers - Raw Materials',

            loadDate: 'Loading Date',
            unloadDate: 'Unloading Date',
            voyageNumber: 'Voyage',
            tankCode: 'Tank',
            loadWeight: 'Weight Qty (KG) Loading',
            loadVolume: 'Volume Qty (LT) Loading',
            unloadWeight: 'Weight Qty (KG) Unloading',
            unloadVolume: 'Volume Qty (LT) Unloading',
            density: 'Density',
            stockQuantity: 'Stock Weight (KG)',
            stockVolume: 'Stock Volume (LT)',
            hter14StockQuantity: 'Stock Weight HTER14 (KG)',
            hter14StockVolume: 'Stock Volume HTER14 (LT)',
            hter14StockTotal: 'TOT. STOCK HTER ACTUAL:',
            unloading: 'Unloading',
            loading: 'Loading',

            msg: {
              unloadingOpNotFound: 'Unloading operation not found.',
              loadingOpNotFound: 'Loading operation not found.',
              loadingOpNotValid: 'Loading operation not valid',
              cannotDeleteLoadingOp: 'Cannot delete a loading operation.',
              cannotUpdateLoadingOp: 'Cannot update a loading operation.',
              unloadingOpAlreadyExists: 'The unloading operation already exists.',
              confirmDelete: 'Are you sure?',
              unloadingOpDateLowerThanLoadigOp: 'Unloading operation date lower than loadig operation date.'
            }
          },
          VersalisMovements: {
            family: 'Register',
            IDREG_PROTOCOL_NUM: 'Register',
            IDREG_ANNO_EMISSIONE_DOC: 'Register Year',
            DATA_DI_RIFERIMENTO: 'Reference Date',
            CODICE_PRODOTTO_NOM_COMB: 'Product',
            DOCUMENTO_TIPO: 'Document Type',
            DOCUMENTO_NUMERO: 'Document Number',
            DOCUMENTO_DATA_EMISSIONE: 'Document Date',
            PROV_DEST_MERCE: 'Origin / Destination',
            QTA_PESO: 'Weight (KG)',
            QTA_LITRI_A15C: 'Volume (LT)',
            QTA_PESO_IN: 'Weight (KG) Load',
            QTA_LITRI_A15C_IN: 'Volume (LT) Load',
            QTA_PESO_OUT: 'Weight (KG) Disc',
            QTA_LITRI_A15C_OUT: 'Volume (LT) Disc',
            DENSITA_A15C: 'Density',
            ACCISA_DOVUTA: 'Excise Due',
            MOVIMENTO_TIPO: 'Movement Type',
            GIACENZA_PESO: 'Stock (KG)',
            GIACENZA_LITRI: 'Stock (LT)',
            movementTypeC: 'Load',
            movementTypeS: 'Unload',
            movementTypeG: 'Stock',
            REC_UPDDT: 'Last Update Date'
          },
          SiteContracts:{
            page_title: 'Site Contract',
            date: "Date",
            quantity: "Quantity",
            incotermCode: "Incoterm",
            contractNumberReference: "Contract Number",
            isOutCDep: "Is Out C/DEP",
            registryInspector: "Inspector",
            voyageNumber: "Allocation",
            updateMessage: "You are updating an operation with an associated telex. Are you sure you want to continue?",
            cloneMessage: "Do you want to clone the selected operation?",
            deleteMessage: "Do you want to delete the selected operation?",
            sendMessage: "Continuing will create the related telex and the document version. Are you sure you want to proceed?",
            creationMessage: "This month has not been created yet. Do you want to create operations for the selected month?",
            note: 'Note'
          },
          SiteContractOperations:{
            page_title: 'Operations',
            counterParty: 'Counter Party',
            registryProduct: 'Product',
            registryOperation: 'Operation',
            registryPlant: 'Plant'
          },
          ProductTollingMapping: {
            page_title: 'Mapping Tolling Product',
            registryProductTolling: 'Tolling Product',
            registryProductReference: 'Reference Product',
            tollingFamilyGroup: 'Tolli Family Group',
            familyPool: 'Family Pool'
          },
          RollingInventory:{
            page_title: 'Inventory Rolling Estimation',
            version: 'Version',
            monthDate: 'Pricing Month',
            description: 'Description',
            uom: 'UoM',
            total: 'Total',
            vesselName: 'Vessel',
            pricingPeriod: 'Pricing Period',
            createVersion: 'Create Version',
            deleteVersion: 'Delete Version',
            create_new_version: 'Do you want to create a new Rolling Inventory Version?',
            notFinal: 'Not Final',
            final: 'Final',
            msg_delete_version: 'Do you want to delete curren Version?',
            msg_delete_item: 'Do you want to delete the selected item?',
            date: 'Date',
            grade: 'Grade',
            vesselName: 'Vessel',
            totalWeightMt: 'MT',
            conversionFactor: 'CF',
            totalVolumeBbl: 'BBL',
            pricingWindow: 'Missing Pricing Window',
            voyageNumber: 'Allocation',
            startInventoryDate: 'Weekly Start Date',
            endInventoryDate: 'Weekly End Date',
            storageMonth: 'Storage Month',
            openingInventory: 'Opening Inventory',
            consProdLiftings: 'Cons/Prod/Liftings',
            totalSupplies: 'Supplies/Imports',
            finalRollingEstimation: 'Final Rolling Estimation',
            changeWeekly: 'Change Weekly Date',
            header_required: 'You must select a version',
            laycan: 'Laycan'
          },
          SysGatewayServer:{
            page_title: 'Gateway Servers',
            url: 'Url',
            fk: 'Server',
            refreshMessage: 'Do you want to refresh Gateway?',
            refreshBtn: 'Refresh Gateway'
          },
          SysGatewayRoute:{
            page_title: 'Gateway Routes',
            fromUrl: 'From Uri',
            toUrl: 'To Uri',
            routeOrder: 'Route Order',
            authenticated: 'Authenticated',
            prefix: 'Prefix'
          },
          InfoilDeviationCheckConfig: {
            page_title: 'Infoil Deviation Check Configuration',
            combinedNomenclature: 'Combined nomenclature',
            previousIdRegistryOperationType:'Previous Operation Type',
            measureType: 'Measure Type',
            alertThreshold: 'Alert Threshold',
            isPiEnabled: 'PI enabled',
            isThresholdCheckEnabled: 'Threshold Check Enabled',
            isSendToInfoilEnabled: 'Send To Infoil Enabled'
          },
          InfoilDeviationCheck: {
            manualMeasure: 'Manual Measures',
            automaticMeasure: 'Automatic Measures',
            movedQtyDelta: 'Delta  Mov',
            movedQtyDeltaPercentage: '% Delta  Mov',
            sendFiscalNotification: 'Enable Send Communication',
            sendDeviationToInfoil: 'Send Deviation to Infoil',
            deviation: 'Deviation',
            thresholdExceeded: 'Threshold Exceeded'
          },
          tollingPrice: {
            page_title: 'Tolling Price',
            crudeTolling: 'Crude Tolling',
            conversionFactor: 'C',
            volumeLessPerc: 'Volume Less (%)',
            isabPaymentForCrude: 'Isab Payment For Crude($)',
            crudeVolumeBBL: 'Crude BBL',
            productPrice: 'Product Price ($/bbl)',
            trafiguraPaymentForProducts: 'Trafigura Payment For Product ($)',
            crudeWeightMT: 'Crude MT',
            productPremium: 'Product Premium ($/bbl)',
            monthlyFee: 'Monthly Fee',
            feeCrude: 'Fee Crude',
            totalValueOfTollFee: 'Total Value Of Tolling Fee ($)',
            crudePrice: 'ICE Brent Avg Month ($/bbl)',
            crudeDifferential: 'Crude Diff',
            dieselBalancingTrade: 'Diesel QP Balancing Trade ($/bbl)',
            dieselBalancingTradePrice: 'Diesel QP Balancing Price ($/bbl)',
            crudePrice: 'Crude Price',
            productPool: 'Product',
            quantityMT: 'MT',
            volumeBBL: 'BBL',
            monthDate: 'Reference Month',
            monthDateToClone: 'Reference Month To Clone',
            clone_tolling_price: 'Are you sure?'
          }
        },
        it: {
          at: 'Alle',
          confirmDialogLoginHeader: 'Per continuare deve essere eseguita una nuova autenticazione',
          create: 'Crea',
          'Master Data': 'Anagrafiche',
          Security: 'Sicurezza',
          ' ': '',
          id: 'Id',
          yes: 'Si',
          no: 'No',
          exit: 'Esci',
          welcomeMessage: 'Benvenuto in Smart SIM',
          testlink1: 'L\'ambiente di test è disponibile ',
          testlinkHere: 'QUI',
          homeMessage: 'Per accedere alle funzionalità utilizza il menu laterale o la barra di ricerca',
          resetPassword: 'Reset Password',
          updatePassword: 'Aggiorna Password',
          noRecordsFound: 'Nessun record trovato',
          imported: 'Caricato',
          readyToSend: 'Pronto per l\'invio',
          date: 'Data',
          createdOn: 'Data Creazione',
          changePassword: {
            title: 'Cambio password',
            message: 'La password è scaduta. E\' necessario aggiornare la tua password',
            oldPassword: 'Vecchia password',
            newPassword: 'Nuova password',
            confirmNewPassword: 'Conferma la password',
            oldPasswordRequired: 'La vecchia password è obbligatoria',
            newPasswordRequired: 'La nuova password è obbligatoria',
            confirmNewPasswordNotEquals: 'La conferma non coincide con la nuova password',
            forgotPassword:'Hai dimenticato la password?',
            forgotPasswordMessage: '*Compila i due campi per ricevere una mail sulla tua casella di posta elettronica che ti permettera di fare il cambio della password',
            returnLogin: 'Torna alla login',
            resetPasswordSuccessMessage: 'Password resettata con successo! Controlla la tua casella di posta elettronica',
            newPasswordRules: 'Regole nuova password',
            minLength: 'Almeno 10 caratteri',
            upperCaseLetter: 'Almeno una lettera maiuscola',
            lowerCaseLetter: 'Almeno una lettera minuscola',
            numberPresence: 'Almeno un numero',
            specialCharacter: 'Almeno un carattere speciale',
            confirmEqual: 'Password di conferma uguale',
            RulesNotMatched: 'Le regole non sono rispettate'
          },
          messages: {
            generic_error_message: 'Si è verificato un errore. Se l\'errore persiste si prega di contattare l\'assistenza',
            delete_message_question: 'Vuoi cancellare l\'elemento ?',
            delete_message_success: 'Elemento eliminato con successo',
            upload_message_success: 'Elemento caricato con successo',
            update_message_success: 'Elemento aggiornato con successo',
            create_message_success: 'Elemento creato con successo',
            import_message_success: 'Importato con successo',
            operation_message_success: 'Operazione eseguita con successo',

            reset_password_question: 'Inserisci una nuova password',

            assignNewDocumentNumber: 'Il documento ha già un numero assegnato. \nGenerarne uno nuovo?',
            clone_current_lot: 'Vuoi duplicare questo lotto?',
            clone_deal: 'Vuoi duplicare il Deal selezionato?',
            calculate_true_up: 'Sei sicuro di volere calcolare il True Up?',
            calculate_priced_quantities_balance: 'Sei sicuro di volere effettuare il calcolo delle Quantità Prezzate?',
            passwordResetSuccessMessage: 'La password è stata recuperata con successo!',
            delete_current_movement_instruction: 'Stai per cancellare l\'istruzione. Se vuoi ripristinare una versione precedente utilizza la funzione "ripristina versione". Vuoi proseguire con la cancellazione?',
            delete_current_lot: 'Vuoi cancellare il lotto?',
            exclude_message_question: 'Vuoi escludere questo record?',
            include_message_question: 'Vuoi includere questo record?',
            confirm_import: 'Vuoi confermare l\'import?',
            verify_all_tabs_validation: 'Verifica le validazioni di tutte le schede',
            confirm_pending_processing_production_before_import: 'Impossibile importare altri file, l\'attuale versione presenta l\'intero mese coperto. Conferma questa versione o annulla un periodo importato, prima di poter importare altri file',
            confirm_reload_page_to_switch_theme_color: 'La modifica richiede di aggiornare la pagina, tutte le informazioni non salvate andranno perse. Sei sicuro di voler continuare?',
            importSuccess: 'Import effettuato con successo',
            exportSuccess: 'Export effettuato con successo',
            exportMessage: 'Vuoi effettuare l\'export dei dati?',
            documentDownloadCorruptedMessage: 'Il documento che si vuole scaricare è corrotto.',
            operationTypeRequired: 'Devi selezionare un tipo operazione',
            movementInstructionCreateFromTheoreticalLot: 'Vuoi creare delle istruzioni movimento a partire dal lotto teorico selzionato?',
            movementInstructionLinkTheoreticalLot: 'Vuoi associare il lotto teorico selezionato alle istruzioni movimento?',
            movementInstructionUnlinkTheoreticalLot: 'Vuoi eliminare l\'associazione tra il lotto teorico e le istruzioni movimento?',
            importQuestion: 'Vuoi effettuare l\'import dei dati?',
            generic_confirm_message: 'Sei sicuro di voler procedere?',
            documentDownloadCorruptedMessage: 'Il documento che si vuole scaricare è corrotto.',
            importDateRequired: 'La data è obbligatoria',
            layoutNotSelected: 'Devi selezionare un layout',
            layoutNameRequired: 'Devi scegliere un nome per il nuovo layout',
            item_exists_replace_message: 'Questo elemento esiste già. Vuoi sovrascriverlo?',
            movementInstructionNotAssociatedMessage: 'Questo viaggio non è associato ad un lotto teorico. Vuoi agganciarlo?',
            request_not_valid: 'Richiesta non valida.',
            db_no_data_saved: 'Errore durante il salvataggio nel database. Nessun dato salvato.',
            itemNotFound: 'Item non trovato',
            itemsListNotValid: 'Item non validi',
            import_interface: 'Vuoi importare la DensityEstimation e la FeedstockTanks?',
            oldValue: 'Vecchio Valore: ',
            exceptionSpec: 'Valore in deroga',
            promiscousTankCalculator: 'Il serbatoio selezionato è attualmente gestito come promiscuo. Si desidera effettuare lo sviluppo in modalità promiscua?'
          },
          btn: {
            notes: 'Note',
            history: 'Cronologia',
            save: 'Salva',
            back: 'Indietro',
            add: 'Aggiungi',
            cancel: 'Annulla',
            filter: 'Filtra',
            reset_filters: 'Reset filtri',
            logout: 'Esci',
            login: 'Accedi',
            changePassword: 'Cambio password',
            updatePassword: 'Aggiorna password',
            clone: 'Clona',
            search: 'Cerca',
            edit: 'Modifica',
            addChild: 'Aggiungi Nodo',
            addRoot: 'Aggiungi Nodo Root',
            delete: 'Cancella',
            newTree: 'Nuovo albero',
            viewDetails: 'Vedi Dettagli',
            viewFile: 'Mostra File',
            refresh: 'Aggiorna',
            copy: 'Copia',
            showVessel: 'Mostra Nave',
            restore: 'Ripristina',
            print: 'Stampa',
            remove: 'Rimuovi',
            reset: 'Reset',
            send: 'Invia',
            insert: 'Inserisci',
            publish: 'Pubblica',
            timesheet: 'TimeSheet',
            export: 'Esporta',
            excel: 'Excel',
            saveAsFavourite: 'Salva come preferito',
            removeFromFavourites: 'Rimuovi dai preferiti',
            create: 'Crea',
            recreate: 'Cancella e ricrea',
            importEveryone: 'Importa tutti',
            load: 'Carica',
            preview: 'Preview',
            import: 'Importa',
            select: 'Seleziona',
            assignLocalNumber: 'Assegna numero',
            nextversion: 'Versione successiva',
            unlock: 'Sblocca',
            develop: 'Sviluppa',
            confirm: 'Conferma',
            change: 'Cambia',
            calculate: 'Calcola',
            convert: 'Converti',
            validateAll: 'Valida tutti',
            resend: 'Reinvia',
            view: 'Vista Report',
            editAssets: 'Modifica attrezzature',
            reimport: 'Re-Importa',
            close: 'Liquida',
            reOpen: 'Riapri',
            assign: 'Assegna',
            download: 'Download',
            copyToTomorrow: 'Copia in un altro piano',
            selectDocuments: 'Seleziona Documenti',
            cancelDocuments: 'Cancella Documenti',
            stockExport: 'Esporta Stoccaggi',
            attachments: 'Allegati',
            link: 'Associa',
            comment: 'Commenta',
            upload: 'Carica',
            theoreticalLots: 'Lotti Teorici',
            addNode: 'Aggiungi Nodo',
            warnings : 'Warnings',
            theoreticalLots: 'Lotti Teorici',
            unlinkTheoreticalLot: 'Disassocia Lotto Teorico',
            align: 'Allinea',
            configure: 'Configura',
            layout: 'Nuovo Layout',
            apply: 'Applica',
            applyAll: 'Applica Tutti',
            expand: 'Espandi',
            collapse: 'Riduci',
            unlink: 'Elimina associazione',
            readPi: 'Leggi da PI',
            admin: 'Admin',
            stock: 'Giacenze',
            importFromFile: 'Importa Da File',
            importWeeklyFromFile: 'Importa Weekly Da File'
          },
          system: {
            page_title: 'Sistema'
          },
          generic: {
            page_title: 'Generali'
          },
          fiscalData: {
            page_title: 'Dati Fiscali'
          },
          products: {
            page_title: 'Prodotti'
          },
          movementOperation: {
            page_title: 'Operazioni'
          },
          users: {
            page_title: 'Utenti',
            firstName: 'Nome',
            lastName: 'Cognome',
            email: 'Email',
            username: 'Username',
            password: 'Password',
            realm: 'Realm',
            isEnabled: 'Abilitato',
            isChangePasswordRequired: 'Cambio password richiesto',
            newPassword: 'Nuova password',
            isAPIKeyUser: 'Utente API Key',
            isLoginByActiveDirectory: 'Accesso tramite Active Directory',
            isDisabledByAdmin: 'Disabilitato da Admin'
          },
          notifications: {
            page_title: 'Notifiche',
            sender: 'Mittente',
            receivers: 'Destinatari',
            subject: 'Oggetto',
            message: 'Messaggio',
            send: 'Invia notifica',
            date: 'Data',
            notificationDate: 'Data Notifica',
            applicationUrlReference: "Riferimento Url Applicazione"
          },
          thread: {
            page_title: 'Thread',
            threadName: 'Nome thread',
            validFrom: 'Valido da',
            validTo: 'Valido a',
            users: 'Utenti',
            validityPeriod: 'Periodo validità',
            partecipants: 'partecipanti',
            sentBy: 'Inviato da',
            at: 'il',
            noThreadSelected: 'Seleziona un thread',
            btn: {
              newThread: 'Nuovo Thread',
              reply: 'Rispondi',
              edit: 'Modifica thread'
            }
          },
          search: {
            strict: 'Ricerca esatta'
          },
          roles: {
            page_title: 'Ruoli',
            name: 'Nome',
            description: 'Descrizione',
            isEnabled: 'Abilitato'
          },
          menu_configuration: {
            page_title: 'Configurazione Menu',
            permissions: 'Permessi'
          },
          attributes:  {
            page_title: 'Attributi',
            role: 'Ruolo',
            attribute: 'Attributo',
            type: 'Tipo',
            value: 'Valore'
          },
          importCvt: {
            page_title: 'Importa CVT',
            startDate: 'Data inizio',
            endDate: 'Data fine',
            tank: 'Serbatoio',
            productCode: 'Codice Prodotto',
            movedWeight: 'Qta Mov (kg)',
            movedVolume: 'Qta Mov (lt)',
            isDenaturatedProduct: 'Prodotto Denaturato',
            denaturantWeight: 'Peso Denaturato',
            exciseValue: 'Accisa',
            suspendedExciseValue: 'Accisa sospesa',
            imported: 'Importato',
            status: 'Stato',
            date: 'Data'
          },
          cvtDeviation: {
            btn: {
              excelDownload: 'Scarica Excel',
              editSelected: 'Modifica Selezionato',
              sendToInfoil: 'Invia ad Infoil',
              calculate: 'Calcola',
              importFromPI: 'Importa Da PI'
            },
            page_title: 'Scostamento CVT',
            deviationCalculator: 'Calcolatore Scostamento',
            date: 'Data',
            dateFrom: 'Data Da',
            dateTo: 'Data A',
            sent: 'Inviato',
            fiscalCommunicationCode: 'Codice Comunicazione',
            isabTankCode: 'Serbatoio',
            simProductCode: 'Prodotto',
            simProductDescription: 'Desc Prodotto',
            initialStockWeight: 'Giacenza iniziale (Kg)',
            initialStockVolume: 'Giacenza iniziale (Lt)',
            realStockWeight: 'Giacenza Reale (Kg)',
            realStockVolume: 'Giacenza Reale (Lt)',
            extractProductWeight: 'Kg Differenza',
            extractProductVolume: 'Lt Differenza',
            lossValue: 'Perdita',
            excessValue: 'Eccesso',
            difference: 'Differenza',
            totalDifference: 'Differenza Totale',
            totalExcess: 'Eccesso Totale',
            totalLoss: 'Perdita Totale',
            temperature: 'Temperatura',
            productLevel: 'Livello Prodotto',
            envTemperature: 'Temperatura Amb',
            gasTemperature: 'Temperatura Gas',
            gasPressure: 'Pressione Gas (Bar)',
            molecularWeight: 'Peso Molecolare',
            notAllFiscalZeroingOnTanks: 'I serbatoi {tanks} non sono ancora stati azzerati. Sarà riproposto di calcolare lo scostamento quando tutti i serbatoi collegati avranno un azzeramento',
            manageMultipleTanks: 'Vuoi gestire i serbatoi {tanks} e calcolare lo scostamento di riepilogo GPL?'
          },
          cvtReport: {
            page_title: 'Report Serbatoi CVT',
            tanks: 'Serbatoi',
            operationDate: 'Data',
            fiscalNotificationCode: 'Cod. Comunicazione Azzeramento',
            operationDate: 'Data Azzeramento',
            tankCode: "Serbatoio",
            initialStock: 'Giacenza Iniziale',
            finalStock: 'Giacenza Contabile',
            realStock: 'Giacenza Finale Reale',
            extractProduct:'Estrazione Contabile',
            realExtractProduct: 'Estrazione Reale',
            stockDifference: 'Diff. Contabile - Reale',
            deviationPerc: '% Scostamento',
            noTanksForFilters: 'Nessun serbatoio per data / impianto selezionati'
          },
          user_roles: {
            page_title: 'Ruoli Utente',
            user: 'Utente di Riferimento',
            role: 'Ruolo'
          },
          analysisSampleReceiver: {
            page_title: 'Analysis Sample Receivers',
            fk: 'Analysis Sample Receiver',
            description: 'Descrizione',
            englishDescription: 'Descrizione inglese',
            isDeleted: 'Cancellato'
          },
          clearanceMovementType: {
            page_title: 'Tipi Movimento di Liquidazione',
            fk: 'Tipo Movimento di Liquidazione'
          },
          vessel: {
            search: 'Cerca navi',
            page_title: 'Navi',
            fk: 'Nave',
            imoNumber: 'Codice Imo',
            name: 'Nome',
            deadWeightTonnage: 'Tonnellaggio a peso morto',
            lengthOverall: 'Lunghezza complessiva',
            draught: 'Tiraggio',
            grossTonnage: 'Stazza lorda',
            netTonnage: 'Stazza netta',
            isBunkerBarge: 'Bettolina',
            countryAndTerritoryFlagCode: 'Bandiera',
            yearOfBuilt: 'Anno di costruzione'
          },
          authorizationType: {
            page_title: 'Tipi di autorizzazione',
            fk: 'Tipo di autorizzazione'
          },
          commercialOperationType: {
            page_title: 'Tipi Operazione Commerciale',
            fk: 'Tipo Operazione Commerciale',
            isPhysicalOperation: 'Fisica',
            code: 'Codice'
          },
          company: {
            page_title: 'Società',
            fk: 'Società',
            transportDepartmentCode: 'Codice Dipartimento',
            infoilCode:'Codice Infoil',
            cvtCode:'Codice CVT',
            isChargeByLandRetailer: 'Rivenditore CVT',
            compulsoryStockCode: 'Codice scorte obbligo',
            isCompulsoryStockEnabled: 'Abilitato Scorte Obbligo',
            isStocchinoPlanEnabled: 'Abilitato Stocchino Plan'
          },
          companyAddress: {
            page_title: 'Indirizzi società',
            completeAddress: 'Indirizzo Completo',
            city: 'Città',
            country: 'Nazione',
            zipCode: 'CAP',
            district: 'Provincia',
            isMainAddress: 'Principale'
          },
          accountType: {
            page_title: 'Tipo Conto',
            fk: 'Tipo Conto'
          },
          recordFileState: {
            page_title: 'Registro Stato File',
          },
          importFromFileState: {
            page_title: 'Importa Da Stato File',
          },
          companySection: {
            page_title: 'Sezionali Committenti',
          },
          balanceConfidentialLevel: {
            page_title: 'Livello di pubblicazione',
          },
          balancePhase: {
            page_title: 'Fasi Bilancio',
          },
          balanceSheetAccountType: {
            page_title: 'Tipo Profilo',
          },
          balanceSheetType: {
            page_title: 'Tipo Bilancio',
          },
          customsChangeValue: {
            page_title: 'Cambio Doganale',
          },
          VAT: {
            page_title: 'VAT',
          },
          portualTax: {
            page_title: 'Tasse Portuali',
          },
          vesselProtocolPaymentType: {
            page_title: 'Tipo Pagamento Protocollo Navi',
          },
          countryAndTerritory: {            
            countryAndTerritory: 'Nazione',
            page_title: 'Nazioni e Territori',
            isoCode: 'Codice Iso',
            shortName: 'Nome Breve',
            transportDepartmentCode: 'Codice Dipartimento di Trasporto',
            transportDepartmentDescription: 'Descrizione Dipartimento di Trasporto',
            originDestination: 'Origine / Destinazione',
            placeOfLoadingDischarge: 'Luogo di Caricazione / Discarica'
          },
          currency: {
            page_title: 'Valute'
          },
          documentType: {
            page_title: 'Tipi Documenti',
            fk: 'Tipo documento'
          },
          documentReceiver: {
            page_title: 'Riceventi Documenti',
            fk: 'Ricevente'
          },
          fiscalPosition: {
            page_title: 'Posizioni Fiscali',
            fk: 'Posizione Fiscale'
          },
          fiscalUse: {
            page_title: 'Usi Fiscali',
            fk: 'Uso Fiscale'
          },
          incoterm: {
            page_title: 'Incoterms',
            fk: 'Incoterm'
          },
          inspectionCost: {
            page_title: 'Costi Ispezione',
            fk: 'Costo Ispezione'
          },
          inspector: {
            page_title: 'Ispettori',
            fk: 'Ispettore',
            email: 'Email',
            isVoyageReportEmailEnabled: 'Email Voyage Report'
          },
          language: {
            page_title: 'Lingue'
          },
          macroMovementType: {
            page_title: 'Tipi Macro Movimenti',
            fk: 'Macro Movimento'
          },
          samplingPoint: {
            page_title: 'Punti di Campionamento',
            fk: 'Punto di Campionamento'
          },
          shippingAgency: {
            page_title: 'Agenzie di Spedizione',
            fk: 'Agenzia di Spedizione'
          },
          transportType: {
            page_title: 'Tipi di Transporto',
            fk: 'Tipo di Transporto'
          },
          counterFieldType: {
            fk: 'Tipo Contatore',
            page_title: 'Tipi di Contatori'
          },
          counter: {
            page_title: 'Contatori'
          },
          dealNoteColumnCombo: {
            page_title: 'Deal Note Column',
            family: 'Famiglia',
            columnType: 'Tipo Colonna',
            description: 'Descrizione',
            referenceDate: 'Data di Riferimento',
            isDeleted: 'Cancellato'
          },
          registryPlant: {
            page_title: 'Impianti',
            fk: 'Impianto',
            registryPortCode: 'Codice Porto',
            infoilPortCode: 'Codice Porto Infoil',
            customAgencyOfficeReference: 'Riferimento Agenzia',
            transportDepartmentCode: 'Codice del dipartimento dei trasporti',
            infoSipCode: 'Codice Info SIP'
          },
          originStorage: {
            page_title: 'Origine Stoccaggio',
            fk: 'Origine',
          },
          contractType: {
            page_title: 'Tipi di Contratto',
            fk: 'Tipo di contratto'
          },
          fiscalDestination: {
            fk: 'Destinazione Fiscale',
            page_title: 'Destinazioni Fiscali'
          },
          infoilFamilyProduct: {
            page_title: 'Famiglie di Prodotti Infoil',
            fk: 'Famiglia Prodotto Infoil',
            isIncludedIntoHter9Flag: 'Incluso in Hter9',
            isGasFlag: 'Gas',
            uoMFlag: 'udM',
            denaturationLabel: 'Label denaturato'
          },
          infoilOperationType: {
            page_title: 'Tipi Operazioni Infoil'
          },
          energyProduct: {
            page_title: 'Prodotti',
            fk: 'Prodotto',
            nC: 'NC',
            infoilRegisterCode: 'Codice registrazione infoil',
            unitOfMeasureEad: 'UoM Eccezione Daa',
            packagingType: 'Codice del tipo di imballaggio'
          },
          energyProductDetail: {
            page_title: 'Dettagli Prodotto',
            fk: 'Dettagli Prodotto',
            cPA: 'CPA',
            tARIC: 'TARIC',
            cADD: 'CADD',
            isTaxed: 'Tassato',
            fiscalSectionCode: 'Sezione Fiscale',
            regionalAccountCode: 'Codice Regionale'
          },
          laytimeUoM: {
            page_title: 'Stallia UdM',
            fk: 'Stallia UdM'
          },
          portAndLocation: {
            page_title: 'Porti',
            fk: 'Porto',
            movementInstrFK: 'Luogo'
          },
          product: {
            product: 'Prodotto',
            fk: 'Prodotto',
            page_title: 'Prodotti',
            imoCode: 'Codice IMO',
            imoDescription: 'Descrizione IMO',
            dealNoteCode: 'Codice Crudo',
            dealNoteSheetFamily: 'Foglio Deal Note',
            familyDescription: 'Famiglia'
          },
          productCompanyOwner: {
            page_title: 'Società Proprietarie Prodotti',
            productPool: 'Product Pool',
            productType: 'Product Type',
            productNature: 'Product Nature',
            smartsim_product: 'Prodotto Smart Sim',
            import: 'Importa Proprietari Prodotto'
          },
          processingProductionProduct: {
            page_title: 'Prodotti Lavorazione/Produzione',
            productLabel: 'Prodotto',
            smartsim_product: 'Prodotto Smart Sim'
          },
          productAggregation: {
            page_title: 'Aggregazioni Prodotti'
          },
          typeMovementInstructionLot: {
            page_title: 'Tipi Movimento Istruzione Lotto'
          },
          unitOfMeasure: {
            page_title: 'Unità di Misura',
            fk: 'UdM'
          },
          unitOfMeasureUsageScopeConfig: {
            page_title: 'UdM Configurazioni',
            printOrder: 'Ordine di stampa'
          },
          movementInstruction: {
            page_title: 'Istruzioni Movimento',
            laycanData: 'Data Cancello',
            laytimeData: 'Dati Stallia',
            revertConfirmMessage: 'Confermando sarà necessario reinserire la nave. Vuoi proseguire?'
          },
          taxWarehouse: {
            page_title: 'Depositi Fiscali',
            fk: 'Deposito Fiscale',
            consignee: 'Principale',
            placeOfDelivery: 'Luogo di Consegna',
            consigneeExciseCode: 'Codice Accisa Principale',
            consigneeName: 'Denominazione Principale',
            consigneeAddress: 'Indirizzo',
            consigneeStreetNumber: 'Civico',
            consigneeZipCode: 'Zip Code',
            consigneeCity: 'Città',
            consigneeEoriCode: 'Codice Eori',
            consigneeVatNumber: 'Partita Iva',
            consigneeActivationDate: 'Data di Attivazione',
            consigneeLanguageCode: 'Lingue',
            consigneeCountryTerritoryCode: 'Nazione',
            consigneeStartDate: 'Data Inizio',
            consigneeEndDate: 'Data Fine',
            competentAuthorityDispatchOfficeReferenceNumber: 'competentAuthorityDispatchOfficeReferenceNumber',
            placeOfDeliveryExciseCode: 'Codice Accisa Secondario',
            placeOfDeliveryName: 'Denominazione Secondaria',
            placeOfDeliveryAddress: 'Indirizzo',
            placeOfDeliveryStreetNumber: 'Civico',
            placeOfDeliveryZipCode: 'Zip Code',
            placeOfDeliveryCity: 'Città',
            placeOfDeliveryLanguageCode: 'Lingue',
            placeOfDeliveryActivationDate: 'Data di Attivazione',
            placeOfDeliveryStartDate: 'Data Inizio',
            placeOfDeliveryEndDate: 'Data Fine'
          },
          customsSituation: {
            page_title: 'Situazioni doganali',
            fk: 'Situazione doganale',
          },
          typeOperationEnergyProductDetailAndProductLink: {
            page_title: 'Prodotti Nomenclatura'
          },
          operationType: {
            page_title: 'Tipi Operazione',
            fk: 'Tipo Operazione',
            isNotifyToCustomAgency: 'Notifica all\'agenzia doganale',
            tankOperationFlag: 'Operazione Serbatoio',
            punctualFlag: 'Puntuale',
            accountingOperationFlag: 'Operazione Contabile',
            chargeDischargeFlag: 'Caricazione Discarica',
            tankGridFlag: 'Griglia Serbatoi',
            movementDirectionFlag: 'Direzione Movimento',
            operationPlanFlag: 'Piano Operativo',
            isInsideOfRefineryWarehouse: 'All\'interno del Magazzino della Raffineria',
            denaturationProcessingFlag: 'Elaborazione di denaturazione',
            isNotIncludedIntoOperationPlan: 'Non incluso nel piano operativo',
            sourceOrRecipientFlag: 'Mittente o destinatario',
            isSetStorage: 'Set Storage',
            checkCargoByLandSendToInfoilIsEnabled: 'Controlla Invio Infoil Abilitato per CVT',
            measurementReportType: 'Tipologia Verbale di misura',
            infoilCode: 'Codice Infoil',
            infoilDescription: 'Descrizione Infoil'
          },
          instructionMovement: {
            page_title: 'Istruzioni Movimenti'
          },
          logs: {
            page_title: 'Logs',
            level: 'Livello',
            utcTimeStamp: "Utc Time Stamp",
            messageTemplate: "Messaggio Template",
            renderedMessage:"Messaggio Renderizzato",
            properties:"Proprietà",
            exception:"Eccezioni",
            key:"Chiave",
            value:"Valore",
            collection: 'Servizio'
          },
          tankManagement: {
            page_title: 'Gestione Serbatoi',
            load: 'Carica',
            downloadTemplate: 'Scarica Template',
            uploadTemplate: 'Carica Template',
            downloadTemplateButtonEmpty: 'Vuoto (nuovo serbatoio)',
            downloadTemplateButtonFilled: 'Aggiorna Calibrazione',
            deleteSelected: 'Elimina',
            downloadCalibrationTable: 'Scarica Tabella Taratura',
            isActive: 'Attivo',
            type: 'Tipo',
            code: 'Codice',
            plant: 'Plant',
            details: 'Dettagli',
            description: 'Descrizione',
            startDate: 'Data Inizio',
            endDate: 'Data fine',
            maxLevel: 'Livello Massimo',
            minLevel: 'Livello Minimo',
            inextricableVolume: 'Volume Inestraibile',
            maxVolume: 'Volume Massimo',
            highFeetMinValue: 'High Feet Min Value',
            level: 'Livello',
            calibrationFactor: 'Fattori Calibrazione',
            volume: 'Volume',
            deleteHeader: 'Eliminazione campo',
            deleteMessage: "Sei sicuro di voler procedere con l'eliminazione?",
            acceptLabel: 'Si',
            rejectLabel: 'No',
            uploadHeader: 'Carica Template',
            uploadButton: 'Invia',
            toastLoadErrorMessage: 'Caricamento fallito: seleziona un serbatoio prima',
            toastUploadSuccesMessage: 'Il template è stato caricato con successo',
            toastDeleteSuccesMessage: 'Il template è stato eliminato con successo',
            insulated: 'Coibentato'
          },
          calculatorInsertData:{
            title: 'Data',
            date_hour: 'Data e ora misura',
            container: 'Serbatoio',
            product: 'Prodotto',
            outOfService: 'Fuori servizio',
            inService: 'In servizio',
            loadDate: 'Carica dati da PI',
            normal: 'Normale',
            exhaust: 'Discarica',
            wrongFeetMessage: 'La posizione dei piedi del serbatoio {tankCode} è {feetPosition}. Sei sicuro di voler proseguire?'
          },
          calculatorTankDevelopment:{
            level: 'Livello (mm)',
            title: 'Dati ingresso',
            tempCalib:'Temp Calib (°C)',
            tempAmb: 'Temp Amb (°C)',
            tempLiq: 'Temp Liq (°C)',
            density:'Densità 15 (Kg/Lt)',
            levWater: 'Liv Acqua (mm)',
            footPosition: 'Posizione Piedi',
            footPositionD: 'Bassi',
            footPositionH: 'Alti',
            empy: 'A vuoto',
            full: 'A pieno',
            movementType: 'Tipo Movimento',
            extraction: 'Estrazione',
            introduction: 'Introduzione',
            tempGas: 'Temp Gas (°C)',
            calculate: 'Calcola',
            tankDevelopment: 'Sviluppo Serbatoio',
            tempMant: 'Temp. Mantello (°C)',
            deltaTemp: 'Delta Temp (°C)',
            volLordo: 'Vol Lordo (Lt)',
            volAcqua:'Vol Acqua (Lt)',
            coeffDilatTerm:'Coeff Dilat Term',
            volLordoH2o:'Vol Lordo - H2O',
            volTetto:'Vol Tetto (Lt)',
            volNetto:'Vol Netto (Lt)',
            coeffFX54:'Coeff FX54',
            vol15:'Vol 15 (Lt)',
            coeffFX56:'Coeff FX56',
            pesoGiacenza:'Peso Giacenza (Kg)',
            livelloApieno:'Livello a pieno (mm)',
            volEstraib:'Vol Estraib (Lt)',
            pesoEstraib:'Peso Estraib (Kg)',
            volVapore:'Vol Vapore (Lt)',
            pesoVapore:'Peso Vapore (Kg)',
            export: 'Esporta',
            start: "Iniziale",
            end: 'Finale',
            result: 'Risultati',
            gasPressure: 'Pressione Gas (Bar)',
            gasPressureKGCM2: 'Pressione Gas (kg/cm2)',
            gasTemperature: 'Temperatura Gas',
            molecularWeight: 'Peso Molecolare',
            PIInterface: 'Interfaccia PI',
            LimsInterface: 'Interfaccia Lims',
            btnLimsLoad: 'Carica',
            volumeExpansionFactor: 'Coeff Dilataz Vol',
            weightCorrectionFactorBiofeed: 'Coeff Corr Peso',
            roofWeight: 'Peso Tetto',
            vacuumWeight: 'Peso Giac Vac (Kg)'
          },
          calculatorDischargeDevelopment:{
            title:'Sviluppo Discariche',
            export: 'Esporta',

            table1: 'Dati Misure Iniziali',
            livelloApieno:'Livello a pieno (mm)',
            levWater: 'Liv Acqua (mm)',
            tempCalib:'Temp Calib (°C)',
            tempAmb: 'Temp Amb (°C)',
            tempLiq: 'Temp Liq (°C)',
            
            sampleTitle: 'Dati Barilotto',
            density:'Densità 15 (Kg/Lt)',
            contAcqua: 'Cont Acqua (%Vol)',
            sediments: 'Sedimenti (%Vol)',
            contAcquaSediments: 'Cont Acqua + Sedimenti (%Vol)',
            buttonLims: 'Dati LIMS',
            exhaust: 'Discarica',
            travaso: 'Travaso',
            calculate: 'Calcola',

            prevOperationTitle: 'Dati Accertamento Iniziale',
            vol15:'Vol 15 (Lt)',
            pesoGiacenza:'Peso Giacenza (Kg)',

            initialMeasureRecalculatedTitle: 'Dati Accertamento Iniziale Ricalcolati',
            coeffFX54:'Coeff FX54',
            volNetto:'Vol Netto (Lt)',

            weightedAverageDensityTitle: 'Densità Media Ponderale',
            volLordoTetto: 'Vol Lordo - Tetto (Lt)',
            densityMed:'Densità Media (Kg/Lt)',
            coeffFX56:'Coeff FX56',
            volTetto:'Vol Tetto (Lt)',

            finalLiquidMeasureTitle: 'Dati Lordi Accertamento Finale',
            tempMant: 'Temp. Mantello (°C)',
            deltaTemp: 'Delta Temp (°C)',
            volLordo: 'Vol Lordo (Lt)',
            volAcqua:'Vol Acqua (Lt)',
            coeffDilatTerm:'Coeff Dilat Term',
            volLordoAcqua: 'Vol Lordo - Acqua (Lt)',
            volIntr: 'Vol Intr (Lt)',
            
            netFinalMeasureTitle: 'Dati Netti Accertamento Finale',
            SW:'S & W (%Vol)',
            coeffsSW: 'Coeff Corr S & W (%Vol)',
            SWLt:'S & W (Lt)',
            Qta: 'Qta Intr (Lt)',
            volEstraib:'Vol Estraib (Lt)',
            pesoEstraib:'Peso Estraib (Kg)',

            limsData: 'Dati LIMS'
          },
          limsInterface: {
            type: 'Tipologia',
            dischargeType: 'Discarica',
            customsType: 'Doganale',
            sampleNumber: 'Numero Campione',
            tank: 'Serbatoio',
            densita15: 'Densità 15',
            pesoMolecolare: 'Peso Molecolare',
            puntoPrelievo: 'Punto Prelievo',
            contenutoAcqua: 'Contenuto Acqua',
            prodotto: 'Prodotto',
            sedimentiPerEstrazione: 'Sedimenti per estrazione',
            dataPrelievo: 'Data prelievo',
            contenutoAcquaSedimenti: 'Contenuto Acqua + Sedimenti',
            viaggio: 'Viaggio',
            gradoApi: 'Grado API',
            nave: 'Nave',
            contenutoZolfo: 'Contenuto Zolfo',
            analysisCode: 'Codice',
            analysisDescription: 'Descrizione',
            analysisMethod: 'Metodo',
            measureUnit: 'Unità di Misura',
            analysisValue: 'Valore',
            sito: 'Sito',
            categoria: 'Categoria',
            codiceProdotto: 'Codice Prodotto'
          },
          movementInstructions: {
            page_title: 'Istruzioni Movimenti',
            voyageNumber: 'Viaggio',
            new: 'Nuove Istruzioni Movimenti',
            laycanFrom: 'Inizio cancello',
            laycanTo: 'Fine cancello',
            lots: 'Lotti',
            etaDate: 'Eta',
            btn: {
              vesselProtocol: 'Apri Protocollo Navi',
              restorePrevVersion: 'Ripristina versione precedente',
              prevVersion: 'Versioni precedenti',
              addLot: 'Aggiungi Lotto',
              cloneLot: 'Clona Lotto',
              duplicateLot: 'Duplica Lotto',
              copyLot: 'Copia da Lotto',
              load: 'Carica',
              cloneNote: 'Clona Nota',
              deleteInstruction: 'Cancella Istruzione',
              deleteLot: 'Cancella Lotto',
              saveVesselNominationNewParcelLink: 'Applica Nuova Associazione'
            },
            messages: {
              bolHeaderNotSelected: 'Devi selezionare una Bill Of Lading',
              documentNotSelected: 'Devi selezionare un Documento',
              lotClonedSuccess: 'Lotto clonato con successo',
              minMaxQuantityValidation: 'La quantità minima non può essere maggiore della massima',
              laycanDateValidation: 'La data inizio cancello deve essere precedente alla data di fine'
            },
            laycanData: 'Data Cancello',
            laytimeData: 'Dati Stallia',
            loadingLaytime: 'Stallia di caricazione',
            loadingFreetime: 'Ore Assicurazione di caricazione',
            dischargeLaytime: 'Ore Stallia di discarica',
            dischargeFreetime: 'Ore Assicurazione di discarica',
            totalLaytime: 'Ore totali stallia',
            totalFreetime: 'Ore totali Assicurazione',
            demurrageRate: 'Importo Controstallia',
            demurrage: 'Controstallia',
            isCrudeOilWashing: 'Pulizia Cisterne',
            crudeOilWashingHours: 'Ore Pulizia Cisterne',
            lotHeader: 'Intestazione',
            isOutCDep: 'Uscita / C.Dep.',
            origin: 'Nazione / Luogo di Caricazione',
            destination: 'Nazione / Luogo di Discarica',
            originNation: 'Origine',
            destinationNation: 'Destinazione',
            destinationPort: 'Porto di Destinazione',
            product: 'Product',
            contractDate: 'Data Contratto',
            contractNumber: 'Numero Contratto',
            shipper: 'Spedizioniere',
            deliveryDocumentHolder: 'Intestatario Documenti',
            billOfLadingHolder: 'Intestatario B/L',
            notifyCompleteAddress: 'Indirizzo completo',
            placeOfLoadingCode: 'Nazione',
            placeofDischargeCode: 'Nazione',
            quantity: 'Quantità',
            minimumQuantity: 'Quantità min',
            maximumQuantity: 'Quantità max',
            productTradeDescription: 'Descrizione Prodotto',
            typeMovementInstructionLotCode: 'Tipo',
            analysisDocumentLanguageCode: 'Lingua documenti di analisi',
            documentLanguageCode: 'Lingua documenti',
            newBoL: 'Nuova Bill Of Lading',
            newBoLItem: 'Nuovo dettaglio Bill Of Lading',
            newAnalysisSample: 'Nuovo Campione di Analisi',
            numberofSamples: 'Numero di campioni',
            newMeasureUnit: 'Nuova Unità di misura',
            minimumValue: 'Valore minimo',
            maximumValue: 'Valore massimo',
            characteristicValue: 'Valore caratteristico',
            samplingMethod: 'Metodo di test',
            noteCodes: 'Codici note',
            headerInfo: 'Testata',
            lotMainInfo: 'Generale',
            billOfLading: 'Bill of Lading',
            documents: 'Documenti',
            documentReceivers: 'Riceventi',
            productSpecifications: 'Specifiche prodotti',
            measureUnits: 'Unità di Misura',
            analysisSamples: 'Campioni di Analisi',
            fiscalInfo: 'Informazioni fiscali',
            isCounterSignedByInspector: 'Controfirmato dall\'ispettore',
            isCounterSignedByThirdparty: 'Controfirmato da terzi',
            isIssuedByThirdparty: 'Emesso da terzi',
            eta: 'ETA',
            etaNumber: 'Numero Eta',
            notifyDate: 'Data Notifica',
            notifyMeans: 'Mezzo Notifica',
            numberOfOriginals: 'Numero di Originali',
            numberOfCopies: 'Numero di Copie',
            addDocumentNumberRequired: 'Il numero documento è obbligatorio',
            log: 'Log',
            externalVoyageNumber: 'Id Viaggio Esterno',
            isFip: 'FIP',
            isOnlyOneLotPermitted: 'Solo un Lotto permesso',
            isPartialEndNotificationWithOnlyInputParams: 'Misura Parziale permessa', 
            versionNote: 'Note di versione',
            copyLotSuccessMessage: 'Dati copiati con successo',
            selectLot: 'Scegli un lotto',
            selectVersion: 'Scegli una versione',
            revertSuccessMessage: 'Versione ripristinata con successo',
            cloneMessageBtn: 'Vuoi clonare questo elemento?',
            insertCode: 'Inserisci codice viaggio',
            eventDescription: 'Descrizione evento',
            completionDate: 'Data completamento',
            completed: 'Completato',
            pipeTransferTypeFlag: 'Pipe Type',
            pipeTypeC: 'Tubo Continuo',
            pipeTypeP: 'Batch',
            notes: 'Note',
            BillOfLadingReportFormat: 'Formato BOL',
            isRefinery: 'Raffineria',
            shipToShip: 'Ship to Ship',
            charterPartyDated: 'Charter Party Dated'
          },
          movementInstructionLots: {
            title: 'Lotti',
            lotCode: 'Rif. Lotto',
            productCode: 'Prodotto',
            quantity: 'Quantità',
            quantityUoMCode: 'Unità di misura',
            typeMovementInstructionLotCode: 'Tipo BL',
            billofLadingHolder: 'Bill of Lading Holder',
            note: 'Note',
            documentLanguageCode: 'Lingua documento',
            analysisDocumentLanguageCode: 'Lingua analisi',
            isOutCDep: 'Uscita / C.Dep.'
          },
          movementInstructionCompaniesByOperation: {
            page_title: 'Società per Operazione'
          },
          productSpecificationHeader: {
            page_title: 'Specifiche prodotti'
          },
          productSpecificationDetail: {
            page_title: 'Dettaglio specifiche prodotti'
          },
          productSpecificationNote: {
            page_title: 'Note specifiche prodotto'
          },
          movementInstructionOutcDepRules: {
            page_title: 'Configurazioni OUTC/DEP'
          },
          movementInstructionSavedAsFavourite: {
            page_title: 'Preferiti'
          },
          movementInstructionChecklist: {
            page_title: 'Checklist'
          },
          productAnalysisTestMethod: {
            page_title: 'Analisi Prodotti - Metodi di test'
          },
          productAnalysis: {
            page_title: 'Analisi Prodotti'
          },
          movement_instruction_roles: {
            page_title: 'Ruoli Istruzioni Movimento'
          },
          movement_instruction_user_roles: {
            page_title: 'Ruoli Utente Istruzioni Movimento'
          },
          movement_instruction_user_role_operation_types: {
            page_title: 'Operazioni Ruoli Utente Istruzioni Movimento'
          },
          tankManagementTypes: {
            page_title: 'Tipi Serbatoio',
            fk: 'Tipo Serbatoio'
          },
          equipmentType: {
            page_title: 'Tipi Attrezzatura',
            fk: 'Tipo Attrezzatura'
          },
          equipment: {
            page_title: 'Attrezzature',
            fk: 'Attrezzatura'
          },
          equipmentTypeProperty: {
            page_title: 'Proprietà Tipo Attrezzatura',
            fk: 'Proprietà Tipo Attrezzatura'
          },
          equipmentProperty: {
            page_title: 'Proprietà Attrezzatura'
          },
          cargoByLandEquipment: {
            page_title: 'Attrezzature CVT'
          },
          tankConfiguration: {
            page_title: 'Configurazioni Serbatoio',
            tankCode: 'Codice Serbatoio',
            isCalculationEnabled: 'Calcolo abilitato',
            densityCorrectionFactor: 'Fattore di correzione densità',
            isThermalExpansionEnabled: 'Espansione termica abilitata',
            isPromiscousCalculationEnabled: 'Calcolo Promiscuo Abilitato'
          },
          tmProductConfiguration: {
            page_title: 'Configurazioni Prodotto',
            f54Routine: 'Routine F54',
            enabledTankTypes: 'Tipi serbatoio abilitati',
            fixedDensity: 'Densità fissata',
            volumeExpansionFactor: 'Fattore di espansione volumetrica',
            isEthylene: 'Etilene',
            gasType: 'Tipo Gas'
          },
          cargoByLandEquipment: {
            page_title: 'Attrezzature CVT',
            registryEquipment: 'Attrezzature',
            disableSendToInfoil: 'Disabilita Invio Ad Infoil',
            isLPG: 'LPG',
            validityStartDate: 'Inizio Validità',
            validityEndDate: 'Fine Validità',
          },
          materialBalance: {
            page_title: 'Bilancio Materiali'
          },
          materialBalanceTemplateLot: {
            page_title: 'Template Lotti Ricorrenti'
          },
          productStock: {
            page_title: 'Giacenza Prodotti',
            stockDate: 'Data Giacenza',
            copyFromDate: 'Copia Da Data',
            balanceSheetDate: 'Data Foglio Bilancio',
            origins: 'Origini',

            btn: {
              copyFrom: 'Copia Da',
              importFrom: 'Importa Da',
            }
          },
          processingProduction: {
            page_title: 'Gestione Lavorazione/Produzione',
            periodDate: 'Data Periodo',
            version: 'Versione',
            period: 'Periodo',
            importStatus: 'Importabile',
            revision: 'Revisione',
            importDate: 'Data Import',
            recordFileState: 'Stato',
            externalProduct: 'Prodotto Esterno',
            errorMessage: 'Messaggio',
            choosePeriod: 'Nessun Periodo',
            dateFrom: 'Data da',
            dateTo: 'Data a',
            totalQuantity: 'Quantità Totale',
            dailyAverageQuantity: 'Quantità Giornaliera (MT)',
            totalQuantitySud: 'Quantità Totale Sud',
            dailyAverageQuantitySud: 'Quantità Giornaliera Sud (MT)',
            totalQuantityNord: 'Quantità Totale Nord',
            dailyAverageQuantityNord: 'Quantità Giornaliera Nord (MT)',
            lastDayQuantity: 'Ultima Quantità (MT)',
            confirmed: 'Confermati',
            imported: 'Importati',
            fileReferenceCode: 'Codice Rif. File',
            registryPlant: 'Impianto',
            
            btn: {
              importFrom: 'Importa Da',
              exclude: 'Escludi',
              include: 'Includi'
            },
            revisionDescriptionValidation: 'La Descrizione non può essere OBR0 quando lo Stato è PLAN',
          },
          monthlyMaterialBalance: {
            page_title: 'Bilancio Materiale Mensile',
            lastElaborated: 'Ultima Elaborazione',
            period: 'Periodo',
            profile: 'Profilo',
            type: 'Tipo',
            phase: 'Fase',
            level: 'Livello',
            elaboratedOn: 'Elaborato il',
            initialStockQty: 'Giacenza Iniziale (MT)',
            processingProductionQty: 'Processo/Produzione (MT)',
            inputBySeaQty: 'Ingresso da mare (MT)',
            inputByPipeQty: 'Ingresso da tubo (MT)',
            inputByLandQty: 'Ingresso da terra (MT)',
            inputByStockTransferQty: 'Ingresso da TS (MT)',
            outputBySeaQty: 'Uscita da mare (MT)',
            outputByPipeQty: 'Uscita da tubo (MT)',
            outputByLandQty: 'Uscita da terra (MT)',
            outputByStockTransferQty: 'Uscita da TS (MT)',
            internalConsumptionQty: 'Consumo Interno (MT)',
            finalStockQty: 'Giacenza Finale (MT)',
            elaboratedFrom: 'Elaborato da',
            elaboratedTo: 'Elaborato a',
            periodFrom: 'Periodo da',
            periodTo: 'Periodo a',
            search: 'Ricerca',
            isLastElaborated: 'Ultimo Elaborato',
            runRefineryBalance: 'Bilancio Raffineria',
            runCompanyBalance: 'Bilancio Azienda',
            refineryId: 'ID Raffineria',
            runProgressiveBalance: 'Bilancio Progressivo',
            publish: 'Pubblica',
            
            btn: {
              progressive: 'Progressivo',
              calculateCompanies: 'Calcola Committenti',
            }
          },
          lotsManagement: {
            page_title: 'Gestione Lotti',
            idMovementInstructionLot: 'Id Lotto Istruzioni Movimento',
            balanceSheetDate: 'Data Foglio Bilancio',
            voyageNumber: 'Viaggio',
            lotCode: 'Codice Lotto',
            externalVoyageNumber: 'Id Viaggio Esterno',
            registryPlant: 'Impianto',
            registryProduct: 'Prodotto',
            registryTransportType: 'Mezzo Trasporto',
            registryCommercialOperationType: 'Operazione Commerciale',
            chargeDischargeFlag: 'Tipo Movimento',
            isInternalConsumption: 'Consumo Interno',
            expectedQuantity: 'Quantità Prevista',
            laycanStartDate: 'Cancello Da',
            laycanEndDate: 'Cancello A',
            etaDate: 'ETA',
            portOrLocationOfLoading: 'Porto/Luogo Caricazione',
            portOrLocationOfDischarge: 'Porto/Luogo Discarica',
            vesselName: 'Nave',
            registryInspector: 'Ispettore',
            company: 'Proprietario',
            counterparty: 'Controparte',
            registryContractType: 'Tipo Contratto',
            contractStartDate: 'Contratto Da',
            contractEndDate: 'Contratto A',
            contractNumberReference: 'Nr. Contratto',
            registryAccountType: 'Tipo Conto',
            incotermCode: 'Incoterm',
            loadingStartDate: 'Caricazione Da',
            loadingEndDate: 'Caricazione A',
            dischargingStartDate: 'Discarica Da',
            dischargingEndDate: 'Discarica A',
            finalDate: 'Data Consuntiva',
            finalQuantity: 'Quantità Consuntiva',
            actualQuantity: 'Quantità Effettiva',
            billOfLadingDate: 'Data Polizza',
            billOfLadingQuantity: 'Quantità Polizza',
            counterpartyLaycanStartDate: 'Cancello Controparte Da',
            counterpartyLaycanEndDate: 'Cancello Controparte A',
            mooringPlatform: 'Piattaforma',
            mooringDate: 'ETB',
            unmooringDate: 'ETS',
            note: 'Note',
            isClosed: 'Chiuso',
            isDeleted: 'Cancellato',
            isCreateSelfInvoice: 'Creata Autofattura',
            protocolNumberofIntentLetter: 'Numero Protocollo Lettera Di Intento',
            importLotFromRS3: 'Importa Lotto Da RS3',
            dateFrom: 'Data Da',
            dateTo: 'Data A',
            origins: 'Origini',

            btn: {
              addLot: 'Aggiungi Lotto',
              cloneLot: 'Clona Lotto',
              importFrom: 'Importa Da',
            },
          },
          tankOperations: {
            page_title: 'Scheda Serbatoi',
            tabOperations: 'Operazioni',
            tank: 'Serbatoio',
            tankContent: 'Contenuto',
            mainInfo: 'Info generali',
            btn: {
              addOperation: 'Aggiungi',
              updateOperation: 'Modifica',
              export: 'Esporta',
              showTankInfo: 'Informazioni Serbatoio'
            },
            operationStatus: 'Stato',
            fiscalCommunicationCode: 'Comunic',
            operationDate: 'Data Misura',
            operationType: 'Operaz',
            product: 'Prodotto',
            combinedNomenclature: 'Nom Comb',
            operationCircuit: 'Circ',
            isSender: 'Mittente',
            measureType: 'Tipo Mis',
            movedWeight: 'Qta Mov (kg)',
            fiscalMovedWeight: 'Qta Mov Fisc (kg)',
            stockWeight: 'Giacenza (kg)',
            totalAccountingStockWeight: 'Tot. Giacenza Cont. (kg)',
            fiscalStockWeight: 'Giacenza Fisc (kg)',
            totalFiscalStockWeight: 'Tot. Giacenza Fisc. (kg)',
            movedVolume: 'Qta Mov (lt)',
            fiscalMovedVolume: 'Qta Mov Fisc (lt)',
            stockVolume15: 'Giacenza (lt)',
            totalAccountingStockVolume: 'Tot. Giacenza Cont. (lt)',
            fiscalStockVolume: 'Giacenza Fisc (lt)',
            totalFiscalStockVolume: 'Tot. Giacenza Fisc. (lt)',
            averageDensity15Deg: 'Densità Media 15°C',
            productLevel: 'Liv Prod',
            waterLevel: 'Liv Acqua',
            temperature: 'Temp',
            environmentTemperature: 'Temp Amb',
            density15: 'Dens 15',
            gasPressure: 'Press (Bar)',
            molecularWeight: 'Peso Mol',
            shrinkage: 'Shrinkage',
            shrinkageGas: 'Shrinkage Gas',
            gasTemperature: 'Temp Gas',
            sulfurPercentage: '% Zolfo',
            denaturantQuantity: 'Qta Denat',
            stockVolume: 'Vol Netto',
            waterVolume: 'Vol Acqua',
            //Volume netto
            grossVolume: 'Vol Lordo',
            fX54: 'FX54',
            fX56: 'FX56',
            shellTemperature: 'Temp Mant',
            deltaTemperatura: 'Delta Temp',
            thermalExpansionFactor: 'Coeff Dilataz Term',
            steamVolume: 'Vol Vapore',
            steamWeight: 'Peso Vapore',
            roofWeight: 'Peso Tetto',
            roofVolume: 'Vol Tetto',
            removableVolume: 'Vol Estraibile',
            removableWeight: 'Peso Estraibile',
            feetPosition: 'Pos Piedi',
            productOwner: 'Prop Merce',
            plantCode: 'Impianto',
            voyageNumber: 'Viaggio',
            managementType: 'Tipo Gestione',
            introducedGrossVolume: 'Vol Intr Lordo (lt)',
            introducedGrossWeight: 'Qta Intr Lorda (kg)',
            sampleBarrelDensity15: 'Dens Barilotto (kg/lt)',
            weightedAverageDensity: 'Dens Media Ponderale (kg/lt)',
            waterAndSedimentsVolumePercentage: 'Acqua + Sed (%vol)',
            waterAndSedimentsCorrectionFactor: 'Coeff Corr Acqua + Sedim',
            waterAndSedimentsIntroducedVolume: 'Vol Acqua + Sedim Intr (lt)',
            volumeExpansionFactor: 'Coeff Dilataz Vol',
            biofeedWeightCorrectiornFactor: 'Coeff Corr Peso (Biofeed)',
            emptyStockWeight: 'Giacenza VAC (kg)',
            automaticProductLevel: 'Livello Prod PI (mm)',
            automaticTemperature: 'Temp PI (°C)',
            automaticStockWeight: 'Giacenza PI (kg)',
            automaticMovedWeight: 'Qta Mov PI (kg)',
            automaticStockVolume: 'Volume 15 PI (lt)',
            automaticMovedVolume: 'Vol Mov PI (lt)',
            deltaMovedQuantity: 'Delta Mov (kg)',
            deltaMovedPercentage: '% Delta Mov',
            otherTank: 'Altro serbatoio',
            measureTypeLevel: 'Livello',
            measureTypeQty: 'Quantità',
            fiscalDocumentNumber: 'N Doc Fiscale',
            fiscalDocumentType: 'Tipo Doc Fiscale',
            general: 'Info Generali',
            levelData: 'Dati',
            environmentTemperatureSensor: 'Sensore',
            shellVolume: 'Volume Mantello',
            exportInCalculator: 'Esporta in calcolatrice',
            calculationMode: 'Modalità Calcolo',
            importInOperation: 'Importa in operazione',

            movedQuantitiesNegativeMessageForSwitchSenderReceiver : 'Le quantità movimentate risulteranno negative. Vuoi procedere con l\'inversione mittente / ricevente?',
            movedQuantitiesNegativeMessageForWarning: 'Le quantità movimentate risulteranno negative. Controlla i dati inseriti',

            isLayerStockAvailableMessage : 'Le quantità movimentate risulteranno maggiori del residuo dello strato. Vuoi procedere con lo scarico totale dello strato (verrà inserita una misura a quantità contenente il totale dello strato)?',

            weightCorrectionFactorBiofeed: 'Coeff. Correz Peso (Biofeed)',
            totalWeightInVac: 'Giac. Peso a vuoto (Kg)',

            azzPDWarning: 'Non è possibile importare una misura a livello per un azzeramento piede',
            checkOperationTankAlert: 'Attenzione! Normalmente questa sequenza di operazione risulta non ammessa. Si vuol proseguire comunque?',
            sequence: 'Sequenza: ',
            accountingStockWeight: 'Giacenza Contabile (Kg)',
            accountingStockWeightPercentage: '% Giacenza Contabile',
            accountingStockVolume: 'Volume Contabile (lt)',
            accountingStockVolumePercentage: '% Volume Contabile',
            fiscalStockWeightPercentage: '% Giacenza Fiscale',
            fiscalStockVolumePercentage: '% Volume Fiscale',
            productCode: 'Codice Prodotto',
            productDescription: 'Prodotto',
            introductionDate: 'Data Introduzione',
            contentProductFamilies: 'Contenuto Famiglie Prodotto',
            productDetails: 'Dettaglio Prodotti',
            tankContent: 'Contenuto Serbatoio',
            highFeetMinValue: 'Min Piedi Alti',
            lowFeetMinValue: 'Min Piedi Bassi',
            highFeetMaxValue: 'Max Piedi Alti',
            lowFeetMaxValue: 'Max Piedi Bassi',
            calibrationTemperature: 'Temp Calibratura',
            sequence: 'Sequenza: ',
            msg: {
              noMeasuresFound: 'Misure non trovate',
              multipleMeasuresFound: 'Più misure trovate',
              measureTypeNotValid: 'Tipo misura non valido',
              invalidOperationGasProduct: 'Il prodotto è un gas',
              deviationCheckDisabled: 'Controllo scostamento disabilitato',
              manualMeasuresNotValid: 'Misura manuale non valida',
              noPiDataFound: 'Nessun dato ricevuto dal PI',
              piError: 'Si è verificato un errore con il PI',
              uomNotValid: 'L\'unità di misura non è valida'
            }
          },
          tankCalculator: {
            level: 'Livello',
            movement: 'Movimento',
            discharge: 'Discarica',
            tank: 'Serbatoio',
            calculator: 'Calcolatrice',
            operation: 'Operazione'
          },
          conversionFactor: {
            page_title: 'Fattori di conversione',
            code: 'Codice',
            density: 'Densità',
            factor: 'Fattore'
          },
          automaticEMailAddress: {
            page_title: 'Indirizzi mail automatici',
            mode: 'Modo',
            address: 'Indirizzi'
          },
          automaticMailingList: {
            page_title: 'Mailing Lists',
            fk: 'Mailing List',
            emailType: 'Tipo Email'
          },
          communication: {
            page_title: 'Comunicazioni',
          },
          operativePlan: {
            page_title: 'Piano Operativo',
            tracking_page_title: 'Tracking Operativo',
            scheduled: 'Pianificate',
            eta: 'Eta',
            dailyplanning: 'Piano giornaliero',
            mooringsDateTo: 'Ormeggi fino al',
            sentToDailyPlan: 'Inviata',
            voyageNumber: 'Viaggio',
            vessel: 'Nave',
            product: 'Prodotto',
            company: 'Proprietario',
            operationType: 'Tipo Operazione',
            inspector: 'Isp.',
            tankListString: 'Serbatoi',
            pipilineListString: 'Oleodotti',
            aspiratorsListString: 'Aspirazione',
            pumpsListString: 'Pompe',
            measurersListString: 'Misuratori',
            mooringPlatform: 'Piatt.',
            isVesselInRoadstead: 'Rada',
            etaDate: 'Data Eta',
            laycanStartDate: 'Laycan da',
            laycanEndDate: 'Laycan a',
            mooringDate: 'Data Ormeggio',
            unmooringDate: 'Data Disormeggio',
            scheduledOperationDate: 'Data Prevista Operazione',
            plant: 'Impianto',
            status: 'Stato',
            movementInstructionCode: 'Codice Istruzioni Movimento',
            notes: 'Note',
            minimumQuantity: 'Qtà Min',
            maximumQuantity: 'Qtà Max',
            draught: 'Draught',
            deadWeightTonnage: 'DWT',
            grossTonnage: 'Gross Tons',
            loadingLaytime: 'Loading Laytime',
            dischargeLaytime: 'Discharge Laytime',
            shippingAgency: 'Agenzia',
            isHidden: 'Nascosta',
            isMovementInstructionLotDeleted: 'Lotto cancellato',

            selectEquipments: 'Seleziona Attrezzature',
            selectTanks: 'Serbatoi',
            selectPipelines: 'Oleodotti',
            selectAspirators: 'Aspirazione',
            selectPumps: 'Pompe',
            selectMeasurers: 'Misuratori',
            selectPlatforms: 'Piattaforme',
            isPushInLine: 'Spinta in Linea',
            isTankReceiver: 'Ricevente',
            dailyPlanDate: 'Data Programma Operativo',
            
            quantity: 'Quantità',
            denaturingFlag: 'Denaturante',
            equipmentLayout: 'Assetto',
            addMovementInstruction: 'Crea Istruzioni Movimento',
            originTank: 'Serbatoio di Origine', 
            sendMessage: 'Vuoi inviare il piano corrente?',
            sendMessageSuccess: 'Piano corrente inviato con successo',

            movements: 'Viaggi',
            equipments: 'Attrezzature',
            utifProgramCode: 'Codice Utif',
            fiscalNotificationCode: 'Codice Comunicazione',
            fiscalNotificationDate: 'Data Comunicazione',
            fiscalNotificationStatus: 'Stato Comunicazione',
            idFiscalNotification: 'Id Comunicazione',
            fiscalNotificationInfoilCode: 'Numero Comunicazione Infoil',
            fiscalNotificationInfoilDate: 'Data Comunicazione Infoil',
            propagateOnAllOperations: 'Copia modifiche su tutte le operazioni',

            alertMooringDateBeforeLaycanStart: 'La data di ormeggio è precedente alla data inizio cancello. Sei sicuro di voler salvare?',
            errorMooringDateAfterUnmooringDate: 'La data di ormeggio non può essere superiore alla data di disormeggio',
            alertDetailsUpdateRequired: 'Tutti i campi sono obbligatori!',
            alertDetailsDisplacementUpdateRequired: 'Data misura e almeno uno tra quantità e volume movimentato sono obbligatori',
          
            tank: 'Serb.',
            operationCode: 'Tp',
            operationDateTime: 'Data Ora',
            operationClass: 'Cls',
            operation: 'Op.',
            tanks: 'Serbatoi',
            ptf: 'Ptf',
            t: 'T',
            minQuantity: 'Q.Min',
            maxQuantity: 'Q.Max',
            aspirators: 'Aspirazioni',
            pipeline: 'Oleo',
            pumps: 'Pompe',
            mis: 'Mis.',
            mooring: 'Orm.',
            shortAspirator: 'Asp.',
            firstPump: 'Pompa',
            code: 'Code',
            qty: 'Qta',
            atb: 'Aut',
            atk: 'ATK',
            platform: 'Plat.',
            emittedOn: 'Emesso il ',
            at: 'alle ',
            cvt: 'CVT',
            displacementTransfer: 'Spiaz. Trav.',
            copyInTomorrowPlanMsg: 'Vuoi copiare l\'operazione corrente in un altro piano?',
            noteScheduling: 'Note Scheduling'
          },
          recurringOperationTemplate : {
            page_title: 'Template Operazioni Ricorrenti'
          },
          operationTypeClass : {
            page_title: 'Classi Tipi Operazione',
            fk: 'Classe'
          },
          dailyPlanValidation: {
            page_title: 'Validazione Programma Operativo',
            operationFrom: 'Operazioni Dal',
            status: 'Stato',
            schedulationBtn: 'Schedulazioni',
            scheduledOperations: 'Operazioni Schedulate',
            operationDate: 'Data Operazione',
            qty: 'Quantità',
            isValidated: 'Validato',

            massSelectionRequired: 'Devi selezionare almeno un\'operazione',
            planEmpty: 'Questo piano è vuoto!',
            publishPlanSuccess: 'Piano pubblicato con successo',
            publishPlanMessage: 'Vuoi pubblicare il piano?',
            validateAllMessage: 'Vuoi validare tutto il piano?'
          },
          dailyPlanManagement: {
            page_title: 'Gestione Programma Operativo',
            cantCreateOperationReceiver: 'Non è possibile creare un\'operazione sul serbatoio ricevente',
            warningOperationOnReceiver: 'Si sta cercando di creare un\'operazione sul serbatoio ricevente. Vuoi proseguire?',
            warningOperationModified: 'Sono presenti modifiche al telex/tracking. Inviare la comunicazione modificata prima di salvare le misure in scheda serbatoi.',
            warningOperationModifiedTelex: 'Sono presenti modifiche al Telex. Inviare la comunicazione modificata prima di salvare le misure in scheda serbatoi.',
            warningOperationModifiedScheduled: 'Sono presenti modifiche al Tracking. Inviare la comunicazione modificata prima di salvare le misure in scheda serbatoi.',
            aggregations: 'Accorpamenti',
            operationsAggregated: 'Accorpati',
            operationsToAggregate: 'Da accorpare',
            fixedBalanceSplit: 'Ripartizione Fisso / Balance',
            measurementReportBillOfLadingWeight: 'Peso polizza',
            measurementReportBillOfLadingVolume: 'Volume polizza',
            measurementReportNotes: 'Note',
            cannotAddOperation: 'Lo stato della comunicazione non permette di aggiungere misure per il serbatoio selezionato'
          },
          biodieselMixingReport: {
            page_title: 'Verbale Miscelazione Biodiesel',
            generalData: 'Dati Generali', 
            dataTransferPureBiodiesel: 'Dati Travaso Biodiesel Puro', 
            biodieselDataOutOfCount: 'Dati Biodiesel Fuori Conteggio', 
            mixtureTransferData: 'Dati travaso Miscela', 
            productionVerificationData: 'Dati Accertamento Produzione', 
            azzPdData: 'Dati Azzeramento Piede', 
            finalMixtureData: 'Dati Finali Miscela',
            documentNumber: 'Nr. Verbale',
            startDateValidity: 'Data Verbale',
            company: 'Società',
            biodieselTank: 'Serbatoio Puro',
            mixTank: 'Serbatoio Miscela',
            sendTankTrvMix: 'Serb. Mittente Trav. Miscela',
            qtyTrvPureBiodieselKg: 'Biodiesel a cont. Kg',
            volTrvPureBiodieselLt: 'Biodiesel a cont. Lt',
            qtyBiodieselOutOfCountKg: 'Biodiesel fuori cont. Kg',
            volBiodieselOutOfCountLt: 'Biodiesel fuori cont. Lt',
            qtyIntrTrvMixKg: 'Qta Introdotta Kg',
            volIntrtrvMixLt: 'Vol Introdotto Lt',
            percWeightSenderTrvMix: '% Biodiesel Kg',
            percVolSenderTrvMix: '% Biodiesel Lt',
            qtyBiodieselIntrTrvMixKg: 'Qta Biodiesel Intr Kg',
            volBiodieselIntrTrvMixLt: 'Vol Biodiesel Intr Lt',
            stockWeightKg: 'Gasolio Kg',
            stockVolumeLt: 'Gasolio Lt',
            fiscalMovedWeightAzzPdKg: 'Gasolio Kg',
            fiscalMovedVolumeAzzPdLt: 'Gasolio Lt',
            qtyBiodieselPrevKg: 'Biodiesel Prec. Kg',
            volBiodieselPrevLt: 'Biodiesel Prec. Lt',
            percQtyBiodieselPrevKg: '% Biodiesel Kg',
            percVolBiodieselPrevLt: '% Biodiesel Lt',
            totalBiodieselWeightKg: 'Totale Biodiesel Kg',
            totalBiodieselVolumeLt: 'Totale Biodiesel Lt',
            percTotalBiodieselWeightKg: '% Biodiesel Kg',
            percTotalBiodieselVolumeLt: '% Biodiesel Lt',
          },
          jetty: {
            page_title: 'Pontile'
          },
          timesheet: {
            page_title: 'Tempi nave',
            eventDescription: 'Descrizione evento',
            dateFrom: 'Data da',
            dateTo: 'Data a',
            note: 'Note',
            vessel: 'Nave',
            voyage: 'Viaggio',
            masterOfVessel: 'Comandante',
            operations: 'Operazioni',
            onlyOpenedVoyage: 'Solo viaggi aperti',
            includePrivate: 'Includi private'
          },
          timesheetOperation: {
            page_title: 'Operazioni Timesheet',
            sequenceNumber: 'Numero Sequenza',
            reportSection: 'Sezione',
            chargeDischargeFlag: 'Caricazione/Discarica',
            isPrivate: 'Privata',
            isMandatory: 'Obbligatoria',
            isPunctualDate: 'Data Puntuale'
          },
          timesheetOperationType: {
            fk: 'Tipologia Operazione',
            page_title: 'Tipologia Operazioni'
          },
          vesselProtocol: {
            page_title: 'Protocollo Navi',
            tabs: {
              'Customs Info': 'Info Doganali',
              'Loading': 'Caricazione',
              'Discharge': 'Discarica',
              'Previsional Commercial Info': 'Info Commerciali Provv.',
              'Final Commercial Info': 'Info Commerciali Def.',
              'Payments': 'Pagamenti',
              'Documents': 'Documenti',
              'Report': 'Report'
            },
            closed: 'Chiuso',
            canceled: 'Cancellato',
            protocolNumber: 'Numero Protocollo',
            voyageNumber: 'Viaggio',
            externalVoyageNumber: 'Viaggio Esterno',
            plant: 'Impianto',
            incoterms: 'Incoterms',
            operationType: 'Tipo Operazione',
            vessel: 'Nave',
            productDescription: 'Prodotto',
            fiscalCommunicationNumber: 'Comunicazione Fiscale',
            originCountry: 'Origine - Nazione',
            destinationCountry: 'Destinazione',
            combinedNomenclature: 'NC',
            customer: 'Committente',
            inspectionCompany: 'Ispettore',
            cargoDestination: 'Destinazione Cargo',
            ceeDestinations: 'Destinazione CEE',
            extraCeeDestinations: 'Destinazione ExtraCEE',
            assets: 'Assetti',
            tanks: 'Serbatoi',
            pipes: 'Oleodotti',
            pumps: 'Pompe',
            aspirations: 'Aspirazione',
            platform: 'Piattaforma',
            measurers: 'Misuratori',
            importerExporter: 'Importatore/Esportatore',
            fiscalDestination: 'Destinazione Fiscale',
            lots: 'Lotti',
            closingReason: 'Motivo Chiusura',
            cancellationReason: 'Motivo Cancellazione',
            lotsAggregationManagement: 'Gestione Aggregazione Lotti',
            changeStatusReason: 'Motivazione Cambio Stato',
            billCode: 'Codice Bolla',
            billDate: 'Data Bolla',
            declaredQuantity: 'Quantità dichiarata in bolla (Kg)',
            quantity: 'Quantità',
            registerType: 'Tipo Registro',
            registerDate: 'Data Registro',
            registerNumber: 'Numero Registro',
            field22: 'Campo 22',
            field33: 'Campo 33',
            field46: 'Campo 46',
            field47: 'Campo 47',
            field47A00: 'Campo 47-A00',
            field47B00: 'Campo 47-B00',
            field8: 'Campo 8',
            field20: 'Campo 20',
            field2: 'Campo 2',
            a93Number: 'Numero A93',
            a93Date: 'Scadenza A93',
            a93DateFrom: 'A93 Data Da',
            a93DateTo: 'A93 Data A',
            a98DateFrom: 'A98 Data Da',
            a98DateTo: 'A98 Data A',
            numberA3: 'Numero A3',
            a2Number: 'Numero A2',
            a2Date: 'Data A2',
            mrn: 'MRN',
            customsClearanceProcedure: 'Regime Doganale',
            releaseCode: 'Codice Di Svincolo',
            status: 'Stato',
            note: 'Note',
            country: 'Stato',
            countryFlag: 'Stato',
            customsExchangeRate: 'Cambio Doganale',
            noticeECustomBill: 'Dichiarazione Bolla di Preavviso',
            finalECustomBill: 'Dichiarazione Bolla Telematica',
            valueReviewBillDeclaration: 'Dichiarazione Bolla Revisione Valore',
            incomingGoodsManifest: 'Manifesto Merci In Arrivo',
            extraCEEGoodsDestinations: 'Destinazione Merce ExtraCEE',
            CEEGoodsDestinations: 'Destinazione Merce CEE',
            mainInformation: 'Informazioni Principali',
            information: 'Informazioni',
            confirmOperation: 'Conferma Operazione',
            changeFiscalDestination: 'Cambio Destinazione Fiscale',
            changeImporterExporter: 'Cambio Importatore/Esportatore',
            otherPanels: 'Altri Pannelli',
            addValueReview: 'Aggiunta revisione valore',
            addIncomingGoodsManifest: 'Aggiunta Manifesto Merce In Arrivo',
            addExtraCEEGoodsDestination: 'Aggiunta Destinazione Merce Extra CEE',
            addCEEGoodsDestination: 'Aggiunta Destinazione Merce CEE',
            shoreData: 'Dati di Raffineria',
            expectedQuantity: 'Quantità Prevista',
            shoreWeightBoL: 'Peso Estratto B/L',
            shoreVolumeBoL: 'Volume Estratto B/L',
            density: 'Densità Prodotto',
            sulfurPercentage: 'Contenuto di Zolfo',
            shipShoreDataComparison: 'Dati Nave e Dati di Raffineria a confronto',
            shipLessShoreWeight: 'Peso Bordo - Peso Estratto B/L',
            shipWithVEFLessShoreWeight: 'Peso Bordo con VEF - Peso Estr. B/L',
            shipWithVEFLessShoreVolume: 'Vol Bordo con VEF - Vol Estr. B/L',
            shipData: 'Dati Nave',
            measuredOnBoardWeight: 'Peso Bordo',
            measuredOnBoardVolume: 'Volume Bordo',
            vef: 'VEF',
            measuredOnBoardWeightKgVEFApplied: 'Peso Bordo con VEF',
            measuredOnBoardVolumeLtVEFApplied: 'Volume Bordo GSV con VEF',
            receiverShoreDifferences: 'Differenze dati ricevitore/raffineria',
            receiverLessShoreWeight: 'Peso ricevitore - Peso Estratto B/L',
            receiverLessShoreVolume: 'Volume ricevitore - Volume Esrtratto B/L',
            receiverData: 'Dati Deposito Ricevente',
            receiverMeasuredWeightKg: 'Peso Ricevitore',
            receiverMeasuredVolumeLt: 'Volume Ricevitore',
            receiverShipDifferences: 'Differenza Dati Ricevitore/Nave',
            receiverLessShipWithVEFWeight: 'Peso Ricevitore - Peso Bordo con VEF',
            receiverLessShipWithVEFVolume: 'Volume Ricevitore - Volume Bordo con VEF',
            harbourTaxes: 'Tasse Portuali',
            notes: 'Note',
            billOfLadingData: 'Dati di Polizza',
            billOfLadingGrossWeightKg: 'Peso (Gross)',
            billOfLadingVolumeLt15: 'Volume (Gross)',
            billOfLadingDensity: 'Densità a 15 °C',
            billOfLadingFX56: 'Densità Corretta (F56)',
            billOfLadingApiGrade: 'API a 60 °F',
            refineryAscertainmentData: 'Dati di Accertamento in Raffineria',
            finalMeasureNetWeightOfH2OKg: 'Peso (al netto di H2O)',
            finalMeasureNetVolumeOfH2OLt: 'Vol. (al netto di H2O)',
            finalMeasureWaterAndSedimentsHogsHeadPercentage: 'H2O e Sedimenti (barilotto)',
            finalMeasureWaterVolume: 'Volume H2O',
            finalMeasureDensityHogsHead: 'Densità di barilotto',
            finalMeasureSulfurPercentage: 'Zolfo',
            finalMeasureGrossWeightWithH2O: 'Peso Lordo (+ H2O)',
            finalMeasureGrossVolumeWithH2O: 'Vol. Lordo (+ H2O)',
            shipFigureOnDeparture: 'Dati Nave al porto di caricazione',
            loadingPortVolumeWithWaterAndOBQLt15: 'Vol. (+ H2O e OBQ)',
            loadingPortVolumeWithWaterAndOBQVEFAppliedLt15: 'Vol. con VEF (+ H2O e OBQ)',
            loadingPortWeightWithWaterAndOBQMetricTons: 'Peso con VEF (lordo di H2O & OBQ)',
            volumeTrasportationPerfomance: 'Rese di Trasporto in Volume',
            shipsOnDepartureWithVEFLessGrossVolumeBoL: 'Bordo Partenza con VEF (+ H2O & OBQ) - Vol. Polizza',
            shipsOnArrivalLessShipsOnDepartureWithVEFLt: 'Bordo Arrivo* - Bordo Partenza* (+ H2O & OBQ)',
            shipOnArrivalWithVEFLessGrossVolumeBoL: 'Bordo Arrivo con VEF (+ H2O & OBQ) - Polizza (lordo)',
            shipFigureOnArrival: 'Dati Nave al porto di discarica',
            weightCustomsPerformance: 'Resa Doganale in peso',
            shoreNetOfH2OLessGrossWeightBoL: 'Raffineria (netto di H2O) - Polizza (lordo)',
            shipDischargingData: 'Dati di discarica nave',
            obqCubicMeters: 'O.B.Q.',
            dischargeWaterVolumeCubicMeters: 'Volume H2O',
            dischargeVolumeWithoutH2OAndOBQLt15: 'Vol a 15° al netto di H2O & OBQ (GSV - OBQ)',
            robCubicMeters: 'R.O.B.',
            dischargeGrossVolumeVEFAppliedCubicMeters: 'Vol. lordo sbarcato (VEF applicato)',
            dischargeGrossWeightVEFAppliedKg: 'Peso lordo sbarcato (VEF applicato)',
            volumeCommercialPerformance: 'Resa commerciale in volume',
            dischargeGrossVolumeVEFAppliedLessGrossVolumeBoL: 'Sbarcato (lordo) con VEF - Polizza (lordo)',
            dischargingLossLT: 'Raffineria (lordo) - Sbarcato (lordo) con VEF',
            totalLossLt: 'Raffineria (lordo) - Polizza (lordo)',
            lotCode: 'Codice Lotto',
            protocolNumber: 'Numero Protocollo',
            commercialValues: 'Valore Commerciale',
            currency: 'Valuta',
            invoiceNumber: 'Fattura/D.V. N°',
            documentNumber: 'N°',
            documentDate: 'Data Fattura',
            documentQuantity: 'Quantità in Dich. doganale(T/M)',
            documentQuantityFinal: 'Totale merce T/M',
            documentUnitCost: 'Costo Unitario(T/M)',
            documentTotalAmount: 'Valore Fattura/D.V.',
            documentAdjustedTotalAmount: 'Importo Adeguato',
            valueTaxes: 'Tributi sui Valori',
            intentDeclarationNumber: 'N. Dichiarazione Intento',
            intentDeclarationDate: 'Data Dichiarazione Intento',
            intentDeclarationTotalAmount: 'Valore Dichiarazione Intento',
            commercialValuesAndTributesOnReproportionedValues: 'Valori Commerciali e Tributi sui Valori Riproporzionati',
            documentReproportionedTotalAmount: 'Fattura D.V.',
            rentalTotalAmount: 'Nolo',
            rentalAdjustedTotalAmount: 'Nolo Adeguato',
            insuranceTotalAmount: 'Assicurazione',
            insuranceAdjustedTotalAmount: 'Assicurazione Adeguata',
            otherCostsTotalAmount: 'Costi Accessori',
            otherCostsAdjustedTotalAmount: 'Costi Accessori Adeguati',
            statisticalValueTotalAmount: 'Valore Statistico',
            customDutiesRate: 'Aliquota Dazio',
            customDutiesTotalAmount: 'Dazio',
            experimentalStationRate: 'Aliquota Stazione Sperimentale',
            experimentalStationTotalAmount: 'Stazione Sperimentale',
            portTaxTotalAmount: 'Tasse Portuali',
            taxableVatTotalAmount: 'Imponibile IVA',
            vatTotalAmount: 'IVA',
            taxTotalAmount: 'Totale Tributi',
            customDutiesRateToBeGuaranteed: 'Aliquota Dazio',
            customDutiesRToBeGuaranteedTotalAmount: 'Dazio da garantire',
            customDutiesReliquidatedTotalAmount: 'Dazio Riliquidato',
            rentalReproportionedTotalAmount: 'Nolo',
            experimentalStationReliquidatedTotalAmount: 'Stazione Sperimentale Riliquidata',
            insuranceReproportionedTotalAmount: 'Assicurazione',
            taxReliquidatedTotalAmount: 'Totale Tributi Riliquidati',
            otherCostsReproportionedTotalAmount: 'Costi Accessori',
            taxableVatReliquidatedTotalAmount: 'Imponibile IVA Riliquidata',
            statisticalValueReproportionedTotalAmount: 'Valore Statistico',
            paymentType: 'Tipologia',
            isRiliquidated: 'Riliquidato',
            referenceDate: 'Data Riferimento',
            dueDate: 'Data Scadenza',
            paymentDescription: 'Descrizione',
            totalAmount: 'Importo',
            totalAmountFinal: 'Totale Transazione',
            isValueReview: 'Revisione Valore',
            isExecuted: 'Eseguito',
            isDueDateModifiable: 'Modificabile',
            isNotifiedByEmail: 'Notificato tramite email',
            isPeriodicPayment: 'Pagamento Periodico',
            isSpecialPayment: 'Pagamento speciale',
            a93Date: 'Data A93',
            a93Number: 'Numero A93',
            a98Date: 'Data A98',
            a98Number: 'Numero A98',
            valueReview: 'Revisione Valore',
            calculateValueReview: 'Calcola Revisione Valore',
            calculateTotalTaxes: 'Calcola Tributi Totali',
            calculateStatisticValue: 'Calcola Valore Statistico',
            calculateValues: 'Calcola Valori',
            calculateReproportionedValues: 'Calcola Valori Riproporzionati',
            calculateReliquidatedTaxes: 'Calcola Tributi Riliquidati',
            documentAmount: 'Totale Documento',
            toBeReproportioned: 'Riproporzionare',
            areYouSureToReproportion: 'Sei sicuro di voler riproporzionare',
            addDocument: 'Aggiunta Documento',
            addPayment: 'Aggiunta Pagamento',
            receiver: 'Destinatario',
            receiverRow1: 'Destinatario Riga 1',
            receiverRow2: 'Destinatario Riga 2',
            registryDate: 'Data registro',
            registryType: 'Tipo registro',
            company: 'Intestatario',
            companyAddress: 'Intestatario - Indirizzo',
            companyPIva: 'Intestatario - P.Iva',
            eoriNumber: 'Intestatario - Codice EORI',
            commitment: 'Committente',
            commitmentAddress: 'Committente - Indirizzo',
            commitmentPIva: 'Committente - P.Iva',
            excisePayd: 'Dazio versato',
            definitiveExcise: 'Dazio definitivo',
            definitiveInterest: 'Interessi definitivi',
            exciseDifference: 'Dazio differenza',
            ivaPayd: 'Iva versata',
            definitiveIva: 'Iva definitiva',
            interest: 'Interessi',
            interestPayd: 'Interessi versati',
            dateFrom: 'Data da',
            dateTo: 'Data a',
            excludedArea: 'Aree escluse',
            signer: 'Firma',
            field12: 'Campo 12',
            field35: 'Campo 35',
            field38: 'Campo 38',
            field42: 'Campo 42',
            field44: 'Campo 44',
            comunicationDate: 'Data comunicazione',
            comunicationPlace: 'Luogo comunicazione',
            originalDestination: 'Destinazione originale',
            vesselName: 'Nave',
            cnc: 'Codice CNC',
            otherDocument: 'Altri Documenti',
            destinationsCee: 'Destinazioni CEE',
            taxWarehouse: 'Deposito fiscale',
            destination: 'Destinazione',
            registrationBillDate: 'Data registrazione bolla',
            destinationsExtraCee: 'Destinazioni Extra CEE',
            reExportCountry: 'Paese di riesportazione',
            valueType: 'Tipo valore',
            productName: 'Prodotto',
            originCountryProduct: 'Provenienza',
            countryOfOrigin: 'Origine merce',
            categories: 'Categorie',
            documentType: 'Tipo Documento',
            consignorTrader: 'Nome Speditore',
            consignorTraderAddress: 'Indirizzo Speditore',
            originCountryType: 'Origine - Tipo Nazione',
            consigneeTrader: 'Destinatario',
            consigneeTraderAddress: 'Indirizzo Destinatario',
            ascertainedQuantity: 'Quantità Accertata',
            uom: 'Unità di misura',
            customsOffice: 'Ufficio doganale',
            registryNumber: 'N° Registro',
            exporterName: 'Esportatore',
            exporterAddress: 'Esportatore - Indirizzo',
            placeOfCertificate: 'Luogo certificato',
            dateOfCertificate: 'Data certificato',
            territory: 'Territorio',
            exportCountry: 'Paese esportazione',
            statisticValue: 'Valore Statistico',
            ceeQuantity: 'Quantità CEE',
            invoice: 'Fattura',
            typeOfCertificate: 'Tipo Certificato',
            exporterIVA: 'Esportatore - IVA',
            formularies: 'Formulari',
            loadingSchedule: 'Dist. di carico',
            goods: 'Articoli',
            totalPackages: 'Totale colli',
            flag: 'Bandiera',
            ctr: 'Ctr',
            transportIdentity: 'Identità mezzo',
            transportMode: 'Modo trasporto',
            loadingPlace: 'Luogo di carico',
            summaryDeclaration: 'Dichiarazione Sommaria',
            specialMentions: 'Menzioni speciali',
            registrant: 'Dichiarante',
            dateBoL: 'Data B/L',
            port: 'Porto',
            declarationDate: 'Data Dichiarazione',
            declarationPlace: 'Luogo Dichiarazione',
            description: 'Descrizione',
            protocolDate: 'Data Protocollo',
            field39: 'Campo 39',
            field40: 'Campo 40',
            field41: 'Campo 41',
            field43: 'Campo 43',
            date: 'Data',
            field45: 'Campo 45',
            fieldXX: 'Campo XX',
            field479AJ: 'Campo 47-9AJ',
            evidenceDocumentation1: 'Documentazione Probatoria 1',
            evidenceDocumentation2: 'Documentazione Probatoria 2',
            evidenceDocumentation3: 'Documentazione Probatoria 3',
            evidenceDocumentation4: 'Documentazione Probatoria 4',
            evidenceDocumentation5: 'Documentazione Probatoria 5',
            evidenceDocumentation6: 'Documentazione Probatoria 6',
            certificateNumber: 'N° Certificato',
            certificateDate: 'Data Certificato',
            authorizationNumber: 'N° Autorizzazione',
            authorizationDate: 'Data Autorizzazione',
            documentPlace: 'Luogo Documento',
            originCertificateCode: 'Codice certificato origine',
            taxCodeOrVatNumber: 'C. Fiscale/P.IVA',
            documentIdentify: 'Identificativo Documento',
            authorizationValidityFrom: 'Validità Autorizzazione (Dal)',
            authorizationValidityTo: 'Validita Autorizzazione (Al)',
            maxExpectedDischarges: 'Massimo Scarichi Previsti',
            documentPlace: 'Luogo Documento',
            requester: 'Richiedente',
            isOriginalBillTransmission: 'Trasmissione bolletta originale',
            place: 'Luogo',
            subject: 'Oggetto (nave, allocation)',
            allocation: 'Viaggio',
            bdaNumber: 'N° BDA',
            bdaDate: 'Data BDA',
            originPlace: 'Luogo partenza',
            transportReason: 'Trasporto - Causale',
            transportType: 'Trasporto - Tipo',
            transportVector: 'Vettore',
            goodsDescription: 'Descrizione beni',
            administration: 'Amministrazione',
            plant: 'Impianto',
            paymentDuedate: 'Data scadenza pagamento (*)',
            rate: 'Cambio',
            totalTaxAmount: 'Importo Tasse Totali',
            isUe: 'UE',
            customsDescription: 'Dogana',
            exportReportPortualTax: 'Scarica Report Tasse Portuali',
            type: 'Tipologia',
            category: 'Categoria',
            document: 'Documento',
            extension: 'Formato',
            typology: 'Tipologia',
            dragAndDropFile: 'Trascina e rilascia qui un file per caricarlo',
            customsBillEmail: 'Bolletta Doganale - E-mail',
            customsBillEmailInformation: 'Allegando un documento di tipologia Bolletta Doganale verrà inviata un\'e-mail di notifica. \nAll\'email verrà allegato il documento in oggetto.',
            proceedToSend: 'Procedere all\'invio?',
            documentsToAttach: 'Documenti da allegare:',
            sendLater: 'Invia Email Dopo',
            sendNow: 'Invia Email Ora',
            fileName: 'Nome File',
            emailStatus: 'Stato Email',
            sendEmail: 'Invia Email',
            resendEmail: 'Reinvia Email',
            emailNotSent: 'Email Non Inviata',
            emailSent: 'Email Inviata',
            createdBy: 'Creato Da',
            isValid: 'Validato',
            confirm_report52: 'Salvando il presente Report verrà chiuso il protocollo. Vuoi Procedere?',
            isValueRevisionConfirm: 'Salvando il presente Report con l\'opzione Revisione Valore selezionata, verrà chiuso il protocollo ed inviata un\'email di notifica. All\'email verrà allegato il report in oggetto e una lista di documenti che è possibile selezionare qui di seguito.',
            attachmentDate: 'Data Documento',
            paymentsEmail: 'Pagamento Periodico Differito - E-mail',
            paymentsEmailInformation: 'E\' possibile inviare un\'email di notifica alla S.O.T. di Augusta / Ufficio delle Dogane di Siracusa. All\'email è possibile allegare una lista di documenti che è possibile selezionare qui di seguito.',
            paymentDescription: 'Descrizione Pagamento',
            updateVesselProtocolButton: 'Aggiorna Protocollo'
          },
          vesselProtocolGeneralReports: {
            page_title: 'Report',
          },
          vesselProtocolSearch: {
            page_title: 'Ricerca Protocolli Nave',
            dateFrom: 'Data Telex Da',
            dateTo: 'A',
            advancedSearch: 'Ricerca Avanzata',
            protocolNumber: 'Numero Protocollo',
            protocolDate: 'Data Protocollo',
            voyageNumber: 'Numero Viaggio',
            externalVoyageNumber: 'Numero Viaggio Esterno',
            incoterms: 'Incoterms',
            fiscalCommunicationNumber: 'Numero Comunicazione Fiscale',
            originCountry: 'Origine',
            destinationCountry: 'Destinazione',
            combinedNomenclature: 'Nomenclatura Combinata',
            customer: 'Cliente',
            inspectionCompany: 'Ispettore',
            cargoDestination: 'Destinazione Merce',
            CEEDestinations: 'Destinazioni CEE',
            extraCEEDestinations: 'Destinazioni Extra CEE',
            importerExporter: 'Importatore Esportatore',
            direction: 'Direzione',
            tanks: 'Serbatoi',
            pipes: 'Oleodotti',
            pumps: 'Pompe',
            aspirations: 'Aspirazione',
            measures: 'Misure',
            platform: 'Piattaforma',
            status: 'Stato',
            statusOpened: 'Protocollato',
            statusClosed: 'Chiuso',
            statusNoProtocol: 'Non Protocollato',
            mrn: 'MRN',
            finalECustomBillCode: 'Codice Bolla Telematica',
            finalECustomBillDate: 'Data Bolla Telematica',
            registerType: 'Tipo Registro',
            registerDate: 'Data Registro',
            noticeECustomBillCode: 'Codice Bolla di Preavviso',
            noticeECustomBillDate: 'Data Bolla di Preavviso',
            eRegistrationCode: 'Numero Registro',
            statisticValue: 'Campo 46',
            field22: 'Campo 22',
            field33: 'Campo 33',
            totalTaxAmount: 'Campo 47',
            a93Number: 'Numero A93',
            releaseCode: 'Codice di Svincolo',
            periodicPaymentExpiration: 'Data A93',
            a2Number: 'Numero A2',
            a2Date: 'Data A2',
            customInformation: 'Sezione Info Doganali',
            customScheme: 'Regime Doganale',
            protocolDateFrom: 'Data Protocollo Da',
            protocolDateTo: 'A'
          },
          fiscalNotification: {
            page_title: 'Scheda Comunicazioni',
            detail_page_title: 'Comunicazione',
            infoilNumber: 'Nr. Infoil',
            infoilDate: 'Data Infoil',
            utifProgramCode: 'Codice UTF',
            notificationSendDate: 'Data Ora Comunicazione',
            notificationCode: 'Codice Comunicazione',
            notificationNumber: 'N°',
            fiscalNotificationState: 'Stato',
            registryOperation: 'Operazione',
            idRegistryOperation: 'Tipo Operazione',
            endOperationDate: 'Data Ora Fine Operazione',
            idRegistryProduct: 'Prodotto',
            productDescription: 'Prodotto',
            fiscalCircuitCode: 'Circuito Fiscale',
            nc: 'Nomenclatura Combinata',
            quantity: 'Qta ~ (mt)',
            shippingNotificationUser: 'Procuratore',
            voyageNumber: 'Codice Allocation',
            vesselName: 'Nave',
            portOrLocationOfFiscalDestinationDescription: 'Porto di destinazione',
            placeOfDeliveryName: 'Destinatario',
            portOrLocationOfLoading: 'Provenienza',
            placeOfFiscalDestinationDescription: 'Nazione Porto di destinazione',
            customAgencyDescription: 'Dogana Destinatario',
            idRegistryFiscalPosition: 'Posizione Fiscale',
            registryFiscalPositionCode: 'Posizione Fiscale',
            placeOfDeliveryExciseCode: 'Codice Accisa Destinatario',
            originCountry: 'Origine',
            exciseDuty: 'Accisa gravante',
            exciseDue: 'Accisa dovuta',
            documentReference: 'Rif. Documento',
            note: 'Note',
            totalFiscalMovedWeight: 'Totale Movimentato (Kg)',
            totalFiscalMovedVolume: 'Totale Movimentato (Lt a 15°C)',
            plant: 'Impianto',
            idRegistryPlant: 'Impianto',
            equipmentCode: 'Codice',
            equipmentDescription: 'Descrizione',
            equipmentType: 'Tipo',
            sentBy: 'Inviata da',
            isMovementInstructionModified: 'Sono presenti modifiche a livello di Istruzioni Movimento.',
            isScheduledOperationModified: 'Sono presenti modifiche a livello di Tracking.',
            tankLayoutString: 'Serbatoi',
            sendSuccessMessage: 'Comunicazione salvata con successo. Invio a Infoil in corso',
            cc: 'Consuntiva',
            reinsertTankErrorMessage: 'Non è possibile inserire un serbatoio se esiste un operazione in stato CC',
            endOperationDateCheckMessage: 'La data fine operazione è in un giorno differente rispetto alla data comunicazione',
            addExciseButton: 'Aggiungi Record Accisa'
          },
          fiscalNotificationDetail: {
            isIncluded: 'Incluso',
            tank: 'Serbatoio',
            operationDate: 'Data e ora misura',
            fiscalNotificationState: 'Stato Operaz.',
            fiscalNotificationCircuit: 'Circuito Fiscale',
            isReceiver: 'M/R',
            nc: 'Nomenclatura Combinata',
            fiscalMovedWeight: 'Qta Movimentata (Kg)',
            fiscalMovedVolume: 'Vol Movimentato (Lt)',
            fiscalStockWeight: 'Giacenza (Kg)',
            fiscalStockVolume: 'Volume a 15°C (Lt)',
            waterLevel: 'Altezza Acqua (mm)',
            productLevel: 'Altezza Livello (mm)',
            denaturantQuantity: 'Denaturante (Kg)',
            density15: 'Densità a 15° (Kg/Lt)',
            gasPressure: 'Pressione (Bar)',
            temperature: 'Temperatura (°C)',
            sulfurPercentage: '% Zolfo',
            receiver: 'R',
            sender: 'M',
          },
          fiscalNotificationList: {
            isClosed: 'Chiuse',
            plant: 'Impianto',
            dateFrom: 'Data da',
          },
          clearanceDocument: {
            page_title: 'Documenti di liquidazione'
          },
          issueOfDocuments: {
            page_title: 'Rilascio di documenti',
            voyage: 'Viaggio',
            documentVersion: 'Versione documento',
            typeDescription: 'Tipo documento',
            code: 'Codice',
            product: 'Prodotto',
            productCode: 'Codice prodotto',
            owner: 'Proprietario',
            receiver: 'Destinatario',
            lot: 'Lotto',
            telexNotes: 'Note Telex',
            shipperNotes: 'Note spedizione',
            quantity: 'Quantità',
            issueDate: 'Data di emissione',
            warningCreateNewVersion: 'Nessuna versione trovata! Crearne una?',
            dangerRecreateDocument: 'Sei sicuro di voler cancellare e ricreare il documento?',
            documentsWithoutNumber: 'Ci sono documenti senza numero, assegnali prima di stampare',
            documentsWithoutNumberClose: 'Ci sono documenti senza numero, assegnali prima di liquidare',
            confirmCloseVoyage: 'Sei sicuro di voler liquidare il viaggio?',
            lotsListToPrintFascicle: 'Seleziona i lotti per stampare la fascicolata',
            noVersionsFound: 'Non è stata trovata nessuna versione del documento',
            signer: 'Firmatario',
            tanks: 'Serbatoi',
            blackProductsTank: 'Selezionare i serbatoi per il calcolo della Densità',
            isPushInLine: 'Spinta in Linea',

            DAA: {
              page_title: 'DAA',
              submissionType: 'Tipo messaggio',
              deferredSubmissionFlag: 'Indicatore di presenza differita',
              arc: '(1.d) ARC',
              guarantorTypeCode: '(1.a) Codice del tipo garante',
              dateOfValidationeEad: '(1.e) Data e ora di convalida dell\'e-AD',
              eaadStateDescription: 'Stato e-AD',
              authorizationTypeDescription: 'Tipo autorizzazione',
              journeyTime: '(1.b.1) Durata del tragitto',
              journeyType: '(1.b.2) Tipo durata del tragitto',
              transportArrangement: '(1.c) Organizzatore del trasporto',
              documentNumber: '(1.f) Numero progressivo',
              dateOfUpdateValidation: '(1.g) Data e ora di convalida dell\'aggiornamento',
              consignorTraderExciseNumber: '(2.a) Codice accisa',
              consignorTraderName: '(2.b) Nome',
              consignorTraderStreetName: '(2.c) Via',
              consignorTraderStreetNumber: '(2.d) Numero civico',
              consignorTraderPostcode: '(2.e) Codice postale',
              consignorTraderCity: '(2.f) Città',
              consignorTraderLanguage: '(2.g) Lingua',
              placeOfDispatchTraderReferenceOfTaxWarehouse: '(3.a) Codice accisa',
              placeOfDispatchTraderName: '(3.b) Nome',
              placeOfDispatchTraderStreetName: '(3.c) Via',
              placeOfDispatchTraderStreetNumber: '(3.d) Numero civico',
              placeOfDispatchTraderPostcode: '(3.e) Codice postale',
              placeOfDispatchTraderCity: '(3.f) Città',
              placeOfDispatchTraderLanguage: '(3.g) Lingua',
              dispatchImportOfficeReferenceNumber: '(4.a) Numero di riferimento dell\'ufficio doganale di importazione',
              competentAuthorityDispatchOfficeReferenceNumber: '(10.a) Autorità competente luogo di spedizione',
              consigneeTraderExciseNumber: '(5.a) Codice accisa',
              consigneeTraderName: '(5.b) Nome',
              consigneeTraderStreetName: '(5.c) Via',
              consigneeTraderStreetNumber: '(5.d) Numero civico',
              consigneeTraderPostcode: '(5.e) Codice postale',
              consigneeTraderCity: '(5.f) Città',
              consigneeTraderLanguage: '(5.g) Lingua',
              consigneeTraderEoriNumber: 'Codice EORI',
              complementConsigneeTraderMemberStateCode: '(6.a) Codice stato membro del destinatario',
              complementConsigneeTraderSerialNumberOfCertificateOfExemption: '(6.b) Numero progressivo del certificato di esenzione delle accise del destinatario',
              deliveryPlaceTraderExciseNumber: '(7.a) Codice accisa',
              deliveryPlaceTraderName: '(7.b) Nome',
              deliveryPlaceTraderStreetName: '(7.c) Via',
              deliveryPlaceTraderStreetNumber: '(7.d) Numero civico',
              deliveryPlaceTraderPostcode: '(7.e) Codice postale',
              deliveryPlaceTraderCity: '(7.f) Città',
              deliveryPlaceTraderLanguage: '(7.g) Lingua',
              deliveryPlaceCustomsOfficeReferenceNumber: '(8.a) Numero di riferimento dell\'ufficio doganale di esportazione',
              eaadLocalReferenceNumber: '(9.a) Numero di riferimento locale',
              eaadInvoiceNumber: '(9.b) Numero della fattura',
              eaadInvoiceDate: '(9.c) Data della fattura',
              eaadOriginTypeCode: '(9.d) Codice del tipo di origine',
              eaadDateAndTimeOfDispatch: '(9.6e+f) Data e ora di spedizione',
              transportModeCode: '(13.a) Codice del modo di trasporto',
              transportArrangerTraderVatNumber: '(14.a) Codice accisa',
              transportArrangerTraderName: '(14.b) Nome',
              transportArrangerTraderStreetName: '(14.c) Via',
              transportArrangerTraderStreetNumber: '(14.d) Numero civico',
              transportArrangerTraderPostcode: '(14.e) Codice postale',
              transportArrangerTraderCity: '(14.f) Città',
              transportArrangerTraderLanguage: '(14.g) Lingua',
              firstTransporterTraderVatNumber: '(15.a) Codice accisa',
              firstTransporterName: '(15.b) Nome',
              firstTransporterStreetName: '(15.c) Via',
              firstTransporterStreetNumber: '(15.d) Numero civico',
              firstTransporterPostcode: '(15.e) Codice postale',
              firstTransporterCity: '(15.f) Città',
              firstTransporterLanguage: '(15.g) Lingua',
              transportUnitCode: '(16.1.a) Codice dell\'unità di trasporto',
              identityOfTransportUnits: '(16.1.b) Identificazione dell\'unità di trasporto',
              transportComplementaryInformation: '(16.1.f) Informazioni complementari',
              transportComplementaryInformationLanguage: '(16.1.g) Lingua info complementari',
              bodyRecordUniqueReference: '(17.1.a) Riferimento unico al corpo dei dati',
              cpaproductCategory: '(17.1.b) Codice del prodotto sottoposto ad accisa',
              nc: '(17.1.c) Codice NC',
              quantity: '(17.1.d) Quantità (Lt a 15°)',
              grossWeight: '(17.1.e) Peso lordo (Kg)',
              netWeight: '(17.1.f) Peso netto (Kg)', 
              density: '(17.1.o) Densità',
              taricCode: 'Codice TARIC',
              caddCode: 'Codice CADD',
              kindOfPackagesTypeCode: '(17.1.1.a) Codice del tipo di imballaggio', 
              numberOfPackages: '(17.1.1.b) Numero di colli',
              header: 'Intestazione',
              consignorTrader: 'Speditore',
              placeOfDispatch: 'Luogo di spedizione',
              complementConsigneeTrader: 'Altri dati destinatario',
              consigneeTrader: 'Destinatario',
              deliveryPlace: 'Luogo di consegna',
              firstTransporterTrader: 'Primo trasportatore',
              dispatchDetails: 'Dettagli spedizione',
              packages: 'Imballaggi',
              product: 'Prodotto',
              transportArrangerTrader: 'Organizzatore del trasporto',
              transportDetails: 'Dettagli del trasporto',
              sendEAD: 'Invia e-AD',
              getArc: 'Ottieni ARC',
              issueDate: 'Data Emissione'
            },

            XAB: {
              documentNumber: 'Numero',
              issueDate: 'Data',
              numberOfOriginals: 'N° Originali',
              numberOfCopies: 'N° Copie',
              departurePortAndLocationDescription: '2 Luogo di partenza',
              deliveryNoteHolder: '3 Committente',
              destinationDescription: '4 Destinatario',
              shippingNote: '5 Annotazioni del mittente',
              commercialReason: '6 Causale Trasporto',
              transportTypeDescription: '7 Tipo Trasporto',
              carrierDescription: '8 Vettore',
              locationOfLoadingAndIncoterm: '9 Porto / Resa',
              vesselName: '10 Mezzo',
              contractNumber: '11 Ordine',
              voyageNumber: '12 Viaggio',
              productCode: '13 Codice prodotto',
              productDescription: '14 Descrizione beni',
              weightMtAir: '16 Quantità in KG',
              weightInMtAirCoded: '16 Quantità Codificata',
              volumeInM3At15CDeg: '16 Metri Cubi a 15° C',
              volumeInM3At15CDegCoded: '16 Volume Codificato',
              tareWeight: '18 Tara',
              grossWeight: '19 Lordo',
              tit: '20 TIT',
              externalVoyageNumber: 'External Voyage Number',
              nc: '21 Nomenclatura combinata',
              densityAt15CDeg: '22 Densità',
              tankList: '23 Serbatoi',
              signer: 'Firmatario',
            },

            'PLZ': {
              documentNumber: 'Codice Polizza',
              shipper: 'Shipper',
              voyageNumber: 'Viaggio',
              externalVoyageNumber: 'External Voyage Number',
              numberOfOriginals: 'N° Originali',
              numberOfCopies: 'N° Copie',
              placeOfIssue: 'Place',
              issueDate: 'Date of issue',
              documentHolder: 'Intestatario',
              notifyAddress: 'Notify address',
              vesselName: 'Nome Nave',
              loadingPortDescription: 'Porto di caricazione',
              dischargePortDescription: 'Porto di destinazione',
              productDescription: "Descrizione Prodotto",
              weightInMtAir: 'Gross weight (MT)',
              volumeInM3At15CDeg: 'Metri Cubi a 15°C',
              movementInstructionNote: 'Note da istruzione movimento',
              shippingNote: 'Note Speditore',
              customCertificateDescription: "Documento fiscale",
              customCertificateNumber: "Nr. Documento fiscale",
              customCertificateDate: "Data documento fiscale",
              freightAsPer: 'Freight payable as per',
              charterPartyDated: 'Charter Party dated',
              freightAdvance: 'Freight Advance',
              accountFreight: 'Received on account of freight',
              freigthAt: 'Freight payable at',
              signer: 'Firmatario',
              masterOfVessel: 'Comandante',
              quantity: 'Quantità',
              minimumQuantity: 'Quantità minima',
              maximumQuantity: 'Quantità massima',

              items: {
                uoMCode: 'UdM',
                uoMDescription: 'UdM',
                movementInstructionLotUoMDescription: 'Unità di misura',
                quantity: 'Quantità',
              }
            },
            'CM': {
              voyageNumber: 'Viaggio',
              issueDate: 'Data',
              vesselName: 'Nome Nave',
              vesselFlag: 'Bandiera',
              masterOfVessel: 'Capitano',
              loadingPortDescription: 'Partita da',
              dischargePortDescription: 'Diretta a',
              departureDate: 'Data partenza',
              shipper: 'Caricatori',
              documentHolder: 'Ricevitori',
              movementInstructionNote: 'Note da istruzioni movimento',
              shippingNote: 'Note Speditore',
              packageAndMarks: 'Colli & Marche',
              productDescription: "Descrizione della merce",
              numberOfOriginals: 'N° Originali',
              numberOfCopies: 'N° Copie',
              signer: 'Firmatario',
              quantity: 'Quantità'
            },
            'CQTA': {
              voyageNumber: 'Viaggio',
              numberOfOriginals: 'N° Originali',
              numberOfCopies: 'N° Copie',
              issueDate: 'Data',
              productDescription: "Descrizione Prodotto",
              loadingPortDescription: 'Porto di Imbarco',
              vesselName: 'Nave',
              dischargePortDescription: 'Destinazione',
              documentHolder: 'Intestatario',
              densityAt15CDeg: 'Densità a 15° C',
              weightInMtAir: 'Tonnellate Metriche',
              firstProductDescription: '1° Prodotto',
              firstProductWeightInMt: 'MT 1° Prodotto',
              secondProductDescription: '2° Prodotto',
              secondProductWeightInMt: 'MT 2° Prodotto',
              volumeInM3At15CDeg: 'Metri cubici',
              volumeInLtAt15CDeg: 'Litri a 15° C',
              observedVolumeInLt: 'Litri Naturali',
              volumeInLtAt20CDeg: 'Litri a 20° C',
              movementInstructionNote: 'Note da istruzioni movimento',
              shippingNote: 'Note Speditore',
              inspectorName: 'Ispettore Indipendente',
              masterOfVessel: 'Comandante',
              signer: 'Firmatario',
              departureDate: 'Data di partenza',
              items: {
                uoMCode: 'UdM',
                uoMDescription: 'UdM',
                movementInstructionLotUoMDescription: 'Unità di misura',
                conversionFactor: 'Fattore di conversione',
                quantity: 'Quantità',
              }
            },
            'NP': {
              documentNumber: 'Numero',
              issueDate: 'Data',
              numberOfOriginals: 'N° Originali',
              numberOfCopies: 'N° Copie',
              departurePortAndLocationDescription: '2 Luogo di partenza',
              deliveryNoteHolder: '3 Committente',
              destinationDescription: '4 Destinatario',
              movementInstructionNote: 'Note da istruzioni movimento',
              shippingNote: 'Note Speditore',
              commercialReason: '6 Causale Trasporto',
              transportTypeDescription: '7 Tipo Trasporto',
              carrierDescription: '8 Vettore',
              locationOfLoadingAndIncoterm: '9 Porto / Resa',
              vesselName: '10 Mezzo',
              contractNumber: '11 Ordine',
              voyageNumber: '12 Viaggio',
              productCode: '13 Codice prodotto',
              productDescription: '14 Descrizione beni',
              weightMtAir: '16 Quantità in T/M',
              weightInMtAirCoded: '16 Quantità Codificata',
              volumeInM3At15CDeg: '16 Metri Cubi a 15° C',
              volumeInM3At15CDegCoded: '16 Volume Codificato',
              tit: '18 TIT',
              externalVoyageNumber: 'External Voyage Number',
              nC: '19 Nomenclatura combinata',
              densityAt15CDeg: '20 Densità',
              tankList: '21 Serbatoi',
              signer: 'Firmatario',
            },
            'RCD': {
              voyageNumber: 'Viaggio',
              issueDate: 'Data',
              numberOfOriginals: 'N° Originali',
              numberOfCopies: 'N° Copie',
              vesselName: 'Nave',
              productDescription: "Carico",
              shipper: 'Shipper',
              documentHolder: 'Intestatario',
              movementInstructionNote: 'Note da istruzioni movimento',
              shippingNote: 'Note Speditore',
              masterOfVessel: 'Comandante',
              signer: 'Firmatario',
              dischargePortDescription: 'Destinazione'
            },
            'RCC' : {
              voyageNumber: 'Viaggio',
              issueDate: 'Data',
              numberOfOriginals: 'N° Originali',
              numberOfCopies: 'N° Copie',
              vesselName: 'Nave',
              productDescription: "Carico",
              dischargePortDescription: 'Destinazione',
              movementInstructionNote: 'Note da istruzioni movimento',
              shippingNote: 'Note Speditore',
              masterOfVessel: 'Comandante',
              signer: 'Firmatario',

              items: {
                receiverDescription: 'Serbatoio',
                idRegistrySamplingPoint: 'Metodo',
                samplingPointDescription: 'Metodo',
                idRegistryAnalysisSampleReceiver: 'Destinatario',
                sampleReceiverDescription: 'Destinatario',
                numberOfSamples: 'N° Campioni',
                uoMCode: 'UdM',
                uoMDescription: 'UdM',
                quantity: 'Quantità campioni',
              }
            },
            'BEM': {
              documentNumber: 'Codice Bolla',
              issueDate: 'Data',
              numberOfOriginals: 'N° Originali',
              numberOfCopies: 'N° Copie',
              companyDescription: 'Committente',
              voyageNumber: 'Viaggio',
              externalVoyageNumber: 'External Voyage No',
              vesselName: 'Nome Nave',
              tankList: 'Serbatoi',
              confirmation: 'Conferma',
              contractNumber: 'Numero contratto',
              productCode: 'Codice prodotto',
              productDescription: "Descrizione prodotto",
              weightInMtAir: 'Quantità in T/M',
              volumeInM3At15CDeg: 'Metri Cubi a 15°C',
              densityAt15CDeg: 'Densità a 15°C',
              movementInstructionNote: 'Note da istruzioni movimento',
              shippingNote: 'Note Speditore',
              signer: 'Firmatario',
            },
            'SHT': {
              issueDate: 'Data',
              numberOfOriginals: 'N° Originali',
              numberOfCopies: 'N° Copie',
              vesselName: 'Nome Nave',
              documentHolder: 'Intestatario',
              voyageNumber: 'Viaggio',
              productCode: 'Codice prodotto',
              productDescription: "Descrizione prodotto",
              dischargePortDescription: 'Destinazione',
              movementInstructionNote: 'Note da istruzioni movimento',
              shippingNote: 'Note Speditore',
              masterOfVessel: 'Comandante',
              signer: 'Firmatario',
            },
          },      
          exciseRate: {
            page_title: 'Accise',
            fk: 'Descrizione Aliquota',
            exciseRate: 'Aliquota',
            exciseDelta: 'Delta',
            isSpecialized: 'Specializzata'
          },
          exciseRateSpecialization: {
            page_title: 'Specializzazione Accise',
            exciseRate: 'Aliquota',
            exciseDelta: 'Delta'
          },
          fixedBalanceDistribution: {
            page_title: 'Ripartizione Fisso / Balance',
            lotsToShare: 'Lotti da ripartire',
            lotsMeasures: 'Misure lotto balance',
            shareResults: 'Risultati ripartizione',

            level: 'Livello (mm)',
            temperature : 'Temperatura (°C)',
            density: 'Densità @ 15°C (Kg/Lt)',
            waterLevel: 'Liv Acqua (mm)',
            movedQty: 'Qta Mov (Kg)',
            stockQty: 'Giacenza (Kg)',
            movelVolume: 'Vol Mov (Lt)',
            stockVolume: 'Volume (Lt)',

            saveSuccess: 'Ripartizione effettuata con successo'
          },
          generalSettings: {
            page_title: 'Impostazioni Generali',
            settingsKey: 'Chiave',
            settingValue: 'Valore',
            settingType: 'Tipo'
          },
          stockManagement: {
            page_title: 'Gestione Stock'
          },
          StockManagementFixedTankCalibration:{
            page_title: 'Calibrazione Serbatoi Fissi',
            tankCode: 'Codice Serbatoio',
            kLevel: 'Livello K',
            defaultDensity: 'Densità default'
          },
          StockManagementIgccTank:{
            page_title: 'Serbatoi IGCC',
            tankCode: 'Codice Serbatoio',
            plantCode: 'Impianto'
          },
          StockManagementLockedAsset:{
            page_title: 'Attrezzature Bloccate',
            referenceDate: 'Data Riferimento',
            assetCode: 'Codice Attrezzatura'
          },
          StockManagementLockedDaily:{
            page_title: 'Dettaglio Record Bloccati',
            referenceDate: 'Data Rif',
            tank: 'Serbatoio',
            type: 'Tipo',
            productLevel: 'Liv Prod',
            waterLevel: 'Liv Acqua',
            density: 'Densità',
            temperature: 'Temperatura',
            pressure: 'Pressione in bar',
            weightInKg: 'Peso In Kg',
            volumeInLt: 'Volume In Lt',
            totalVolumeInCubicMeters: 'Volume Totale (M3)',
            liquidWeightInTons: 'Peso Liquidi (MT)',
            netGasWeightInTons: 'Peso Netto Gas (MT)',
            gasVolumeInCubicMeters: 'Vol Gas (M3)',
            molecularWeight: 'Peso Molecolare',
            gasTemperature: 'Temp Gas',
            waterLevelCubicMeters: 'Liv Acqua (M3)',
            environmentTemperature: 'Temp Amb',
            note: 'Note',
          },
          StockManagementMovementType:{
            page_title: 'Tipi di Movimento',
            isCalculationEnabled: 'Calcolo abilitato'
          },
          StockManagementPipe:{
            page_title: 'Stocchino Oleodotti Giornaliero'
          },
          StockManagementPipeMonthly:{
            page_title: 'Stocchino Oleodotti Mensile'
          },
          StockManagementTankCorrectionFactor:{
            page_title: 'Fattori di correzione',
            tankCode: 'Codice Serbatoio',
            correctionFactor: 'Fattore di correzione'
          },
          stockManagementMonthly: {
            page_title: 'Mensile'
          },
          stockManagementDaily: {
            page_title: 'Giornaliero'
          },
          StockManagementDailyPipe: {
            page_title: 'Stocchino Oleodotti',
            referenceDate: 'Data',
            pipeCode: 'Oleodotto',
            capability: 'Capacità',
            movementType: 'Tipo Movimento',
            vesselName: 'Nave',
            temperature: 'Temperatura',
            density: 'Densità',
            fX54: 'FX54',
            fX56: 'FX56',
            weightInKg: 'Peso (Kg)',

            reimportMessage: 'Sei sicuro di reimportare i dati di oggi?',
            reimportSuccess: 'I dati sono stati importati correttamente'
          },
          StockManagementDailyDeadStock: {
            page_title: 'Dead Stock',
            referenceDate: 'Data',
            assetCode: 'Attrezzatura',
            capability: 'Capacità',
            movementType: 'Tipo Movimento',
            vesselName: 'Nave',
            temperature: 'Temperatura',
            density: 'Densità',
            fX54: 'FX54',
            fX56: 'FX56',
            weight: 'Peso (Kg)',
            environmentTemperature: 'Temperatura Ambiente',
            gasTemperature: 'Temperatura Gas',
            level: 'Livello',
            minLevel: 'Livello Min',
            molecularWeight: 'Peso Molecolare',
            pressure: 'Pressione (Bar)',
            realLevel: 'Livello Reale',
            volume: 'Volume',
            waterLevel: 'Livello Acqua',
            reimportMessage: 'Sei sicuro di reimportare i dati di oggi?',
            reimportSuccess: 'I dati sono stati importati correttamente'
          },
          StockManagementMonthlyTank: {
            page_title: 'Stocchino Mensile Serbatoi',
          },
          StockManagementDailyTank: {
            page_title: 'Stocchino Giornaliero Serbatoi',
            referenceDate: 'Data',
            manualTab: 'Manuale',
            autoTab: 'Automatico',
            manualLockTab: 'Manuale+Congelamenti',
            
            lockedProductLevel: 'Livello Cong',
            lockedForcedProductLevel: 'Livello Cong Forzato',
            tankcode	: 'Serbatoio',
            movementType: 'Tipo Mov',
            productLevel: 'Lvl (mm)',
            waterLevel: 'H20 (mm)',
            yesterdayWaterLevel: 'H20 Ieri (mm)',
            deltaWaterLevel: 'Delta H20 (mm)',
            density: 'Dens (Kg/Lt)',
            yesterdayDensity: 'Dens Ieri (Kg/Lt)',
            deltaDensity: 'Delta Dens (Kg/Lt)',
            temperature: 'Temp (°C)',
            pressure: 'Press (Bar)',
            weightInKg: 'Peso (Kg)',
            volumeInLt: 'Volume (Lt)',
            movementTypeSource: '',
            idProductSource: '',
            productSource: '',
            productLevelSource: '',
            waterLevelSource: '',
            densitySource: '',
            temperatureSource: '',
            pressureSource: '',
            weightInKgSource: '',
            volumeInLtSource: '',
            totalVolumeInCubicMeters: '',
            liquidWeightInTons: '',
            netGasWeightInTons: '',
            gasVolumeInCubicMeters: '',
            molecularWeight: 'Peso Molecolare',
            gasTemperature: 'Temp Gas (°C)',
            molecularWeightSource: '',
            gasTemperatureSource: '',
            waterLevelCubicMeters: 'Vol H20 (m3)',
            environmentTemperature: 'Temp Amb (°C)',
            environmentSensor: '',
            environmentTemperatureSource: '',
            spVolumeTotal: '',
            spVolMax: '',
            spVolUnextractable: '',
            spVolAvailable: '',
            spVolExtractable: '',
            spWeightTotal: '',
            spWeightMax: '',
            spWeightUnextractable: '',
            spWeightAvailable: '',
            spWeightExtractable: '',
            waterLevelFromMTS: 'H2O MTS (mm)',
            deltaWaterLevelFromMTS: 'Delta H2O MTS (mm)',
            waterLevelFromMTSource: '',
            weightMTS: 'Peso MTS (Kg)',
            deltaWeightMTS: 'Delta Peso MTS (Kg)',
            deltaVolumeMTS: 'Delta Volume MTS (Lt)',
            volumeMTS: 'Volume MTS (Lt)',
            waterVolumeCubicMetersMTS: 'Vol H20 MTS (m3)',
            deltaWaterVolumeCubicMetersMTS: 'Delta Vol H20 MTS (m3)',
            yesterdayWaterLevelCubicMeters: 'Vol H20 Ieri (m3)',
            deltaWaterLevelCubicMeters: 'Delta Vol H20 (m3)',
            btn: {
              loadprovenance: 'Provenienza',
              calculate: 'Calcola Stocchino',
              tanksExcluded: 'Serbatoi esclusi',
              deltaStockReport: 'Delta Report',
              reimportExternalData: 'Reimporta Sistemi Esterni',
              export: 'Esportazioni',
              createLockedAsset: 'Re-Importa Congelamenti',
              manualLockTank: 'Congela',
              manualUnlockTank: 'Rimuovi dai Congelamenti',
              deltaStockEmail: 'Invia e-mail delta stock report'
            },
            calculateMessage: 'Vuoi ricalcolare lo stocchino?',
            reimportMessage: 'Vuoi reimportare lo stocchino? Tutte le modifiche effettuate verranno sovrascritte',
            exportMessage: 'Sei sicuro di voler esportare i dati?',
            createLockedAssetMessage: 'Sei sicuro di voler reimportare i congelamenti?',
            manualLockTankMessage: 'Vuoi congelare il serbatoio selezionato?',
            manualUnlockTankMessage: 'Vuoi rimuovere il serbatoio dai congelamenti?',
            deltaStockEmailMessage: 'Vuoi inviare l\'e-mail relativa al report delta stock per lo stocchino giornaliero del {XXX}?',

            sludgeWeight: 'Peso Sludge',
            sludgeVolume: 'Volume Sludge',
            propagateTankLock: 'Propaga congelamento nei giorni successivi'
          },
          DeltaStockReportConfiguration: {
            page_title: 'Configurazioni Delta Stock Report'
          },
          DeltaStockReportExcludedTanksConfig: {
            page_title: 'Serbatoi Esclusi'
          },
          DeltaStockReportProductConfig: {
            page_title: 'Prodotti',
            category: 'Categoria',
            subCategory: 'Sotto-Categoria'
          }, 
          FiscalDocuments: {
            page_title: 'Documenti Fiscali'
          },
          TanksMovementsListA18: {
            page_title: 'Lista Movimenti su Serbatoi (A18)',
            tankCode: "SERB",
            tankFiscalCircuitCode: "CIRC.",
            operationDate: "DATA MOVIMENTO",
            operationTypeCode: "COD TIPO MOV",
            operationTypeShortDesc: "TIPO MOV",
            productCode: "COD PROD",
            otherTankCode: "2° SERB",
            otherTankFiscalCircuitCode: "CIRC 2° SERB",
            movedWeight: "QTA MOVIMENTATA (KG)",
            movedVolume:  "QTA MOVIMENTATA (LT)",
            company: "CLIENTE",
            xyz: "XYZ",
            fiscalPositionShortDesc: "POS FISCALE",
            fiscalDestinationShortDesc: "DEST",
            fiscalUseDesc: "DEST D'USO",
            measurementReportNumber: 'N° VERB'
          },
          StockSummary: {
            page_title: 'Riepilogo Giacenze',
            productDescription: "Prodotto",
            productCode: "Prodotto",
            initialStockWeight: "Giacenza Iniziale KG",
            initialStockVolume: "Giacenza Iniziale LT",
            introducedWeight: "Introduzione KG",
            introducedVolume: "Introduzione LT",
            processedWeight: "Lavorazione KG",
            processedVolume: "Lavorazione LT",
            fiscalStockWeight: "Giacenza Finale KG",
            fiscalStockVolume: "Giacenza Finale LT"
          },
          Vetting: {
            page_title: 'Vetting'
          },
          VettingSafety: {
            page_title: 'Safety',
            status: ' ',
            plant: 'Impianto',
            voyageNumber: 'Viaggio',
            vessel: 'Nave',
            imoCode: 'Cod.IMO',
            chargeDischarge: ' ',
            product: 'Prodotto',
            voyageType: 'Tipo Viaggio',
            agency: 'Agenzia',
            laycan: 'Cancello',
            eta: 'ETA',
            etb: 'ETB',
            mooringDate: 'Ormeggio',
            inspectionDate: 'Data Ispezione',
            evaluation: 'Valutazione',
            ticket: 'Ticket',
            doubleMooring: 'Doppio Ormeggio',
            vesselNamed: 'Nomina Nave',
            invoice: 'Fattura',
            amount: 'Importo',
            note: 'Note',
            isPreArrivalOk: 'Pre Arrival OK',
            isTanksAcceptabilityOk: 'Accettabilità Cisterne OK',
            isPreArrivalKo: 'Pre Arrival KO',
            isTanksAcceptabilityKo: 'Accettabilità Cisterne KO'
          },
          isEthylene: 'Ethylene',
          isMethanol: 'Metanolo',
          isBlackProduct: 'Black Product',
          isBiofeed: 'Biofeed',
          familyDescription: 'Famiglia Prodotto',
          code: 'Codice',
          infoilCode: 'Codice Infoil',
          description: 'Descrizione',
          isDeleted: 'Cancellato',
          isEnabled: 'Abilitato',
          startDate: 'Data di inizio',
          expireDate: 'Data di scadenza',
          endDate: 'Data di fine',
          position: 'Posizione',
          isRefinery: 'Raffineria',
          isIgcc: 'Igcc',
          owner: 'Proprietario',
          currencyCode: 'Valuta',
          isoCode: 'Codice Iso',
          isoCodeNumber: 'Numero Codice Iso',
          name: 'Nome',
          languageCode: 'Lingue',
          isIssued: 'Emesso',
          isFiscal: 'Fiscale',
          aliasVesselNominationAI: 'Alias Vessel Nomination IA',
          englishDescription: 'Descrizione Inglese',
          isInternalUse: 'Uso Interno',
          isForTheMaster: 'Per il capitano',
          isForTheConsignee: 'Per il destinatario',
          documentDescription: 'Descrizione Documento',
          infoilCode: 'Codice Infoil',
          shortDescription: 'Descrizione Breve',
          longDescription: 'Descrizione Estesa',
          isMovementInstructionSelected: 'Istruzione Movimento Selezionata',
          prefix: 'Prefisso',
          suffix: 'Suffisso',
          format: 'Formato',
          year: 'Anno',
          month: 'Mese',
          day: 'Giorno',
          progressive: 'Progressivo',
          header: 'Intestazione',
          form: 'Modulo',
          details: 'Dettagli',
          abbreviation: 'Abbreviazione',
          italianDocumentHeader: 'Intestazione Documento Italiano',
          englishDocumentHeader: 'Intestazione Documento Inglese',
          genericDescription: 'Descrizione Generica',
          order: 'Ordine',
          note: 'Note',
          unitofMeasureCode: 'UdM',
          transportDepartmentCode: 'Codice del dipartimento dei trasporti',
          transportDepartmentDescription: 'Descrizione Dipartimento di Trasporto',
          isGas: 'Gas',
          isMain: 'Principale',
          formatQuantity: 'Formato',
          conversionTableCode: 'Funzione di conversione',
          scope: 'Ambito',
          general: 'Generali',
          isManual: 'Manuale',
          status: 'Stato',
          counterparty: 'Controparte',
          documentNumber: 'Numero Documento',
          documentDate: 'Data Documento',
          grossQuantity: 'Qtà lorda',
          netQuantity: 'Qtà netta',
          DRAFT_STATUS: 'Bozza',
          validFrom: 'Inizio validità',
          validTo: 'Fine validità',
          testMethods: 'Metodi di test',
          uoMCode: 'Unità di misura',
          propertyCode: 'Codice proprietà',
          value:'Valore',
          key: 'Chiave',
          minValue: 'Valore minimo',
          maxValue: 'Valore massimo',
          message: 'Messaggio',
          operationDate: 'Data Operazione',
          CREATED: 'Creato',
          CANCELED: 'Cancellato',
          CLOSED: 'Chiuso',
          ONGOING: 'In corso',
          version: 'Versione',
          alternativeDescription: 'Descrizione Alternativa',
          isTankOperationRegistryEnabled: 'Operazione Serbatoio Abilitata',
          isReal: 'Reale',
          IsBufferTank: 'Serbatoio Polmone',
          validityStartDate: 'Inizio Data Validità',
          validityEndDate: 'Fine Data Validità',
          intValue: 'Valore Intero',
          decimalValue: 'Valore Decimale',
          textValue: 'Valore Testuale',
          from: 'Da',
          to: 'A',
          showHidden: 'Mostra Nascosti',
          all: 'Tutti',
          departmentNote: 'Nota',
          companyDescription: 'Azienda',
          counterparty: 'Controparte',
          operationTypeDescription: 'Tipo operazione',
          plant: 'Impianto',
          productDescription: 'Prodotto',
          lastInsertDate: 'Data ultimo inserimento',
          quantity: 'Quantità',
          minimumQuantity: 'Quantità minima',
          maximumQuantity: 'Quantità massima',
          laycanStartDate: 'Laycan da',
          laycanEndDate: 'Laycan a',
          revision: 'Revisione',
          group: 'Gruppo',
          isFip: 'FIP',
          isOnlyOneLotPermitted: 'Solo un Lotto permesso',
          isPartialEndNotificationWithOnlyInputParams: 'Misura Parziale permessa', 
          reports: 'Report',
          total: 'Totale',
          equipmentSenderTankDecantingOpSwitch: {
            page_title: 'Mittenti Travaso per Inversione'
          },
          FINAL: 'Consuntivo',
          PARTIAL: 'Parziale',
          taxRate: 'Aliquota',
          destination: 'Destinazione',
          reportType: 'Formato',
          chooseReportTypeTitle: 'Scegli il formato',
          macroProductCode: 'Macro Prodotti',
          StockManagementManualEditLog: {
            page_title: 'Log Modifiche',
            referenceDate: 'Data Riferimento',
            modificationDate: 'Data',
            modificationUser: 'Utente',
            modificationField: 'Campo',
            oldValue: 'Vecchio valore',
            newValue: 'Nuovo valore'
          },
          StockManagementMts: {
            page_title: 'MTS',
            referenceDate: 'Stocchino Del',
            measureDate: 'Data Misura',
            tankCodeMts: 'Serbatoio MTS',
            tankCode: 'Serbatoio',
            waterLevelMts: 'Livello Acqua MTS',
            waterLevel: 'Livello Acqua',
            notes: 'Note',
            productLevelMts: 'Livello Prodotto MTS',
            recordStatus: 'Stato Record',
            btn: {
              insert: 'Aggiungi',
              export: 'Export a stocchino manuale',
              update: 'Aggiorna'
            },
            message: {
              confirmReimport: 'Attenzione! Questo cancellerà tutte le modifica ai dati MTS effettuate riguardanti questo giorno. Vuoi procedere?',
              confirmExport: 'Vuoi esportare i valori nello stocchino manuale?',
              referenceDateRequired: 'Specificare la data dello stocchino giornaliero.'
            }
          },
          Hter9: {
            page_title: 'HTER9',
            productMacroCode: "Prodotto",
            note: "",
            destination: "",
            movementType: "Tipo Mov",
            fiscalPosition: "Pos Fisc",
            movedWeight: "Qta Estratta (Kg)",
            movedVolume: "Qta Estratta (Lt)",
            taxableQuantity: "Qta Imponib Kg/Lt",
            exciseRate: "Aliquota",
            exciseDue: "Imposta Dovuta",
            exciseDuty: "Imposta Gravante",
            liquids: 'Liquidi',
            gas: 'Gas',
            today: 'Odierna',
            prev: 'Precedente',
            total: 'Totale'
          },
          AdditiveReport: {
            page_title: 'Report Additivi / Denaturanti',
            tankCode: 'Serbatoio',
            operationDate: 'Data',
            additive: 'Additivi',
            denaturing: 'Denaturanti',
            reportType: 'Tipologia'
          },
          VesselProtocolAlerts: {
            page_title: 'Alert Protocollo Navi',
            alertType: 'Tipo',
            alertCount: 'Numero',
            exportExcel: 'Esporta Excel Alert',
            hiddenButton: 'Nascondi Alert',
            hiddenMessage: 'Vuoi nascondere l\'alert selezionato?'
          },
          VesselProtocolDocumentSearch: {
            page_title: 'Ricerca Documenti'
          },
          VesselProtocolTributeSearch: {
            page_title: 'Ricerca Tributi',
            arc: 'Arc',
            portualTax: 'Tasse portuali',
            dateFrom: 'Data Scadenza Pagamento da:',
            dateTo: 'Data Scadenza Pagamento da:'
          },
          JettyUllage: {
            page_title: 'Ullage Report',
            voyageNumber: 'Viaggio',
            from: 'Da',
            to: 'A',
            registryVessel: 'Nave',
            berthNumber: 'Piattaforma',
            ullageDate: 'Data',
            draftFore: 'Draft Fore',
            draftAfter: 'Draft After',
            draftTrim: 'Trim by Stern',
            list: 'List',
            products: 'Prodotti',
            type: 'Tipologia',
            insertDate: 'Data Inserimento',
            documentDescription: 'Descrizione',
            documentDate: 'Data Documento',

            gradeName: 'Grade Name',
            density15: 'Density @ 15°C',
            density20: 'Density @ 20°C',
            tov: 'T.O.V.',
            freeWater: 'Free Water',
            averageTemperature: 'Av. Temper.',
            gov: 'G.O.V.',
            gsv: 'G.S.V.',
            sedimentsAndWater: 'S&W',
            nsv: 'N.S.V.',
            obq: 'O.B.Q.',
            vef: 'V.E.F.',
            weightInAir: 'Weight in air',
            netWeight: 'Net Weight',

            tank: 'Tank n°',
            tankSubTitle: 'N° Cisterna',
            ullage: 'Ullage',
            freeWaterInnage: 'Free Water Innage',
            freeWaterVolume: 'Free Water Volume',
            temperature: 'Temp.',
            vcf: 'V.C.F.',

            tankVolume: 'Tank\'s Volume',
            level: 'Level',
            pressure: 'Pressure',
            liquidTemperature: 'Liquid T',
            liquidShrinkageFactor: 'Liquid Shr. Fac.',
            liquidDensity: 'Liquid Density',
            liquidVolume: 'Liquid Volume',
            liquidWeight: 'Liquid Weight',
            steamTemperature: 'Vapour T',
            steamShrinkageFactor: 'Vapour Shr. Fac.',
            molecularWeight: 'P.M.',
            steamVolume: 'Vapour Volume',
            steamWeight: 'Vapour Weight',
            steamDensity: 'Vapour Density',
            quantitiesOnBoard: 'Quantities On Board',
            quantitiesOnBoardBefore: 'Quantities On Board Before Operation',
            totalCorrectedLiquidVolume: 'Total Corrected Liquid Volume',
            totalCorrectedSteamVolume: 'Total Corrected Vapour Volume',
            totalLiquidWeight: 'Total Liquid Weight', 
            totalSteamWeight: 'Total Vapour Weight',
            totalWeight: 'Total Weight',
          },
          copyProfile: 'Clona Ruoli',
          copyProfileMessage: 'Sei sicuro di voler importare tutti i ruoli dall\'utente selezionato?',
          cloneProductSpecification: 'Clona Specifiche',
          cloneProductSpecificationMessage: 'Sei sicuro di voler clonare le specifiche selezionate?',
          newValidityStartDate: 'Nuova data inizio validità',
          type: 'Tipo',
          vesselProtocolProtocolReport: 'Report Protocolli',
          ProtocolReport: {
            loading: 'Loading',
            discharge: 'Discharge',
            dataProtocollo: 'Protocol Date',
            protocolNumber: 'Protocol Number',
            allocation: 'Allocation',
            shipsName: 'Ship\'s name',
            cargoName: 'Cargo name',
            origineOfTheCargo: 'Origin of the Cargo',
            comingOfTheCargo: 'Coming of the Cargo',
            shipToShip: 'Ship to Ship',
            installation: 'Installation',
            berth: 'Berth',
            shorePipeline: 'Shore Pipeline',
            shoreTank: 'Shore Tank',
            customsDeclaration: 'Customs Declaration',
            documentsNumber: 'Documents Number',
            documentsDate: 'Documents Date',
            incoterms: 'Incoterms',
            totaleFatture: 'Invoice Value',
            valoreUnitario: 'Unit price per T/M',
            dataPolizza: 'Bill of lading date',
            qtaBillOfLading: 'Bill of lading qty(KG)',
            vol15BillOfLading_A: 'Bill of lading qty(Liters at 15) -A-',
            densitaDiPolizza: "Bill of lading density",
            densitaBarilotto: "Automatic Sample Density",
            obq: "OBQ",
            rob: "ROB",
            vef: 'VEF',
            volumeBordoPartenzaLordoAcquaObq: "Ship's Departure figure (Liters at 15°)",
            volumeBordoPartenzaLordoAcquaObqVEF: 'Ship\'s Departure figure V.E.F. applied (Liters at 15°)',
            volumeBordoArrivoLordoAcquaObq: 'Ship\'s arrival figure (Liters at 15°)',
            volumeBordoArrivoLordoAcquaObqVEF: 'Ship\'s arrival figure V.E.F. applied (Liters at 15°)',
            volumeLordoSbarcatoVEFApplicato: 'Ship\'s qty discharged including water and OBQ, less R.O.B. with V.E.F. applied (Liters at 15°)',
            accertamentoSerbatoioNettoH2O: 'Shore tanks qty including water and sediments (Liters at 15°)',
            bordoArrivo_Meno_BordoPartenzaInLitri: 'Ship\'s arrival figure LESS ship\'s departure figure (Liters at 15°)',
            bordoArrivoVEF_Meno_BordoPartenzaVEFInLitri: 'Ship\'s arrival figure LESS ship\'s departure figure V.E.F. applied (Liters at 15°)',
            volumeBordoArrivoLordo_Meno_BOLLitriA15: 'Ship\'s arrival figure V.E.F. applied LESS Bill of Lading (Liters at 15°)',
            volumeLordoSbarcatoVEF_Meno_BOLInLitri: 'Ship\'s qty discharged incl. H2O and OBQ less ROB VEF appl. LESS Bill of Lading',
            accSerbatoioLordoAcqua_Meno_VolLordoSbarcatoVEFInLitri: 'Shore tanks quantity Liters at 15° LESS Ship qty disch. Incl. H2O, OBQ less ROB VEF appl.',
            accSerbatoioLordoAcqua_Meno_VBillOfLadingQuantityLiters15: 'Shore tanks quantity incl. Water and sediments LESS Bill of Lading',
            bordoArrivo_Meno_BordoPartenzaPerc: 'Loss in transit (NO VEF)',
            bordoArrivoVEF_Meno_BordoPartenzaVEFPerc: 'Loss in transit (VEF applied)',
            volumeBordoArrivoLordo_Meno_BOLLitriA15Perc: 'Loss on arrival',
            volumeLordoSbarcatoVEF_Meno_BOLPerc: 'Loss transport',
            accSerbatoioLordoAcqua_Meno_VolLordoSbarcatoVEFPerc: 'Loss vs Ship',
            accSerbatoioLordoAcqua_Meno_VBillOfLadingQuantityPerc: 'Total Loss',

            cargoDestination: 'Cargo Destination',
            finalDestination: 'Final Destination',
            inf3AtrEur1Coo: 'Inf3-Atr-Eur1-Coo',
            averageDensity: 'Average Density',
            zolfoPerc: '% Zolfo',
            billOfLadingDate: 'Bill Of Lading Date',
            billOfLadingQttyLitri: 'Bill Of Lading Qty (Lt) -A1-',
            billOfLadingQttyKg: 'Bill Of Lading Qty (KG) -A-',
            pesoBordo: 'Ship s fig. as per ullage report(Kg)',
            pesoBordoVEF: 'Ship s fig. vef applied -B-',
            qtaAccertataDepRiceventeKg: 'Quantity received at discharging port (Kg.) - C -',
            qtaAccertataDepRiceventeLitri: 'Quantity received at discharging port (Lt.) - D -',
            pesoBordoVEF_Meno_QtaAccertataBillOfLadingKg: 'Ship s fig.(vef apll.) less B/L in KG-(B - A)',
            pesoBordoVEF_Meno_QtaAccertataBillOfLadingPerc: 'Ship s fig.(vef apll.) less B/L in %- (B - A)',
            qtaAccDepRicevente_Meno_QtaAccBillOfLadingKg: 'Qtty at disch. port less B/L in KG- (C - A)',
            qtaAccDepRicevente_Meno_QtaAccBillOfLadingKgPerc: 'Qtty at disch. port less B/L in %- (C - A)',
            qtaAccDepRicevente_Meno_QtaAccBillOfLadingLitri: 'Qtty at disch. port less B/L in LT- (D - A1)',
            qtaAccDepRicevente_Meno_QtaAccBillOfLadingLitriPerc: 'Qtty at disch. port less B/L in LT- (D - A1)',

            generalInfo: 'Info principali',
            asset: 'Assetti',
            customsInfo: 'Info Doganali',
            refineryAscertainmentData: 'Dati accertamento Raffineria',
            boardAscertainmentData: 'Dati accertamento Bordo',
            receiverAscertainmentData: 'Dati accertamento Dep. Ricevente',
            diffKg: 'Diff KG',
            diffLt: 'Diff LT',
            diffPerc: 'Diff %',

            commercialInfo: 'Info Commerciali',
            billOfLadingData: 'Dati di polizza',
            ascertainmentData: 'Dati di accertamento',
            volumeDiff: 'Differenze in volume',
            percDiff: 'Differenze in percentuale',
          },
          compulsoryStock: {
            page_title: 'Gestione Scorte d\'obbligo - Mensili',
            importTab: 'Importa',
            processTab: 'Elabora',
            exportTab: 'Esporta',
            referenceDate: 'Data Riferimento',
            registryProduct: 'Prodotto',
            ownerCompany: "Società",
            productFamily: "Gruppo Prodotto Scorte",
            quantity: "Quantità",
            originType: "Origine",
            deposit: "Deposito",
            isImportable: "Importabile",
            warning: "Warning",
            tankCode: 'Serbatoio'
          },
          dailyCompulsoryStock: {
            page_title: 'Gestione Scorte d\'obbligo - Giornaliere'
          },
          DischargeTrackingReport: {
            page_title: 'Report Tracciamento Discariche',
            referenceDate: 'Data Riferimento (Fine cancello)',
            certificateOfOriginStatus: 'Certificato di Origine',
            suppliersDeclarationStatus: 'Dichiarazione del Fornitore',
            exportDeclarationStatus: 'Dichiarazione di Esportazione',
            nonManipulationDeclarationStatus: 'Dichiarazione di non manipolazione',
            voyageReportStatus: 'Voyage Report',
            receiptOfDocumentsAndSamplesStatus: 'Ricevuta documenti e campioni',
            letterOfProtestSamplesStatus: 'Lettera di Protesta (Campioni)',
            letterOfProtestFromMasterStatus: 'Lettera di Protesta (da Capitano)',
            isOriginSamplePresent: 'Campione di origine',
            isCompleted: 'Completo',
            document: 'Documento',
            documentStatus: 'Stato',
            genericGridDocumentStatus: 'Stato Tracciamento Discariche',
            upload: 'Carica',
            status: {
              Missing: 'Mancante',
              ToBeValidated: 'Da validare',
              NotValid: 'Non valido',
              Valid: 'Valido',
              Present: 'Presente'
            },
            changeStatusMessage: 'Vuoi confermare il cambio di stato per il documento selezionato?',
            logDate: 'Data',
            logEntry: 'Evento',
            loadingPort: 'Porto di caricazione',
            dischargePort: 'Porto di discarica',
            infoExportDeclaration: 'Obbligatorio solo se il porto di provenienza è Russo',
            infoNonManipulation: 'Obbligatorio solo se il viaggio è ship to ship',
            infoLetterOfProtestSamples: 'Obbligatorio solo se il campione di origine è assente',
            infoSuppliersDeclaration: 'Obbligatorio se il prodotto non è un greggio'
          },
          RawMaterialCheck: {
            page_title: 'Verifica Materie Prime',
            originSample: 'Campione d\'origine',
            loadingPort: 'Porto di caricazione',
            isRecordProcessed: 'Done?',
            rawMaterial: 'Raw Material',
            grade: 'Grade',
            voyageNumber: 'Allocation',
            vesselName: 'MT',
            analysisSampleNumber: 'Sample Number',
            sample: 'BARILOTTO',
            originSampleHeader: 'CAMPIONE ORIGINE',
            loadingPortHeader: 'PORTO DI CARICAZIONE',
            uomDensity: 'd [kg/m3]',
            uomSulphur: 'zolfo [%p]',
            differenceSampleVsOriginSample: 'DIFFERENZA BARILOTTO vs ORIGINE',
            differenceSampleVsLoadingPortSample: 'DIFFERENZA BARILOTTO vs PORTO DI CARICAZIONE',
            density: 'DENSITA\'',
            sulphur: 'ZOLFO (ASTM D4294)',
            x: 'X',
            r: 'R',
            plus2R: '+2R',
            minus2R: '-2R',
            result: 'Result',
            ok: 'Ok',
            associateNoteQuestion: 'Vuoi associare questa nota?',
            referenceDate: 'Data Riferimento',
            oldValue: 'Vecchio valore',
            newValue: 'Nuovo valore',
            color: 'Colore',
            analysisValuesImportSuccess: 'Dati analisi importati correttamente',
            analysisValuesImportNotFound: 'Dati analisi non trovati',

            barrelDensity: 'Densità Barilotto',
            barrelApiGrade: 'Grado API Barilotto',
            barrelSulphurContent: 'Contenuto Zolfo Barilotto',

            originSampleDensity: 'Densità Campione Origine',
            originSampleApiGrade: 'Grado API Campione Origine',
            originSampleSulphurContent: 'Contenuto Zolfo Campione Origine',
            importSample: 'Importa Campione',
            validate: 'Valida',
            validateMessage: 'Imposta stato',
            done: 'Completato',
            undone: 'Non Completato',
            copyFrom: 'Copia da',
            copyNotesQuestion: 'Vuoi copiare le note dal mese selezionato?',
            deleteNoteAssociation: 'Vuoi eliminare l\'associazione alla nota?'
          },
          isDischargeTrackingEnabled: 'Tracking Discariche',
          isEquipmentTrackingEnabled: 'Tracking Serbatoi Vendite',
          planning:{
            page_title: 'Planning'
          },
          vesselSummary: {
            page_title: 'Vessel Summary',
            cluster: 'Cluster',
            product: 'Product',
            note: 'Note',
            isabCode: 'Isab Code',
            terminal: 'Terminal',
            laycanString: 'Laycan',
            provisionalQuantityString: 'Provisional Quantity',
            pricing: 'Pricing',
            premium: 'Premium',
            weekNumber: 'Settimana',
            year: 'Anno',
            norDate: 'NOR',
            mooringDate: 'Data Ormeggio',
            startDate: 'Data inizio',
            endDate: 'Data fine',
            lastVersions: 'Versioni Pubblicate',
            changeStatusBtn: 'Cambia Stato',
            alignActualInfo: 'Align Actual Info',
            operationaLaycan: 'Operational Laycan'
          },
          dealNote:{
            page_title: 'Deal Note',
            laycanStartDate: "Data Inizio Cancello",
            laycanEndDate: "Data Fine Cancello",
            plannedLaycanStartDate: "Data Inizio Cancello Pianificato",
            plannedLaycanEndDate: "Data Fine Cancello Pianificato",
            dealDate: 'Data Deal',
            family: "Cluster",
            product: 'Prodotto',
            plannedProduct: 'Prodotto Pianificato',
            grade: 'Grade',
            isabCode: 'IsabCode',
            terminal: 'Terminal',
            plannedTerminal: 'Terminal Pianificato',
            status: 'Status',
            quantity: 'Quantità Kton',
            plannedQuantity: 'Quantità Pianificata',
            quality: 'Qualità',
            econs: 'Econs',
            priceWindow: 'Price Window',
            premium: 'Premium',
            dfl: 'DFL',
            margin: 'Marging',
            buyerSeller: 'Buyer/Seller',
            benchmark: 'BenchMark',
            comment: 'Comment',
            load: 'Carica',
            update: 'Modifica',
            minimumQuantity: 'Quantità Minima Kton',
            maximumQuantity: 'Quantità Massima Kton',
            uom: 'UoM',
            plannedMinimumQuantity: 'Quantità Minima Pianificata',
            plannedMaximumQuantity: 'Quantità Massima Pianificata',
            plannedUom: 'UoM Pianificata',
            marker: 'Marker',
            export: "Esporta",
            legend: 'Differenze Con i Campi Planned',
            description: 'Descrizione Documento',
            documentDate: 'Data Caricazione',
            createdBy: 'Caricato Da',
            fileName: 'Nome File',
            documents: 'Documenti Caricati',
            warning: 'Nessun documento caricato per questo Deal',
            fileExtension: 'Tipo File',
            premiumBase: 'Premium Base',
            qualityPremium: 'Quality Premium',
            code: 'Code',
            platts: 'Platts',
            startDate: 'Data da',
            updateStatusDoneMessage: 'Lo stato del Deal è Done. Sicuro di voler procedere con la modifica?',
            uploadDocument: 'Carica Documenti',
            downloadDocument: 'Download Documenti',
            exportTooltip: 'Esporta Excel',
            registryVessel: 'Nave',
            voyageNumber: 'Allocation',
            quantityKbbl: 'Quantità Kbbl',
            log: 'Deal Note Log',
            field: 'Campo Modificato',
            oldValue: 'Valore Precedente',
            newValue: 'Valore Attuale',
            operationDate: 'Data Modifica',
            logWarning: 'Deal Note Creato',
            openLog: 'Visualizza Log',
            clone: 'Clona Deal',
            exitMessage: 'Vuoi uscire dalla pagina? Potrebbero esserci delle modifiche non salvate.',
            username: 'Username',
            provisionalDensity: 'Densità Previsionale',
            contractualCoefficient: 'Coefficiente Contrattuale',
            labelPriceWindow: 'Price Window',
            labelDatePriceWindow: 'Mese di riferimento',
            priceWindowMessage: 'Il campo Label / Mese di riferimento della PriceWindow è obbligatorio!',
            addPriceWindow: 'Aggiungi Price Window',
            updateBlocked: 'Il movimento fà parte di un TrueUp chiuso.',

            splitMessage1: 'Il viaggio da clonare è stato liquidato con quantità: ',
            splitMessage2: ' e ',
            splitMessage3: ' con Price Window: ',
            actualQuantity1: 'Quantità 1',
            actualQuantity2: 'Quantità 2',
            actualVolume1: 'Volume 1',
            actualVolume2: 'Volume 2',
          },
          stocchinoPlanManagement: {
            page_title: 'Stocchino Plan Management'
          },
          stocchinoPlanMasterData: {
            page_title: 'Anagrafiche'
          },
          operativeLevels: {
            page_title: 'Livelli Operativi',
            lastUpdateDate: 'Data Aggiornamento',
            referenceLevel: 'Linea di Fede',
            minOperativeLevel: 'Livello Min Operativo',
            maxOperativeLevel: 'Livello Max Operativo',
            conversionFactor: 'Coefficiente di conversione',
            downloadTemplateExcel: 'Scarica template Excel',
            importExcel: 'Importa da Excel',
            importSudSuccess: 'Import dei dati di SUD completato con successo',
            importNordSuccess: 'Import dei dati di NORD completato con successo'
          },
          StocchinoPlanAggregationType: {
            page_title: 'Tipologia Aggregazioni',
            fk:  'Tipologia Aggregazione',
            nome: 'Nome',
            descrizione: 'Descrizione',
            validityStartDate: 'Data inizio validità',
            validityEndDate: 'Data fine validità',
            versione: 'Versione',
            isAggregazioneProdotti: 'Aggregazione Prodotti?'
          },
          StocchinoPlanProductAggregation: {
            page_title: 'Aggregazione Prodotti',
            codice: 'Codice',
            descrizione: 'Descrizione',
            site: 'Sito',
            ordineLivello: 'Ordine Livello',
            isFamigliaProdottoDefault : 'Famiglia Prodotto Default',
            isSemiFinished: 'Semilavorato',
            isRawMaterial: 'Materia Prima',
            newVersion: 'Nuova Versione',
            checked: 'Associato'
          },
          StocchinoPlanFamilyAggregation: {
            page_title: 'Aggregazione Famiglie',
            codice: 'Codice',
            descrizione: 'Descrizione',
            site: 'Sito',
            ordineLivello: 'Ordine Livello',
            isFamigliaProdottoDefault : 'Famiglia Prodotto Default',
            isSemiFinished: 'Semilavorato',
            isRawMaterial: 'Materia Prima',
            newVersion: 'Nuova Versione',
            calcolaMinMaxWS: 'Calcola Min Max WS',
            invertiSegnoDeltaTargetSummary: 'Inverti Segno Delta Target'
          },
          StocchinoPlanTankExceptions: {
            page_title: 'Eccezioni Serbatoi',
            idAttr: 'Tank',
            isImportEscluso: 'Import Escluso?',
            isVolumeFromPI: 'Volume da PI?',
            isDaRielaborare: 'Da Rielaborare?',
            startDate: 'Data inizio',
            endDate: 'Data fine'
          },
          StocchinoPlan: {
            page_title: 'Stocchino Plan',
            automatic_title: 'Stock',
            productFamilyStorage_title: 'Product Family Storage',
            inventory_title: 'Inventory',
            minMaxWs_title: 'Min/Max Working Stock',
            dataStocchino: 'Data Stocchino',
            tank: 'Serbatoio',
            isFuoriServizio: 'Fuori Servizio',
            site: 'Sito',
            target: 'Target',
            ownerCompanyDescription: 'Proprietario merci',
            ownerCompanyDescriptionNotSpecified: 'Non specificato',
            density: 'Densità',
            productLevel: 'Livello Prodotto',
            waterLevel: 'Livello H2O',
            volH2O: 'MC H2O',
            isSemiFinished: 'Semifinito',
            volExtractable: 'MC Estraibili',
            volEmpty: 'MC a vuoto',
            weightExtractable: 'Ton. Estraibili',
            weightEmpty: 'Ton. a vuoto',
            volTotal: 'MC Totali',
            weightTotal: 'Ton. Totali',
            product: 'Prodotto',
            family: 'Famiglia',
            messageOutOfServiceChangedAuto: 'Lo stato del serbatoio è stato impostato dal job automatico. Vuoi modificare lo stato del serbatoio?',
            stockFamilyDescription: 'Stock',
            recalculate: 'Ricalcola',
            importAndRecalculate: 'Importa e Ricalcola',
            importAndRecalculateMessage: 'Questa funzionalità importa nuovamente i dati dallo Stocchino Giornaliero COFI. Le eventuali modifiche apportate verranno perse. Vuoi continuare?',
            saveHasWarnings: 'Salvataggio effettuato con successo. Verifica i warning',
            inventory: 'Inventory',
            holdUpQty: 'Qtà Hold Up',
            inventoryHoldUpQty: 'Qtà Inventario Hold Up',
            target: 'Target',
            maxVolumeOfTanksQty: 'Max Volume of Tanks Qty',
            availableVolume: 'Empty Volume',
            delta: 'Delta',
            inventorySouthQty: 'Qtà Sud',
            inventoryNorthQty: 'Qtà Nord',
            inventoryTotalQty: 'Qtà Totale',
            minWSQty: 'Qtà Min. Ws',
            maxWSQty: 'Qtà Max. Ws',
            isabTargetQty: 'ISAB Qtà',
            availableVolumeOfTanksSouthQty: 'Qtà Sud',
            availableVolumeOfTanksNorthQty: 'Qtà Nord',
            availableVolumeOfTanksTotalQty: 'Qtà Totale',
            deltaInvMinWSQty: 'INV.-mWS',
            deltaMinWSInvQty: 'mWS -INV',
            deltaIsabTargetInvQty: 'INV - ISAB target',
            summaryViewBtn: 'Visualizzazione Estesa',
            inventoryViewBtn: 'Visualizzazione Compatta',
            inventoryExtractable: 'Inventario Estraibile',
            inventoryUnextractable: 'Inventario Inestraibile',
            inventoryExtractableSouthQty: 'Qtà Sud',
            inventoryExtractableNorthQty: 'Qtà Nord',
            inventoryExtractableTotalQty: 'Qtà Totale',
            floatingStorageQty: 'Qtà Floating Storage',
            inventoryHoldUpLoadBtn: 'Carica Hold-up',
            totalTankStorageQty: 'Tot. Capacità Stoccabile',
            oneThirdSemifinishedProductQty: '1/3 Semifinished Product Qty',
            unextractableQty: 'Qtà inestraibile',
            safetyStockIN: 'Stock di sicurezza',
            budgetProductDailyQtyIN: 'Budget Qtà Giornaliera',
            daysOfProductionIN: 'Giorni di produzione',
            safetyTonsIN: 'Tonnellate di sicurezza',
            holdUpQtyIN: 'Hold Up',
            productionByBudgetDailyQtyIN: 'Produzione Giornaliera',
            budgetTpIN: 'Budget t/p',
            minWs: 'Min WS',
            maxWs: 'Max WS',
            lukoilTargetQty: 'LUKOIL Qtà',
            deltaLukoilTargetLukoilInvQty: 'Lukoil Target - Inventory in Lukoil',
            deltaMaxWSInvQty: 'MWS - INV',
            inventoryLukoilTotalQty: 'Qta Inventario Lukoil Target',
            changeTabMessage: 'Ci sono delle modifiche non salvate. Cambiando pagina perderai le modifiche non salvate. Vuoi continuare?',
            tankCompositionNotAvailable: 'La composizione del serbatoio selezionato non è disponibile.',
            tankCompositionTitle: 'Contenuto Serbatoio: '
          },
          StocchinoPlanAuditMasterData: {
            page_title: 'Audit Anagrafiche'
          },
          StocchinoPlanAuditStocchino: {
            page_title: 'Audit Stocchino'
          },
          StocchinoPlanAuditOperativeLevels: {
            page_title: 'Audit Livelli Operativi'
          },
          StocchinoPlanAudit:{
            page_title: 'Audit',
            entity: 'Entity',
            idRecord: 'Id Record',
            username: 'Utente',
            dataOperazione: 'Data Operazione',
            tipoOperazione: 'Tipo Operazione'
          },
          parent: 'Parent',
          DailyProfiles: {
            page_title: 'Profili Giornalieri',
            family: 'Famiglia',
            startDate: 'Data Inizio',
            endDate: 'Data Fine',
            referenceDate: 'Day',
            southMovedQuantity: 'S',
            southMovedNote: 'S Note',
            northMovedQuantity: 'N',
            northMovedNote: 'N Note',
            stkQuantity: 'STK',
            stkActualQuantity: 'STK Actual (BMG)',
            stkRealQuantity: 'STK Real (Stocchino)',
            plannedTPQuantity: 'T/P',
            actualTPQuantity: 'T/P Actual',
            minWSQuantity: 'mWS',
            maxWSQuantity: 'MWS',
            transferQuantityS: 'Transfer S',
            transferQuantityN: 'Transfer N',
            startingStk: 'Giacenza iniziale',
            recalculateBtn: 'Ricalcola',
            importBMM: 'Importa da BMM',
            importBMG: 'Importa da BMG',
            importTpPlanned: 'Importa LP Planned',
            importStkReal: 'Importa Stoccaggio Reale',
            importMinMaxWs: 'Importa Min Max Ws',
            month: 'Mese',
            createMonth: 'Crea Mese',
            TD: 't/d',
            TP: 't/p',
            deltaQuantity: 'Δ',
            minMaxWs: 'Min Max WS',
            initialStockQuantity: 'IN STK',
            tpQuantity: 'TP',
            inQuantity: 'INTRO',
            forecastQuantity: 'FORECAST',
            transferQuantity: 'TUBE',
            finalStockQuantity: 'FIN STK',
            finalBMMStockQuantity: 'IN STK BMM',
            refreshSummaryMessage: 'Vuoi ripristinare i dati? Le eventuali modifiche saranno sovrascritte.',
            familyTransferQuantity: 'Transfer Fam',
            truckQuantity: 'Truck',
            target: 'Target',
            inventory: 'Inventory',
            familyNameRequired: 'Devi scegliere una famiglia',
            exportMinMaxWS: 'Esporta in Profili Giornalieri',
            exportMinMaxWSSuccess: 'Operazione effettuata con successo',
            holdUpQuantity: 'Hold Up',
            extractableQuantity: 'Extractable',
            airLiquideQuantity: 'Air Liquide',
            versalisQuantity: 'Versalis',
            voyagesCount: 'VOYAGE COUNT',
            voyagesQuantity: 'VOYAGE QTY',
            plannedTpQuantity: 'TP',
            finalStkQuantity: 'FIN STK',
            alignStkMessage: 'Vuoi allineare gli stoccaggi?',
            emptyQuantity: 'Ton Empty',
            notValidated: 'Non validato',
            massiveMoveVoyages: 'Spostamento Massivo',
            dateFrom: 'Data Da',
            dateTo: 'Data A',
            days: 'N Giorni',
            moveReferenceDate: 'Sposta Data Riferimento',
            moveLaycanDates: 'Sposta Cancelli',
            daysRequired: 'Devi scegliere un numero di giorni',
            dateFromRequired: 'Devi scegliere una data di inizio',
            dateToRequired: 'Devi scegliere una data di fine'
          },
          StocchinoPlanFamilyAssociation: {
            page_title: 'Associazione Famiglie'
          },
          weeklySettlement:{
            page_title: 'Weekly Settlement',
            periodStartDate: 'Data Inizio Periodo',
            periodEndDate: 'Data Fine Periodo',
            loadTransferStock: 'Carica Transfer Stock',
            voyageNumber: 'Codice Allocation',
            quantity: 'Quantità Mt',
            code: 'Codice Prodotto',
            productName: 'Prodotto',
            isImportable: 'Importabile',
            isCreated: 'Creato',
            productQuantity: 'Prodotti/Quantità',
            load: 'Carica',
            errorString: 'Motivazione',
            import: 'Importa',
            operationType: 'Tipo Operazione',
            exitMessage: 'Transfer Stock già importati! Passare alla pagina successiva.',
            lotManagementCheck: "Lotti Management"
          },
          trueUp:{
            page_title: 'True Up',
            settings: 'Anagrafiche',
            priceFormula: 'Price Formula',
            description: 'Descrizione',
            shortDescription: 'Descrizione Breve',
            registryCalculationType: 'Tipo Calcolo',
            quantityUnitOfMeasureCode: 'UoM',
            currencyCode: 'Valuta',
            formula: 'Formula',
            priceFormulaEdit: 'Modifica',
            priceFormulaDelete: 'Cancella',
            rangeTo: 'Range To',
            rangeFrom: 'Range From',
            markerBase: 'Marker Base',
            priceFormulaHeader: 'Price Formula',
            priceFormulaDetails: 'Dettagli Price Formula',
            deletePriceFormulaDetails: 'Cancella Dettaglio',        
          },

          FamilyPoolConfiguration:{
            page_title: 'Family Pool Configuration',
            monthStartDate: 'Data Mese',
            poolName: 'Pool Name',
            familyGroup: 'Family Group',
            isCrude: 'Crudo',
            isProduct: 'Prodotto',
            isTrueUpEqualsToVessel: 'True Up Uguale al Vessel',
            planningPriceFormula: 'Price Formula',
            referenceDensity: 'Densità di Riferimento',
            plannedDensity: 'Densità Pianificata',
            isDeleted: 'Cancellato'
          },

          Settle:{
            page_title: 'Settle',
            load: 'Carica',
            startDate: 'Data',
            monthStartDate: 'Data Inizio',
            isFinal: 'Consuntivo',
            planningTrueUpFamilyPoolConfiguration: 'Family Pool Configuration',
            averageSettle: 'Settle Medio',
            export: 'Esporta',
            exitMessage: 'Potrebbero esserci delle modifiche non salvate? Sei sicuro di uscire?'
          },
          SettleDetails:{
            page_title: 'Settle Daily Price',
            settleDate: 'Data Settle',
            settleValue: 'Valore Settle',
            deletesettleDailyPrice: 'Cancella Settle Daily Price'
          },
          provisionalInvoice:{
            page_title: 'Fatture Provvisorie',
            initialInventoryDate: 'Data inizio inventario',
            endingInventoryDate: 'Data Fine inventario',
            weeklyDescription: 'Weekly',
            planningTrueUpFamilyPoolConfiguration: 'Family Pool Configuration',
            familyGroup: 'Family Group',
            familyPool: 'Family Pool',
            cubicMeters: 'Metri Cubi',
            density: 'Densità',
            conversionFactor: 'Fattore di Conversione',
            barrels: 'Barili',
            metricTonnes: 'Metric Tons',
            settlementBase: 'Base Settlement',
            settlementDate: 'Data Settlement',
            settle: 'Settle',
            premiumOrDiscount: 'Premio o sconto',
            price: 'Prezzo',
            escalatedPrice: 'Prezzo Maggiorato',
            invoiceAmount: 'Totale Fattura',
            trafiguraTrade: 'Trade Trafigura',
            isValid: 'Valido',
            dateFromForImport: 'Data da cui importare',
            isFinaL: 'Consuntivo'
          },
          DensityEstimation: {
            page_title: 'Density Estimation',
            page_title_title: 'Density Estimation - Eudora',
            referenceDate: 'Data di Riferimento',
            voyageNumber: 'Voyage Number',
            vesselName: 'Vessel',
            weeklyStartDate: 'Data Inizio Weekly',
            weeklyEndDate: 'Data Fine Weekly',
            laycanStartDate: 'Laycan Da',
            laycanEndDate: 'Laycan A',
            deal: 'Deal',
            productCode: 'Product Code',
            productPool: 'Product Pool',
            productName: 'Product Name',
            quantityMt: 'Quantità Mt',
            previsionalQuantityMt: 'Quantità Previsionale Mt',
            finalQuantityMt: 'Quantità Consuntiva Mt',
            isFinal: 'Consuntivo',
            density: 'Densità',
            premium: 'Premio',
            isRevised: 'Is Revised'    
          },
          ProductsWeightedAverageValue: {
            monthStartDate: 'Mese',
            endingInventoryDate: 'Data fine',
            isFinal: 'Consuntivo',
            planningTrueUpFamilyPoolConfiguration: 'Family Pool',
            totalQuantity: 'Quantità Totale',
            weightedAverageDensity: 'Densità Media',
            weightedAveragePremiumOrDiscount: 'Premio o Sconto',
            totalQuantity: 'Product lifting (estimated)'
          },
          ProductsWtdDetail:{
            transactionTypeDescription: 'Transaction Type',
            dealId: 'Deal Id',
            vesselDescription: 'Nome Nave',
            quantity: 'Quantità',
            density: 'Densità',
            premiumOrDiscount: 'Premio o Sconto',
          },
          InvoicePrices: {
            page_title: 'Prezzi',
            settlementDate: "Data Settlement",
            isFinal: 'Consuntivo',
            productFamily: "Product Family",
            settlementUnits: "Settlement Units",
            consumptionProduction: "Consumption Production",
            baseQuote: "Base Quote",
            settle: 'Settle',
            premiumDiscount: 'Premio/Sconto',
            price: 'Prezzo',
            density: 'Densità',
            escalatedPrice: 'Prezzo Maggiorato',
            monthStartDate: 'Data inizio mese',
            endingInventoryDate: 'Data fine',
            isFinal: 'Consuntivo',
            familyPool: 'Family Pool'
          },
          FeedstocksWeightedAverage:{
            page_title: 'Medie Pesate Feedstock',
            monthStartDate: 'Data inizio mese',
            endingInventoryDate: 'Data fine',
            isFinal: 'Consuntivo',
            planningTrueUpFamilyPoolConfiguration: 'Family Pool',
            totalQuantity: 'Quantità Totale',
            weightedAveragePremiumOrDiscount: 'Premio o Sconto',
            totalQuantity: 'Product lifting (estimated)',
            grade: 'Grade',
            vessel: 'Nave',
            laycanFrom: 'Cancello Da',
            laycanTo: 'Cancello A',
            tradeId: 'Trade Id',
            dealId: 'Deal Id',
            volume: 'Volume',
            premiumOrDiscount: 'Premio o Sconto',
            settlementDate: 'Data di settlement',
            premiumConverted: 'Visualizza Excel Premio',
            referenceDate: 'Data di Riferimento'
          },
          FeedstocksWtdDetail:{
            transactionTypeDescription: 'Transaction Type',
            dealId: 'Deal Id',
            tradeId: 'Trade Id',
            vesselDescription: 'Nome Nave',
            volume: 'Volume',
            density: 'Densità',
            laycanFrom: 'Cancello da',
            laycanTo: 'Cancello a',
            gradeDescription: 'Grade',
            premiumOrDiscount: 'Premio o Sconto',
            totalVolume: 'Volume Totale',
            premium: 'Prem/Sconto'
          },
          PricedQuantitiesBalance:{
            page_title: 'Calcolo Quantità Prezzate',
            monthStartDate: 'Data inizio mese',
            products: 'Prodotti',
            feedstocks: 'FeedStocks',
            M3: 'M3',
            D15: 'D15',
            MT: 'MT',
            CF: 'CF',
            BBL: 'BBL',
            description: 'Descrizione',
            isClosed: 'TrueUp Chiuso',
            isOpen: 'TrueUp Aperto',
            open_priced_quantities_balance: 'Vuoi aprire il TrueUp?',
            close_priced_quantities_balance: 'Vuoi chiudere il TrueUp?'
          },
          FinalInvoice: {
            page_title: 'True Up Fatture',
            unitOfMeasureCode: 'UoM',
            currency: 'Valuta',
            deltaPrices: 'Delta Prezzi',
            quantities: 'Quantità Prezzate',
            totalFinalInvoices: 'True-Up',
            trueUpPrice: 'Prezzi True Up',
            trueUpTollingValues: 'Valore Fatture True Up Tolling',
            tollingPrice: 'Prezzi Tolling',
            tollingInvoice: 'Fatture Tolling',
            deltaAmount: 'Delta',
            total: 'Totale'
          },
          pitag: {
            page_title: 'Anagrafica Tag OSI PI',
            equipmentCode: 'Codice Attrezzatura',
            tagCode: 'Codice Tag',
            tagType: 'Tipologia Tag',
            isMain: 'Principale'
          },
          DailyProfileException: {
            page_title: 'Eccezioni Profili Giornalieri',
            externalProductCode: 'Micro-Code',
            isTruck : 'Truck',
            isVersalis: 'Versalis',
            isAirLiquide: 'Air Liquide',
            stkManagement: 'Gestione Stoccaggi',
            addException: 'Aggiungi Eccezione'
          },
          crudeConversionFactor: {
            page_title: 'Fattore di Conversione Crudi',
            registryProduct: 'Prodotto',
            conversionFactor: 'Fattore di Conversione'
          },
          periodicMovementBySeaReport: {
            page_title: 'Report Periodico Movimentazione Via Mare',
            panelHeaderDischargeName: 'Discariche',
            panelHeaderChargeName: 'Caricazioni',
            referenceMonthDate: 'Mese di Riferimento',
            idMovementInstructionLot: 'Id Lotto',
            voyageNumber: 'Allocation',
            vesselName: 'Nave',
            productCode: 'Codice Prodotto',
            productDescription: 'Prodotto',
            incoterms: 'Incoterms',
            loadingDischargePort: 'Porto Caricazione',
            finalDate: 'Data Consuntiva',
            finalQuantityMT: 'Quantità Consuntiva (MT)',
            finalQuantityM3: 'Quantità Consuntiva (M3)',
            finalQuantityBBL: 'Quantità Consuntiva (BBLS)',
            density15: 'Densità a 15°C',
            mooringPlatform: 'Piattaforma'
          },
          dealNotePriceWindow:{
            page_title: 'Price Window',
            description: 'Descrizione',
            priceWindowType: 'Tipo Price Window',
            monthDate: 'Mese di riferimento',
            dateFrom: 'Data da',
            dateTo: 'Data a',
            priceWindowDateType: 'Data di riferimento',
            dayToAdd: 'Giorni da aggiungere',
            isReferenceDateIncluded: 'Includi Data di Riferimento'
          },
          VesselNomination: {
            page_title: 'Vessel Nomination',
            topicDescription: 'Oggetto Mail',
            vesselName: 'Nave',
            loadingDateRangeFrom: 'Inizio Cancello',
            loadingDateRangeTo: 'Fine Cancello',
            inspectors: 'Ispettore',
            demurrageRate: 'Controstallie',
            agents: 'Agents',
            superIntendent: 'Super Intendent',
            incoterm: 'Incoterm',
            trafiguraTradeRef: 'Trafigura Trade Ref',
            linkTopicMessage: 'Vuoi associare questo thread mail al viaggio selezionato?',
            parcel: {
              consignee: 'Intestatario B/L',
              notifyAddress: 'Indirizzo completo',
              charterPartyDated: "CP Date",
              charterPartyDatedString: "CP Date Testo",
              portOfLoading: 'Porto di caricazione',
              portOfDischarge: 'Porto di discarica',
              freight: 'Freight',
              marked: 'Marked',
              product: 'Prodotto',
              quantity: 'Quantità',
              eadConsignee: 'Deposito Fiscale principale',
              eadPlaceOfDelivery: 'Deposito Fiscale secondario',
              masterForHisOwnUse: 'Master for his own use',
              masterForReceivers: 'Master for receivers'
            },
            modifiedFieldListNotEmpty: 'Sono arrivate nuove e-mail',
            lotsCountDifferent: 'Il numero di lotti non coincide con quelli delle e-mail',
            unlinkMessage: 'Vuoi eliminare l\'associazione a questo thread?',
            threads: 'Threads',
            details: 'Dettaglio'
          },
          bookOut:{
            page_title: 'Book Out',
            monthReferenceDate: 'Mese di Riferimento',
            load: 'Carica BookOut',
            exportTooltip: 'Export BookOut',
            vessel: 'Vessel',
            tradeRef: 'Trade Ref',
            quantity: 'Quantità',
            uom: 'UOM',
            marker: 'Marker',
            period: 'Period',
            premium: 'Prem',
            price: 'Price (USD)',
            amount: 'Amount',
            invoice: 'Invoice #',
            sentReceiver: 'Sent / Receiver',
            isabPO: 'ISAB P.O.',
            billOfLadingDate: 'B/L Date',
            weeklyOrder: 'Weekly Order',
            quote: 'Quote',
            calculate_book_out: 'Vuoi calcolare i Book Out per il mese selezionato?',
            isFinal: 'Consuntivo/Previsionale'
          },
          EudoraInterface:{
            page_title: 'Interfacce Eudora'
          },
          PremiumDiscountCalculationDetails:{
            page_title: 'Premium/Discount Details - Eudora',
            discount: 'Premio/Sconto'
          },
          TankTracking: {
            page_title: 'Tracciamento Serbatoi Vendite',
            fiscalClearanceDate: 'Via Fiscale',
            viewed: 'Presa Visione',
            automaticRefresh: 'Aggiornamento Automatico',
            vesselCommunicationPreventive: 'Nave in Preventiva',
            referenceDate: "Data Riferimento",
            displacements: 'Spiazzamenti',
            stock: 'Giacenza',
            available: 'Disponibile',
            notAvailable: 'Operazione in corso'
          },
          EquipmentTrackingAudit: {
            page_title: 'Log Tracciamento Serbatoi Vendite',
            idRecord: 'Record Id'
          },
          denaturantBulkCapacity: {
            page_title: 'Capacità Bulk Denaturanti',
            capacity: 'Capacità'
          },
          denaturantBulkRegistry: {
            page_title: 'Gestione Bulk Denaturanti',
            referenceDate: 'Data Riferimento',
            registryProduct: 'Product',
            rechargeButton: 'Ricarica Bulk',
            importButton: 'Importa CVT',
            operationDate: 'Data Operazione',
            operationType: 'Operazione',
            operationTypeRecharge: 'Ricarica',
            operationTypeExtraction: 'Estrazione',
            movedQuantity: 'Quantità Movimentata (Kg)',
            stockQuantity: 'Giacenza (Kg)',
            insertButton: 'Inserisci Operazione di Estrazione',
            updateButton: 'Aggiorna',
            deleteButton: 'Cancella',
            forceInsertInThePast: 'Stai inserendo un\'operazione <b>nel passato</b>. <br/>Se continui verranno ricalcolate le giacenze delle operazioni successive fino alla prima operazione di ricarica. <br/> Vuoi continuare?',
            forceImport: 'Forza Import',
            forceImportTooltip: 'Forzando l\'import verranno cancellate eventuali operazioni di estrazione già inserite.',
            selectPlantErrorMessage: 'Selezionare l\'impianto',
            selectProductErrorMessage: 'Selezionare il prodotto',
            rechargeInsertMessage: 'Vuoi ricaricare il bulk?',
            thresholdSettings: {
              gridName: 'Soglie Riempimento Bulk',
              DenaturantBulkRunningLowThreshold: 'Soglia bulk in esaurimento (%)',
              DenaturantBulkEmptyThreshold: 'Soglia bulk vuoto (%)',
              valueNotValid: 'Valore soglia non valido. Inserire un numero intero compreso tra 0 e 100.'
            }
          },
          TimeSpanConfiguration: {
            page_title: 'Intervalli'
          },
          StockAdjustment:{
            page_title: 'DeadStock Adjustment',
            initialStockDate: 'Data Inizio Stocchino',
            date: 'Data Fine Stocchino',
            tankCode: 'Codice Serbatoio',
            productCode: 'Codice Prodotto',
            poolName: 'Family Pool',
            adjustmentType: 'Tipo Adjustment',
            dischargeOrCharge: 'Caricazione/Discarica',
            description: 'Descrizione',
            cubicMeters: 'Metri Cubi',
            density: 'Densità',
            conversionFactor: 'Fattore di Conversione',
            barrels: 'Barili',
            metricTonnes: 'Tonnellate Metriche',
            monthStartDate: 'Data Inizio Mese',
            required: 'è obbligatorio!',
            field: 'Il campo',
            importDeadstock: 'Importa Deadstock',
            sendToLotManagement: 'Inserisci Lotti PB',
            voyageNumber: 'Voyage Number',
            referenceDate: 'Data Riferimento Stocchino'
          },
          AdjustmentType:{
            page_title: 'Tipo Adjustment',
            description: 'Descrizione',
            id: 'Id'    
          },
          TmTankVolumetricData: {
            page_title: 'Dati Volumetrici',
            fk: 'Codice Serbatoio',
            grossShellCapacity: 'Gross Shell Capacity',
            maxOperatingCapacity: 'Max Operating Capacity',
            workingVolume: 'Working Volume',
            deadStockVolume: 'DeadStock Volume',
            downloadTemplate: 'Download Template Vuoto',
            importTemplate: 'Importa da Excel'
          },
          ExciseFiscalRegister:{
            page_title: 'Registro Accise',
            notificationCode: 'Codice Comunicazione',
            notificationDate: 'Data Comunicazione',
            notificationDateFrom: 'Data Comunicazione Da',
            plantDescription: 'Impianto',
            operationTypeDescription: 'Operazione',
            tankCode: 'Tank Code',
            idRegistryProduct: 'Prodotto',
            productCode: 'Codice Prodotto',
            productDescription: 'Descrizione Prodotto',
            productFamily: 'Famiglia Prodotto',
            isGas: 'Gas',
            nc: 'NC',
            fiscalMovedWeight: 'Quantità Movimentata',
            fiscalMovedVolume: 'Volume Movimentato',
            denaturantQuantity: 'Quantità Denaturante',
            denaturantVolume: 'Volume Denaturante',
            fiscalStockWeight: 'Giacenza Fiscale (Kg)',
            fiscalStockVolume: 'Giacenza Fiscale (Lt)',
            placeOfDeliveryName: 'Luogo di Destinazione',
            fiscalDestination: 'Destinazione Fiscale',
            fiscalPosition: 'Posizione Fiscale',
            fiscalUse: 'Uso Fiscale',
            fiscalDocumentNumber: 'Numero Documento Fiscale',
            exciseDuty: 'Accise',
            exciseDue: 'Accise Dovute',
            exciseDutySuspended: 'Accise Sospesa',
            taxableQuantity: 'Quantità Tassabile',
            exciseRate: 'Excise Rate',
            portOrLocation: 'Porto di Destinazione',
            infoilCvtOperationKey: 'InfoilCvtOperationKey',
            calculator: 'Calcolatrice',
            localExciseDue: 'Accise Locali Dovute',
            exciseDelta: 'Delta',
            documentType: 'Tipo Documento',
            documentTypeLanguage: 'Lingua Documento',
            notificationDateTo: 'Data Comunicazione A'
          },
          DeductionDefault:{
            page_title: 'Deduzioni di Default',
            DeductionDescription: 'Descrizione',
            timesheetOperationStartDate:'Data Inizio',
            timesheetOperationEndDate: 'Data Fine',
          },
          DemurrageCalculator:{
            page_title: 'Calcolatrice',
            voyage: 'Viaggi',
            onlyOpenedVoyage: 'Solo viaggi aperti',
            vessel: 'Vessel',
            product: 'Product',
            loadport: 'Loadport',
            disport: 'Disport',
            nor: 'NOR',
            hosesDisconnection: 'Hoses Disconnection',
            documentOnBoard: 'Document on Board',
            contract: 'Contract',
            grossLayout: 'GROSS LAYOUT',
            laytimeCommenced: 'Laytime commenced',
            laytimeCompleted: 'Laytime completed',
            grossLaytime: 'Gross laytime',
            demurrageRate: 'Demurrage Rate',
            proratedAllowedLaytime: 'Prorated Allowed Laytime',
            layday: 'Layday ISAB',
            deductions: 'DEDUCTIONS',
            reasons: 'Reasons',
            extendedReasonDescription: 'Extended Reason',
            from: 'From',
            to: 'To',
            share: 'Share',
            totalHoursMins: 'Total Hrs Mins',
            totalHours: 'Total Hrs',
            deliveryDocuments : 'DELIVERY OF DOCUMENTS',
            totalNetUsedTimeMins: 'Total net used Time (HRS MINS)',
            totalNetUsedTime: 'Total net used Time (HRS)',
            timeOnDemurrageMins: 'Time on Demurrage (HRS MINS)',
            timeOnDemurrage: 'Time on Demurrage (HRS)',
            totalHrs: 'Total (HRS)',
            total: 'Total',
            totalMins: 'Total (HRS MINS)',
            name: 'Nome',
            deduction: 'Deduzione',
            description: 'Descrizione',
            sumAndDifference: 'Somma / Differenza',
            origin: 'Provenienza',
            entryStart: 'Voce Inizio',
            entryEnd: 'Voce Fine',
            startDate: 'Data Inizio',
            endDate: 'Data Fine',
            value: 'Valore (Hrs Mins)',
            titleDialogCalculator: 'Calcolo Deduzione',
            sign: 'Segno',
            sum: 'Somma',
            difference: 'Differenza',
            timesheet: 'Timesheet',
            fixedValue: 'Valore Fisso',
            regenerateTitleDialog: 'Rigenera controstallia per il viaggio selezionato  ',
            btn: {
              regenerate: "Rigenera",
              sendMail: "Invio Mail",
              simpleDeduction: "Aggiungi deduzione semplice",
              composedDeduction: "Aggiungi deduzione composta",
              reason: "Aggiungi giustificazione",
              internal: 'Download Interni',
              notInternal: 'Download Esterni',
            },
            messages: {
              error_valid_date: 'Data inizio non può essere maggiore di data fine',
              createCalculator: 'Vuoi creare una nuova controstallia per il viaggio selezionato?',
              error_valid_deduction: 'Compilare tutti i campi',
              regenerateCalculator: 'A seguito della rigenerazione verranno ricaricati tutti i dati. Vuoi mantenere le deduzioni manuali inserite?',
              send_mail_message: 'Vuoi inviare la mail? Puoi inserire delle note che verranno aggiunte alla mail:',
              noCalculatorCreated: 'Il calcolo non è ancora stato creato per questo viaggio',
              error_valid_hrs_minutes: 'Inserisci un orario valido (es: 12:30)',
              error_valid_reason_hrs: 'Non è possibile inserire una reason con un totale di ore pari a 0' ,
            },
            note: 'Note',
            totalDeduction: 'Total Deduction (HRS)',
            totalDeductionMins: 'Total Deduction (HRS MINS)',            
            totalNetLaytime: 'Total Net Laytime (HRS)',
            totalNetLaytimeMins: 'Total Net Laytime (HRS MINS)',
            from: 'From', 
            to: 'To',
            yearToExchange: 'Seleziona il mese',
            titleDialogExchange: 'Exchange valuta',
            rate: 'Tasso di cambio',
            titleDialogMail: 'Invio Mail',
            demurrageReason: 'DEMURRAGE REASON',
            totalDemurrage: 'Total Demurrage',
            internalNote: 'Note interne',
            demurrageDeltaHrsMins: 'Delta (HRS MINS)',
            demurrageDeltaHrs: 'Delta (HRS)',
            demurrageDeltaTotal: 'Delta',
            demurrageReasonHrsMins: 'Total Demurrage Reason (HRS MINS)',
            demurrageReasonHrs: 'Total Demurrage Reason (HRS)',
            demurrageReasonTotal: 'Total Demurrage Reason',
            reproportionateReasonsMessage: 'Vuoi riproporzionare i valori?',
            reproportionateBtn: 'Riproporziona'
          },
          DemurrageRegister:{
            demurrage_page_title: 'Controstallie',
            page_title: 'Registro',
            month: 'Mese',
            plant: 'ISAB North/South',
            dischargeLifting: 'Discharge/Lifting',
            discharge: 'D',
            lifting: 'L',
            vesselName: 'Vessel Name',
            allocation: 'Allocation',
            product: 'Product',
            demurrageRate: 'Controstallia',
            timeOnDemurrage: 'Time on Demurrage (Hrs)',
            timeOnDemurrageNetOftimeExpired: 'Time on Demurrage (Hrs) net of time expired',
            totalUsd: 'Total',
            note: 'Note',
            extendedNote: 'Extended Note',
            netOfTimeEXpired: 'Total net of time expired',
            counterpartyRequest: 'Counterparty request',
            delta: 'Delta',
            agreedNotAgreed: 'Agreed/Not agreed',
            dateOrder: 'Data Ordine',
            dateInvoiceCounterparty: 'Data Fattura Controparte',
            agreedValue: 'Agreed value',
            pendingValue: 'Not agreed. Pending value',
            poteintialClaim: 'Potential claim to be received',
            lastEstimedDateOfBLOrCOD: 'Last estimated date of B/L',
            availableTimeForClaimPresentation: 'Available time for claim presentation BL + 95',
            planningStrategy: 'Planning Strategy',
            btn: {
              detail: "Dettaglio",
              preview: "Anteprima",
            },
            messages: {
              error_valid: 'Errore di validazione, compilare correttamente i dati inseriti',
              error_entry_month: 'Seleziona il mese da visualizzare',
              error_entry_year: 'Seleziona anno da esportare',
            },
            titleDialogPreview : 'Anteprima deduzioni',
            titleDialogExcel: 'Export',
            yearToExport: 'Seleziona anno',
            valued: 'Valorizzati',
            empty: 'Vuoti',
            all: 'Tutti',
            originalValue: 'Valore originario: ',
          },
          SchedulingAttachments: {
            messages: {
              open_documents_messages: 'Desideri aprire la carpetta?',
              close_documents_messages: 'Desideri chiudere la carpetta?',
              send_notification_messages: 'Desideri inviare la notifica?',
              send_notification_success: 'Comunicazione inviata con succeso'
            },
            closedDocuments: 'CARPETTA CHIUSA',
            openDocuments: 'Apri Carpetta',
            closeDocuments: 'Chiudi Carpetta',
            sendNotification: 'Invia notifica',
            downloadDocuments: 'Scarica tutti i documenti'
          },
          TmTankType: {
            volumeCalculationRoutine: 'Routine Calcolo Volume'
          },
          StockManagementInventory: {
            page_title: 'Inventario',
            liquid: 'Liquidi',
            gas: 'Gas',
            referenceDate: 'Data Riferimento Inventario',
            measureDate: 'Measure Date',
            tankCode: "Tank",
            isOutOfService: "Out Of Service",
            isHidden: "Nascosto",
            registryProduct: 'Product',
            productLevelManual: "Manual Measurement (mm)",
            productLevelAuto: "Authomatic Measurement (mm)",
            productLevelDailyStock: "Daily Stock Value (mm)",
            productLevelManualVsAutoDelta: "Differences (mm)",
            density: "Density (kg/l)",
            densityDailyStock: "Density Daily Stock (kg/l)",
            temperatureManual: "Manual Temperature (°C)",
            temperatureAuto: "Automatic Temperature (°C)",
            temperatureAutoGasGrid: "Temperature °C (liquid)",
            temperatureDailyStock: "Daily Stock Temperature (°C)",
            temperatureManualVsAutoDelta: "Differeces (°C)",
            waterLevel: "H2O (mm)",
            waterLevelDailyStock: "H2O Daily Stock (mm)",
            sludgeLevel: "Sludge",
            gasTemperature: "Temperature °C (gas)",
            gasTemperatureDailyStock: "Temperature °C Daily Stock (gas)",
            pressure: "Pressure (bar)",
            pressureDailyStock: "Pressure Daily Stock (bar)",
            molecularWeight: "Molecular Weight",
            molecularWeightDailyStock: "Molecular Weight",
            weightInKg: "Weight (kg)",
            weightInKgDailyStock: "Weight Daily Stock (kg)",
            volumeInLt: "Volume (lt)",
            volumeInLtDailyStock: "Volume Daily Stock (lt)",
            waterVolumeInLt: "Water Volume (lt)",
            waterVolumeInLtDailyStock: "Water Volume Daily Stock (lt)",
            theoreticalVolumeInLt: "Theoretical Volume (lt)",
            technicalVolumeInLt: "Technical Volume (lt)",
            lastChangedBy: "Person In Charge",
            audit: "KPMG",
            schedulingNotes: "Notes (SCHEDULING)",
            notes: "Notes",
            isValidated: "Validato",
            status: "Stato",
            version: "Versione",
            elaborationStartedAt: "Data Inizio Elaborazione",
            elaborationEndedAt: "Data Fine Elaborazione",
            stage: "Stage",
            stageStartDate: "Data Inizio",
            stageEndDate: "Data Fine",
            errorMessage: "Errore",
            elaborationUsername: "Username",
            dailyStockReferenceDate: "Data Stocchino Riferimento",
            createdAt: "Creato Il",
            createdBy: "Creato Da",
            published: "Pubblicato",
            notPublished: "Non Pubblicato",
            publishedAt: "Pubblicato Il",
            publishedBy: "Pubblicato Da",
            btn: {
              createNewInventory: 'Crea nuovo inventario',
              calculateInventoryStock: 'Sviluppa inventario',
              validateItem: 'Valida Serbatoio',
              editRow: "Edit",
              validateTank: "Valida Serbatoi",
              validateTankTooltip: "Valida Serbatoi Visualizzati",
              invalidateTank: "Invalida Serbatoi",
              invalidateTankTooltip: "Invalida Serbatoi Visualizzati",
              calculateStock: "Calcola Stoccaggi",
              calculateStockTooltip: "Calcola Stoccaggi Serbatoi Visualizzati",
              startInventoryNewElaboration: "Nuova Elaborazione Inventario",
              continueInventoryElaboration: "Riprendi Elaborazione Inventario",
              abortInventoryElaboration: "Annulla Elaborazione Inventario",
              inventoryElaboration: "Stato Ultima Elaborazione Inventario",
              updateItemsByOsiPi: "Aggiorna misure da PI",
              updateItemsByOsiPiTooltip: "Aggiorna misure da PI serbatoi visualizzati",
              unlockItem: "Sblocca",
              lockItem: "Blocca",
              publishInventory: "Pubblica",
              publishInventoryCancel: "Annulla Pubblicazione",
              reportOverageLoss: 'Report Check',
            },
            Msg: {
              confirm: 'Vuoi procedere?',
              confirmNewInventoryCreation: 'Vuoi procedere con la creazione di un nuovo inventario da ',
              confirmNewInventoryElaboration: 'Vuoi procedere con una nuova elaborazione di inventario per la data del ',
              allDataWillBeDeleted: 'Eventuali dati presenti per questa data verranno sovrascritti.',
              invalidReferenceDate: 'Data inventario non valida.',
              CannotContinueDailyStockMissing: 'Impossibile procedere con l\'operazione. Nessuno stocchino giornaliero presente.',
              CannotCreateInventoryRefDate: 'Impossibile creare un nuovo inventario. Esistono già uno o più inventari successivi alla data selezionata.',
              pendingInventoryElaborationExists: 'Impossibile creare un nuovo inventario. Nella data selezionata c\'è un inventario in elaborazione.',
              CannotCreateInventoryGetTankListError: 'Impossibile creare un nuovo inventario. Errore durante il recupero della configurazione dei serbatoi.',
              noSelectedInventoryItems: 'Nessun serbatoio selezionato.',
              elaborationNotFound: 'Nessuna elaborazione trovata.',
              NoMoreDataToSpread: "Non ci sono più dati da propagare.",
              RecordLocked: "Il record è bloccato.",
              CannotCreateInventoryPublished: 'Impossibile creare un nuovo inventario. L\'inventario attuale è pubblicato.',
              CannotUpdateVersionPublished: 'Impossibile aggiornare. L\'inventario attuale è pubblicato.',
              CannotUpdateItemValidated: 'Impossibile creare un nuovo inventario. L\'item è validato.',
              CannotStartElaborationNoInventoryFound: 'Impossibile avviare una nuova elaborazione. Non ci sono dati di invantario.',
              CannotStartElaborationNoPublishedInventoryFound: 'Impossibile avviare una nuova elaborazione. L\'inventario non è ancora pubblicato.',
              forceNewInventoryCreation: 'Esiste già un inventario per questa data. Vuoi forzare la creazione di una nuova versione?',
              RecordLocked: "Il serbatoio è bloccato da ",
              RecordAlreadyLocked: "Il serbatoio è già bloccato.",
              RecordUnlocked: "Il serbatoio è sbloccato. Occorre bloccarlo prima di procedere.",
              RecordAlreadyUnlocked: "Il serbatoio è già sbloccato.",
              RecordUnlockForce: "Vuoi forzarne lo sblocco?",
              InvalidOperation: "Operazione non consentita."
            },
            inventoryElaborationStageStatus: {
              Start: 'Inizio procedura',
              Init: 'Inizializzazione dati inventario',
              DailyStockProcessing: 'Elaborazione Stocchino Giornaliero',
              Completed: 'Completato',
              Aborted: 'Abortito'
            }
          },
          RegistryMaterialBalanceIgccEquipment: {
            page_title: 'Attrezzature IGCC'
          },
          DemurrageStatistics: {
            page_title: 'Statistiche',
            year: 'Anno',
            previous_years: 'Anni precedenti',
            recap: 'Recap',
            referenceDate: 'Mese',
            grossTotalDemurrage: "Gross Demurrage Calculation",
            netTotalDemurrage: "Net Demurrage Calculation",
            counterpartyOriginalRequest: "Counterparty's original request",
            counterpartyUpdatedRequest: "Counterparty's updated request",
            monthlyAverageDemurrageRate: "Monthly Avg Demurrage Rate (USD/day)",
            yearlyAverageDemurrageRate: "Yearly Avg Demurrage Rate (USD/day)",
            grossMonthlyAverageTimeOnDemurrage: "Gross Monthly Avg Time on Demurrage (hrs/vessel)",
            netMonthlyAverageTimeOnDemurrage: "Net Monthly Avg Time on Demurrage (hrs/vessel)",
            grossYearlyAverageTimeOnDemurrage: "Gross Yearly Avg Time on Demurrage (hrs/vessel)",
            netYearlyAverageTimeOnDemurrage: "Net Yearly Avg Time on Demurrage (hrs/vessel)",
            grossQuantity: 'Gross Quantity (tons)',
            grossMonthlyDemurrageRatioTotalTon: 'Gross Monthly Demurrage Ratio ($/ton)',
            grossYearlyDemurrageRatioTotalTon: 'Gross Yearly Demurrage Ratio ($/ton)',
            netQuantity: 'Net Quantity (tons)',
            netMonthlyDemurrageRatioTotalTon: 'Net Monthly Demurrage Ratio ($/ton)',
            netYearlyDemurrageRatioTotalTon: 'Net Yearly Demurrage Ratio ($/ton)',
            grossTimeOnDemurrage: 'Gross Time on Demurrage (hrs)',
            grossMonthlyDemurrageRatioHrsTon: 'Gross Monthly Demurrage Ratio (hrs/kton)',
            grossYearlyDemurrageRatioHrsTon: 'Gross Yearly Demurrage Ratio (hrs/kton)',
            netTimeOnDemurrage: 'Net Time on Demurrage (hrs)',
            netMonthlyDemurrageRatioHrsTon: 'Net Monthly Demurrage Ratio (hrs/kton)',
            netYearlyDemurrageRatioHrsTon: 'Net Yearly Demurrage Ratio (hrs/kton)',
            showReasons: 'Mostra Giustificazioni',
            showPreviousYears: 'Mostra anni precedenti',
            plant: 'Impianto',
            chargeDischarge: 'Caricazioni / Discariche',
            southTotalDemurrage: 'ISAB South',
            southTotalDemurragePercent: 'ISAB South %',
            northTotalDemurrage: 'ISAB North',
            northTotalDemurragePercent: 'ISAB North %',
            total: 'Totale',
            chargeTotalDemurrage: 'Liftings',
            chargeTotalDemurragePercent: 'Liftings %',
            dischargeTotalDemurrage: 'Discharges',
            dischargeTotalDemurragePercent: 'Discharges %',
            bars: 'Barre',
            lines: 'Linee',
            graphs: 'Grafici',
            progressive: 'Progressivo',
            pivot: 'Pivot',
            actVsBdg: 'Attuale Vs Budget',
            mainReason: "ISAB's demurrage main reasons",
            totalDemurrage: 'SUM OF $ NET OF TIME EXPIRED',
            totalDemurragePercent: '% ($ NET OF TIME EXPIRED/TOTAL)',
            timeOnDemurrage: 'Sum of Time on Demurrage (Hrs)',
            timeOnDemurragePercent: '% (Time on Demurrage (Hrs)/TOTAL)',
            averageTimeOnDemurrage: 'Avg. of Time on Demurrage (Hrs)',
            averageDemurrageRate: 'Avg. of Demurrage Rate (USD/Day)',
            month: 'Mese',
            dischargeLifting: 'Discharge/Lifting',
            note: 'Nota',
            vesselName: 'Vessel Name',
            allocation: 'Allocation',
            planningStrategy: 'Planning Strategy',
            timeOnDemurrage: 'Time on Demurrage (Hrs)',
            product: 'Prodotto',
            demurrageRate: 'Demurrage Rate (USD/DAY)',
            plantSouthNorth: 'ISAB North/South',
            netOfTimeEXpired: '$ Net of time expired',
            budget: 'Budget',
            estimatedVsBudget: 'Gross Demurrage vs Budget',
            titleActVsBudgetGraph: 'Attuale vs Budget',
            discharge: 'Discharge',
            lifting: 'Lifting',
            selectedMonths: 'Mesi'
          },
          monthNames: {
            0: 'Gennaio',
            1: 'Febbraio',
            2: 'Marzo',
            3: 'Aprile',
            4: 'Maggio',
            5: 'Giugno',
            6: 'Luglio',
            7: 'Agosto',
            8: 'Settembre',
            9: 'Ottobre',
            10: 'Novembre',
            11: 'Dicembre',
          },
          registryTankOperationRules: {
            page_title: 'Sequenza Operazioni Scheda',
            previousOperationCode: 'Codice Operazione Precedente',
            previousOperationDescription: 'Descrizione Operazione Precedente',
            currentOperationCode: 'Codice Operazione Corrente',
            currentOperationDescription: 'Descrizione Operazione Corrente'
          },
          StockManagementInventoryDataStaging: {
              page_title: 'Preparazione Dati',
              referenceDate: 'Data Riferimento',
              label: 'Nome Inventario',
              startLabel: 'Inventario al  ',
              liquid: 'Liquidi',
              gas: 'Gas',
              reason: 'Motivazione: ',
              product: 'Prodotto',
              plantCode: 'Impianto',
              tankCode: 'Serbatoio',
              schedulingDate: 'Data programmazione',
              measureDate: 'Data di Misura',
              outOfService: 'Fuori Servizio',
              onService: 'In servizio',
              isFinal: 'Congelato',
              samplingMethod: 'Metodo di campionamento',
              productLevelManual: 'Livello Prodotto Manuale',
              titleDialogCreateInventory: 'Nuovo inventario',
              titleDialogEditProductItem: 'Modifica prodotto',
              titleDialogPublishTankSelectionRevision: 'Seleziona l\'impianto da pubblicare',
              titleDialogEditMeasures: 'Modifica Misure',
              titleDialogScheduleTank: 'Programma serbatoio',
              schedulationDate: 'Data di programmazione:',
              selectInventory: 'Scegli l\'inventario',
              actualStageLabel: 'Stato Inventario:',
              TankSelection: 'Scelta dei serbatoi',
              TankSelectionRevision: 'Revisione della scelta dei serbatoi',
              TankMeasurements: 'Misure Serbatoi',
              temperature: 'Temperatura',
              isIncluded: 'Incluso',
              productLevelManual: "Livello Manuale (mm)",
              productLevelAuto: "Livello Automatico (mm)",
              productLevelManualVsAutoDelta: "Delta (mm)",
              density: "Densità (kg/l)",
              densityDailyStock: "Density Daily Stock (kg/l)",
              temperatureManual: "Temperatura Manuale (°C)",
              temperatureAuto: "Temperatura Automatica (°C)",
              temperatureAutoGasGrid: "Temperatura °C (liquido)",
              temperatureManualVsAutoDelta: "Delta (°C)",
              waterLevel: "H2O (mm)",
              sludgeLevel: "Sludge",
              gasTemperature: "Temperatura °C (gas)",
              pressure: "Pressione (bar)",
              molecularWeight: "Peso Molecolare",
              weightInKg: "Peso (kg)",
              volumeInLt: "Volume (lt)",
              waterVolumeInLt: "Volume Acqua (lt)",
              schedulingNotes: "Note Scheduling",
              blendingNotes: 'Note Blending',
              shippingNotes: 'Note Spedizioni',
              bilmatNotes: 'Note Bilmat',
              scheduling: "Scheduling",
              blending: 'Blending',
              shipping: 'Spedizioni',
              bilmat: 'Bilmat',
              notes: 'Note',
              FILANTE:'Filante',
              PIUALTEZZE: ' Più altezze',
              NOCAMPIONE: 'No campione',
              environmentTemperature: 'Temperatura ambiente',
              measuresManual: 'Misure Manuali',
              measuresAuto: 'Misure Automatiche',
              requiredMeasuredDate: 'Data di misura obbligatoria',
              requiredReferenceDate: 'Data di riferimento obbligatoria',
              requiredLabelInventory: 'Nome Inventario obbligatorio',
              rescheduleRequests: 'Richieste di ripianificazione',
              reason: 'Motivazione',
              reschedule_question:'Desideri ripianificare il serbatoio per una nuova misurazione?',
              requiredReason: 'Motivazione obbligatoria',
              requestDate: 'Data della richiesta',
              requestedBy: 'Richiesta da',
              responseBy: 'Risposta da',
              requestRejectedReason: 'Motivazione del rifiuto',
              requestStatus: 'Stato della richiesta',
              NEW: 'Nuova',
              APPROVED: 'Approvata',
              REJECTED: 'Rifiutata',
              rejectReschedule: 'Rifiuta richiesta di programmazione',
              valuedService: 'In Servizio',
              emptyService: 'Non in servizio',
              all: 'Tutte',
              level:'Livello (mm)',
              temperature: 'Temperatura (°C)',
              volume: 'Volume (lt)',
              weight:'Peso (kg)',
              manual: 'Manuale',
              automatic: 'Automatico',
              delta: 'Delta',
              workPermit: 'Permesso di lavoro',
              analysisSampleNumber: 'Numero campione',
              insertDateDailyStock: 'Inserisci la data delle misure da importare dallo stocchino',
              densityFromDailyStock: 'Densità (kg/l) da Stocchino',
              waterLevelFromDailyStock: 'H20 (mm) da Stocchino',
              weightFromCofi: 'Peso (kg) da Stocchino',
              volumeFromCofi: 'Volume (lt) da Stocchino',
              waterWeightFromCofi: 'Peso acqua (kg) da Stocchino',
              waterVolumeFromCofi: 'Volume acqua (lt) da Stocchino',
              fromInventory: ' (da Inventario)',
              manualAndFreeze: 'Manuale + Congelamenti',
              mixed: 'Inventario',
              cofidate: 'Data Stocchino (Man + Cong)',
              btn: {
                selectTank: 'Scegli serbatoi',
                selectTankTooltip: 'Scegli serbatoi',
                editRow: "Modifica",
                publishInventory: "Pubblica",
                publishInventoryCancel: "Annulla Pubblicazione",
                schedule: 'Programma',
                scheduleItem: 'Programma',
                importPi: 'Importa da Pi',
                importLims: 'Importa da Lims',
                editMeasures: 'Modifica Misure',
                viewNotes: 'Vedi note',
                reschedule:'Riprogramma',
                approve: 'Approva',
                reject: 'Rifiuta',
                create: 'Crea Inventario',
                downloadExcel: 'Scarica excel',
                importLimsMassive: 'Import Lims Massivo',
                planned: 'Programmati',
                toBePlanned: 'Da programmare',
                importFromStockManagements: 'Importa da Stocchino',
              },
              messages: {
                create_message_question: 'Vuoi creare un nuovo inventario?',
                create_message_success: 'Inventario creato con successo',
                outOfService_message_question: 'Vuoi cambiare lo stato del serbatoio in "Fuori Servizio"?',
                not_outOfService_message_question: 'Vuoi cambiare lo stato del serbatoio?',
                change_product_message_success: 'Vuoi cambiare il prodotto?',
                include_message_question: 'Vuoi includere il serbatoio?',
                not_include_message_question: 'Vuoi escludere il serbatoio?',
                publish_message_question: 'Vuoi pubblicare i serbatoi selezionati?',
                publish_message_success: 'Pubblicazione effettuata con successo.',
                operation_message_success: 'Operazione effettuata con successo.',
                schedule_message_question: 'Vuoi programmare i serbatoi selezionati?',
                schedule_message_success: 'Programmazione effettuata con successo.',    
                importPi_message_question: 'Vuoi importare le misure dal PI?',
                importLims_message_question : 'Vuoi importare le misure da LIMS?',
                confirm_measure_message_question: 'Vuoi confermare le misure nella data:',
                confirm_approve_message_question: 'Vuoi approvare la richiesta di riprogrammazione?',
                reject_request_question: 'Vuoi rifiutare la richiesta di riprogrammazione?',
                deactive_schedule_message_question:'Vuoi rimuovere la pubblicazione del serbatoio?',
                importLimsMassive_message_question: 'Vuoi importare le misure da Lims per tutti i serbatoi?',
                importDailyStock_message_question:'Vuoi importare le misure dallo stocchino?',
                cant_schedule_message: 'Non è possibile schedulare serbatoi se ci sono modifiche in corso'
              },
          },
          DischargeDropsReport:{
            page_title: 'Report Cali Discarica',
            referenceDate: 'Data Riferimento',
            tankCode: 'Serbatoio',
            lockedDate: 'Data Congelamento',
            endOperationDate: 'Data Acc. Discarica',
            fiscalStockWeight: 'Giacenza Fiscale (Kg)',
            fiscalStockVolume: 'Volume Fiscale (Lt)',
            cofiLockedWeight: 'Peso Congelato (Kg)',
            cofiLockedVolume: 'Volume Congelato (Lt)',
            sludgeWeight: 'Peso Sludge (Kg)',
            sludgeVolume: 'Volume Sludge (Lt)',
            fiscalMovedWeight: 'Peso Intr. Discarica (Kg)',
            fiscalMovedVolume: 'Volume Intr. Discarica (Lt)',
            theoreticalWeight: 'Peso Teorico (Kg)',
            theoreticalVolume: 'Volume Teorico (Lt)',
            deltaWeight: 'Delta Peso (Kg)',
            deltaVolume: 'Delta Volume (Lt)'
          },
          VesselAcceptance: {
            page_title: 'Interfaccia accettazione navi',
            msg: {
              movementInstructionNotValid: 'Telex non valido.',
              movementInstructionLotListNotValid: 'Nessun lotto presente.',
              lotsProductListNotValid: 'Lista prodotti lotti telex non valida.',
              operationTypeNotValid: 'Operazione non valida.',
              plantNotValid: 'Impianto non valido.',
              noValidAcceptanceFound: 'Nessuna accettazione valida trovata.',
              movementInstructionNotCreted: 'È possibile inserire la nave solo dopo aver creato il telex ed aver inserito almeno un lotto.'
            },
            
          },
          versalisRegister: {
            page_title: 'Registri Versalis - Carico/Scarico',
            detail_page_title: 'Dettaglio',
            fk: 'Registro Versalis',
            product_movements_page_title: 'Registri Versalis - Prodotti',
            raw_materials_movements_page_title: 'Registri Versalis - Materie Prime',

            loadDate: 'Data Carico',
            unloadDate: 'Data Scarico',
            voyageNumber: 'Viaggio',
            tankCode: 'Serbatoio',
            loadWeight: 'Qtà Peso (KG) Carico',
            loadVolume: 'Qtà Volume (LT) Carico',
            unloadWeight: 'Qtà Peso (KG) Scarico',
            unloadVolume: 'Qtà Volume (LT) Scarico',
            density: 'Densità',
            stockQuantity: 'Rimanenza (KG)',
            stockVolume: 'Rimanenza (LT)',
            hter14StockQuantity: 'Giacenza HTER14 (KG)',
            hter14StockVolume: 'Giacenza HTER14 (LT)',
            hter14StockTotal: 'TOT. GIAC. HTER ATTUALE:',
            unloading: 'Scarico',
            loading: 'Carico',

            msg: {
              unloadingOpNotFound: 'Operazione di scarico non trovata',
              loadingOpNotFound: 'Operazione di carico non trovata',
              loadingOpNotValid: 'Operazione di carico non valida',
              cannotDeleteLoadingOp: 'Impossibile cancellare un\'operazione di carico.',
              cannotUpdateLoadingOp: 'Impossibile modificare un\'operazione di carico.',
              unloadingOpAlreadyExists: 'L\'operazione di scarico esiste già.',
              confirmDelete: 'Vuoi cancellare l\'operazione?',
              unloadingOpDateLowerThanLoadigOp: 'Data operazione di scarico inferiore a quella di carico'
            }
          },
          VersalisMovements: {
            family: 'Registro',
            IDREG_ANNO_EMISSIONE_DOC: 'Anno Registro',
            IDREG_PROTOCOL_NUM: 'Registro',
            DATA_DI_RIFERIMENTO: 'Data di Riferimento',
            CODICE_PRODOTTO_NOM_COMB: 'Prodotto',
            DOCUMENTO_TIPO: 'Tipo Documento',
            DOCUMENTO_NUMERO: 'Numero Documento',
            DOCUMENTO_DATA_EMISSIONE: 'Data Documento',
            PROV_DEST_MERCE: 'Provenienza / Destinazione',
            QTA_PESO: 'Qtà Peso (KG)',
            QTA_LITRI_A15C: 'Qtà Volume (LT)',
            QTA_PESO_IN: 'Qtà Peso (KG) Carico',
            QTA_LITRI_A15C_IN: 'Qtà Volume (LT) Carico',
            QTA_PESO_OUT: 'Qtà Peso (KG) Scarico',
            QTA_LITRI_A15C_OUT: 'Qtà Volume (LT) Scarico',
            DENSITA_A15C: 'Densità',
            ACCISA_DOVUTA: 'Accisa Dovuta',
            MOVIMENTO_TIPO: 'Tipo Movimento',
            GIACENZA_PESO: 'Giacenza (KG)',
            GIACENZA_LITRI: 'Giacenza (LT)',
            movementTypeC: 'Carico',
            movementTypeS: 'Scarico',
            movementTypeG: 'Giacenza',
            REC_UPDDT: 'Data Ultima Modifica'
          },
          SiteContracts:{
            page_title: 'Interscambi di Sito',
            date: 'Data',
            quantity: 'Quantità',
            incotermCode: 'Incoterm',
            contractNumberReference: 'Nr Contratto',
            isOutCDep: 'Uscita Conto/Dep',
            registryInspector: 'Ispettore',
            voyageNumber: 'Allocation',
            updateMessage: 'Si sta aggiornando una operazione con un telex associato. Sicuro di continuare?',
            cloneMessage: 'Vuoi clonare l\'operazione selezionata?',
            deleteMessage: 'Vuoi cancellare l\'operazione selezionata?',
            sendMessage: 'Continuando verranno creati i relativi interscambi e verranno liquidati. Sicuro di volero continuare?',
            creationMessage: 'Mese non ancora creato. Creare i movimenti per il mese selezionato?',
            note: 'Note'
          },
          SiteContractOperations:{
            page_title: 'Operazioni',
            counterParty: 'Controparte',
            registryProduct: 'Prodotto',
            registryOperation: 'Operazione',
            registryPlant: 'Impianto'
          },
          ProductTollingMapping: {
            page_title: 'Mapping Prodotti Tolling',
            registryProductTolling: 'Prodotto Tolling',
            registryProductReference: 'Prodotto di Riferimento',
            tollingFamilyGroup: 'Gruppo Famiglia Tolling',
            familyPool: 'Family Pool'
          },
          RollingInventory:{
            page_title: 'Inventory Rolling Estimation',
            version: 'Versione',
            monthDate: 'Pricing Month',
            description: 'Descrizione',
            uom: 'UoM',
            total: 'Totale',
            vesselName: 'Vessel',
            pricingPeriod: 'Pricing Period',
            createVersion: 'Crea Versione',
            deleteVersion: 'Cancella Versione',
            create_new_version: 'Vuoi creare una nuova versione del Rolling Inventory per il mese di riferimento?',
            referenceDate: 'Mese di Riferimento',
            notFinal: 'Non Consuntivo',
            final: 'Consuntivo',
            msg_delete_version: 'Eliminare la versione corrente?',
            msg_delete_item: 'Eliminare l\'elemento selezionato?',
            date: 'Date',
            grade: 'Grade',
            vesselName: 'Vessel',
            totalWeightMt: 'MT',
            conversionFactor: 'CF',
            totalVolumeBbl: 'BBL',
            pricingWindow: 'Manca Finestra di Prezzatura',
            voyageNumber: 'Allocation',
            startInventoryDate: 'Data inizio Weekly',
            endInventoryDate: 'Data fine Weekly',
            storageMonth: 'Storage Month',
            openingInventory: 'Opening Inventory',
            consProdLiftings: 'Cons/Prod/Liftings',
            totalSupplies: 'Supplies/Imports',
            finalRollingEstimation: 'Final Rolling Estimation',
            changeWeekly: 'Cambia Data Weekly',
            header_required: 'Bisogna selezionare una versione',
            laycan: 'Cancello'
          },
          SysGatewayServer:{
            page_title: 'Gateway Servers',
            url: 'Url',
            fk: 'Server',
            refreshMessage: 'Vuoi ricaricare le route del Gateway?',
            refreshBtn: 'Ricarica Gateway'
          },
          SysGatewayRoute:{
            page_title: 'Gateway Routes',
            fromUrl: 'Indirizzo Da',
            toUrl: 'Indirizzo A',
            routeOrder: 'Ordine Route',
            authenticated: 'Con Authenticazione',
            prefix: 'Prefisso'
          },
          InfoilDeviationCheckConfig: {
            page_title: 'Configurazioni Infoil Scostamenti',
            combinedNomenclature: 'Nomenclatura Combinata',
            previousIdRegistryOperationType:'Tipo Operazione Precedente',
            measureType: 'Tipo Misura',
            alertThreshold: 'Soglia Alert',
            isPiEnabled: 'PI abilitato',
            isThresholdCheckEnabled: 'Controllo Soglia abilitato',
            isSendToInfoilEnabled: 'Invio a Infoil abilitato'
          },
          InfoilDeviationCheck: {
            manualMeasure: 'Misure Manuali',
            automaticMeasure: 'Misure Automatiche',
            movedQtyDelta: 'Delta  Mov',
            movedQtyDeltaPercentage: '% Delta  Mov',
            sendFiscalNotification: 'Abilita Invio Comunicazione',
            sendDeviationToInfoil: 'Invio Scostamenti ad Infoil',
            deviation: 'Scostamento',
            thresholdExceeded: 'Superamento Soglia'
          },
          tollingPrice: {
            page_title: 'Tolling Price',
            crudeTolling: 'Crudo Tolling',
            conversionFactor: 'CF',
            volumeLessPerc: 'Volume Perdita (%)',
            isabPaymentForCrude: 'Isab Payment For Crude($)',
            crudeVolumeBBL: 'Crude BBL',
            productPrice: 'Product Price ($/bbl)',
            trafiguraPaymentForProducts: 'Trafigura Payment For Product ($)',
            crudeWeightMT: 'Crude MT',
            productPremium: 'Product Premium ($/bbl)',
            monthlyFee: 'Monthly Fee',
            feeCrude: 'Fee Crude',
            totalValueOfTollFee: 'Total Value Of Tolling Fee ($)',
            crudePriceAvgMonth: 'ICE Brent Avg Month ($/bbl)',
            crudeDifferential: 'Crude Diff',
            dieselBalancingTrade: 'Diesel QP Balancing Trade ($/bbl)',
            dieselBalancingTradePrice: 'Diesel QP Balancing Price ($/bbl)',
            crudePrice: 'Crude Price',
            productPool: 'Prodotto',
            quantityMT: 'MT',
            volumeBBL: 'BBL',
            monthDate: 'Mese di Riferimento',
            monthDateToClone: 'Mese da Clonare',
            clone_tolling_price: 'Sei sicuro di procedere?'
          }
        },
      },
      
});



{/* 
    Per cambiare al volo la localizzazione
    <script>

import { defineComponent, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";


export default defineComponent({
  name: "app",
  data() {
    return {};
  },

  setup() {
    const i18n = useI18n();
    const store = useStore();

    watch(()=>store.getters.currentLang,(newVal) => { //watch the getter

      i18n.locale.value = store.getters.currentLang;
    },{
      immediate:true
    });
  },
});
</script> */}